class Fr extends Error {
  constructor(t, e = {}) {
    super(`Node not found: ${t}`, e), this.name = "NodeNotFoundError";
  }
}
class pi extends Error {
  constructor(t) {
    super(`Missing key: ${t}`), this.name = "KeyError";
  }
}
class is {
  #t;
  constructor(t, e, n) {
    typeof t == "number" ? this.#t = new Uint8Array(t) : t instanceof ArrayBuffer ? this.#t = new Uint8Array(t, e, n) : this.#t = new Uint8Array(Array.from(t, (s) => s ? 1 : 0));
  }
  get BYTES_PER_ELEMENT() {
    return 1;
  }
  get byteOffset() {
    return this.#t.byteOffset;
  }
  get byteLength() {
    return this.#t.byteLength;
  }
  get buffer() {
    return this.#t.buffer;
  }
  get length() {
    return this.#t.length;
  }
  get(t) {
    let e = this.#t[t];
    return typeof e == "number" ? e !== 0 : e;
  }
  set(t, e) {
    this.#t[t] = e ? 1 : 0;
  }
  fill(t) {
    this.#t.fill(t ? 1 : 0);
  }
  *[Symbol.iterator]() {
    for (let t = 0; t < this.length; t++)
      yield this.get(t);
  }
}
class ss {
  _data;
  chars;
  #t;
  constructor(t, e, n, s) {
    if (this.chars = t, this.#t = new TextEncoder(), typeof e == "number")
      this._data = new Uint8Array(e * t);
    else if (e instanceof ArrayBuffer)
      s && (s = s * t), this._data = new Uint8Array(e, n, s);
    else {
      let i = Array.from(e);
      this._data = new Uint8Array(i.length * t);
      for (let a = 0; a < i.length; a++)
        this.set(a, i[a]);
    }
  }
  get BYTES_PER_ELEMENT() {
    return this.chars;
  }
  get byteOffset() {
    return this._data.byteOffset;
  }
  get byteLength() {
    return this._data.byteLength;
  }
  get buffer() {
    return this._data.buffer;
  }
  get length() {
    return this.byteLength / this.BYTES_PER_ELEMENT;
  }
  get(t) {
    const e = new Uint8Array(this.buffer, this.byteOffset + this.chars * t, this.chars);
    return new TextDecoder().decode(e).replace(/\x00/g, "");
  }
  set(t, e) {
    const n = new Uint8Array(this.buffer, this.byteOffset + this.chars * t, this.chars);
    n.fill(0), n.set(this.#t.encode(e));
  }
  fill(t) {
    const e = this.#t.encode(t);
    for (let n = 0; n < this.length; n++)
      this._data.set(e, n * this.chars);
  }
  *[Symbol.iterator]() {
    for (let t = 0; t < this.length; t++)
      yield this.get(t);
  }
}
class pn {
  #t;
  chars;
  constructor(t, e, n, s) {
    if (this.chars = t, typeof e == "number")
      this.#t = new Int32Array(e * t);
    else if (e instanceof ArrayBuffer)
      s && (s *= t), this.#t = new Int32Array(e, n, s);
    else {
      const i = e, a = new pn(t, 1);
      this.#t = new Int32Array(function* () {
        for (let c of i)
          a.set(0, c), yield* a.#t;
      }());
    }
  }
  get BYTES_PER_ELEMENT() {
    return this.#t.BYTES_PER_ELEMENT * this.chars;
  }
  get byteLength() {
    return this.#t.byteLength;
  }
  get byteOffset() {
    return this.#t.byteOffset;
  }
  get buffer() {
    return this.#t.buffer;
  }
  get length() {
    return this.#t.length / this.chars;
  }
  get(t) {
    const e = this.chars * t;
    let n = "";
    for (let s = 0; s < this.chars; s++)
      n += String.fromCodePoint(this.#t[e + s]);
    return n.replace(/\u0000/g, "");
  }
  set(t, e) {
    const n = this.chars * t, s = this.#t.subarray(n, n + this.chars);
    s.fill(0);
    for (let i = 0; i < this.chars; i++)
      s[i] = e.codePointAt(i) ?? 0;
  }
  fill(t) {
    this.set(0, t);
    let e = this.#t.subarray(0, this.chars);
    for (let n = 1; n < this.length; n++)
      this.#t.set(e, n * this.chars);
  }
  *[Symbol.iterator]() {
    for (let t = 0; t < this.length; t++)
      yield this.get(t);
  }
}
function os(r) {
  const t = JSON.stringify(r, null, 2);
  return new TextEncoder().encode(t);
}
function rr(r) {
  const t = new TextDecoder().decode(r);
  return JSON.parse(t);
}
function Vs(r, t) {
  const e = t / 2, n = t - 1;
  let s = 0;
  for (let i = 0; i < r.length; i += t)
    for (let a = 0; a < e; a += 1)
      s = r[i + a], r[i + a] = r[i + n - a], r[i + n - a] = s;
}
const xu = {
  int8: Int8Array,
  int16: Int16Array,
  int32: Int32Array,
  int64: globalThis.BigInt64Array,
  uint8: Uint8Array,
  uint16: Uint16Array,
  uint32: Uint32Array,
  uint64: globalThis.BigUint64Array,
  float32: Float32Array,
  float64: Float64Array,
  bool: is
}, Au = /v2:([US])(\d+)/;
function ta(r) {
  if (r === "v2:object")
    return globalThis.Array;
  let t = r.match(Au);
  if (t) {
    let [, n, s] = t;
    return (n === "U" ? pn : ss).bind(null, Number(s));
  }
  let e = xu[r];
  return Yt(e, `Unknown or unsupported data_type: ${r}`), e;
}
function tr(r, t) {
  const e = r.length;
  typeof t == "string" && (t = t === "C" ? Array.from({ length: e }, (i, a) => a) : Array.from({ length: e }, (i, a) => e - 1 - a)), Yt(e === t.length, "Order length must match the number of dimensions.");
  let n = 1, s = new Array(e);
  for (let i = t.length - 1; i >= 0; i--)
    s[t[i]] = n, n *= r[t[i]];
  return s;
}
function Eu({ name: r, configuration: t }) {
  if (r === "default") {
    const e = t?.separator ?? "/";
    return (n) => ["c", ...n].join(e);
  }
  if (r === "v2") {
    const e = t?.separator ?? ".";
    return (n) => n.join(e) || "0";
  }
  throw new Error(`Unknown chunk key encoding: ${r}`);
}
function Tu(r) {
  if (r === "|O")
    return { data_type: "v2:object" };
  let t = r.match(/^([<|>])(.*)$/);
  Yt(t, `Invalid dtype: ${r}`);
  let [, e, n] = t, s = {
    b1: "bool",
    i1: "int8",
    u1: "uint8",
    i2: "int16",
    u2: "uint16",
    i4: "int32",
    u4: "uint32",
    i8: "int64",
    u8: "uint64",
    f4: "float32",
    f8: "float64"
  }[n] ?? (n.startsWith("S") || n.startsWith("U") ? `v2:${n}` : void 0);
  return Yt(s, `Unsupported or unknown dtype: ${r}`), e === "|" ? { data_type: s } : { data_type: s, endian: e === "<" ? "little" : "big" };
}
function Mu(r, t = {}) {
  let e = [], n = Tu(r.dtype);
  r.order === "F" && e.push({ name: "transpose", configuration: { order: "F" } }), "endian" in n && n.endian === "big" && e.push({ name: "bytes", configuration: { endian: "big" } });
  for (let { id: s, ...i } of r.filters ?? [])
    e.push({ name: s, configuration: i });
  if (r.compressor) {
    let { id: s, ...i } = r.compressor;
    e.push({ name: s, configuration: i });
  }
  return {
    zarr_format: 3,
    node_type: "array",
    shape: r.shape,
    data_type: n.data_type,
    chunk_grid: {
      name: "regular",
      configuration: {
        chunk_shape: r.chunks
      }
    },
    chunk_key_encoding: {
      name: "v2",
      configuration: {
        separator: r.dimension_separator ?? "."
      }
    },
    codecs: e,
    fill_value: r.fill_value,
    attributes: t
  };
}
function Ou(r, t = {}) {
  return {
    zarr_format: 3,
    node_type: "group",
    attributes: t
  };
}
function Fu(r, t) {
  if (t !== "number" && t !== "bigint" && t !== "boolean" && t !== "object" && t !== "string")
    return r === t;
  let e = r === "bool";
  if (t === "boolean")
    return e;
  let n = r.startsWith("v2:U") || r.startsWith("v2:S");
  if (t === "string")
    return n;
  let s = r === "int64" || r === "uint64";
  if (t === "bigint")
    return s;
  let i = r === "v2:object";
  return t === "object" ? i : !n && !s && !e && !i;
}
function ku(r) {
  return r?.name === "sharding_indexed";
}
function ea(r) {
  return (r.data_type === "uint64" || r.data_type === "int64") && r.fill_value != null ? BigInt(r.fill_value) : r.fill_value;
}
function ra(r, ...t) {
  if (!t.some((e) => r instanceof e))
    throw r;
}
function Yt(r, t = "") {
  if (!r)
    throw new Error(t);
}
class as {
  kind = "array_to_array";
  constructor(t, e) {
    Yt(t.keepbits >= 0, "keepbits must be zero or positive");
  }
  static fromConfig(t, e) {
    return new as(t, e);
  }
  /**
   * Encode a chunk of data with bit-rounding.
   * @param _arr - The chunk to encode
   */
  encode(t) {
    throw new Error("`BitroundCodec.encode` is not implemented. Please open an issue at https://github.com/manzt/zarrita.js/issues.");
  }
  /**
   * Decode a chunk of data (no-op).
   * @param arr - The chunk to decode
   * @returns The decoded chunk
   */
  decode(t) {
    return t;
  }
}
const Ws = Nu();
function Nu() {
  const r = new Uint32Array([305419896]);
  return new Uint8Array(r.buffer, r.byteOffset, r.byteLength)[0] !== 18;
}
function Zs(r) {
  return "BYTES_PER_ELEMENT" in r ? r.BYTES_PER_ELEMENT : 4;
}
class yi {
  kind = "array_to_bytes";
  #t;
  #e;
  #n;
  #i;
  #r;
  constructor(t, e) {
    this.#r = t?.endian, this.#e = ta(e.data_type), this.#i = e.shape, this.#t = tr(e.shape, "C");
    const n = new this.#e(0);
    this.#n = n.BYTES_PER_ELEMENT;
  }
  static fromConfig(t, e) {
    return new yi(t, e);
  }
  encode(t) {
    let e = new Uint8Array(t.data.buffer);
    return Ws && this.#r === "big" && Vs(e, Zs(this.#e)), e;
  }
  decode(t) {
    return Ws && this.#r === "big" && Vs(t, Zs(this.#e)), {
      data: new this.#e(t.buffer, t.byteOffset, t.byteLength / this.#n),
      shape: this.#i,
      stride: this.#t
    };
  }
}
class cs {
  kind = "bytes_to_bytes";
  static fromConfig() {
    return new cs();
  }
  encode(t) {
    throw new Error("Not implemented");
  }
  decode(t) {
    return new Uint8Array(t.buffer, t.byteOffset, t.byteLength - 4);
  }
}
function Du(r, t) {
  return Yt(!Number.isNaN(t), "JsonCodec allow_nan is false but NaN was encountered during encoding."), Yt(t !== Number.POSITIVE_INFINITY, "JsonCodec allow_nan is false but Infinity was encountered during encoding."), Yt(t !== Number.NEGATIVE_INFINITY, "JsonCodec allow_nan is false but -Infinity was encountered during encoding."), t;
}
function Uu(r, t) {
  return t instanceof Object && !Array.isArray(t) ? Object.keys(t).sort().reduce((e, n) => (e[n] = t[n], e), {}) : t;
}
class us {
  configuration;
  kind = "array_to_bytes";
  #t;
  #e;
  constructor(t = {}) {
    this.configuration = t;
    const { encoding: e = "utf-8", skipkeys: n = !1, ensure_ascii: s = !0, check_circular: i = !0, allow_nan: a = !0, sort_keys: c = !0, indent: d, strict: p = !0 } = t;
    let y = t.separators;
    y || (d ? y = [", ", ": "] : y = [",", ":"]), this.#t = {
      encoding: e,
      skipkeys: n,
      ensure_ascii: s,
      check_circular: i,
      allow_nan: a,
      indent: d,
      separators: y,
      sort_keys: c
    }, this.#e = { strict: p };
  }
  static fromConfig(t) {
    return new us(t);
  }
  encode(t) {
    const { indent: e, encoding: n, ensure_ascii: s, check_circular: i, allow_nan: a, sort_keys: c } = this.#t;
    Yt(n === "utf-8", "JsonCodec does not yet support non-utf-8 encoding.");
    const d = [];
    Yt(i, "JsonCodec does not yet support skipping the check for circular references during encoding."), a || d.push(Du), c && d.push(Uu);
    const p = Array.from(t.data);
    p.push("|O"), p.push(t.shape);
    let y;
    d.length && (y = (R, F) => {
      let T = F;
      for (let U of d)
        T = U(R, T);
      return T;
    });
    let B = JSON.stringify(p, y, e);
    return s && (B = B.replace(/[\u007F-\uFFFF]/g, (R) => {
      const F = `0000${R.charCodeAt(0).toString(16)}`;
      return `\\u${F.substring(F.length - 4)}`;
    })), new TextEncoder().encode(B);
  }
  decode(t) {
    const { strict: e } = this.#e;
    Yt(e, "JsonCodec does not yet support non-strict decoding.");
    const n = rr(t), s = n.pop();
    n.pop(), Yt(s, "0D not implemented for JsonCodec.");
    const i = tr(s, "C");
    return { data: n, shape: s, stride: i };
  }
}
const hs = {};
function Gs(r) {
  return r instanceof is || r instanceof ss || r instanceof pn ? new Proxy(r, {
    get(e, n) {
      return e.get(Number(n));
    },
    set(e, n, s) {
      return e.set(Number(n), s), !0;
    }
  }) : r;
}
function Lu(r, t) {
  let e;
  return r.data instanceof ss || r.data instanceof pn ? e = new r.constructor(
    // @ts-expect-error
    r.data.length,
    r.data.chars
  ) : e = new r.constructor(r.data.length), {
    data: e,
    shape: r.shape,
    stride: tr(r.shape, t)
  };
}
function Cu(r, t) {
  let e = Lu(r, t), n = r.shape.length, s = r.data.length, i = Array(n).fill(0), a = Gs(r.data), c = Gs(e.data);
  for (let d = 0; d < s; d++) {
    let p = 0;
    for (let y = 0; y < n; y++)
      p += i[y] * e.stride[y];
    c[p] = a[d], i[0] += 1;
    for (let y = 0; y < n; y++)
      if (i[y] === r.shape[y]) {
        if (y + 1 === n)
          break;
        i[y] = 0, i[y + 1] += 1;
      }
  }
  return e;
}
function Ru(r) {
  let t = r.shape.length;
  return hs(t === r.stride.length, "Shape and stride must have the same length."), r.stride.map((e, n) => ({ stride: e, index: n })).sort((e, n) => n.stride - e.stride).map((e) => e.index);
}
function Pu(r, t) {
  let e = Ru(r);
  return hs(e.length === t.length, "Orders must match"), e.every((n, s) => n === t[s]);
}
class ls {
  kind = "array_to_array";
  #t;
  #e;
  constructor(t, e) {
    let n = t.order ?? "C", s = e.shape.length, i = new Array(s), a = new Array(s);
    if (n === "C")
      for (let c = 0; c < s; ++c)
        i[c] = c, a[c] = c;
    else if (n === "F")
      for (let c = 0; c < s; ++c)
        i[c] = s - c - 1, a[c] = s - c - 1;
    else
      i = n, i.forEach((c, d) => {
        hs(a[c] === void 0, `Invalid permutation: ${JSON.stringify(n)}`), a[c] = d;
      });
    this.#t = i, this.#e = a;
  }
  static fromConfig(t, e) {
    return new ls(t, e);
  }
  encode(t) {
    return Pu(t, this.#e) ? t : Cu(t, this.#e);
  }
  decode(t) {
    return {
      data: t.data,
      shape: t.shape,
      stride: tr(t.shape, this.#t)
    };
  }
}
class ds {
  kind = "array_to_bytes";
  #t;
  #e;
  constructor(t) {
    this.#t = t, this.#e = tr(t, "C");
  }
  static fromConfig(t, e) {
    return new ds(e.shape);
  }
  encode(t) {
    throw new Error("Method not implemented.");
  }
  decode(t) {
    let e = new TextDecoder(), n = new DataView(t.buffer), s = Array(n.getUint32(0, !0)), i = 4;
    for (let a = 0; a < s.length; a++) {
      let c = n.getUint32(i, !0);
      i += 4, s[a] = e.decode(t.buffer.slice(i, i + c)), i += c;
    }
    return { data: s, shape: this.#t, stride: this.#e };
  }
}
function $u() {
  return (/* @__PURE__ */ new Map()).set("blosc", () => import("./blosc-BOWv2fO7.js").then((r) => r.default)).set("gzip", () => import("./gzip-DchmmbTG.js").then((r) => r.default)).set("lz4", () => import("./lz4-DUlZKApi.js").then((r) => r.default)).set("zlib", () => import("./zlib-Din1wO0I.js").then((r) => r.default)).set("zstd", () => import("./zstd-DnzmycJs.js").then((r) => r.default)).set("transpose", () => ls).set("bytes", () => yi).set("crc32c", () => cs).set("vlen-utf8", () => ds).set("json2", () => us).set("bitround", () => as);
}
const na = $u();
function Pi(r) {
  let t;
  return {
    async encode(e) {
      t || (t = await Ys(r));
      for (const s of t.array_to_array)
        e = await s.encode(e);
      let n = await t.array_to_bytes.encode(e);
      for (const s of t.bytes_to_bytes)
        n = await s.encode(n);
      return n;
    },
    async decode(e) {
      t || (t = await Ys(r));
      for (let s = t.bytes_to_bytes.length - 1; s >= 0; s--)
        e = await t.bytes_to_bytes[s].decode(e);
      let n = await t.array_to_bytes.decode(e);
      for (let s = t.array_to_array.length - 1; s >= 0; s--)
        n = await t.array_to_array[s].decode(n);
      return n;
    }
  };
}
async function Ys(r) {
  let t = r.codecs.map(async (i) => {
    let a = await na.get(i.name)?.();
    return Yt(a, `Unknown codec: ${i.name}`), { Codec: a, meta: i };
  }), e = [], n, s = [];
  for await (let { Codec: i, meta: a } of t) {
    let c = i.fromConfig(a.configuration, r);
    switch (c.kind) {
      case "array_to_array":
        e.push(c);
        break;
      case "array_to_bytes":
        n = c;
        break;
      default:
        s.push(c);
    }
  }
  return n || (Yt(zu(r), `Cannot encode ${r.data_type} to bytes without a codec`), n = yi.fromConfig({ endian: "little" }, r)), { array_to_array: e, array_to_bytes: n, bytes_to_bytes: s };
}
function zu(r) {
  return r.data_type !== "v2:object";
}
const Js = 18446744073709551615n;
function ju(r, t, e, n) {
  Yt(r.store.getRange, "Store does not support range requests");
  let s = r.store.getRange.bind(r.store), i = t.map((d, p) => d / n.chunk_shape[p]), a = Pi({
    data_type: "uint64",
    shape: [...i, 2],
    codecs: n.index_codecs
  }), c = {};
  return async (d) => {
    let p = d.map((P, C) => Math.floor(P / i[C])), y = r.resolve(e(p)).path, B;
    if (y in c)
      B = c[y];
    else {
      let P = 4, C = 16 * i.reduce((G, x) => G * x, 1), V = await s(y, {
        suffixLength: C + P
      });
      B = c[y] = V ? await a.decode(V) : null;
    }
    if (B === null)
      return;
    let { data: R, shape: F, stride: T } = B, U = d.map((P, C) => P % F[C]).reduce((P, C, V) => P + C * T[V], 0), O = R[U], N = R[U + 1];
    if (!(O === Js && N === Js))
      return s(y, {
        offset: Number(O),
        length: Number(N)
      });
  };
}
class nr {
  store;
  path;
  constructor(t, e = "/") {
    this.store = t, this.path = e;
  }
  resolve(t) {
    let e = new URL(`file://${this.path.endsWith("/") ? this.path : `${this.path}/`}`);
    return new nr(this.store, new URL(t, e).pathname);
  }
}
class gi extends nr {
  kind = "group";
  #t;
  constructor(t, e, n) {
    super(t, e), this.#t = n;
  }
  get attrs() {
    return this.#t.attributes;
  }
}
function Hs(r) {
  return r.find((e) => e.name === "transpose")?.configuration?.order ?? "C";
}
const Kr = Symbol("zarrita.context");
function ia(r) {
  return r[Kr];
}
function Vu(r, t) {
  let { configuration: e } = t.codecs.find(ku) ?? {}, n = {
    encode_chunk_key: Eu(t.chunk_key_encoding),
    TypedArray: ta(t.data_type),
    fill_value: t.fill_value
  };
  if (e) {
    let i = Hs(e.codecs);
    return {
      ...n,
      kind: "sharded",
      chunk_shape: e.chunk_shape,
      codec: Pi({
        data_type: t.data_type,
        shape: e.chunk_shape,
        codecs: e.codecs
      }),
      get_strides(a, c) {
        return tr(a, c ?? i);
      },
      get_chunk_bytes: ju(r, t.chunk_grid.configuration.chunk_shape, n.encode_chunk_key, e)
    };
  }
  let s = Hs(t.codecs);
  return {
    ...n,
    kind: "regular",
    chunk_shape: t.chunk_grid.configuration.chunk_shape,
    codec: Pi({
      data_type: t.data_type,
      shape: t.chunk_grid.configuration.chunk_shape,
      codecs: t.codecs
    }),
    get_strides(i, a) {
      return tr(i, a ?? s);
    },
    async get_chunk_bytes(i, a) {
      let c = n.encode_chunk_key(i), d = r.resolve(c).path;
      return r.store.get(d, a);
    }
  };
}
let vr = class extends nr {
  kind = "array";
  #t;
  [Kr];
  constructor(t, e, n) {
    super(t, e), this.#t = {
      ...n,
      fill_value: ea(n)
    }, this[Kr] = Vu(this, n);
  }
  get attrs() {
    return this.#t.attributes;
  }
  get shape() {
    return this.#t.shape;
  }
  get chunks() {
    return this[Kr].chunk_shape;
  }
  get dtype() {
    return this.#t.data_type;
  }
  async getChunk(t, e) {
    let n = this[Kr], s = await n.get_chunk_bytes(t, e);
    if (!s) {
      let i = n.chunk_shape.reduce((c, d) => c * d, 1), a = new n.TypedArray(i);
      return a.fill(n.fill_value), {
        data: a,
        shape: n.chunk_shape,
        stride: n.get_strides(n.chunk_shape)
      };
    }
    return n.codec.decode(s);
  }
  /**
   * A helper method to narrow `zarr.Array` Dtype.
   *
   * ```typescript
   * let arr: zarr.Array<DataType, FetchStore> = zarr.open(store, { kind: "array" });
   *
   * // Option 1: narrow by scalar type (e.g. "bool", "raw", "bigint", "number")
   * if (arr.is("bigint")) {
   *   // zarr.Array<"int64" | "uint64", FetchStore>
   * }
   *
   * // Option 3: exact match
   * if (arr.is("float32")) {
   *   // zarr.Array<"float32", FetchStore, "/">
   * }
   * ```
   */
  is(t) {
    return Fu(this.dtype, t);
  }
}, mi = Wu();
function Wu() {
  let r = /* @__PURE__ */ new WeakMap();
  function t(e) {
    let n = r.get(e) ?? { v2: 0, v3: 0 };
    return r.set(e, n), n;
  }
  return {
    increment(e, n) {
      t(e)[n] += 1;
    },
    version_max(e) {
      let n = t(e);
      return n.v3 > n.v2 ? "v3" : "v2";
    }
  };
}
async function Zu(r) {
  let t = await r.store.get(r.resolve(".zattrs").path);
  return t ? rr(t) : {};
}
async function Gu(r, t = {}) {
  let e = "store" in r ? r : new nr(r), n = {};
  return (t.attrs ?? !0) && (n = await Zu(e)), t.kind === "array" ? qs(e, n) : t.kind === "group" ? Ks(e, n) : qs(e, n).catch((s) => (ra(s, Fr), Ks(e, n)));
}
async function qs(r, t) {
  let { path: e } = r.resolve(".zarray"), n = await r.store.get(e);
  if (!n)
    throw new Fr("v2 array", {
      cause: new pi(e)
    });
  return mi.increment(r.store, "v2"), new vr(r.store, r.path, Mu(rr(n), t));
}
async function Ks(r, t) {
  let { path: e } = r.resolve(".zgroup"), n = await r.store.get(e);
  if (!n)
    throw new Fr("v2 group", {
      cause: new pi(e)
    });
  return mi.increment(r.store, "v2"), new gi(r.store, r.path, Ou(rr(n), t));
}
async function Yu(r) {
  let { store: t, path: e } = r.resolve("zarr.json"), n = await r.store.get(e);
  if (!n)
    throw new Fr("v3 array or group", {
      cause: new pi(e)
    });
  let s = rr(n);
  return s.node_type === "array" && (s.fill_value = ea(s)), s.node_type === "array" ? new vr(t, r.path, s) : new gi(t, r.path, s);
}
async function Ju(r, t = {}) {
  let e = "store" in r ? r : new nr(r), n = await Yu(e);
  if (mi.increment(e.store, "v3"), t.kind === void 0 || t.kind === "array" && n instanceof vr || t.kind === "group" && n instanceof gi)
    return n;
  let s = n instanceof vr ? "array" : "group";
  throw new Error(`Expected node of kind ${t.kind}, found ${s}.`);
}
async function Ge(r, t = {}) {
  let e = "store" in r ? r.store : r, n = mi.version_max(e), s = n === "v2" ? Ge.v2 : Ge.v3, i = n === "v2" ? Ge.v3 : Ge.v2;
  return s(r, t).catch((a) => (ra(a, Fr), i(r, t)));
}
Ge.v2 = Gu;
Ge.v3 = Ju;
async function Xs(r, t = {}) {
  let e = "store" in r ? r : new nr(r);
  return "shape" in t ? await qu(e, t) : Hu(e, t);
}
async function Hu(r, t = {}) {
  let e = {
    zarr_format: 3,
    node_type: "group",
    attributes: t.attributes ?? {}
  };
  return await r.store.set(r.resolve("zarr.json").path, os(e)), new gi(r.store, r.path, e);
}
async function qu(r, t) {
  let e = {
    zarr_format: 3,
    node_type: "array",
    shape: t.shape,
    data_type: t.data_type,
    chunk_grid: {
      name: "regular",
      configuration: {
        chunk_shape: t.chunk_shape
      }
    },
    chunk_key_encoding: {
      name: "default",
      configuration: {
        separator: t.chunk_separator ?? "/"
      }
    },
    codecs: t.codecs ?? [],
    fill_value: t.fill_value ?? null,
    attributes: t.attributes ?? {}
  };
  return await r.store.set(r.resolve("zarr.json").path, os(e)), new vr(r.store, r.path, e);
}
async function Ku(r) {
  let t = await r.get("/.zmetadata");
  if (!t)
    throw new Fr("v2 consolidated metadata", {
      cause: new pi("/.zmetadata")
    });
  let e = rr(t);
  return Yt(e.zarr_consolidated_format === 1, "Unsupported consolidated format."), e;
}
function Xu(r) {
  return r.endsWith(".zarray") || r.endsWith(".zgroup") || r.endsWith(".zattrs") || r.endsWith("zarr.json");
}
function Qu(r) {
  return "zarr_format" in r && r.zarr_format === 3;
}
async function th(r) {
  let t = await Ku(r), e = {};
  for (let [n, s] of Object.entries(t.metadata))
    e[`/${n}`] = s;
  return {
    async get(...n) {
      let [s, i] = n;
      if (e[s])
        return os(e[s]);
      let a = await r.get(s, i);
      if (Xu(s) && a) {
        let c = rr(a);
        e[s] = c;
      }
      return a;
    },
    // Delegate range requests to the underlying store.
    // Note: Supporting range requests for consolidated metadata is possible
    // but unlikely to be useful enough to justify the effort.
    getRange: r.getRange?.bind(r),
    contents() {
      let n = [];
      for (let [s, i] of Object.entries(e)) {
        let a = s.split("/"), c = a.pop(), d = a.join("/") || "/";
        c === ".zarray" && n.push({ path: d, kind: "array" }), c === ".zgroup" && n.push({ path: d, kind: "group" }), Qu(i) && n.push({ path: d, kind: i.node_type });
      }
      return n;
    }
  };
}
function* eh(r, t, e = 1) {
  t === void 0 && (t = r, r = 0);
  for (let n = r; n < t; n += e)
    yield n;
}
function* rh(...r) {
  if (r.length === 0)
    return;
  const t = r.map((n) => n[Symbol.iterator]()), e = t.map((n) => n.next());
  if (e.some((n) => n.done))
    throw new Error("Input contains an empty iterator.");
  for (let n = 0; ; ) {
    if (e[n].done) {
      if (t[n] = r[n][Symbol.iterator](), e[n] = t[n].next(), ++n >= t.length)
        return;
    } else
      yield e.map(({ value: s }) => s), n = 0;
    e[n] = t[n].next();
  }
}
function nh({ start: r, stop: t, step: e }, n) {
  if (e === 0)
    throw new Error("slice step cannot be zero");
  e = e ?? 1;
  const s = e < 0, [i, a] = s ? [-1, n - 1] : [0, n];
  return r === null ? r = s ? a : i : r < 0 ? (r += n, r < i && (r = i)) : r > a && (r = a), t === null ? t = s ? i : a : t < 0 ? (t += n, t < i && (t = i)) : t > a && (t = a), [r, t, e];
}
function $i(r, t, e = null) {
  return t === void 0 && (t = r, r = null), {
    start: r,
    stop: t,
    step: e
  };
}
function sa() {
  const r = [];
  return {
    add: (t) => r.push(t()),
    onIdle: () => Promise.all(r)
  };
}
class fs extends Error {
  constructor(t) {
    super(t), this.name = "IndexError";
  }
}
function ih(r, t) {
  throw new fs(`too many indicies for array; expected ${t.length}, got ${r.length}`);
}
function sh(r) {
  throw new fs(`index out of bounds for dimension with length ${r}`);
}
function oh() {
  throw new fs("only slices with step >= 1 are supported");
}
function ah(r, t) {
  r.length > t.length && ih(r, t);
}
function ch(r, t) {
  return r = Math.trunc(r), r < 0 && (r = t + r), (r >= t || r < 0) && sh(t), r;
}
class uh {
  dim_sel;
  dim_len;
  dim_chunk_len;
  nitems;
  constructor({ dim_sel: t, dim_len: e, dim_chunk_len: n }) {
    t = ch(t, e), this.dim_sel = t, this.dim_len = e, this.dim_chunk_len = n, this.nitems = 1;
  }
  *[Symbol.iterator]() {
    const t = Math.floor(this.dim_sel / this.dim_chunk_len), e = t * this.dim_chunk_len, n = this.dim_sel - e;
    yield { dim_chunk_ix: t, dim_chunk_sel: n };
  }
}
class Qs {
  start;
  stop;
  step;
  dim_len;
  dim_chunk_len;
  nitems;
  nchunks;
  constructor({ dim_sel: t, dim_len: e, dim_chunk_len: n }) {
    const [s, i, a] = nh(t, e);
    this.start = s, this.stop = i, this.step = a, this.step < 1 && oh(), this.dim_len = e, this.dim_chunk_len = n, this.nitems = Math.max(0, Math.ceil((this.stop - this.start) / this.step)), this.nchunks = Math.ceil(this.dim_len / this.dim_chunk_len);
  }
  *[Symbol.iterator]() {
    const t = Math.floor(this.start / this.dim_chunk_len), e = Math.ceil(this.stop / this.dim_chunk_len);
    for (const n of eh(t, e)) {
      const s = n * this.dim_chunk_len, i = Math.min(this.dim_len, (n + 1) * this.dim_chunk_len), a = i - s;
      let c = 0, d = 0;
      if (this.start < s) {
        const F = (s - this.start) % this.step;
        F && (d += this.step - F), c = Math.ceil((s - this.start) / this.step);
      } else
        d = this.start - s;
      const p = this.stop > i ? a : this.stop - s, y = [
        d,
        p,
        this.step
      ], B = Math.ceil((p - d) / this.step), R = [
        c,
        c + B,
        1
      ];
      yield { dim_chunk_ix: n, dim_chunk_sel: y, dim_out_sel: R };
    }
  }
}
function hh(r, t) {
  let e = [];
  return r === null ? e = t.map((n) => $i(null)) : Array.isArray(r) && (e = r.map((n) => n ?? $i(null))), ah(e, t), e;
}
class oa {
  dim_indexers;
  shape;
  constructor({ selection: t, shape: e, chunk_shape: n }) {
    this.dim_indexers = hh(t, e).map((s, i) => new (typeof s == "number" ? uh : Qs)({
      // @ts-expect-error ts inference not strong enough to know correct chunk
      dim_sel: s,
      dim_len: e[i],
      dim_chunk_len: n[i]
    })), this.shape = this.dim_indexers.filter((s) => s instanceof Qs).map((s) => s.nitems);
  }
  *[Symbol.iterator]() {
    for (const t of rh(...this.dim_indexers)) {
      const e = t.map((s) => s.dim_chunk_ix), n = t.map((s) => "dim_out_sel" in s ? { from: s.dim_chunk_sel, to: s.dim_out_sel } : { from: s.dim_chunk_sel, to: null });
      yield { chunk_coords: e, mapping: n };
    }
  }
}
function lh(r, t) {
  return "get" in r ? r.get(t) : r[t];
}
async function dh(r, t, e, n) {
  let s = ia(r), i = new oa({
    selection: t,
    shape: r.shape,
    chunk_shape: r.chunks
  }), a = n.prepare(new s.TypedArray(i.shape.reduce((d, p) => d * p, 1)), i.shape, s.get_strides(i.shape, e.order)), c = e.create_queue?.() ?? sa();
  for (const { chunk_coords: d, mapping: p } of i)
    c.add(async () => {
      let { data: y, shape: B, stride: R } = await r.getChunk(d, e.opts), F = n.prepare(y, B, R);
      n.set_from_chunk(a, F, p);
    });
  return await c.onIdle(), i.shape.length === 0 ? lh(a.data, 0) : a;
}
function fh(r) {
  return r.to == null ? { from: r.to, to: r.from } : { from: r.to, to: r.from };
}
async function ph(r, t, e, n, s) {
  const i = ia(r);
  if (i.kind === "sharded")
    throw new Error("Set not supported for sharded arrays.");
  const a = new oa({
    selection: t,
    shape: r.shape,
    chunk_shape: r.chunks
  }), c = r.chunks.reduce((p, y) => p * y, 1), d = n.create_queue ? n.create_queue() : sa();
  for (const { chunk_coords: p, mapping: y } of a) {
    const B = y.map((F) => F.from), R = y.map(fh);
    d.add(async () => {
      const F = r.resolve(i.encode_chunk_key(p)).path;
      let T;
      const U = r.chunks.slice(), O = i.get_strides(U);
      if (yh(B, U))
        if (T = new i.TypedArray(c), typeof e == "object") {
          const N = s.prepare(T, U.slice(), O.slice());
          s.set_from_chunk(N, e, R);
        } else
          T.fill(e);
      else {
        T = await r.getChunk(p).then(({ data: P }) => P);
        const N = s.prepare(T, U.slice(), O.slice());
        typeof e == "object" ? s.set_from_chunk(N, e, R) : s.set_scalar(N, B, e);
      }
      await r.store.set(F, await i.codec.encode({
        data: T,
        shape: U,
        stride: O
      }));
    });
  }
  await d.onIdle();
}
function yh(r, t) {
  return r.every((e, n) => {
    if (typeof e == "number")
      return !1;
    const [s, i, a] = e;
    return i - s === t[n] && a === 1;
  });
}
function ps(r, t = 0, e) {
  let n = e ?? r.length - t;
  return {
    length: n,
    subarray(s, i = n) {
      return ps(r, t + s, i - s);
    },
    set(s, i = 0) {
      for (let a = 0; a < s.length; a++)
        r[t + i + a] = s.get(a);
    },
    get(s) {
      return r[t + s];
    }
  };
}
function xi(r) {
  return globalThis.Array.isArray(r.data) ? {
    // @ts-expect-error
    data: ps(r.data),
    stride: r.stride,
    bytes_per_element: 1
  } : {
    data: new Uint8Array(r.data.buffer, r.data.byteOffset, r.data.byteLength),
    stride: r.stride,
    bytes_per_element: r.data.BYTES_PER_ELEMENT
  };
}
function gh(r) {
  return "chars" in r ? r.constructor.bind(null, r.chars) : r.constructor;
}
function mh(r, t) {
  if (globalThis.Array.isArray(r.data))
    return ps([t]);
  let e = gh(r.data), n = new e([t]);
  return new Uint8Array(n.buffer, n.byteOffset, n.byteLength);
}
const aa = {
  prepare(r, t, e) {
    return { data: r, shape: t, stride: e };
  },
  set_scalar(r, t, e) {
    let n = xi(r);
    zi(n, t, mh(r, e), n.bytes_per_element);
  },
  set_from_chunk(r, t, e) {
    let n = xi(r);
    xn(n, xi(t), n.bytes_per_element, e);
  }
};
async function wh(r, t = null, e = {}) {
  return dh(r, t, e, aa);
}
async function bh(r, t, e, n = {}) {
  return ph(r, t, e, n, aa);
}
function ca(r, t, e) {
  return e < 0 && t < r ? Math.floor((r - t - 1) / -e) + 1 : r < t ? Math.floor((t - r - 1) / e) + 1 : 0;
}
function zi(r, t, e, n) {
  if (t.length === 0) {
    r.data.set(e, 0);
    return;
  }
  const [s, ...i] = t, [a, ...c] = r.stride;
  if (typeof s == "number") {
    const R = r.data.subarray(a * s * n);
    zi({ data: R, stride: c }, i, e, n);
    return;
  }
  const [d, p, y] = s, B = ca(d, p, y);
  if (i.length === 0) {
    for (let R = 0; R < B; R++)
      r.data.set(e, a * (d + y * R) * n);
    return;
  }
  for (let R = 0; R < B; R++) {
    const F = r.data.subarray(a * (d + y * R) * n);
    zi({ data: F, stride: c }, i, e, n);
  }
}
function xn(r, t, e, n) {
  const [s, ...i] = n, [a, ...c] = r.stride, [d, ...p] = t.stride;
  if (s.from === null) {
    if (i.length === 0) {
      r.data.set(t.data.subarray(0, e), s.to * e);
      return;
    }
    xn({
      data: r.data.subarray(a * s.to * e),
      stride: c
    }, t, e, i);
    return;
  }
  if (s.to === null) {
    if (i.length === 0) {
      let N = s.from * e;
      r.data.set(t.data.subarray(N, N + e), 0);
      return;
    }
    xn(r, {
      data: t.data.subarray(d * s.from * e),
      stride: p
    }, e, i);
    return;
  }
  const [y, B, R] = s.to, [F, T, U] = s.from, O = ca(y, B, R);
  if (i.length === 0) {
    if (R === 1 && U === 1 && a === 1 && d === 1) {
      let N = F * e, P = O * e;
      r.data.set(t.data.subarray(N, N + P), y * e);
      return;
    }
    for (let N = 0; N < O; N++) {
      let P = d * (F + U * N) * e;
      r.data.set(t.data.subarray(P, P + e), a * (y + R * N) * e);
    }
    return;
  }
  for (let N = 0; N < O; N++)
    xn({
      data: r.data.subarray(a * (y + N * R) * e),
      stride: c
    }, {
      data: t.data.subarray(d * (F + N * U) * e),
      stride: p
    }, e, i);
}
function gt(r, t, e, n) {
  function s(i) {
    return i instanceof e ? i : new e(function(a) {
      a(i);
    });
  }
  return new (e || (e = Promise))(function(i, a) {
    function c(y) {
      try {
        p(n.next(y));
      } catch (B) {
        a(B);
      }
    }
    function d(y) {
      try {
        p(n.throw(y));
      } catch (B) {
        a(B);
      }
    }
    function p(y) {
      y.done ? i(y.value) : s(y.value).then(c, d);
    }
    p((n = n.apply(r, t || [])).next());
  });
}
function to(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function wt(r) {
  return this instanceof wt ? (this.v = r, this) : new wt(r);
}
function Ae(r, t, e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = e.apply(r, t || []), s, i = [];
  return s = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), c("next"), c("throw"), c("return", a), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function a(F) {
    return function(T) {
      return Promise.resolve(T).then(F, B);
    };
  }
  function c(F, T) {
    n[F] && (s[F] = function(U) {
      return new Promise(function(O, N) {
        i.push([F, U, O, N]) > 1 || d(F, U);
      });
    }, T && (s[F] = T(s[F])));
  }
  function d(F, T) {
    try {
      p(n[F](T));
    } catch (U) {
      R(i[0][3], U);
    }
  }
  function p(F) {
    F.value instanceof wt ? Promise.resolve(F.value.v).then(y, B) : R(i[0][2], F);
  }
  function y(F) {
    d("next", F);
  }
  function B(F) {
    d("throw", F);
  }
  function R(F, T) {
    F(T), i.shift(), i.length && d(i[0][0], i[0][1]);
  }
}
function An(r) {
  var t, e;
  return t = {}, n("next"), n("throw", function(s) {
    throw s;
  }), n("return"), t[Symbol.iterator] = function() {
    return this;
  }, t;
  function n(s, i) {
    t[s] = r[s] ? function(a) {
      return (e = !e) ? { value: wt(r[s](a)), done: !1 } : i ? i(a) : a;
    } : i;
  }
}
function br(r) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = r[Symbol.asyncIterator], e;
  return t ? t.call(r) : (r = typeof to == "function" ? to(r) : r[Symbol.iterator](), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function() {
    return this;
  }, e);
  function n(i) {
    e[i] = r[i] && function(a) {
      return new Promise(function(c, d) {
        a = r[i](a), s(c, d, a.done, a.value);
      });
    };
  }
  function s(i, a, c, d) {
    Promise.resolve(d).then(function(p) {
      i({ value: p, done: c });
    }, a);
  }
}
const _h = new TextDecoder("utf-8"), ji = (r) => _h.decode(r), Sh = new TextEncoder(), ys = (r) => Sh.encode(r), Ih = (r) => typeof r == "number", Bh = (r) => typeof r == "boolean", qt = (r) => typeof r == "function", me = (r) => r != null && Object(r) === r, un = (r) => me(r) && qt(r.then), wi = (r) => me(r) && qt(r[Symbol.iterator]), gs = (r) => me(r) && qt(r[Symbol.asyncIterator]), Vi = (r) => me(r) && me(r.schema), ua = (r) => me(r) && "done" in r && "value" in r, ha = (r) => me(r) && qt(r.stat) && Ih(r.fd), la = (r) => me(r) && ms(r.body), da = (r) => "_getDOMStream" in r && "_getNodeStream" in r, ms = (r) => me(r) && qt(r.cancel) && qt(r.getReader) && !da(r), fa = (r) => me(r) && qt(r.read) && qt(r.pipe) && Bh(r.readable) && !da(r), vh = (r) => me(r) && qt(r.clear) && qt(r.bytes) && qt(r.position) && qt(r.setPosition) && qt(r.capacity) && qt(r.getBufferIdentifier) && qt(r.createLong), ws = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : ArrayBuffer;
function xh(r) {
  const t = r[0] ? [r[0]] : [];
  let e, n, s, i;
  for (let a, c, d = 0, p = 0, y = r.length; ++d < y; ) {
    if (a = t[p], c = r[d], !a || !c || a.buffer !== c.buffer || c.byteOffset < a.byteOffset) {
      c && (t[++p] = c);
      continue;
    }
    if ({ byteOffset: e, byteLength: s } = a, { byteOffset: n, byteLength: i } = c, e + s < n || n + i < e) {
      c && (t[++p] = c);
      continue;
    }
    t[p] = new Uint8Array(a.buffer, e, n - e + i);
  }
  return t;
}
function eo(r, t, e = 0, n = t.byteLength) {
  const s = r.byteLength, i = new Uint8Array(r.buffer, r.byteOffset, s), a = new Uint8Array(t.buffer, t.byteOffset, Math.min(n, s));
  return i.set(a, e), r;
}
function Ee(r, t) {
  const e = xh(r), n = e.reduce((y, B) => y + B.byteLength, 0);
  let s, i, a, c = 0, d = -1;
  const p = Math.min(t || Number.POSITIVE_INFINITY, n);
  for (const y = e.length; ++d < y; ) {
    if (s = e[d], i = s.subarray(0, Math.min(s.length, p - c)), p <= c + i.length) {
      i.length < s.length ? e[d] = s.subarray(i.length) : i.length === s.length && d++, a ? eo(a, i, c) : a = i;
      break;
    }
    eo(a || (a = new Uint8Array(p)), i, c), c += i.length;
  }
  return [a || new Uint8Array(0), e.slice(d), n - (a ? a.byteLength : 0)];
}
function Mt(r, t) {
  let e = ua(t) ? t.value : t;
  return e instanceof r ? r === Uint8Array ? new r(e.buffer, e.byteOffset, e.byteLength) : e : e ? (typeof e == "string" && (e = ys(e)), e instanceof ArrayBuffer ? new r(e) : e instanceof ws ? new r(e) : vh(e) ? Mt(r, e.bytes()) : ArrayBuffer.isView(e) ? e.byteLength <= 0 ? new r(0) : new r(e.buffer, e.byteOffset, e.byteLength / r.BYTES_PER_ELEMENT) : r.from(e)) : new r(0);
}
const Dr = (r) => Mt(Int32Array, r), ro = (r) => Mt(BigInt64Array, r), It = (r) => Mt(Uint8Array, r), Wi = (r) => (r.next(), r);
function* Ah(r, t) {
  const e = function* (s) {
    yield s;
  }, n = typeof t == "string" || ArrayBuffer.isView(t) || t instanceof ArrayBuffer || t instanceof ws ? e(t) : wi(t) ? t : e(t);
  return yield* Wi(function* (s) {
    let i = null;
    do
      i = s.next(yield Mt(r, i));
    while (!i.done);
  }(n[Symbol.iterator]())), new r();
}
const Eh = (r) => Ah(Uint8Array, r);
function pa(r, t) {
  return Ae(this, arguments, function* () {
    if (un(t))
      return yield wt(yield wt(yield* An(br(pa(r, yield wt(t))))));
    const n = function(a) {
      return Ae(this, arguments, function* () {
        yield yield wt(yield wt(a));
      });
    }, s = function(a) {
      return Ae(this, arguments, function* () {
        yield wt(yield* An(br(Wi(function* (c) {
          let d = null;
          do
            d = c.next(yield d?.value);
          while (!d.done);
        }(a[Symbol.iterator]())))));
      });
    }, i = typeof t == "string" || ArrayBuffer.isView(t) || t instanceof ArrayBuffer || t instanceof ws ? n(t) : wi(t) ? s(t) : gs(t) ? t : n(t);
    return yield wt(
      // otherwise if AsyncIterable, use it
      yield* An(br(Wi(function(a) {
        return Ae(this, arguments, function* () {
          let c = null;
          do
            c = yield wt(a.next(yield yield wt(Mt(r, c))));
          while (!c.done);
        });
      }(i[Symbol.asyncIterator]()))))
    ), yield wt(new r());
  });
}
const Th = (r) => pa(Uint8Array, r);
function Mh(r, t) {
  let e = 0;
  const n = r.length;
  if (n !== t.length)
    return !1;
  if (n > 0)
    do
      if (r[e] !== t[e])
        return !1;
    while (++e < n);
  return !0;
}
const ce = {
  fromIterable(r) {
    return bn(Oh(r));
  },
  fromAsyncIterable(r) {
    return bn(Fh(r));
  },
  fromDOMStream(r) {
    return bn(kh(r));
  },
  fromNodeStream(r) {
    return bn(Dh(r));
  },
  // @ts-ignore
  toDOMStream(r, t) {
    throw new Error('"toDOMStream" not available in this environment');
  },
  // @ts-ignore
  toNodeStream(r, t) {
    throw new Error('"toNodeStream" not available in this environment');
  }
}, bn = (r) => (r.next(), r);
function* Oh(r) {
  let t, e = !1, n = [], s, i, a, c = 0;
  function d() {
    return i === "peek" ? Ee(n, a)[0] : ([s, n, c] = Ee(n, a), s);
  }
  ({ cmd: i, size: a } = (yield null) || { cmd: "read", size: 0 });
  const p = Eh(r)[Symbol.iterator]();
  try {
    do
      if ({ done: t, value: s } = Number.isNaN(a - c) ? p.next() : p.next(a - c), !t && s.byteLength > 0 && (n.push(s), c += s.byteLength), t || a <= c)
        do
          ({ cmd: i, size: a } = yield d());
        while (a < c);
    while (!t);
  } catch (y) {
    (e = !0) && typeof p.throw == "function" && p.throw(y);
  } finally {
    e === !1 && typeof p.return == "function" && p.return(null);
  }
  return null;
}
function Fh(r) {
  return Ae(this, arguments, function* () {
    let e, n = !1, s = [], i, a, c, d = 0;
    function p() {
      return a === "peek" ? Ee(s, c)[0] : ([i, s, d] = Ee(s, c), i);
    }
    ({ cmd: a, size: c } = (yield yield wt(null)) || { cmd: "read", size: 0 });
    const y = Th(r)[Symbol.asyncIterator]();
    try {
      do
        if ({ done: e, value: i } = Number.isNaN(c - d) ? yield wt(y.next()) : yield wt(y.next(c - d)), !e && i.byteLength > 0 && (s.push(i), d += i.byteLength), e || c <= d)
          do
            ({ cmd: a, size: c } = yield yield wt(p()));
          while (c < d);
      while (!e);
    } catch (B) {
      (n = !0) && typeof y.throw == "function" && (yield wt(y.throw(B)));
    } finally {
      n === !1 && typeof y.return == "function" && (yield wt(y.return(new Uint8Array(0))));
    }
    return yield wt(null);
  });
}
function kh(r) {
  return Ae(this, arguments, function* () {
    let e = !1, n = !1, s = [], i, a, c, d = 0;
    function p() {
      return a === "peek" ? Ee(s, c)[0] : ([i, s, d] = Ee(s, c), i);
    }
    ({ cmd: a, size: c } = (yield yield wt(null)) || { cmd: "read", size: 0 });
    const y = new Nh(r);
    try {
      do
        if ({ done: e, value: i } = Number.isNaN(c - d) ? yield wt(y.read()) : yield wt(y.read(c - d)), !e && i.byteLength > 0 && (s.push(It(i)), d += i.byteLength), e || c <= d)
          do
            ({ cmd: a, size: c } = yield yield wt(p()));
          while (c < d);
      while (!e);
    } catch (B) {
      (n = !0) && (yield wt(y.cancel(B)));
    } finally {
      n === !1 ? yield wt(y.cancel()) : r.locked && y.releaseLock();
    }
    return yield wt(null);
  });
}
class Nh {
  constructor(t) {
    this.source = t, this.reader = null, this.reader = this.source.getReader(), this.reader.closed.catch(() => {
    });
  }
  get closed() {
    return this.reader ? this.reader.closed.catch(() => {
    }) : Promise.resolve();
  }
  releaseLock() {
    this.reader && this.reader.releaseLock(), this.reader = null;
  }
  cancel(t) {
    return gt(this, void 0, void 0, function* () {
      const { reader: e, source: n } = this;
      e && (yield e.cancel(t).catch(() => {
      })), n && n.locked && this.releaseLock();
    });
  }
  read(t) {
    return gt(this, void 0, void 0, function* () {
      if (t === 0)
        return { done: this.reader == null, value: new Uint8Array(0) };
      const e = yield this.reader.read();
      return !e.done && (e.value = It(e)), e;
    });
  }
}
const Ai = (r, t) => {
  const e = (s) => n([t, s]);
  let n;
  return [t, e, new Promise((s) => (n = s) && r.once(t, e))];
};
function Dh(r) {
  return Ae(this, arguments, function* () {
    const e = [];
    let n = "error", s = !1, i = null, a, c, d = 0, p = [], y;
    function B() {
      return a === "peek" ? Ee(p, c)[0] : ([y, p, d] = Ee(p, c), y);
    }
    if ({ cmd: a, size: c } = (yield yield wt(null)) || { cmd: "read", size: 0 }, r.isTTY)
      return yield yield wt(new Uint8Array(0)), yield wt(null);
    try {
      e[0] = Ai(r, "end"), e[1] = Ai(r, "error");
      do {
        if (e[2] = Ai(r, "readable"), [n, i] = yield wt(Promise.race(e.map((F) => F[2]))), n === "error")
          break;
        if ((s = n === "end") || (Number.isFinite(c - d) ? (y = It(r.read(c - d)), y.byteLength < c - d && (y = It(r.read()))) : y = It(r.read()), y.byteLength > 0 && (p.push(y), d += y.byteLength)), s || c <= d)
          do
            ({ cmd: a, size: c } = yield yield wt(B()));
          while (c < d);
      } while (!s);
    } finally {
      yield wt(R(e, n === "error" ? i : null));
    }
    return yield wt(null);
    function R(F, T) {
      return y = p = null, new Promise((U, O) => {
        for (const [N, P] of F)
          r.off(N, P);
        try {
          const N = r.destroy;
          N && N.call(r, T), T = void 0;
        } catch (N) {
          T = N || T;
        } finally {
          T != null ? O(T) : U();
        }
      });
    }
  });
}
var zt;
(function(r) {
  r[r.V1 = 0] = "V1", r[r.V2 = 1] = "V2", r[r.V3 = 2] = "V3", r[r.V4 = 3] = "V4", r[r.V5 = 4] = "V5";
})(zt || (zt = {}));
var re;
(function(r) {
  r[r.Sparse = 0] = "Sparse", r[r.Dense = 1] = "Dense";
})(re || (re = {}));
var Jt;
(function(r) {
  r[r.HALF = 0] = "HALF", r[r.SINGLE = 1] = "SINGLE", r[r.DOUBLE = 2] = "DOUBLE";
})(Jt || (Jt = {}));
var de;
(function(r) {
  r[r.DAY = 0] = "DAY", r[r.MILLISECOND = 1] = "MILLISECOND";
})(de || (de = {}));
var at;
(function(r) {
  r[r.SECOND = 0] = "SECOND", r[r.MILLISECOND = 1] = "MILLISECOND", r[r.MICROSECOND = 2] = "MICROSECOND", r[r.NANOSECOND = 3] = "NANOSECOND";
})(at || (at = {}));
var Te;
(function(r) {
  r[r.YEAR_MONTH = 0] = "YEAR_MONTH", r[r.DAY_TIME = 1] = "DAY_TIME", r[r.MONTH_DAY_NANO = 2] = "MONTH_DAY_NANO";
})(Te || (Te = {}));
const Ei = 2, Be = 4, Ne = 4, xt = 4, We = new Int32Array(2), no = new Float32Array(We.buffer), io = new Float64Array(We.buffer), _n = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;
var Zi;
(function(r) {
  r[r.UTF8_BYTES = 1] = "UTF8_BYTES", r[r.UTF16_STRING = 2] = "UTF16_STRING";
})(Zi || (Zi = {}));
let xr = class ya {
  /**
   * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
   */
  constructor(t) {
    this.bytes_ = t, this.position_ = 0, this.text_decoder_ = new TextDecoder();
  }
  /**
   * Create and allocate a new ByteBuffer with a given size.
   */
  static allocate(t) {
    return new ya(new Uint8Array(t));
  }
  clear() {
    this.position_ = 0;
  }
  /**
   * Get the underlying `Uint8Array`.
   */
  bytes() {
    return this.bytes_;
  }
  /**
   * Get the buffer's position.
   */
  position() {
    return this.position_;
  }
  /**
   * Set the buffer's position.
   */
  setPosition(t) {
    this.position_ = t;
  }
  /**
   * Get the buffer's capacity.
   */
  capacity() {
    return this.bytes_.length;
  }
  readInt8(t) {
    return this.readUint8(t) << 24 >> 24;
  }
  readUint8(t) {
    return this.bytes_[t];
  }
  readInt16(t) {
    return this.readUint16(t) << 16 >> 16;
  }
  readUint16(t) {
    return this.bytes_[t] | this.bytes_[t + 1] << 8;
  }
  readInt32(t) {
    return this.bytes_[t] | this.bytes_[t + 1] << 8 | this.bytes_[t + 2] << 16 | this.bytes_[t + 3] << 24;
  }
  readUint32(t) {
    return this.readInt32(t) >>> 0;
  }
  readInt64(t) {
    return BigInt.asIntN(64, BigInt(this.readUint32(t)) + (BigInt(this.readUint32(t + 4)) << BigInt(32)));
  }
  readUint64(t) {
    return BigInt.asUintN(64, BigInt(this.readUint32(t)) + (BigInt(this.readUint32(t + 4)) << BigInt(32)));
  }
  readFloat32(t) {
    return We[0] = this.readInt32(t), no[0];
  }
  readFloat64(t) {
    return We[_n ? 0 : 1] = this.readInt32(t), We[_n ? 1 : 0] = this.readInt32(t + 4), io[0];
  }
  writeInt8(t, e) {
    this.bytes_[t] = e;
  }
  writeUint8(t, e) {
    this.bytes_[t] = e;
  }
  writeInt16(t, e) {
    this.bytes_[t] = e, this.bytes_[t + 1] = e >> 8;
  }
  writeUint16(t, e) {
    this.bytes_[t] = e, this.bytes_[t + 1] = e >> 8;
  }
  writeInt32(t, e) {
    this.bytes_[t] = e, this.bytes_[t + 1] = e >> 8, this.bytes_[t + 2] = e >> 16, this.bytes_[t + 3] = e >> 24;
  }
  writeUint32(t, e) {
    this.bytes_[t] = e, this.bytes_[t + 1] = e >> 8, this.bytes_[t + 2] = e >> 16, this.bytes_[t + 3] = e >> 24;
  }
  writeInt64(t, e) {
    this.writeInt32(t, Number(BigInt.asIntN(32, e))), this.writeInt32(t + 4, Number(BigInt.asIntN(32, e >> BigInt(32))));
  }
  writeUint64(t, e) {
    this.writeUint32(t, Number(BigInt.asUintN(32, e))), this.writeUint32(t + 4, Number(BigInt.asUintN(32, e >> BigInt(32))));
  }
  writeFloat32(t, e) {
    no[0] = e, this.writeInt32(t, We[0]);
  }
  writeFloat64(t, e) {
    io[0] = e, this.writeInt32(t, We[_n ? 0 : 1]), this.writeInt32(t + 4, We[_n ? 1 : 0]);
  }
  /**
   * Return the file identifier.   Behavior is undefined for FlatBuffers whose
   * schema does not include a file_identifier (likely points at padding or the
   * start of a the root vtable).
   */
  getBufferIdentifier() {
    if (this.bytes_.length < this.position_ + Be + Ne)
      throw new Error("FlatBuffers: ByteBuffer is too short to contain an identifier.");
    let t = "";
    for (let e = 0; e < Ne; e++)
      t += String.fromCharCode(this.readInt8(this.position_ + Be + e));
    return t;
  }
  /**
   * Look up a field in the vtable, return an offset into the object, or 0 if the
   * field is not present.
   */
  __offset(t, e) {
    const n = t - this.readInt32(t);
    return e < this.readInt16(n) ? this.readInt16(n + e) : 0;
  }
  /**
   * Initialize any Table-derived type to point to the union at the given offset.
   */
  __union(t, e) {
    return t.bb_pos = e + this.readInt32(e), t.bb = this, t;
  }
  /**
   * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
   * This allocates a new string and converts to wide chars upon each access.
   *
   * To avoid the conversion to string, pass Encoding.UTF8_BYTES as the
   * "optionalEncoding" argument. This is useful for avoiding conversion when
   * the data will just be packaged back up in another FlatBuffer later on.
   *
   * @param offset
   * @param opt_encoding Defaults to UTF16_STRING
   */
  __string(t, e) {
    t += this.readInt32(t);
    const n = this.readInt32(t);
    t += Be;
    const s = this.bytes_.subarray(t, t + n);
    return e === Zi.UTF8_BYTES ? s : this.text_decoder_.decode(s);
  }
  /**
   * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
   * if a string then return a new one
   *
   * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
   * makes the behaviour of __union_with_string different compared to __union
   */
  __union_with_string(t, e) {
    return typeof t == "string" ? this.__string(e) : this.__union(t, e);
  }
  /**
   * Retrieve the relative offset stored at "offset"
   */
  __indirect(t) {
    return t + this.readInt32(t);
  }
  /**
   * Get the start of data of a vector whose offset is stored at "offset" in this object.
   */
  __vector(t) {
    return t + this.readInt32(t) + Be;
  }
  /**
   * Get the length of a vector whose offset is stored at "offset" in this object.
   */
  __vector_len(t) {
    return this.readInt32(t + this.readInt32(t));
  }
  __has_identifier(t) {
    if (t.length != Ne)
      throw new Error("FlatBuffers: file identifier must be length " + Ne);
    for (let e = 0; e < Ne; e++)
      if (t.charCodeAt(e) != this.readInt8(this.position() + Be + e))
        return !1;
    return !0;
  }
  /**
   * A helper function for generating list for obj api
   */
  createScalarList(t, e) {
    const n = [];
    for (let s = 0; s < e; ++s) {
      const i = t(s);
      i !== null && n.push(i);
    }
    return n;
  }
  /**
   * A helper function for generating list for obj api
   * @param listAccessor function that accepts an index and return data at that index
   * @param listLength listLength
   * @param res result list
   */
  createObjList(t, e) {
    const n = [];
    for (let s = 0; s < e; ++s) {
      const i = t(s);
      i !== null && n.push(i.unpack());
    }
    return n;
  }
}, ga = class ma {
  /**
   * Create a FlatBufferBuilder.
   */
  constructor(t) {
    this.minalign = 1, this.vtable = null, this.vtable_in_use = 0, this.isNested = !1, this.object_start = 0, this.vtables = [], this.vector_num_elems = 0, this.force_defaults = !1, this.string_maps = null, this.text_encoder = new TextEncoder();
    let e;
    t ? e = t : e = 1024, this.bb = xr.allocate(e), this.space = e;
  }
  clear() {
    this.bb.clear(), this.space = this.bb.capacity(), this.minalign = 1, this.vtable = null, this.vtable_in_use = 0, this.isNested = !1, this.object_start = 0, this.vtables = [], this.vector_num_elems = 0, this.force_defaults = !1, this.string_maps = null;
  }
  /**
   * In order to save space, fields that are set to their default value
   * don't get serialized into the buffer. Forcing defaults provides a
   * way to manually disable this optimization.
   *
   * @param forceDefaults true always serializes default values
   */
  forceDefaults(t) {
    this.force_defaults = t;
  }
  /**
   * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
   * called finish(). The actual data starts at the ByteBuffer's current position,
   * not necessarily at 0.
   */
  dataBuffer() {
    return this.bb;
  }
  /**
   * Get the bytes representing the FlatBuffer. Only call this after you've
   * called finish().
   */
  asUint8Array() {
    return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
  }
  /**
   * Prepare to write an element of `size` after `additional_bytes` have been
   * written, e.g. if you write a string, you need to align such the int length
   * field is aligned to 4 bytes, and the string data follows it directly. If all
   * you need to do is alignment, `additional_bytes` will be 0.
   *
   * @param size This is the of the new element to write
   * @param additional_bytes The padding size
   */
  prep(t, e) {
    t > this.minalign && (this.minalign = t);
    const n = ~(this.bb.capacity() - this.space + e) + 1 & t - 1;
    for (; this.space < n + t + e; ) {
      const s = this.bb.capacity();
      this.bb = ma.growByteBuffer(this.bb), this.space += this.bb.capacity() - s;
    }
    this.pad(n);
  }
  pad(t) {
    for (let e = 0; e < t; e++)
      this.bb.writeInt8(--this.space, 0);
  }
  writeInt8(t) {
    this.bb.writeInt8(this.space -= 1, t);
  }
  writeInt16(t) {
    this.bb.writeInt16(this.space -= 2, t);
  }
  writeInt32(t) {
    this.bb.writeInt32(this.space -= 4, t);
  }
  writeInt64(t) {
    this.bb.writeInt64(this.space -= 8, t);
  }
  writeFloat32(t) {
    this.bb.writeFloat32(this.space -= 4, t);
  }
  writeFloat64(t) {
    this.bb.writeFloat64(this.space -= 8, t);
  }
  /**
   * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int8` to add the buffer.
   */
  addInt8(t) {
    this.prep(1, 0), this.writeInt8(t);
  }
  /**
   * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int16` to add the buffer.
   */
  addInt16(t) {
    this.prep(2, 0), this.writeInt16(t);
  }
  /**
   * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int32` to add the buffer.
   */
  addInt32(t) {
    this.prep(4, 0), this.writeInt32(t);
  }
  /**
   * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int64` to add the buffer.
   */
  addInt64(t) {
    this.prep(8, 0), this.writeInt64(t);
  }
  /**
   * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float32` to add the buffer.
   */
  addFloat32(t) {
    this.prep(4, 0), this.writeFloat32(t);
  }
  /**
   * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float64` to add the buffer.
   */
  addFloat64(t) {
    this.prep(8, 0), this.writeFloat64(t);
  }
  addFieldInt8(t, e, n) {
    (this.force_defaults || e != n) && (this.addInt8(e), this.slot(t));
  }
  addFieldInt16(t, e, n) {
    (this.force_defaults || e != n) && (this.addInt16(e), this.slot(t));
  }
  addFieldInt32(t, e, n) {
    (this.force_defaults || e != n) && (this.addInt32(e), this.slot(t));
  }
  addFieldInt64(t, e, n) {
    (this.force_defaults || e !== n) && (this.addInt64(e), this.slot(t));
  }
  addFieldFloat32(t, e, n) {
    (this.force_defaults || e != n) && (this.addFloat32(e), this.slot(t));
  }
  addFieldFloat64(t, e, n) {
    (this.force_defaults || e != n) && (this.addFloat64(e), this.slot(t));
  }
  addFieldOffset(t, e, n) {
    (this.force_defaults || e != n) && (this.addOffset(e), this.slot(t));
  }
  /**
   * Structs are stored inline, so nothing additional is being added. `d` is always 0.
   */
  addFieldStruct(t, e, n) {
    e != n && (this.nested(e), this.slot(t));
  }
  /**
   * Structures are always stored inline, they need to be created right
   * where they're used.  You'll get this assertion failure if you
   * created it elsewhere.
   */
  nested(t) {
    if (t != this.offset())
      throw new TypeError("FlatBuffers: struct must be serialized inline.");
  }
  /**
   * Should not be creating any other object, string or vector
   * while an object is being constructed
   */
  notNested() {
    if (this.isNested)
      throw new TypeError("FlatBuffers: object serialization must not be nested.");
  }
  /**
   * Set the current vtable at `voffset` to the current location in the buffer.
   */
  slot(t) {
    this.vtable !== null && (this.vtable[t] = this.offset());
  }
  /**
   * @returns Offset relative to the end of the buffer.
   */
  offset() {
    return this.bb.capacity() - this.space;
  }
  /**
   * Doubles the size of the backing ByteBuffer and copies the old data towards
   * the end of the new buffer (since we build the buffer backwards).
   *
   * @param bb The current buffer with the existing data
   * @returns A new byte buffer with the old data copied
   * to it. The data is located at the end of the buffer.
   *
   * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
   * it a uint8Array we need to suppress the type check:
   * @suppress {checkTypes}
   */
  static growByteBuffer(t) {
    const e = t.capacity();
    if (e & 3221225472)
      throw new Error("FlatBuffers: cannot grow buffer beyond 2 gigabytes.");
    const n = e << 1, s = xr.allocate(n);
    return s.setPosition(n - e), s.bytes().set(t.bytes(), n - e), s;
  }
  /**
   * Adds on offset, relative to where it will be written.
   *
   * @param offset The offset to add.
   */
  addOffset(t) {
    this.prep(Be, 0), this.writeInt32(this.offset() - t + Be);
  }
  /**
   * Start encoding a new object in the buffer.  Users will not usually need to
   * call this directly. The FlatBuffers compiler will generate helper methods
   * that call this method internally.
   */
  startObject(t) {
    this.notNested(), this.vtable == null && (this.vtable = []), this.vtable_in_use = t;
    for (let e = 0; e < t; e++)
      this.vtable[e] = 0;
    this.isNested = !0, this.object_start = this.offset();
  }
  /**
   * Finish off writing the object that is under construction.
   *
   * @returns The offset to the object inside `dataBuffer`
   */
  endObject() {
    if (this.vtable == null || !this.isNested)
      throw new Error("FlatBuffers: endObject called without startObject");
    this.addInt32(0);
    const t = this.offset();
    let e = this.vtable_in_use - 1;
    for (; e >= 0 && this.vtable[e] == 0; e--)
      ;
    const n = e + 1;
    for (; e >= 0; e--)
      this.addInt16(this.vtable[e] != 0 ? t - this.vtable[e] : 0);
    const s = 2;
    this.addInt16(t - this.object_start);
    const i = (n + s) * Ei;
    this.addInt16(i);
    let a = 0;
    const c = this.space;
    t: for (e = 0; e < this.vtables.length; e++) {
      const d = this.bb.capacity() - this.vtables[e];
      if (i == this.bb.readInt16(d)) {
        for (let p = Ei; p < i; p += Ei)
          if (this.bb.readInt16(c + p) != this.bb.readInt16(d + p))
            continue t;
        a = this.vtables[e];
        break;
      }
    }
    return a ? (this.space = this.bb.capacity() - t, this.bb.writeInt32(this.space, a - t)) : (this.vtables.push(this.offset()), this.bb.writeInt32(this.bb.capacity() - t, this.offset() - t)), this.isNested = !1, t;
  }
  /**
   * Finalize a buffer, poiting to the given `root_table`.
   */
  finish(t, e, n) {
    const s = n ? xt : 0;
    if (e) {
      const i = e;
      if (this.prep(this.minalign, Be + Ne + s), i.length != Ne)
        throw new TypeError("FlatBuffers: file identifier must be length " + Ne);
      for (let a = Ne - 1; a >= 0; a--)
        this.writeInt8(i.charCodeAt(a));
    }
    this.prep(this.minalign, Be + s), this.addOffset(t), s && this.addInt32(this.bb.capacity() - this.space), this.bb.setPosition(this.space);
  }
  /**
   * Finalize a size prefixed buffer, pointing to the given `root_table`.
   */
  finishSizePrefixed(t, e) {
    this.finish(t, e, !0);
  }
  /**
   * This checks a required field has been set in a given table that has
   * just been constructed.
   */
  requiredField(t, e) {
    const n = this.bb.capacity() - t, s = n - this.bb.readInt32(n);
    if (!(e < this.bb.readInt16(s) && this.bb.readInt16(s + e) != 0))
      throw new TypeError("FlatBuffers: field " + e + " must be set");
  }
  /**
   * Start a new array/vector of objects.  Users usually will not call
   * this directly. The FlatBuffers compiler will create a start/end
   * method for vector types in generated code.
   *
   * @param elem_size The size of each element in the array
   * @param num_elems The number of elements in the array
   * @param alignment The alignment of the array
   */
  startVector(t, e, n) {
    this.notNested(), this.vector_num_elems = e, this.prep(Be, t * e), this.prep(n, t * e);
  }
  /**
   * Finish off the creation of an array and all its elements. The array must be
   * created with `startVector`.
   *
   * @returns The offset at which the newly created array
   * starts.
   */
  endVector() {
    return this.writeInt32(this.vector_num_elems), this.offset();
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If the string passed has
   * already been seen, we return the offset of the already written string
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createSharedString(t) {
    if (!t)
      return 0;
    if (this.string_maps || (this.string_maps = /* @__PURE__ */ new Map()), this.string_maps.has(t))
      return this.string_maps.get(t);
    const e = this.createString(t);
    return this.string_maps.set(t, e), e;
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
   * instead of a string, it is assumed to contain valid UTF-8 encoded data.
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createString(t) {
    if (t == null)
      return 0;
    let e;
    return t instanceof Uint8Array ? e = t : e = this.text_encoder.encode(t), this.addInt8(0), this.startVector(1, e.length, 1), this.bb.setPosition(this.space -= e.length), this.bb.bytes().set(e, this.space), this.endVector();
  }
  /**
   * Create a byte vector.
   *
   * @param v The bytes to add
   * @returns The offset in the buffer where the byte vector starts
   */
  createByteVector(t) {
    return t == null ? 0 : (this.startVector(1, t.length, 1), this.bb.setPosition(this.space -= t.length), this.bb.bytes().set(t, this.space), this.endVector());
  }
  /**
   * A helper function to pack an object
   *
   * @returns offset of obj
   */
  createObjectOffset(t) {
    return t === null ? 0 : typeof t == "string" ? this.createString(t) : t.pack(this);
  }
  /**
   * A helper function to pack a list of object
   *
   * @returns list of offsets of each non null object
   */
  createObjectOffsetList(t) {
    const e = [];
    for (let n = 0; n < t.length; ++n) {
      const s = t[n];
      if (s !== null)
        e.push(this.createObjectOffset(s));
      else
        throw new TypeError("FlatBuffers: Argument for createObjectOffsetList cannot contain null.");
    }
    return e;
  }
  createStructOffsetList(t, e) {
    return e(this, t.length), this.createObjectOffsetList(t.slice().reverse()), this.endVector();
  }
};
var Cn;
(function(r) {
  r[r.BUFFER = 0] = "BUFFER";
})(Cn || (Cn = {}));
var Rn;
(function(r) {
  r[r.LZ4_FRAME = 0] = "LZ4_FRAME", r[r.ZSTD = 1] = "ZSTD";
})(Rn || (Rn = {}));
class Ze {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsBodyCompression(t, e) {
    return (e || new Ze()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsBodyCompression(t, e) {
    return t.setPosition(t.position() + xt), (e || new Ze()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Compressor library.
   * For LZ4_FRAME, each compressed buffer must consist of a single frame.
   */
  codec() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt8(this.bb_pos + t) : Rn.LZ4_FRAME;
  }
  /**
   * Indicates the way the record batch body was compressed
   */
  method() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.readInt8(this.bb_pos + t) : Cn.BUFFER;
  }
  static startBodyCompression(t) {
    t.startObject(2);
  }
  static addCodec(t, e) {
    t.addFieldInt8(0, e, Rn.LZ4_FRAME);
  }
  static addMethod(t, e) {
    t.addFieldInt8(1, e, Cn.BUFFER);
  }
  static endBodyCompression(t) {
    return t.endObject();
  }
  static createBodyCompression(t, e, n) {
    return Ze.startBodyCompression(t), Ze.addCodec(t, e), Ze.addMethod(t, n), Ze.endBodyCompression(t);
  }
}
class wa {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  /**
   * The relative offset into the shared memory page where the bytes for this
   * buffer starts
   */
  offset() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * The absolute length (in bytes) of the memory buffer. The memory is found
   * from offset (inclusive) to offset + length (non-inclusive). When building
   * messages using the encapsulated IPC message, padding bytes may be written
   * after a buffer, but such padding bytes do not need to be accounted for in
   * the size here.
   */
  length() {
    return this.bb.readInt64(this.bb_pos + 8);
  }
  static sizeOf() {
    return 16;
  }
  static createBuffer(t, e, n) {
    return t.prep(8, 16), t.writeInt64(BigInt(n ?? 0)), t.writeInt64(BigInt(e ?? 0)), t.offset();
  }
}
let ba = class {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  /**
   * The number of value slots in the Arrow array at this level of a nested
   * tree
   */
  length() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * The number of observed nulls. Fields with null_count == 0 may choose not
   * to write their physical validity bitmap out as a materialized buffer,
   * instead setting the length of the bitmap buffer to 0.
   */
  nullCount() {
    return this.bb.readInt64(this.bb_pos + 8);
  }
  static sizeOf() {
    return 16;
  }
  static createFieldNode(t, e, n) {
    return t.prep(8, 16), t.writeInt64(BigInt(n ?? 0)), t.writeInt64(BigInt(e ?? 0)), t.offset();
  }
}, Oe = class Gi {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsRecordBatch(t, e) {
    return (e || new Gi()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsRecordBatch(t, e) {
    return t.setPosition(t.position() + xt), (e || new Gi()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * number of records / rows. The arrays in the batch should all have this
   * length
   */
  length() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt64(this.bb_pos + t) : BigInt("0");
  }
  /**
   * Nodes correspond to the pre-ordered flattened logical schema
   */
  nodes(t, e) {
    const n = this.bb.__offset(this.bb_pos, 6);
    return n ? (e || new ba()).__init(this.bb.__vector(this.bb_pos + n) + t * 16, this.bb) : null;
  }
  nodesLength() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * Buffers correspond to the pre-ordered flattened buffer tree
   *
   * The number of buffers appended to this list depends on the schema. For
   * example, most primitive arrays will have 2 buffers, 1 for the validity
   * bitmap and 1 for the values. For struct arrays, there will only be a
   * single buffer for the validity (nulls) bitmap
   */
  buffers(t, e) {
    const n = this.bb.__offset(this.bb_pos, 8);
    return n ? (e || new wa()).__init(this.bb.__vector(this.bb_pos + n) + t * 16, this.bb) : null;
  }
  buffersLength() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * Optional compression of the message body
   */
  compression(t) {
    const e = this.bb.__offset(this.bb_pos, 10);
    return e ? (t || new Ze()).__init(this.bb.__indirect(this.bb_pos + e), this.bb) : null;
  }
  static startRecordBatch(t) {
    t.startObject(4);
  }
  static addLength(t, e) {
    t.addFieldInt64(0, e, BigInt("0"));
  }
  static addNodes(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static startNodesVector(t, e) {
    t.startVector(16, e, 8);
  }
  static addBuffers(t, e) {
    t.addFieldOffset(2, e, 0);
  }
  static startBuffersVector(t, e) {
    t.startVector(16, e, 8);
  }
  static addCompression(t, e) {
    t.addFieldOffset(3, e, 0);
  }
  static endRecordBatch(t) {
    return t.endObject();
  }
}, ar = class Yi {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsDictionaryBatch(t, e) {
    return (e || new Yi()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDictionaryBatch(t, e) {
    return t.setPosition(t.position() + xt), (e || new Yi()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  id() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt64(this.bb_pos + t) : BigInt("0");
  }
  data(t) {
    const e = this.bb.__offset(this.bb_pos, 6);
    return e ? (t || new Oe()).__init(this.bb.__indirect(this.bb_pos + e), this.bb) : null;
  }
  /**
   * If isDelta is true the values in the dictionary are to be appended to a
   * dictionary with the indicated id. If isDelta is false this dictionary
   * should replace the existing dictionary.
   */
  isDelta() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  static startDictionaryBatch(t) {
    t.startObject(3);
  }
  static addId(t, e) {
    t.addFieldInt64(0, e, BigInt("0"));
  }
  static addData(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static addIsDelta(t, e) {
    t.addFieldInt8(2, +e, 0);
  }
  static endDictionaryBatch(t) {
    return t.endObject();
  }
};
var Ar;
(function(r) {
  r[r.Little = 0] = "Little", r[r.Big = 1] = "Big";
})(Ar || (Ar = {}));
var Pn;
(function(r) {
  r[r.DenseArray = 0] = "DenseArray";
})(Pn || (Pn = {}));
class oe {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsInt(t, e) {
    return (e || new oe()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsInt(t, e) {
    return t.setPosition(t.position() + xt), (e || new oe()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  bitWidth() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  isSigned() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  static startInt(t) {
    t.startObject(2);
  }
  static addBitWidth(t, e) {
    t.addFieldInt32(0, e, 0);
  }
  static addIsSigned(t, e) {
    t.addFieldInt8(1, +e, 0);
  }
  static endInt(t) {
    return t.endObject();
  }
  static createInt(t, e, n) {
    return oe.startInt(t), oe.addBitWidth(t, e), oe.addIsSigned(t, n), oe.endInt(t);
  }
}
class De {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsDictionaryEncoding(t, e) {
    return (e || new De()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDictionaryEncoding(t, e) {
    return t.setPosition(t.position() + xt), (e || new De()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * The known dictionary id in the application where this data is used. In
   * the file or streaming formats, the dictionary ids are found in the
   * DictionaryBatch messages
   */
  id() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt64(this.bb_pos + t) : BigInt("0");
  }
  /**
   * The dictionary indices are constrained to be non-negative integers. If
   * this field is null, the indices must be signed int32. To maximize
   * cross-language compatibility and performance, implementations are
   * recommended to prefer signed integer types over unsigned integer types
   * and to avoid uint64 indices unless they are required by an application.
   */
  indexType(t) {
    const e = this.bb.__offset(this.bb_pos, 6);
    return e ? (t || new oe()).__init(this.bb.__indirect(this.bb_pos + e), this.bb) : null;
  }
  /**
   * By default, dictionaries are not ordered, or the order does not have
   * semantic meaning. In some statistical, applications, dictionary-encoding
   * is used to represent ordered categorical data, and we provide a way to
   * preserve that metadata here
   */
  isOrdered() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  dictionaryKind() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.readInt16(this.bb_pos + t) : Pn.DenseArray;
  }
  static startDictionaryEncoding(t) {
    t.startObject(4);
  }
  static addId(t, e) {
    t.addFieldInt64(0, e, BigInt("0"));
  }
  static addIndexType(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static addIsOrdered(t, e) {
    t.addFieldInt8(2, +e, 0);
  }
  static addDictionaryKind(t, e) {
    t.addFieldInt16(3, e, Pn.DenseArray);
  }
  static endDictionaryEncoding(t) {
    return t.endObject();
  }
}
class jt {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsKeyValue(t, e) {
    return (e || new jt()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsKeyValue(t, e) {
    return t.setPosition(t.position() + xt), (e || new jt()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  key(t) {
    const e = this.bb.__offset(this.bb_pos, 4);
    return e ? this.bb.__string(this.bb_pos + e, t) : null;
  }
  value(t) {
    const e = this.bb.__offset(this.bb_pos, 6);
    return e ? this.bb.__string(this.bb_pos + e, t) : null;
  }
  static startKeyValue(t) {
    t.startObject(2);
  }
  static addKey(t, e) {
    t.addFieldOffset(0, e, 0);
  }
  static addValue(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static endKeyValue(t) {
    return t.endObject();
  }
  static createKeyValue(t, e, n) {
    return jt.startKeyValue(t), jt.addKey(t, e), jt.addValue(t, n), jt.endKeyValue(t);
  }
}
let so = class Xr {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsBinary(t, e) {
    return (e || new Xr()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsBinary(t, e) {
    return t.setPosition(t.position() + xt), (e || new Xr()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startBinary(t) {
    t.startObject(0);
  }
  static endBinary(t) {
    return t.endObject();
  }
  static createBinary(t) {
    return Xr.startBinary(t), Xr.endBinary(t);
  }
}, oo = class Qr {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsBool(t, e) {
    return (e || new Qr()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsBool(t, e) {
    return t.setPosition(t.position() + xt), (e || new Qr()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startBool(t) {
    t.startObject(0);
  }
  static endBool(t) {
    return t.endObject();
  }
  static createBool(t) {
    return Qr.startBool(t), Qr.endBool(t);
  }
}, En = class cr {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsDate(t, e) {
    return (e || new cr()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDate(t, e) {
    return t.setPosition(t.position() + xt), (e || new cr()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : de.MILLISECOND;
  }
  static startDate(t) {
    t.startObject(1);
  }
  static addUnit(t, e) {
    t.addFieldInt16(0, e, de.MILLISECOND);
  }
  static endDate(t) {
    return t.endObject();
  }
  static createDate(t, e) {
    return cr.startDate(t), cr.addUnit(t, e), cr.endDate(t);
  }
}, ur = class Ve {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsDecimal(t, e) {
    return (e || new Ve()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDecimal(t, e) {
    return t.setPosition(t.position() + xt), (e || new Ve()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Total number of decimal digits
   */
  precision() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  /**
   * Number of digits after the decimal point "."
   */
  scale() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  /**
   * Number of bits per value. The only accepted widths are 128 and 256.
   * We use bitWidth for consistency with Int::bitWidth.
   */
  bitWidth() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.readInt32(this.bb_pos + t) : 128;
  }
  static startDecimal(t) {
    t.startObject(3);
  }
  static addPrecision(t, e) {
    t.addFieldInt32(0, e, 0);
  }
  static addScale(t, e) {
    t.addFieldInt32(1, e, 0);
  }
  static addBitWidth(t, e) {
    t.addFieldInt32(2, e, 128);
  }
  static endDecimal(t) {
    return t.endObject();
  }
  static createDecimal(t, e, n, s) {
    return Ve.startDecimal(t), Ve.addPrecision(t, e), Ve.addScale(t, n), Ve.addBitWidth(t, s), Ve.endDecimal(t);
  }
}, Tn = class hr {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsDuration(t, e) {
    return (e || new hr()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDuration(t, e) {
    return t.setPosition(t.position() + xt), (e || new hr()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : at.MILLISECOND;
  }
  static startDuration(t) {
    t.startObject(1);
  }
  static addUnit(t, e) {
    t.addFieldInt16(0, e, at.MILLISECOND);
  }
  static endDuration(t) {
    return t.endObject();
  }
  static createDuration(t, e) {
    return hr.startDuration(t), hr.addUnit(t, e), hr.endDuration(t);
  }
}, Mn = class lr {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsFixedSizeBinary(t, e) {
    return (e || new lr()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsFixedSizeBinary(t, e) {
    return t.setPosition(t.position() + xt), (e || new lr()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Number of bytes per value
   */
  byteWidth() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  static startFixedSizeBinary(t) {
    t.startObject(1);
  }
  static addByteWidth(t, e) {
    t.addFieldInt32(0, e, 0);
  }
  static endFixedSizeBinary(t) {
    return t.endObject();
  }
  static createFixedSizeBinary(t, e) {
    return lr.startFixedSizeBinary(t), lr.addByteWidth(t, e), lr.endFixedSizeBinary(t);
  }
}, On = class dr {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsFixedSizeList(t, e) {
    return (e || new dr()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsFixedSizeList(t, e) {
    return t.setPosition(t.position() + xt), (e || new dr()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Number of list items per value
   */
  listSize() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  static startFixedSizeList(t) {
    t.startObject(1);
  }
  static addListSize(t, e) {
    t.addFieldInt32(0, e, 0);
  }
  static endFixedSizeList(t) {
    return t.endObject();
  }
  static createFixedSizeList(t, e) {
    return dr.startFixedSizeList(t), dr.addListSize(t, e), dr.endFixedSizeList(t);
  }
};
class ve {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsFloatingPoint(t, e) {
    return (e || new ve()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsFloatingPoint(t, e) {
    return t.setPosition(t.position() + xt), (e || new ve()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  precision() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : Jt.HALF;
  }
  static startFloatingPoint(t) {
    t.startObject(1);
  }
  static addPrecision(t, e) {
    t.addFieldInt16(0, e, Jt.HALF);
  }
  static endFloatingPoint(t) {
    return t.endObject();
  }
  static createFloatingPoint(t, e) {
    return ve.startFloatingPoint(t), ve.addPrecision(t, e), ve.endFloatingPoint(t);
  }
}
class xe {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsInterval(t, e) {
    return (e || new xe()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsInterval(t, e) {
    return t.setPosition(t.position() + xt), (e || new xe()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : Te.YEAR_MONTH;
  }
  static startInterval(t) {
    t.startObject(1);
  }
  static addUnit(t, e) {
    t.addFieldInt16(0, e, Te.YEAR_MONTH);
  }
  static endInterval(t) {
    return t.endObject();
  }
  static createInterval(t, e) {
    return xe.startInterval(t), xe.addUnit(t, e), xe.endInterval(t);
  }
}
let ao = class tn {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsLargeBinary(t, e) {
    return (e || new tn()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsLargeBinary(t, e) {
    return t.setPosition(t.position() + xt), (e || new tn()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startLargeBinary(t) {
    t.startObject(0);
  }
  static endLargeBinary(t) {
    return t.endObject();
  }
  static createLargeBinary(t) {
    return tn.startLargeBinary(t), tn.endLargeBinary(t);
  }
}, co = class en {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsLargeUtf8(t, e) {
    return (e || new en()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsLargeUtf8(t, e) {
    return t.setPosition(t.position() + xt), (e || new en()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startLargeUtf8(t) {
    t.startObject(0);
  }
  static endLargeUtf8(t) {
    return t.endObject();
  }
  static createLargeUtf8(t) {
    return en.startLargeUtf8(t), en.endLargeUtf8(t);
  }
}, uo = class rn {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsList(t, e) {
    return (e || new rn()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsList(t, e) {
    return t.setPosition(t.position() + xt), (e || new rn()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startList(t) {
    t.startObject(0);
  }
  static endList(t) {
    return t.endObject();
  }
  static createList(t) {
    return rn.startList(t), rn.endList(t);
  }
}, Fn = class fr {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsMap(t, e) {
    return (e || new fr()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsMap(t, e) {
    return t.setPosition(t.position() + xt), (e || new fr()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Set to true if the keys within each value are sorted
   */
  keysSorted() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  static startMap(t) {
    t.startObject(1);
  }
  static addKeysSorted(t, e) {
    t.addFieldInt8(0, +e, 0);
  }
  static endMap(t) {
    return t.endObject();
  }
  static createMap(t, e) {
    return fr.startMap(t), fr.addKeysSorted(t, e), fr.endMap(t);
  }
}, ho = class nn {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsNull(t, e) {
    return (e || new nn()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsNull(t, e) {
    return t.setPosition(t.position() + xt), (e || new nn()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startNull(t) {
    t.startObject(0);
  }
  static endNull(t) {
    return t.endObject();
  }
  static createNull(t) {
    return nn.startNull(t), nn.endNull(t);
  }
};
class Xe {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsStruct_(t, e) {
    return (e || new Xe()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsStruct_(t, e) {
    return t.setPosition(t.position() + xt), (e || new Xe()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startStruct_(t) {
    t.startObject(0);
  }
  static endStruct_(t) {
    return t.endObject();
  }
  static createStruct_(t) {
    return Xe.startStruct_(t), Xe.endStruct_(t);
  }
}
class ue {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsTime(t, e) {
    return (e || new ue()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsTime(t, e) {
    return t.setPosition(t.position() + xt), (e || new ue()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : at.MILLISECOND;
  }
  bitWidth() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.readInt32(this.bb_pos + t) : 32;
  }
  static startTime(t) {
    t.startObject(2);
  }
  static addUnit(t, e) {
    t.addFieldInt16(0, e, at.MILLISECOND);
  }
  static addBitWidth(t, e) {
    t.addFieldInt32(1, e, 32);
  }
  static endTime(t) {
    return t.endObject();
  }
  static createTime(t, e, n) {
    return ue.startTime(t), ue.addUnit(t, e), ue.addBitWidth(t, n), ue.endTime(t);
  }
}
class he {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsTimestamp(t, e) {
    return (e || new he()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsTimestamp(t, e) {
    return t.setPosition(t.position() + xt), (e || new he()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : at.SECOND;
  }
  timezone(t) {
    const e = this.bb.__offset(this.bb_pos, 6);
    return e ? this.bb.__string(this.bb_pos + e, t) : null;
  }
  static startTimestamp(t) {
    t.startObject(2);
  }
  static addUnit(t, e) {
    t.addFieldInt16(0, e, at.SECOND);
  }
  static addTimezone(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static endTimestamp(t) {
    return t.endObject();
  }
  static createTimestamp(t, e, n) {
    return he.startTimestamp(t), he.addUnit(t, e), he.addTimezone(t, n), he.endTimestamp(t);
  }
}
class ee {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsUnion(t, e) {
    return (e || new ee()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsUnion(t, e) {
    return t.setPosition(t.position() + xt), (e || new ee()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  mode() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : re.Sparse;
  }
  typeIds(t) {
    const e = this.bb.__offset(this.bb_pos, 6);
    return e ? this.bb.readInt32(this.bb.__vector(this.bb_pos + e) + t * 4) : 0;
  }
  typeIdsLength() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  typeIdsArray() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? new Int32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  static startUnion(t) {
    t.startObject(2);
  }
  static addMode(t, e) {
    t.addFieldInt16(0, e, re.Sparse);
  }
  static addTypeIds(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static createTypeIdsVector(t, e) {
    t.startVector(4, e.length, 4);
    for (let n = e.length - 1; n >= 0; n--)
      t.addInt32(e[n]);
    return t.endVector();
  }
  static startTypeIdsVector(t, e) {
    t.startVector(4, e, 4);
  }
  static endUnion(t) {
    return t.endObject();
  }
  static createUnion(t, e, n) {
    return ee.startUnion(t), ee.addMode(t, e), ee.addTypeIds(t, n), ee.endUnion(t);
  }
}
let lo = class sn {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsUtf8(t, e) {
    return (e || new sn()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsUtf8(t, e) {
    return t.setPosition(t.position() + xt), (e || new sn()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startUtf8(t) {
    t.startObject(0);
  }
  static endUtf8(t) {
    return t.endObject();
  }
  static createUtf8(t) {
    return sn.startUtf8(t), sn.endUtf8(t);
  }
};
var Dt;
(function(r) {
  r[r.NONE = 0] = "NONE", r[r.Null = 1] = "Null", r[r.Int = 2] = "Int", r[r.FloatingPoint = 3] = "FloatingPoint", r[r.Binary = 4] = "Binary", r[r.Utf8 = 5] = "Utf8", r[r.Bool = 6] = "Bool", r[r.Decimal = 7] = "Decimal", r[r.Date = 8] = "Date", r[r.Time = 9] = "Time", r[r.Timestamp = 10] = "Timestamp", r[r.Interval = 11] = "Interval", r[r.List = 12] = "List", r[r.Struct_ = 13] = "Struct_", r[r.Union = 14] = "Union", r[r.FixedSizeBinary = 15] = "FixedSizeBinary", r[r.FixedSizeList = 16] = "FixedSizeList", r[r.Map = 17] = "Map", r[r.Duration = 18] = "Duration", r[r.LargeBinary = 19] = "LargeBinary", r[r.LargeUtf8 = 20] = "LargeUtf8", r[r.LargeList = 21] = "LargeList", r[r.RunEndEncoded = 22] = "RunEndEncoded";
})(Dt || (Dt = {}));
let ae = class kn {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsField(t, e) {
    return (e || new kn()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsField(t, e) {
    return t.setPosition(t.position() + xt), (e || new kn()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  name(t) {
    const e = this.bb.__offset(this.bb_pos, 4);
    return e ? this.bb.__string(this.bb_pos + e, t) : null;
  }
  /**
   * Whether or not this field can contain nulls. Should be true in general.
   */
  nullable() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  typeType() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.readUint8(this.bb_pos + t) : Dt.NONE;
  }
  /**
   * This is the type of the decoded value if the field is dictionary encoded.
   */
  type(t) {
    const e = this.bb.__offset(this.bb_pos, 10);
    return e ? this.bb.__union(t, this.bb_pos + e) : null;
  }
  /**
   * Present only if the field is dictionary encoded.
   */
  dictionary(t) {
    const e = this.bb.__offset(this.bb_pos, 12);
    return e ? (t || new De()).__init(this.bb.__indirect(this.bb_pos + e), this.bb) : null;
  }
  /**
   * children apply only to nested data types like Struct, List and Union. For
   * primitive types children will have length 0.
   */
  children(t, e) {
    const n = this.bb.__offset(this.bb_pos, 14);
    return n ? (e || new kn()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + t * 4), this.bb) : null;
  }
  childrenLength() {
    const t = this.bb.__offset(this.bb_pos, 14);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * User-defined metadata
   */
  customMetadata(t, e) {
    const n = this.bb.__offset(this.bb_pos, 16);
    return n ? (e || new jt()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + t * 4), this.bb) : null;
  }
  customMetadataLength() {
    const t = this.bb.__offset(this.bb_pos, 16);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startField(t) {
    t.startObject(7);
  }
  static addName(t, e) {
    t.addFieldOffset(0, e, 0);
  }
  static addNullable(t, e) {
    t.addFieldInt8(1, +e, 0);
  }
  static addTypeType(t, e) {
    t.addFieldInt8(2, e, Dt.NONE);
  }
  static addType(t, e) {
    t.addFieldOffset(3, e, 0);
  }
  static addDictionary(t, e) {
    t.addFieldOffset(4, e, 0);
  }
  static addChildren(t, e) {
    t.addFieldOffset(5, e, 0);
  }
  static createChildrenVector(t, e) {
    t.startVector(4, e.length, 4);
    for (let n = e.length - 1; n >= 0; n--)
      t.addOffset(e[n]);
    return t.endVector();
  }
  static startChildrenVector(t, e) {
    t.startVector(4, e, 4);
  }
  static addCustomMetadata(t, e) {
    t.addFieldOffset(6, e, 0);
  }
  static createCustomMetadataVector(t, e) {
    t.startVector(4, e.length, 4);
    for (let n = e.length - 1; n >= 0; n--)
      t.addOffset(e[n]);
    return t.endVector();
  }
  static startCustomMetadataVector(t, e) {
    t.startVector(4, e, 4);
  }
  static endField(t) {
    return t.endObject();
  }
}, Se = class Me {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsSchema(t, e) {
    return (e || new Me()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsSchema(t, e) {
    return t.setPosition(t.position() + xt), (e || new Me()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * endianness of the buffer
   * it is Little Endian by default
   * if endianness doesn't match the underlying system then the vectors need to be converted
   */
  endianness() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : Ar.Little;
  }
  fields(t, e) {
    const n = this.bb.__offset(this.bb_pos, 6);
    return n ? (e || new ae()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + t * 4), this.bb) : null;
  }
  fieldsLength() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  customMetadata(t, e) {
    const n = this.bb.__offset(this.bb_pos, 8);
    return n ? (e || new jt()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + t * 4), this.bb) : null;
  }
  customMetadataLength() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * Features used in the stream/file.
   */
  features(t) {
    const e = this.bb.__offset(this.bb_pos, 10);
    return e ? this.bb.readInt64(this.bb.__vector(this.bb_pos + e) + t * 8) : BigInt(0);
  }
  featuresLength() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startSchema(t) {
    t.startObject(4);
  }
  static addEndianness(t, e) {
    t.addFieldInt16(0, e, Ar.Little);
  }
  static addFields(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static createFieldsVector(t, e) {
    t.startVector(4, e.length, 4);
    for (let n = e.length - 1; n >= 0; n--)
      t.addOffset(e[n]);
    return t.endVector();
  }
  static startFieldsVector(t, e) {
    t.startVector(4, e, 4);
  }
  static addCustomMetadata(t, e) {
    t.addFieldOffset(2, e, 0);
  }
  static createCustomMetadataVector(t, e) {
    t.startVector(4, e.length, 4);
    for (let n = e.length - 1; n >= 0; n--)
      t.addOffset(e[n]);
    return t.endVector();
  }
  static startCustomMetadataVector(t, e) {
    t.startVector(4, e, 4);
  }
  static addFeatures(t, e) {
    t.addFieldOffset(3, e, 0);
  }
  static createFeaturesVector(t, e) {
    t.startVector(8, e.length, 8);
    for (let n = e.length - 1; n >= 0; n--)
      t.addInt64(e[n]);
    return t.endVector();
  }
  static startFeaturesVector(t, e) {
    t.startVector(8, e, 8);
  }
  static endSchema(t) {
    return t.endObject();
  }
  static finishSchemaBuffer(t, e) {
    t.finish(e);
  }
  static finishSizePrefixedSchemaBuffer(t, e) {
    t.finish(e, void 0, !0);
  }
  static createSchema(t, e, n, s, i) {
    return Me.startSchema(t), Me.addEndianness(t, e), Me.addFields(t, n), Me.addCustomMetadata(t, s), Me.addFeatures(t, i), Me.endSchema(t);
  }
};
var Bt;
(function(r) {
  r[r.NONE = 0] = "NONE", r[r.Schema = 1] = "Schema", r[r.DictionaryBatch = 2] = "DictionaryBatch", r[r.RecordBatch = 3] = "RecordBatch", r[r.Tensor = 4] = "Tensor", r[r.SparseTensor = 5] = "SparseTensor";
})(Bt || (Bt = {}));
var A;
(function(r) {
  r[r.NONE = 0] = "NONE", r[r.Null = 1] = "Null", r[r.Int = 2] = "Int", r[r.Float = 3] = "Float", r[r.Binary = 4] = "Binary", r[r.Utf8 = 5] = "Utf8", r[r.Bool = 6] = "Bool", r[r.Decimal = 7] = "Decimal", r[r.Date = 8] = "Date", r[r.Time = 9] = "Time", r[r.Timestamp = 10] = "Timestamp", r[r.Interval = 11] = "Interval", r[r.List = 12] = "List", r[r.Struct = 13] = "Struct", r[r.Union = 14] = "Union", r[r.FixedSizeBinary = 15] = "FixedSizeBinary", r[r.FixedSizeList = 16] = "FixedSizeList", r[r.Map = 17] = "Map", r[r.Duration = 18] = "Duration", r[r.LargeBinary = 19] = "LargeBinary", r[r.LargeUtf8 = 20] = "LargeUtf8", r[r.Dictionary = -1] = "Dictionary", r[r.Int8 = -2] = "Int8", r[r.Int16 = -3] = "Int16", r[r.Int32 = -4] = "Int32", r[r.Int64 = -5] = "Int64", r[r.Uint8 = -6] = "Uint8", r[r.Uint16 = -7] = "Uint16", r[r.Uint32 = -8] = "Uint32", r[r.Uint64 = -9] = "Uint64", r[r.Float16 = -10] = "Float16", r[r.Float32 = -11] = "Float32", r[r.Float64 = -12] = "Float64", r[r.DateDay = -13] = "DateDay", r[r.DateMillisecond = -14] = "DateMillisecond", r[r.TimestampSecond = -15] = "TimestampSecond", r[r.TimestampMillisecond = -16] = "TimestampMillisecond", r[r.TimestampMicrosecond = -17] = "TimestampMicrosecond", r[r.TimestampNanosecond = -18] = "TimestampNanosecond", r[r.TimeSecond = -19] = "TimeSecond", r[r.TimeMillisecond = -20] = "TimeMillisecond", r[r.TimeMicrosecond = -21] = "TimeMicrosecond", r[r.TimeNanosecond = -22] = "TimeNanosecond", r[r.DenseUnion = -23] = "DenseUnion", r[r.SparseUnion = -24] = "SparseUnion", r[r.IntervalDayTime = -25] = "IntervalDayTime", r[r.IntervalYearMonth = -26] = "IntervalYearMonth", r[r.DurationSecond = -27] = "DurationSecond", r[r.DurationMillisecond = -28] = "DurationMillisecond", r[r.DurationMicrosecond = -29] = "DurationMicrosecond", r[r.DurationNanosecond = -30] = "DurationNanosecond";
})(A || (A = {}));
var Fe;
(function(r) {
  r[r.OFFSET = 0] = "OFFSET", r[r.DATA = 1] = "DATA", r[r.VALIDITY = 2] = "VALIDITY", r[r.TYPE = 3] = "TYPE";
})(Fe || (Fe = {}));
const Uh = void 0;
function hn(r) {
  if (r === null)
    return "null";
  if (r === Uh)
    return "undefined";
  switch (typeof r) {
    case "number":
      return `${r}`;
    case "bigint":
      return `${r}`;
    case "string":
      return `"${r}"`;
  }
  return typeof r[Symbol.toPrimitive] == "function" ? r[Symbol.toPrimitive]("string") : ArrayBuffer.isView(r) ? r instanceof BigInt64Array || r instanceof BigUint64Array ? `[${[...r].map((t) => hn(t))}]` : `[${r}]` : ArrayBuffer.isView(r) ? `[${r}]` : JSON.stringify(r, (t, e) => typeof e == "bigint" ? `${e}` : e);
}
function Lt(r) {
  if (typeof r == "bigint" && (r < Number.MIN_SAFE_INTEGER || r > Number.MAX_SAFE_INTEGER))
    throw new TypeError(`${r} is not safe to convert to a number.`);
  return Number(r);
}
function _a(r, t) {
  return Lt(r / t) + Lt(r % t) / Lt(t);
}
const Lh = Symbol.for("isArrowBigNum");
function be(r, ...t) {
  return t.length === 0 ? Object.setPrototypeOf(Mt(this.TypedArray, r), this.constructor.prototype) : Object.setPrototypeOf(new this.TypedArray(r, ...t), this.constructor.prototype);
}
be.prototype[Lh] = !0;
be.prototype.toJSON = function() {
  return `"${dn(this)}"`;
};
be.prototype.valueOf = function(r) {
  return Sa(this, r);
};
be.prototype.toString = function() {
  return dn(this);
};
be.prototype[Symbol.toPrimitive] = function(r = "default") {
  switch (r) {
    case "number":
      return Sa(this);
    case "string":
      return dn(this);
    case "default":
      return Ph(this);
  }
  return dn(this);
};
function _r(...r) {
  return be.apply(this, r);
}
function Sr(...r) {
  return be.apply(this, r);
}
function ln(...r) {
  return be.apply(this, r);
}
Object.setPrototypeOf(_r.prototype, Object.create(Int32Array.prototype));
Object.setPrototypeOf(Sr.prototype, Object.create(Uint32Array.prototype));
Object.setPrototypeOf(ln.prototype, Object.create(Uint32Array.prototype));
Object.assign(_r.prototype, be.prototype, { constructor: _r, signed: !0, TypedArray: Int32Array, BigIntArray: BigInt64Array });
Object.assign(Sr.prototype, be.prototype, { constructor: Sr, signed: !1, TypedArray: Uint32Array, BigIntArray: BigUint64Array });
Object.assign(ln.prototype, be.prototype, { constructor: ln, signed: !0, TypedArray: Uint32Array, BigIntArray: BigUint64Array });
const Ch = BigInt(4294967296) * BigInt(4294967296), Rh = Ch - BigInt(1);
function Sa(r, t) {
  const { buffer: e, byteOffset: n, byteLength: s, signed: i } = r, a = new BigUint64Array(e, n, s / 8), c = i && a.at(-1) & BigInt(1) << BigInt(63);
  let d = BigInt(0), p = 0;
  if (c) {
    for (const y of a)
      d |= (y ^ Rh) * (BigInt(1) << BigInt(64 * p++));
    d *= BigInt(-1), d -= BigInt(1);
  } else
    for (const y of a)
      d |= y * (BigInt(1) << BigInt(64 * p++));
  if (typeof t == "number") {
    const y = BigInt(Math.pow(10, t)), B = d / y, R = d % y;
    return Lt(B) + Lt(R) / Lt(y);
  }
  return Lt(d);
}
function dn(r) {
  if (r.byteLength === 8)
    return `${new r.BigIntArray(r.buffer, r.byteOffset, 1)[0]}`;
  if (!r.signed)
    return Ti(r);
  let t = new Uint16Array(r.buffer, r.byteOffset, r.byteLength / 2);
  if (new Int16Array([t.at(-1)])[0] >= 0)
    return Ti(r);
  t = t.slice();
  let n = 1;
  for (let i = 0; i < t.length; i++) {
    const a = t[i], c = ~a + n;
    t[i] = c, n &= a === 0 ? 1 : 0;
  }
  return `-${Ti(t)}`;
}
function Ph(r) {
  return r.byteLength === 8 ? new r.BigIntArray(r.buffer, r.byteOffset, 1)[0] : dn(r);
}
function Ti(r) {
  let t = "";
  const e = new Uint32Array(2);
  let n = new Uint16Array(r.buffer, r.byteOffset, r.byteLength / 2);
  const s = new Uint32Array((n = new Uint16Array(n).reverse()).buffer);
  let i = -1;
  const a = n.length - 1;
  do {
    for (e[0] = n[i = 0]; i < a; )
      n[i++] = e[1] = e[0] / 10, e[0] = (e[0] - e[1] * 10 << 16) + n[i];
    n[i] = e[1] = e[0] / 10, e[0] = e[0] - e[1] * 10, t = `${e[0]}${t}`;
  } while (s[0] || s[1] || s[2] || s[3]);
  return t ?? "0";
}
class bs {
  /** @nocollapse */
  static new(t, e) {
    switch (e) {
      case !0:
        return new _r(t);
      case !1:
        return new Sr(t);
    }
    switch (t.constructor) {
      case Int8Array:
      case Int16Array:
      case Int32Array:
      case BigInt64Array:
        return new _r(t);
    }
    return t.byteLength === 16 ? new ln(t) : new Sr(t);
  }
  /** @nocollapse */
  static signed(t) {
    return new _r(t);
  }
  /** @nocollapse */
  static unsigned(t) {
    return new Sr(t);
  }
  /** @nocollapse */
  static decimal(t) {
    return new ln(t);
  }
  constructor(t, e) {
    return bs.new(t, e);
  }
}
var Ia, Ba, va, xa, Aa, Ea, Ta, Ma, Oa, Fa, ka, Na, Da, Ua, La, Ca, Ra, Pa, $a, za, ja, Va;
class tt {
  /** @nocollapse */
  static isNull(t) {
    return t?.typeId === A.Null;
  }
  /** @nocollapse */
  static isInt(t) {
    return t?.typeId === A.Int;
  }
  /** @nocollapse */
  static isFloat(t) {
    return t?.typeId === A.Float;
  }
  /** @nocollapse */
  static isBinary(t) {
    return t?.typeId === A.Binary;
  }
  /** @nocollapse */
  static isLargeBinary(t) {
    return t?.typeId === A.LargeBinary;
  }
  /** @nocollapse */
  static isUtf8(t) {
    return t?.typeId === A.Utf8;
  }
  /** @nocollapse */
  static isLargeUtf8(t) {
    return t?.typeId === A.LargeUtf8;
  }
  /** @nocollapse */
  static isBool(t) {
    return t?.typeId === A.Bool;
  }
  /** @nocollapse */
  static isDecimal(t) {
    return t?.typeId === A.Decimal;
  }
  /** @nocollapse */
  static isDate(t) {
    return t?.typeId === A.Date;
  }
  /** @nocollapse */
  static isTime(t) {
    return t?.typeId === A.Time;
  }
  /** @nocollapse */
  static isTimestamp(t) {
    return t?.typeId === A.Timestamp;
  }
  /** @nocollapse */
  static isInterval(t) {
    return t?.typeId === A.Interval;
  }
  /** @nocollapse */
  static isDuration(t) {
    return t?.typeId === A.Duration;
  }
  /** @nocollapse */
  static isList(t) {
    return t?.typeId === A.List;
  }
  /** @nocollapse */
  static isStruct(t) {
    return t?.typeId === A.Struct;
  }
  /** @nocollapse */
  static isUnion(t) {
    return t?.typeId === A.Union;
  }
  /** @nocollapse */
  static isFixedSizeBinary(t) {
    return t?.typeId === A.FixedSizeBinary;
  }
  /** @nocollapse */
  static isFixedSizeList(t) {
    return t?.typeId === A.FixedSizeList;
  }
  /** @nocollapse */
  static isMap(t) {
    return t?.typeId === A.Map;
  }
  /** @nocollapse */
  static isDictionary(t) {
    return t?.typeId === A.Dictionary;
  }
  /** @nocollapse */
  static isDenseUnion(t) {
    return tt.isUnion(t) && t.mode === re.Dense;
  }
  /** @nocollapse */
  static isSparseUnion(t) {
    return tt.isUnion(t) && t.mode === re.Sparse;
  }
  constructor(t) {
    this.typeId = t;
  }
}
Ia = Symbol.toStringTag;
tt[Ia] = ((r) => (r.children = null, r.ArrayType = Array, r.OffsetArrayType = Int32Array, r[Symbol.toStringTag] = "DataType"))(tt.prototype);
class Ye extends tt {
  constructor() {
    super(A.Null);
  }
  toString() {
    return "Null";
  }
}
Ba = Symbol.toStringTag;
Ye[Ba] = ((r) => r[Symbol.toStringTag] = "Null")(Ye.prototype);
class er extends tt {
  constructor(t, e) {
    super(A.Int), this.isSigned = t, this.bitWidth = e;
  }
  get ArrayType() {
    switch (this.bitWidth) {
      case 8:
        return this.isSigned ? Int8Array : Uint8Array;
      case 16:
        return this.isSigned ? Int16Array : Uint16Array;
      case 32:
        return this.isSigned ? Int32Array : Uint32Array;
      case 64:
        return this.isSigned ? BigInt64Array : BigUint64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
  toString() {
    return `${this.isSigned ? "I" : "Ui"}nt${this.bitWidth}`;
  }
}
va = Symbol.toStringTag;
er[va] = ((r) => (r.isSigned = null, r.bitWidth = null, r[Symbol.toStringTag] = "Int"))(er.prototype);
class fn extends er {
  constructor() {
    super(!0, 32);
  }
  get ArrayType() {
    return Int32Array;
  }
}
Object.defineProperty(fn.prototype, "ArrayType", { value: Int32Array });
class $n extends tt {
  constructor(t) {
    super(A.Float), this.precision = t;
  }
  get ArrayType() {
    switch (this.precision) {
      case Jt.HALF:
        return Uint16Array;
      case Jt.SINGLE:
        return Float32Array;
      case Jt.DOUBLE:
        return Float64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
  toString() {
    return `Float${this.precision << 5 || 16}`;
  }
}
xa = Symbol.toStringTag;
$n[xa] = ((r) => (r.precision = null, r[Symbol.toStringTag] = "Float"))($n.prototype);
class zn extends tt {
  constructor() {
    super(A.Binary);
  }
  toString() {
    return "Binary";
  }
}
Aa = Symbol.toStringTag;
zn[Aa] = ((r) => (r.ArrayType = Uint8Array, r[Symbol.toStringTag] = "Binary"))(zn.prototype);
class jn extends tt {
  constructor() {
    super(A.LargeBinary);
  }
  toString() {
    return "LargeBinary";
  }
}
Ea = Symbol.toStringTag;
jn[Ea] = ((r) => (r.ArrayType = Uint8Array, r.OffsetArrayType = BigInt64Array, r[Symbol.toStringTag] = "LargeBinary"))(jn.prototype);
class Vn extends tt {
  constructor() {
    super(A.Utf8);
  }
  toString() {
    return "Utf8";
  }
}
Ta = Symbol.toStringTag;
Vn[Ta] = ((r) => (r.ArrayType = Uint8Array, r[Symbol.toStringTag] = "Utf8"))(Vn.prototype);
class Wn extends tt {
  constructor() {
    super(A.LargeUtf8);
  }
  toString() {
    return "LargeUtf8";
  }
}
Ma = Symbol.toStringTag;
Wn[Ma] = ((r) => (r.ArrayType = Uint8Array, r.OffsetArrayType = BigInt64Array, r[Symbol.toStringTag] = "LargeUtf8"))(Wn.prototype);
class Zn extends tt {
  constructor() {
    super(A.Bool);
  }
  toString() {
    return "Bool";
  }
}
Oa = Symbol.toStringTag;
Zn[Oa] = ((r) => (r.ArrayType = Uint8Array, r[Symbol.toStringTag] = "Bool"))(Zn.prototype);
class Gn extends tt {
  constructor(t, e, n = 128) {
    super(A.Decimal), this.scale = t, this.precision = e, this.bitWidth = n;
  }
  toString() {
    return `Decimal[${this.precision}e${this.scale > 0 ? "+" : ""}${this.scale}]`;
  }
}
Fa = Symbol.toStringTag;
Gn[Fa] = ((r) => (r.scale = null, r.precision = null, r.ArrayType = Uint32Array, r[Symbol.toStringTag] = "Decimal"))(Gn.prototype);
class Yn extends tt {
  constructor(t) {
    super(A.Date), this.unit = t;
  }
  toString() {
    return `Date${(this.unit + 1) * 32}<${de[this.unit]}>`;
  }
  get ArrayType() {
    return this.unit === de.DAY ? Int32Array : BigInt64Array;
  }
}
ka = Symbol.toStringTag;
Yn[ka] = ((r) => (r.unit = null, r[Symbol.toStringTag] = "Date"))(Yn.prototype);
class Jn extends tt {
  constructor(t, e) {
    super(A.Time), this.unit = t, this.bitWidth = e;
  }
  toString() {
    return `Time${this.bitWidth}<${at[this.unit]}>`;
  }
  get ArrayType() {
    switch (this.bitWidth) {
      case 32:
        return Int32Array;
      case 64:
        return BigInt64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
}
Na = Symbol.toStringTag;
Jn[Na] = ((r) => (r.unit = null, r.bitWidth = null, r[Symbol.toStringTag] = "Time"))(Jn.prototype);
class Hn extends tt {
  constructor(t, e) {
    super(A.Timestamp), this.unit = t, this.timezone = e;
  }
  toString() {
    return `Timestamp<${at[this.unit]}${this.timezone ? `, ${this.timezone}` : ""}>`;
  }
}
Da = Symbol.toStringTag;
Hn[Da] = ((r) => (r.unit = null, r.timezone = null, r.ArrayType = BigInt64Array, r[Symbol.toStringTag] = "Timestamp"))(Hn.prototype);
class qn extends tt {
  constructor(t) {
    super(A.Interval), this.unit = t;
  }
  toString() {
    return `Interval<${Te[this.unit]}>`;
  }
}
Ua = Symbol.toStringTag;
qn[Ua] = ((r) => (r.unit = null, r.ArrayType = Int32Array, r[Symbol.toStringTag] = "Interval"))(qn.prototype);
class Kn extends tt {
  constructor(t) {
    super(A.Duration), this.unit = t;
  }
  toString() {
    return `Duration<${at[this.unit]}>`;
  }
}
La = Symbol.toStringTag;
Kn[La] = ((r) => (r.unit = null, r.ArrayType = BigInt64Array, r[Symbol.toStringTag] = "Duration"))(Kn.prototype);
class Xn extends tt {
  constructor(t) {
    super(A.List), this.children = [t];
  }
  toString() {
    return `List<${this.valueType}>`;
  }
  get valueType() {
    return this.children[0].type;
  }
  get valueField() {
    return this.children[0];
  }
  get ArrayType() {
    return this.valueType.ArrayType;
  }
}
Ca = Symbol.toStringTag;
Xn[Ca] = ((r) => (r.children = null, r[Symbol.toStringTag] = "List"))(Xn.prototype);
class Kt extends tt {
  constructor(t) {
    super(A.Struct), this.children = t;
  }
  toString() {
    return `Struct<{${this.children.map((t) => `${t.name}:${t.type}`).join(", ")}}>`;
  }
}
Ra = Symbol.toStringTag;
Kt[Ra] = ((r) => (r.children = null, r[Symbol.toStringTag] = "Struct"))(Kt.prototype);
class Qn extends tt {
  constructor(t, e, n) {
    super(A.Union), this.mode = t, this.children = n, this.typeIds = e = Int32Array.from(e), this.typeIdToChildIndex = e.reduce((s, i, a) => (s[i] = a) && s || s, /* @__PURE__ */ Object.create(null));
  }
  toString() {
    return `${this[Symbol.toStringTag]}<${this.children.map((t) => `${t.type}`).join(" | ")}>`;
  }
}
Pa = Symbol.toStringTag;
Qn[Pa] = ((r) => (r.mode = null, r.typeIds = null, r.children = null, r.typeIdToChildIndex = null, r.ArrayType = Int8Array, r[Symbol.toStringTag] = "Union"))(Qn.prototype);
class ti extends tt {
  constructor(t) {
    super(A.FixedSizeBinary), this.byteWidth = t;
  }
  toString() {
    return `FixedSizeBinary[${this.byteWidth}]`;
  }
}
$a = Symbol.toStringTag;
ti[$a] = ((r) => (r.byteWidth = null, r.ArrayType = Uint8Array, r[Symbol.toStringTag] = "FixedSizeBinary"))(ti.prototype);
class ei extends tt {
  constructor(t, e) {
    super(A.FixedSizeList), this.listSize = t, this.children = [e];
  }
  get valueType() {
    return this.children[0].type;
  }
  get valueField() {
    return this.children[0];
  }
  get ArrayType() {
    return this.valueType.ArrayType;
  }
  toString() {
    return `FixedSizeList[${this.listSize}]<${this.valueType}>`;
  }
}
za = Symbol.toStringTag;
ei[za] = ((r) => (r.children = null, r.listSize = null, r[Symbol.toStringTag] = "FixedSizeList"))(ei.prototype);
class ri extends tt {
  constructor(t, e = !1) {
    var n, s, i;
    if (super(A.Map), this.children = [t], this.keysSorted = e, t && (t.name = "entries", !((n = t?.type) === null || n === void 0) && n.children)) {
      const a = (s = t?.type) === null || s === void 0 ? void 0 : s.children[0];
      a && (a.name = "key");
      const c = (i = t?.type) === null || i === void 0 ? void 0 : i.children[1];
      c && (c.name = "value");
    }
  }
  get keyType() {
    return this.children[0].type.children[0].type;
  }
  get valueType() {
    return this.children[0].type.children[1].type;
  }
  get childType() {
    return this.children[0].type;
  }
  toString() {
    return `Map<{${this.children[0].type.children.map((t) => `${t.name}:${t.type}`).join(", ")}}>`;
  }
}
ja = Symbol.toStringTag;
ri[ja] = ((r) => (r.children = null, r.keysSorted = null, r[Symbol.toStringTag] = "Map_"))(ri.prototype);
const $h = /* @__PURE__ */ ((r) => () => ++r)(-1);
class Er extends tt {
  constructor(t, e, n, s) {
    super(A.Dictionary), this.indices = e, this.dictionary = t, this.isOrdered = s || !1, this.id = n == null ? $h() : Lt(n);
  }
  get children() {
    return this.dictionary.children;
  }
  get valueType() {
    return this.dictionary;
  }
  get ArrayType() {
    return this.dictionary.ArrayType;
  }
  toString() {
    return `Dictionary<${this.indices}, ${this.dictionary}>`;
  }
}
Va = Symbol.toStringTag;
Er[Va] = ((r) => (r.id = null, r.indices = null, r.isOrdered = null, r.dictionary = null, r[Symbol.toStringTag] = "Dictionary"))(Er.prototype);
function ke(r) {
  const t = r;
  switch (r.typeId) {
    case A.Decimal:
      return r.bitWidth / 32;
    case A.Interval:
      return 1 + t.unit;
    // case Type.Int: return 1 + +((t as Int_).bitWidth > 32);
    // case Type.Time: return 1 + +((t as Time_).bitWidth > 32);
    case A.FixedSizeList:
      return t.listSize;
    case A.FixedSizeBinary:
      return t.byteWidth;
    default:
      return 1;
  }
}
class St {
  visitMany(t, ...e) {
    return t.map((n, s) => this.visit(n, ...e.map((i) => i[s])));
  }
  visit(...t) {
    return this.getVisitFn(t[0], !1).apply(this, t);
  }
  getVisitFn(t, e = !0) {
    return zh(this, t, e);
  }
  getVisitFnByTypeId(t, e = !0) {
    return pr(this, t, e);
  }
  visitNull(t, ...e) {
    return null;
  }
  visitBool(t, ...e) {
    return null;
  }
  visitInt(t, ...e) {
    return null;
  }
  visitFloat(t, ...e) {
    return null;
  }
  visitUtf8(t, ...e) {
    return null;
  }
  visitLargeUtf8(t, ...e) {
    return null;
  }
  visitBinary(t, ...e) {
    return null;
  }
  visitLargeBinary(t, ...e) {
    return null;
  }
  visitFixedSizeBinary(t, ...e) {
    return null;
  }
  visitDate(t, ...e) {
    return null;
  }
  visitTimestamp(t, ...e) {
    return null;
  }
  visitTime(t, ...e) {
    return null;
  }
  visitDecimal(t, ...e) {
    return null;
  }
  visitList(t, ...e) {
    return null;
  }
  visitStruct(t, ...e) {
    return null;
  }
  visitUnion(t, ...e) {
    return null;
  }
  visitDictionary(t, ...e) {
    return null;
  }
  visitInterval(t, ...e) {
    return null;
  }
  visitDuration(t, ...e) {
    return null;
  }
  visitFixedSizeList(t, ...e) {
    return null;
  }
  visitMap(t, ...e) {
    return null;
  }
}
function zh(r, t, e = !0) {
  return typeof t == "number" ? pr(r, t, e) : typeof t == "string" && t in A ? pr(r, A[t], e) : t && t instanceof tt ? pr(r, fo(t), e) : t?.type && t.type instanceof tt ? pr(r, fo(t.type), e) : pr(r, A.NONE, e);
}
function pr(r, t, e = !0) {
  let n = null;
  switch (t) {
    case A.Null:
      n = r.visitNull;
      break;
    case A.Bool:
      n = r.visitBool;
      break;
    case A.Int:
      n = r.visitInt;
      break;
    case A.Int8:
      n = r.visitInt8 || r.visitInt;
      break;
    case A.Int16:
      n = r.visitInt16 || r.visitInt;
      break;
    case A.Int32:
      n = r.visitInt32 || r.visitInt;
      break;
    case A.Int64:
      n = r.visitInt64 || r.visitInt;
      break;
    case A.Uint8:
      n = r.visitUint8 || r.visitInt;
      break;
    case A.Uint16:
      n = r.visitUint16 || r.visitInt;
      break;
    case A.Uint32:
      n = r.visitUint32 || r.visitInt;
      break;
    case A.Uint64:
      n = r.visitUint64 || r.visitInt;
      break;
    case A.Float:
      n = r.visitFloat;
      break;
    case A.Float16:
      n = r.visitFloat16 || r.visitFloat;
      break;
    case A.Float32:
      n = r.visitFloat32 || r.visitFloat;
      break;
    case A.Float64:
      n = r.visitFloat64 || r.visitFloat;
      break;
    case A.Utf8:
      n = r.visitUtf8;
      break;
    case A.LargeUtf8:
      n = r.visitLargeUtf8;
      break;
    case A.Binary:
      n = r.visitBinary;
      break;
    case A.LargeBinary:
      n = r.visitLargeBinary;
      break;
    case A.FixedSizeBinary:
      n = r.visitFixedSizeBinary;
      break;
    case A.Date:
      n = r.visitDate;
      break;
    case A.DateDay:
      n = r.visitDateDay || r.visitDate;
      break;
    case A.DateMillisecond:
      n = r.visitDateMillisecond || r.visitDate;
      break;
    case A.Timestamp:
      n = r.visitTimestamp;
      break;
    case A.TimestampSecond:
      n = r.visitTimestampSecond || r.visitTimestamp;
      break;
    case A.TimestampMillisecond:
      n = r.visitTimestampMillisecond || r.visitTimestamp;
      break;
    case A.TimestampMicrosecond:
      n = r.visitTimestampMicrosecond || r.visitTimestamp;
      break;
    case A.TimestampNanosecond:
      n = r.visitTimestampNanosecond || r.visitTimestamp;
      break;
    case A.Time:
      n = r.visitTime;
      break;
    case A.TimeSecond:
      n = r.visitTimeSecond || r.visitTime;
      break;
    case A.TimeMillisecond:
      n = r.visitTimeMillisecond || r.visitTime;
      break;
    case A.TimeMicrosecond:
      n = r.visitTimeMicrosecond || r.visitTime;
      break;
    case A.TimeNanosecond:
      n = r.visitTimeNanosecond || r.visitTime;
      break;
    case A.Decimal:
      n = r.visitDecimal;
      break;
    case A.List:
      n = r.visitList;
      break;
    case A.Struct:
      n = r.visitStruct;
      break;
    case A.Union:
      n = r.visitUnion;
      break;
    case A.DenseUnion:
      n = r.visitDenseUnion || r.visitUnion;
      break;
    case A.SparseUnion:
      n = r.visitSparseUnion || r.visitUnion;
      break;
    case A.Dictionary:
      n = r.visitDictionary;
      break;
    case A.Interval:
      n = r.visitInterval;
      break;
    case A.IntervalDayTime:
      n = r.visitIntervalDayTime || r.visitInterval;
      break;
    case A.IntervalYearMonth:
      n = r.visitIntervalYearMonth || r.visitInterval;
      break;
    case A.Duration:
      n = r.visitDuration;
      break;
    case A.DurationSecond:
      n = r.visitDurationSecond || r.visitDuration;
      break;
    case A.DurationMillisecond:
      n = r.visitDurationMillisecond || r.visitDuration;
      break;
    case A.DurationMicrosecond:
      n = r.visitDurationMicrosecond || r.visitDuration;
      break;
    case A.DurationNanosecond:
      n = r.visitDurationNanosecond || r.visitDuration;
      break;
    case A.FixedSizeList:
      n = r.visitFixedSizeList;
      break;
    case A.Map:
      n = r.visitMap;
      break;
  }
  if (typeof n == "function")
    return n;
  if (!e)
    return () => null;
  throw new Error(`Unrecognized type '${A[t]}'`);
}
function fo(r) {
  switch (r.typeId) {
    case A.Null:
      return A.Null;
    case A.Int: {
      const { bitWidth: t, isSigned: e } = r;
      switch (t) {
        case 8:
          return e ? A.Int8 : A.Uint8;
        case 16:
          return e ? A.Int16 : A.Uint16;
        case 32:
          return e ? A.Int32 : A.Uint32;
        case 64:
          return e ? A.Int64 : A.Uint64;
      }
      return A.Int;
    }
    case A.Float:
      switch (r.precision) {
        case Jt.HALF:
          return A.Float16;
        case Jt.SINGLE:
          return A.Float32;
        case Jt.DOUBLE:
          return A.Float64;
      }
      return A.Float;
    case A.Binary:
      return A.Binary;
    case A.LargeBinary:
      return A.LargeBinary;
    case A.Utf8:
      return A.Utf8;
    case A.LargeUtf8:
      return A.LargeUtf8;
    case A.Bool:
      return A.Bool;
    case A.Decimal:
      return A.Decimal;
    case A.Time:
      switch (r.unit) {
        case at.SECOND:
          return A.TimeSecond;
        case at.MILLISECOND:
          return A.TimeMillisecond;
        case at.MICROSECOND:
          return A.TimeMicrosecond;
        case at.NANOSECOND:
          return A.TimeNanosecond;
      }
      return A.Time;
    case A.Timestamp:
      switch (r.unit) {
        case at.SECOND:
          return A.TimestampSecond;
        case at.MILLISECOND:
          return A.TimestampMillisecond;
        case at.MICROSECOND:
          return A.TimestampMicrosecond;
        case at.NANOSECOND:
          return A.TimestampNanosecond;
      }
      return A.Timestamp;
    case A.Date:
      switch (r.unit) {
        case de.DAY:
          return A.DateDay;
        case de.MILLISECOND:
          return A.DateMillisecond;
      }
      return A.Date;
    case A.Interval:
      switch (r.unit) {
        case Te.DAY_TIME:
          return A.IntervalDayTime;
        case Te.YEAR_MONTH:
          return A.IntervalYearMonth;
      }
      return A.Interval;
    case A.Duration:
      switch (r.unit) {
        case at.SECOND:
          return A.DurationSecond;
        case at.MILLISECOND:
          return A.DurationMillisecond;
        case at.MICROSECOND:
          return A.DurationMicrosecond;
        case at.NANOSECOND:
          return A.DurationNanosecond;
      }
      return A.Duration;
    case A.Map:
      return A.Map;
    case A.List:
      return A.List;
    case A.Struct:
      return A.Struct;
    case A.Union:
      switch (r.mode) {
        case re.Dense:
          return A.DenseUnion;
        case re.Sparse:
          return A.SparseUnion;
      }
      return A.Union;
    case A.FixedSizeBinary:
      return A.FixedSizeBinary;
    case A.FixedSizeList:
      return A.FixedSizeList;
    case A.Dictionary:
      return A.Dictionary;
  }
  throw new Error(`Unrecognized type '${A[r.typeId]}'`);
}
St.prototype.visitInt8 = null;
St.prototype.visitInt16 = null;
St.prototype.visitInt32 = null;
St.prototype.visitInt64 = null;
St.prototype.visitUint8 = null;
St.prototype.visitUint16 = null;
St.prototype.visitUint32 = null;
St.prototype.visitUint64 = null;
St.prototype.visitFloat16 = null;
St.prototype.visitFloat32 = null;
St.prototype.visitFloat64 = null;
St.prototype.visitDateDay = null;
St.prototype.visitDateMillisecond = null;
St.prototype.visitTimestampSecond = null;
St.prototype.visitTimestampMillisecond = null;
St.prototype.visitTimestampMicrosecond = null;
St.prototype.visitTimestampNanosecond = null;
St.prototype.visitTimeSecond = null;
St.prototype.visitTimeMillisecond = null;
St.prototype.visitTimeMicrosecond = null;
St.prototype.visitTimeNanosecond = null;
St.prototype.visitDenseUnion = null;
St.prototype.visitSparseUnion = null;
St.prototype.visitIntervalDayTime = null;
St.prototype.visitIntervalYearMonth = null;
St.prototype.visitDuration = null;
St.prototype.visitDurationSecond = null;
St.prototype.visitDurationMillisecond = null;
St.prototype.visitDurationMicrosecond = null;
St.prototype.visitDurationNanosecond = null;
const Wa = new Float64Array(1), or = new Uint32Array(Wa.buffer);
function Za(r) {
  const t = (r & 31744) >> 10, e = (r & 1023) / 1024, n = Math.pow(-1, (r & 32768) >> 15);
  switch (t) {
    case 31:
      return n * (e ? Number.NaN : 1 / 0);
    case 0:
      return n * (e ? 6103515625e-14 * e : 0);
  }
  return n * Math.pow(2, t - 15) * (1 + e);
}
function jh(r) {
  if (r !== r)
    return 32256;
  Wa[0] = r;
  const t = (or[1] & 2147483648) >> 16 & 65535;
  let e = or[1] & 2146435072, n = 0;
  return e >= 1089470464 ? or[0] > 0 ? e = 31744 : (e = (e & 2080374784) >> 16, n = (or[1] & 1048575) >> 10) : e <= 1056964608 ? (n = 1048576 + (or[1] & 1048575), n = 1048576 + (n << (e >> 20) - 998) >> 21, e = 0) : (e = e - 1056964608 >> 10, n = (or[1] & 1048575) + 512 >> 10), t | e | n & 65535;
}
class ct extends St {
}
function dt(r) {
  return (t, e, n) => {
    if (t.setValid(e, n != null))
      return r(t, e, n);
  };
}
const Vh = (r, t, e) => {
  r[t] = Math.floor(e / 864e5);
}, Ga = (r, t, e, n) => {
  if (e + 1 < t.length) {
    const s = Lt(t[e]), i = Lt(t[e + 1]);
    r.set(n.subarray(0, i - s), s);
  }
}, Wh = ({ offset: r, values: t }, e, n) => {
  const s = r + e;
  n ? t[s >> 3] |= 1 << s % 8 : t[s >> 3] &= ~(1 << s % 8);
}, Re = ({ values: r }, t, e) => {
  r[t] = e;
}, _s = ({ values: r }, t, e) => {
  r[t] = e;
}, Ya = ({ values: r }, t, e) => {
  r[t] = jh(e);
}, Zh = (r, t, e) => {
  switch (r.type.precision) {
    case Jt.HALF:
      return Ya(r, t, e);
    case Jt.SINGLE:
    case Jt.DOUBLE:
      return _s(r, t, e);
  }
}, Ja = ({ values: r }, t, e) => {
  Vh(r, t, e.valueOf());
}, Ha = ({ values: r }, t, e) => {
  r[t] = BigInt(e);
}, Gh = ({ stride: r, values: t }, e, n) => {
  t.set(n.subarray(0, r), r * e);
}, qa = ({ values: r, valueOffsets: t }, e, n) => Ga(r, t, e, n), Ka = ({ values: r, valueOffsets: t }, e, n) => Ga(r, t, e, ys(n)), Yh = (r, t, e) => {
  r.type.unit === de.DAY ? Ja(r, t, e) : Ha(r, t, e);
}, Xa = ({ values: r }, t, e) => {
  r[t] = BigInt(e / 1e3);
}, Qa = ({ values: r }, t, e) => {
  r[t] = BigInt(e);
}, tc = ({ values: r }, t, e) => {
  r[t] = BigInt(e * 1e3);
}, ec = ({ values: r }, t, e) => {
  r[t] = BigInt(e * 1e6);
}, Jh = (r, t, e) => {
  switch (r.type.unit) {
    case at.SECOND:
      return Xa(r, t, e);
    case at.MILLISECOND:
      return Qa(r, t, e);
    case at.MICROSECOND:
      return tc(r, t, e);
    case at.NANOSECOND:
      return ec(r, t, e);
  }
}, rc = ({ values: r }, t, e) => {
  r[t] = e;
}, nc = ({ values: r }, t, e) => {
  r[t] = e;
}, ic = ({ values: r }, t, e) => {
  r[t] = e;
}, sc = ({ values: r }, t, e) => {
  r[t] = e;
}, Hh = (r, t, e) => {
  switch (r.type.unit) {
    case at.SECOND:
      return rc(r, t, e);
    case at.MILLISECOND:
      return nc(r, t, e);
    case at.MICROSECOND:
      return ic(r, t, e);
    case at.NANOSECOND:
      return sc(r, t, e);
  }
}, qh = ({ values: r, stride: t }, e, n) => {
  r.set(n.subarray(0, t), t * e);
}, Kh = (r, t, e) => {
  const n = r.children[0], s = r.valueOffsets, i = fe.getVisitFn(n);
  if (Array.isArray(e))
    for (let a = -1, c = s[t], d = s[t + 1]; c < d; )
      i(n, c++, e[++a]);
  else
    for (let a = -1, c = s[t], d = s[t + 1]; c < d; )
      i(n, c++, e.get(++a));
}, Xh = (r, t, e) => {
  const n = r.children[0], { valueOffsets: s } = r, i = fe.getVisitFn(n);
  let { [t]: a, [t + 1]: c } = s;
  const d = e instanceof Map ? e.entries() : Object.entries(e);
  for (const p of d)
    if (i(n, a, p), ++a >= c)
      break;
}, Qh = (r, t) => (e, n, s, i) => n && e(n, r, t[i]), tl = (r, t) => (e, n, s, i) => n && e(n, r, t.get(i)), el = (r, t) => (e, n, s, i) => n && e(n, r, t.get(s.name)), rl = (r, t) => (e, n, s, i) => n && e(n, r, t[s.name]), nl = (r, t, e) => {
  const n = r.type.children.map((i) => fe.getVisitFn(i.type)), s = e instanceof Map ? el(t, e) : e instanceof Ft ? tl(t, e) : Array.isArray(e) ? Qh(t, e) : rl(t, e);
  r.type.children.forEach((i, a) => s(n[a], r.children[a], i, a));
}, il = (r, t, e) => {
  r.type.mode === re.Dense ? oc(r, t, e) : ac(r, t, e);
}, oc = (r, t, e) => {
  const n = r.type.typeIdToChildIndex[r.typeIds[t]], s = r.children[n];
  fe.visit(s, r.valueOffsets[t], e);
}, ac = (r, t, e) => {
  const n = r.type.typeIdToChildIndex[r.typeIds[t]], s = r.children[n];
  fe.visit(s, t, e);
}, sl = (r, t, e) => {
  var n;
  (n = r.dictionary) === null || n === void 0 || n.set(r.values[t], e);
}, ol = (r, t, e) => {
  r.type.unit === Te.DAY_TIME ? cc(r, t, e) : uc(r, t, e);
}, cc = ({ values: r }, t, e) => {
  r.set(e.subarray(0, 2), 2 * t);
}, uc = ({ values: r }, t, e) => {
  r[t] = e[0] * 12 + e[1] % 12;
}, hc = ({ values: r }, t, e) => {
  r[t] = e;
}, lc = ({ values: r }, t, e) => {
  r[t] = e;
}, dc = ({ values: r }, t, e) => {
  r[t] = e;
}, fc = ({ values: r }, t, e) => {
  r[t] = e;
}, al = (r, t, e) => {
  switch (r.type.unit) {
    case at.SECOND:
      return hc(r, t, e);
    case at.MILLISECOND:
      return lc(r, t, e);
    case at.MICROSECOND:
      return dc(r, t, e);
    case at.NANOSECOND:
      return fc(r, t, e);
  }
}, cl = (r, t, e) => {
  const { stride: n } = r, s = r.children[0], i = fe.getVisitFn(s);
  if (Array.isArray(e))
    for (let a = -1, c = t * n; ++a < n; )
      i(s, c + a, e[a]);
  else
    for (let a = -1, c = t * n; ++a < n; )
      i(s, c + a, e.get(a));
};
ct.prototype.visitBool = dt(Wh);
ct.prototype.visitInt = dt(Re);
ct.prototype.visitInt8 = dt(Re);
ct.prototype.visitInt16 = dt(Re);
ct.prototype.visitInt32 = dt(Re);
ct.prototype.visitInt64 = dt(Re);
ct.prototype.visitUint8 = dt(Re);
ct.prototype.visitUint16 = dt(Re);
ct.prototype.visitUint32 = dt(Re);
ct.prototype.visitUint64 = dt(Re);
ct.prototype.visitFloat = dt(Zh);
ct.prototype.visitFloat16 = dt(Ya);
ct.prototype.visitFloat32 = dt(_s);
ct.prototype.visitFloat64 = dt(_s);
ct.prototype.visitUtf8 = dt(Ka);
ct.prototype.visitLargeUtf8 = dt(Ka);
ct.prototype.visitBinary = dt(qa);
ct.prototype.visitLargeBinary = dt(qa);
ct.prototype.visitFixedSizeBinary = dt(Gh);
ct.prototype.visitDate = dt(Yh);
ct.prototype.visitDateDay = dt(Ja);
ct.prototype.visitDateMillisecond = dt(Ha);
ct.prototype.visitTimestamp = dt(Jh);
ct.prototype.visitTimestampSecond = dt(Xa);
ct.prototype.visitTimestampMillisecond = dt(Qa);
ct.prototype.visitTimestampMicrosecond = dt(tc);
ct.prototype.visitTimestampNanosecond = dt(ec);
ct.prototype.visitTime = dt(Hh);
ct.prototype.visitTimeSecond = dt(rc);
ct.prototype.visitTimeMillisecond = dt(nc);
ct.prototype.visitTimeMicrosecond = dt(ic);
ct.prototype.visitTimeNanosecond = dt(sc);
ct.prototype.visitDecimal = dt(qh);
ct.prototype.visitList = dt(Kh);
ct.prototype.visitStruct = dt(nl);
ct.prototype.visitUnion = dt(il);
ct.prototype.visitDenseUnion = dt(oc);
ct.prototype.visitSparseUnion = dt(ac);
ct.prototype.visitDictionary = dt(sl);
ct.prototype.visitInterval = dt(ol);
ct.prototype.visitIntervalDayTime = dt(cc);
ct.prototype.visitIntervalYearMonth = dt(uc);
ct.prototype.visitDuration = dt(al);
ct.prototype.visitDurationSecond = dt(hc);
ct.prototype.visitDurationMillisecond = dt(lc);
ct.prototype.visitDurationMicrosecond = dt(dc);
ct.prototype.visitDurationNanosecond = dt(fc);
ct.prototype.visitFixedSizeList = dt(cl);
ct.prototype.visitMap = dt(Xh);
const fe = new ct(), pe = Symbol.for("parent"), Ir = Symbol.for("rowIndex");
class Ss {
  constructor(t, e) {
    return this[pe] = t, this[Ir] = e, new Proxy(this, ll);
  }
  toArray() {
    return Object.values(this.toJSON());
  }
  toJSON() {
    const t = this[Ir], e = this[pe], n = e.type.children, s = {};
    for (let i = -1, a = n.length; ++i < a; )
      s[n[i].name] = ne.visit(e.children[i], t);
    return s;
  }
  toString() {
    return `{${[...this].map(([t, e]) => `${hn(t)}: ${hn(e)}`).join(", ")}}`;
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.toString();
  }
  [Symbol.iterator]() {
    return new ul(this[pe], this[Ir]);
  }
}
class ul {
  constructor(t, e) {
    this.childIndex = 0, this.children = t.children, this.rowIndex = e, this.childFields = t.type.children, this.numChildren = this.childFields.length;
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    const t = this.childIndex;
    return t < this.numChildren ? (this.childIndex = t + 1, {
      done: !1,
      value: [
        this.childFields[t].name,
        ne.visit(this.children[t], this.rowIndex)
      ]
    }) : { done: !0, value: null };
  }
}
Object.defineProperties(Ss.prototype, {
  [Symbol.toStringTag]: { enumerable: !1, configurable: !1, value: "Row" },
  [pe]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [Ir]: { writable: !0, enumerable: !1, configurable: !1, value: -1 }
});
class hl {
  isExtensible() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !0;
  }
  ownKeys(t) {
    return t[pe].type.children.map((e) => e.name);
  }
  has(t, e) {
    return t[pe].type.children.some((n) => n.name === e);
  }
  getOwnPropertyDescriptor(t, e) {
    if (t[pe].type.children.some((n) => n.name === e))
      return { writable: !0, enumerable: !0, configurable: !0 };
  }
  get(t, e) {
    if (Reflect.has(t, e))
      return t[e];
    const n = t[pe].type.children.findIndex((s) => s.name === e);
    if (n !== -1) {
      const s = ne.visit(t[pe].children[n], t[Ir]);
      return Reflect.set(t, e, s), s;
    }
  }
  set(t, e, n) {
    const s = t[pe].type.children.findIndex((i) => i.name === e);
    return s !== -1 ? (fe.visit(t[pe].children[s], t[Ir], n), Reflect.set(t, e, n)) : Reflect.has(t, e) || typeof e == "symbol" ? Reflect.set(t, e, n) : !1;
  }
}
const ll = new hl();
class nt extends St {
}
function ut(r) {
  return (t, e) => t.getValid(e) ? r(t, e) : null;
}
const dl = (r, t) => 864e5 * r[t], fl = (r, t) => null, pc = (r, t, e) => {
  if (e + 1 >= t.length)
    return null;
  const n = Lt(t[e]), s = Lt(t[e + 1]);
  return r.subarray(n, s);
}, pl = ({ offset: r, values: t }, e) => {
  const n = r + e;
  return (t[n >> 3] & 1 << n % 8) !== 0;
}, yc = ({ values: r }, t) => dl(r, t), gc = ({ values: r }, t) => Lt(r[t]), He = ({ stride: r, values: t }, e) => t[r * e], yl = ({ stride: r, values: t }, e) => Za(t[r * e]), mc = ({ values: r }, t) => r[t], gl = ({ stride: r, values: t }, e) => t.subarray(r * e, r * (e + 1)), wc = ({ values: r, valueOffsets: t }, e) => pc(r, t, e), bc = ({ values: r, valueOffsets: t }, e) => {
  const n = pc(r, t, e);
  return n !== null ? ji(n) : null;
}, ml = ({ values: r }, t) => r[t], wl = ({ type: r, values: t }, e) => r.precision !== Jt.HALF ? t[e] : Za(t[e]), bl = (r, t) => r.type.unit === de.DAY ? yc(r, t) : gc(r, t), _c = ({ values: r }, t) => 1e3 * Lt(r[t]), Sc = ({ values: r }, t) => Lt(r[t]), Ic = ({ values: r }, t) => _a(r[t], BigInt(1e3)), Bc = ({ values: r }, t) => _a(r[t], BigInt(1e6)), _l = (r, t) => {
  switch (r.type.unit) {
    case at.SECOND:
      return _c(r, t);
    case at.MILLISECOND:
      return Sc(r, t);
    case at.MICROSECOND:
      return Ic(r, t);
    case at.NANOSECOND:
      return Bc(r, t);
  }
}, vc = ({ values: r }, t) => r[t], xc = ({ values: r }, t) => r[t], Ac = ({ values: r }, t) => r[t], Ec = ({ values: r }, t) => r[t], Sl = (r, t) => {
  switch (r.type.unit) {
    case at.SECOND:
      return vc(r, t);
    case at.MILLISECOND:
      return xc(r, t);
    case at.MICROSECOND:
      return Ac(r, t);
    case at.NANOSECOND:
      return Ec(r, t);
  }
}, Il = ({ values: r, stride: t }, e) => bs.decimal(r.subarray(t * e, t * (e + 1))), Bl = (r, t) => {
  const { valueOffsets: e, stride: n, children: s } = r, { [t * n]: i, [t * n + 1]: a } = e, d = s[0].slice(i, a - i);
  return new Ft([d]);
}, vl = (r, t) => {
  const { valueOffsets: e, children: n } = r, { [t]: s, [t + 1]: i } = e, a = n[0];
  return new Is(a.slice(s, i - s));
}, xl = (r, t) => new Ss(r, t), Al = (r, t) => r.type.mode === re.Dense ? Tc(r, t) : Mc(r, t), Tc = (r, t) => {
  const e = r.type.typeIdToChildIndex[r.typeIds[t]], n = r.children[e];
  return ne.visit(n, r.valueOffsets[t]);
}, Mc = (r, t) => {
  const e = r.type.typeIdToChildIndex[r.typeIds[t]], n = r.children[e];
  return ne.visit(n, t);
}, El = (r, t) => {
  var e;
  return (e = r.dictionary) === null || e === void 0 ? void 0 : e.get(r.values[t]);
}, Tl = (r, t) => r.type.unit === Te.DAY_TIME ? Oc(r, t) : Fc(r, t), Oc = ({ values: r }, t) => r.subarray(2 * t, 2 * (t + 1)), Fc = ({ values: r }, t) => {
  const e = r[t], n = new Int32Array(2);
  return n[0] = Math.trunc(e / 12), n[1] = Math.trunc(e % 12), n;
}, kc = ({ values: r }, t) => r[t], Nc = ({ values: r }, t) => r[t], Dc = ({ values: r }, t) => r[t], Uc = ({ values: r }, t) => r[t], Ml = (r, t) => {
  switch (r.type.unit) {
    case at.SECOND:
      return kc(r, t);
    case at.MILLISECOND:
      return Nc(r, t);
    case at.MICROSECOND:
      return Dc(r, t);
    case at.NANOSECOND:
      return Uc(r, t);
  }
}, Ol = (r, t) => {
  const { stride: e, children: n } = r, i = n[0].slice(t * e, e);
  return new Ft([i]);
};
nt.prototype.visitNull = ut(fl);
nt.prototype.visitBool = ut(pl);
nt.prototype.visitInt = ut(ml);
nt.prototype.visitInt8 = ut(He);
nt.prototype.visitInt16 = ut(He);
nt.prototype.visitInt32 = ut(He);
nt.prototype.visitInt64 = ut(mc);
nt.prototype.visitUint8 = ut(He);
nt.prototype.visitUint16 = ut(He);
nt.prototype.visitUint32 = ut(He);
nt.prototype.visitUint64 = ut(mc);
nt.prototype.visitFloat = ut(wl);
nt.prototype.visitFloat16 = ut(yl);
nt.prototype.visitFloat32 = ut(He);
nt.prototype.visitFloat64 = ut(He);
nt.prototype.visitUtf8 = ut(bc);
nt.prototype.visitLargeUtf8 = ut(bc);
nt.prototype.visitBinary = ut(wc);
nt.prototype.visitLargeBinary = ut(wc);
nt.prototype.visitFixedSizeBinary = ut(gl);
nt.prototype.visitDate = ut(bl);
nt.prototype.visitDateDay = ut(yc);
nt.prototype.visitDateMillisecond = ut(gc);
nt.prototype.visitTimestamp = ut(_l);
nt.prototype.visitTimestampSecond = ut(_c);
nt.prototype.visitTimestampMillisecond = ut(Sc);
nt.prototype.visitTimestampMicrosecond = ut(Ic);
nt.prototype.visitTimestampNanosecond = ut(Bc);
nt.prototype.visitTime = ut(Sl);
nt.prototype.visitTimeSecond = ut(vc);
nt.prototype.visitTimeMillisecond = ut(xc);
nt.prototype.visitTimeMicrosecond = ut(Ac);
nt.prototype.visitTimeNanosecond = ut(Ec);
nt.prototype.visitDecimal = ut(Il);
nt.prototype.visitList = ut(Bl);
nt.prototype.visitStruct = ut(xl);
nt.prototype.visitUnion = ut(Al);
nt.prototype.visitDenseUnion = ut(Tc);
nt.prototype.visitSparseUnion = ut(Mc);
nt.prototype.visitDictionary = ut(El);
nt.prototype.visitInterval = ut(Tl);
nt.prototype.visitIntervalDayTime = ut(Oc);
nt.prototype.visitIntervalYearMonth = ut(Fc);
nt.prototype.visitDuration = ut(Ml);
nt.prototype.visitDurationSecond = ut(kc);
nt.prototype.visitDurationMillisecond = ut(Nc);
nt.prototype.visitDurationMicrosecond = ut(Dc);
nt.prototype.visitDurationNanosecond = ut(Uc);
nt.prototype.visitFixedSizeList = ut(Ol);
nt.prototype.visitMap = ut(vl);
const ne = new nt(), yr = Symbol.for("keys"), Br = Symbol.for("vals"), gr = Symbol.for("kKeysAsStrings"), Ji = Symbol.for("_kKeysAsStrings");
class Is {
  constructor(t) {
    return this[yr] = new Ft([t.children[0]]).memoize(), this[Br] = t.children[1], new Proxy(this, new kl());
  }
  /** @ignore */
  get [gr]() {
    return this[Ji] || (this[Ji] = Array.from(this[yr].toArray(), String));
  }
  [Symbol.iterator]() {
    return new Fl(this[yr], this[Br]);
  }
  get size() {
    return this[yr].length;
  }
  toArray() {
    return Object.values(this.toJSON());
  }
  toJSON() {
    const t = this[yr], e = this[Br], n = {};
    for (let s = -1, i = t.length; ++s < i; )
      n[t.get(s)] = ne.visit(e, s);
    return n;
  }
  toString() {
    return `{${[...this].map(([t, e]) => `${hn(t)}: ${hn(e)}`).join(", ")}}`;
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.toString();
  }
}
class Fl {
  constructor(t, e) {
    this.keys = t, this.vals = e, this.keyIndex = 0, this.numKeys = t.length;
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    const t = this.keyIndex;
    return t === this.numKeys ? { done: !0, value: null } : (this.keyIndex++, {
      done: !1,
      value: [
        this.keys.get(t),
        ne.visit(this.vals, t)
      ]
    });
  }
}
class kl {
  isExtensible() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !0;
  }
  ownKeys(t) {
    return t[gr];
  }
  has(t, e) {
    return t[gr].includes(e);
  }
  getOwnPropertyDescriptor(t, e) {
    if (t[gr].indexOf(e) !== -1)
      return { writable: !0, enumerable: !0, configurable: !0 };
  }
  get(t, e) {
    if (Reflect.has(t, e))
      return t[e];
    const n = t[gr].indexOf(e);
    if (n !== -1) {
      const s = ne.visit(Reflect.get(t, Br), n);
      return Reflect.set(t, e, s), s;
    }
  }
  set(t, e, n) {
    const s = t[gr].indexOf(e);
    return s !== -1 ? (fe.visit(Reflect.get(t, Br), s, n), Reflect.set(t, e, n)) : Reflect.has(t, e) ? Reflect.set(t, e, n) : !1;
  }
}
Object.defineProperties(Is.prototype, {
  [Symbol.toStringTag]: { enumerable: !1, configurable: !1, value: "Row" },
  [yr]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [Br]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [Ji]: { writable: !0, enumerable: !1, configurable: !1, value: null }
});
let po;
function Lc(r, t, e, n) {
  const { length: s = 0 } = r;
  let i = typeof t != "number" ? 0 : t, a = typeof e != "number" ? s : e;
  return i < 0 && (i = (i % s + s) % s), a < 0 && (a = (a % s + s) % s), a < i && (po = i, i = a, a = po), a > s && (a = s), n ? n(r, i, a) : [i, a];
}
const Bs = (r, t) => r < 0 ? t + r : r, yo = (r) => r !== r;
function kr(r) {
  if (typeof r !== "object" || r === null)
    return yo(r) ? yo : (e) => e === r;
  if (r instanceof Date) {
    const e = r.valueOf();
    return (n) => n instanceof Date ? n.valueOf() === e : !1;
  }
  return ArrayBuffer.isView(r) ? (e) => e ? Mh(r, e) : !1 : r instanceof Map ? Dl(r) : Array.isArray(r) ? Nl(r) : r instanceof Ft ? Ul(r) : Ll(r, !0);
}
function Nl(r) {
  const t = [];
  for (let e = -1, n = r.length; ++e < n; )
    t[e] = kr(r[e]);
  return bi(t);
}
function Dl(r) {
  let t = -1;
  const e = [];
  for (const n of r.values())
    e[++t] = kr(n);
  return bi(e);
}
function Ul(r) {
  const t = [];
  for (let e = -1, n = r.length; ++e < n; )
    t[e] = kr(r.get(e));
  return bi(t);
}
function Ll(r, t = !1) {
  const e = Object.keys(r);
  if (!t && e.length === 0)
    return () => !1;
  const n = [];
  for (let s = -1, i = e.length; ++s < i; )
    n[s] = kr(r[e[s]]);
  return bi(n, e);
}
function bi(r, t) {
  return (e) => {
    if (!e || typeof e != "object")
      return !1;
    switch (e.constructor) {
      case Array:
        return Cl(r, e);
      case Map:
        return go(r, e, e.keys());
      case Is:
      case Ss:
      case Object:
      case void 0:
        return go(r, e, t || Object.keys(e));
    }
    return e instanceof Ft ? Rl(r, e) : !1;
  };
}
function Cl(r, t) {
  const e = r.length;
  if (t.length !== e)
    return !1;
  for (let n = -1; ++n < e; )
    if (!r[n](t[n]))
      return !1;
  return !0;
}
function Rl(r, t) {
  const e = r.length;
  if (t.length !== e)
    return !1;
  for (let n = -1; ++n < e; )
    if (!r[n](t.get(n)))
      return !1;
  return !0;
}
function go(r, t, e) {
  const n = e[Symbol.iterator](), s = t instanceof Map ? t.keys() : Object.keys(t)[Symbol.iterator](), i = t instanceof Map ? t.values() : Object.values(t)[Symbol.iterator]();
  let a = 0;
  const c = r.length;
  let d = i.next(), p = n.next(), y = s.next();
  for (; a < c && !p.done && !y.done && !d.done && !(p.value !== y.value || !r[a](d.value)); ++a, p = n.next(), y = s.next(), d = i.next())
    ;
  return a === c && p.done && y.done && d.done ? !0 : (n.return && n.return(), s.return && s.return(), i.return && i.return(), !1);
}
function Cc(r, t, e, n) {
  return (e & 1 << n) !== 0;
}
function Pl(r, t, e, n) {
  return (e & 1 << n) >> n;
}
function mo(r, t, e) {
  const n = e.byteLength + 7 & -8;
  if (r > 0 || e.byteLength < n) {
    const s = new Uint8Array(n);
    return s.set(r % 8 === 0 ? e.subarray(r >> 3) : (
      // Otherwise iterate each bit from the offset and return a new one
      Hi(new vs(e, r, t, null, Cc)).subarray(0, n)
    )), s;
  }
  return e;
}
function Hi(r) {
  const t = [];
  let e = 0, n = 0, s = 0;
  for (const a of r)
    a && (s |= 1 << n), ++n === 8 && (t[e++] = s, s = n = 0);
  (e === 0 || n > 0) && (t[e++] = s);
  const i = new Uint8Array(t.length + 7 & -8);
  return i.set(t), i;
}
class vs {
  constructor(t, e, n, s, i) {
    this.bytes = t, this.length = n, this.context = s, this.get = i, this.bit = e % 8, this.byteIndex = e >> 3, this.byte = t[this.byteIndex++], this.index = 0;
  }
  next() {
    return this.index < this.length ? (this.bit === 8 && (this.bit = 0, this.byte = this.bytes[this.byteIndex++]), {
      value: this.get(this.context, this.index++, this.byte, this.bit++)
    }) : { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
function qi(r, t, e) {
  if (e - t <= 0)
    return 0;
  if (e - t < 8) {
    let i = 0;
    for (const a of new vs(r, t, e - t, r, Pl))
      i += a;
    return i;
  }
  const n = e >> 3 << 3, s = t + (t % 8 === 0 ? 0 : 8 - t % 8);
  return (
    // Get the popcnt of bits between the left hand side, and the next highest multiple of 8
    qi(r, t, s) + // Get the popcnt of bits between the right hand side, and the next lowest multiple of 8
    qi(r, n, e) + // Get the popcnt of all bits between the left and right hand sides' multiples of 8
    $l(r, s >> 3, n - s >> 3)
  );
}
function $l(r, t, e) {
  let n = 0, s = Math.trunc(t);
  const i = new DataView(r.buffer, r.byteOffset, r.byteLength), a = e === void 0 ? r.byteLength : s + e;
  for (; a - s >= 4; )
    n += Mi(i.getUint32(s)), s += 4;
  for (; a - s >= 2; )
    n += Mi(i.getUint16(s)), s += 2;
  for (; a - s >= 1; )
    n += Mi(i.getUint8(s)), s += 1;
  return n;
}
function Mi(r) {
  let t = Math.trunc(r);
  return t = t - (t >>> 1 & 1431655765), t = (t & 858993459) + (t >>> 2 & 858993459), (t + (t >>> 4) & 252645135) * 16843009 >>> 24;
}
const zl = -1;
class Et {
  get typeId() {
    return this.type.typeId;
  }
  get ArrayType() {
    return this.type.ArrayType;
  }
  get buffers() {
    return [this.valueOffsets, this.values, this.nullBitmap, this.typeIds];
  }
  get nullable() {
    if (this._nullCount !== 0) {
      const { type: t } = this;
      return tt.isSparseUnion(t) ? this.children.some((e) => e.nullable) : tt.isDenseUnion(t) ? this.children.some((e) => e.nullable) : this.nullBitmap && this.nullBitmap.byteLength > 0;
    }
    return !0;
  }
  get byteLength() {
    let t = 0;
    const { valueOffsets: e, values: n, nullBitmap: s, typeIds: i } = this;
    return e && (t += e.byteLength), n && (t += n.byteLength), s && (t += s.byteLength), i && (t += i.byteLength), this.children.reduce((a, c) => a + c.byteLength, t);
  }
  get nullCount() {
    if (tt.isUnion(this.type))
      return this.children.reduce((n, s) => n + s.nullCount, 0);
    let t = this._nullCount, e;
    return t <= zl && (e = this.nullBitmap) && (this._nullCount = t = e.length === 0 ? (
      // no null bitmap, so all values are valid
      0
    ) : this.length - qi(e, this.offset, this.offset + this.length)), t;
  }
  constructor(t, e, n, s, i, a = [], c) {
    this.type = t, this.children = a, this.dictionary = c, this.offset = Math.floor(Math.max(e || 0, 0)), this.length = Math.floor(Math.max(n || 0, 0)), this._nullCount = Math.floor(Math.max(s || 0, -1));
    let d;
    i instanceof Et ? (this.stride = i.stride, this.values = i.values, this.typeIds = i.typeIds, this.nullBitmap = i.nullBitmap, this.valueOffsets = i.valueOffsets) : (this.stride = ke(t), i && ((d = i[0]) && (this.valueOffsets = d), (d = i[1]) && (this.values = d), (d = i[2]) && (this.nullBitmap = d), (d = i[3]) && (this.typeIds = d)));
  }
  getValid(t) {
    const { type: e } = this;
    if (tt.isUnion(e)) {
      const n = e, s = this.children[n.typeIdToChildIndex[this.typeIds[t]]], i = n.mode === re.Dense ? this.valueOffsets[t] : t;
      return s.getValid(i);
    }
    if (this.nullable && this.nullCount > 0) {
      const n = this.offset + t;
      return (this.nullBitmap[n >> 3] & 1 << n % 8) !== 0;
    }
    return !0;
  }
  setValid(t, e) {
    let n;
    const { type: s } = this;
    if (tt.isUnion(s)) {
      const i = s, a = this.children[i.typeIdToChildIndex[this.typeIds[t]]], c = i.mode === re.Dense ? this.valueOffsets[t] : t;
      n = a.getValid(c), a.setValid(c, e);
    } else {
      let { nullBitmap: i } = this;
      const { offset: a, length: c } = this, d = a + t, p = 1 << d % 8, y = d >> 3;
      (!i || i.byteLength <= y) && (i = new Uint8Array((a + c + 63 & -64) >> 3).fill(255), this.nullCount > 0 ? (i.set(mo(a, c, this.nullBitmap), 0), Object.assign(this, { nullBitmap: i })) : Object.assign(this, { nullBitmap: i, _nullCount: 0 }));
      const B = i[y];
      n = (B & p) !== 0, i[y] = e ? B | p : B & ~p;
    }
    return n !== !!e && (this._nullCount = this.nullCount + (e ? -1 : 1)), e;
  }
  clone(t = this.type, e = this.offset, n = this.length, s = this._nullCount, i = this, a = this.children) {
    return new Et(t, e, n, s, i, a, this.dictionary);
  }
  slice(t, e) {
    const { stride: n, typeId: s, children: i } = this, a = +(this._nullCount === 0) - 1, c = s === 16 ? n : 1, d = this._sliceBuffers(t, e, n, s);
    return this.clone(
      this.type,
      this.offset + t,
      e,
      a,
      d,
      // Don't slice children if we have value offsets (the variable-width types)
      i.length === 0 || this.valueOffsets ? i : this._sliceChildren(i, c * t, c * e)
    );
  }
  _changeLengthAndBackfillNullBitmap(t) {
    if (this.typeId === A.Null)
      return this.clone(this.type, 0, t, 0);
    const { length: e, nullCount: n } = this, s = new Uint8Array((t + 63 & -64) >> 3).fill(255, 0, e >> 3);
    s[e >> 3] = (1 << e - (e & -8)) - 1, n > 0 && s.set(mo(this.offset, e, this.nullBitmap), 0);
    const i = this.buffers;
    return i[Fe.VALIDITY] = s, this.clone(this.type, 0, t, n + (t - e), i);
  }
  _sliceBuffers(t, e, n, s) {
    let i;
    const { buffers: a } = this;
    return (i = a[Fe.TYPE]) && (a[Fe.TYPE] = i.subarray(t, t + e)), (i = a[Fe.OFFSET]) && (a[Fe.OFFSET] = i.subarray(t, t + e + 1)) || // Otherwise if no offsets, slice the data buffer. Don't slice the data vector for Booleans, since the offset goes by bits not bytes
    (i = a[Fe.DATA]) && (a[Fe.DATA] = s === 6 ? i : i.subarray(n * t, n * (t + e))), a;
  }
  _sliceChildren(t, e, n) {
    return t.map((s) => s.slice(e, n));
  }
}
Et.prototype.children = Object.freeze([]);
class an extends St {
  visit(t) {
    return this.getVisitFn(t.type).call(this, t);
  }
  visitNull(t) {
    const { ["type"]: e, ["offset"]: n = 0, ["length"]: s = 0 } = t;
    return new Et(e, n, s, s);
  }
  visitBool(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.nullBitmap), i = Mt(e.ArrayType, t.data), { ["length"]: a = i.length >> 3, ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, a, c, [void 0, i, s]);
  }
  visitInt(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.nullBitmap), i = Mt(e.ArrayType, t.data), { ["length"]: a = i.length, ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, a, c, [void 0, i, s]);
  }
  visitFloat(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.nullBitmap), i = Mt(e.ArrayType, t.data), { ["length"]: a = i.length, ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, a, c, [void 0, i, s]);
  }
  visitUtf8(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.data), i = It(t.nullBitmap), a = Dr(t.valueOffsets), { ["length"]: c = a.length - 1, ["nullCount"]: d = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, c, d, [a, s, i]);
  }
  visitLargeUtf8(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.data), i = It(t.nullBitmap), a = ro(t.valueOffsets), { ["length"]: c = a.length - 1, ["nullCount"]: d = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, c, d, [a, s, i]);
  }
  visitBinary(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.data), i = It(t.nullBitmap), a = Dr(t.valueOffsets), { ["length"]: c = a.length - 1, ["nullCount"]: d = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, c, d, [a, s, i]);
  }
  visitLargeBinary(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.data), i = It(t.nullBitmap), a = ro(t.valueOffsets), { ["length"]: c = a.length - 1, ["nullCount"]: d = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, c, d, [a, s, i]);
  }
  visitFixedSizeBinary(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.nullBitmap), i = Mt(e.ArrayType, t.data), { ["length"]: a = i.length / ke(e), ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, a, c, [void 0, i, s]);
  }
  visitDate(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.nullBitmap), i = Mt(e.ArrayType, t.data), { ["length"]: a = i.length / ke(e), ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, a, c, [void 0, i, s]);
  }
  visitTimestamp(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.nullBitmap), i = Mt(e.ArrayType, t.data), { ["length"]: a = i.length / ke(e), ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, a, c, [void 0, i, s]);
  }
  visitTime(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.nullBitmap), i = Mt(e.ArrayType, t.data), { ["length"]: a = i.length / ke(e), ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, a, c, [void 0, i, s]);
  }
  visitDecimal(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.nullBitmap), i = Mt(e.ArrayType, t.data), { ["length"]: a = i.length / ke(e), ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, a, c, [void 0, i, s]);
  }
  visitList(t) {
    const { ["type"]: e, ["offset"]: n = 0, ["child"]: s } = t, i = It(t.nullBitmap), a = Dr(t.valueOffsets), { ["length"]: c = a.length - 1, ["nullCount"]: d = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, c, d, [a, void 0, i], [s]);
  }
  visitStruct(t) {
    const { ["type"]: e, ["offset"]: n = 0, ["children"]: s = [] } = t, i = It(t.nullBitmap), { length: a = s.reduce((d, { length: p }) => Math.max(d, p), 0), nullCount: c = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, a, c, [void 0, void 0, i], s);
  }
  visitUnion(t) {
    const { ["type"]: e, ["offset"]: n = 0, ["children"]: s = [] } = t, i = Mt(e.ArrayType, t.typeIds), { ["length"]: a = i.length, ["nullCount"]: c = -1 } = t;
    if (tt.isSparseUnion(e))
      return new Et(e, n, a, c, [void 0, void 0, void 0, i], s);
    const d = Dr(t.valueOffsets);
    return new Et(e, n, a, c, [d, void 0, void 0, i], s);
  }
  visitDictionary(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.nullBitmap), i = Mt(e.indices.ArrayType, t.data), { ["dictionary"]: a = new Ft([new an().visit({ type: e.dictionary })]) } = t, { ["length"]: c = i.length, ["nullCount"]: d = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, c, d, [void 0, i, s], [], a);
  }
  visitInterval(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.nullBitmap), i = Mt(e.ArrayType, t.data), { ["length"]: a = i.length / ke(e), ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, a, c, [void 0, i, s]);
  }
  visitDuration(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = It(t.nullBitmap), i = Mt(e.ArrayType, t.data), { ["length"]: a = i.length, ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, a, c, [void 0, i, s]);
  }
  visitFixedSizeList(t) {
    const { ["type"]: e, ["offset"]: n = 0, ["child"]: s = new an().visit({ type: e.valueType }) } = t, i = It(t.nullBitmap), { ["length"]: a = s.length / ke(e), ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, a, c, [void 0, void 0, i], [s]);
  }
  visitMap(t) {
    const { ["type"]: e, ["offset"]: n = 0, ["child"]: s = new an().visit({ type: e.childType }) } = t, i = It(t.nullBitmap), a = Dr(t.valueOffsets), { ["length"]: c = a.length - 1, ["nullCount"]: d = t.nullBitmap ? -1 : 0 } = t;
    return new Et(e, n, c, d, [a, void 0, i], [s]);
  }
}
const jl = new an();
function _t(r) {
  return jl.visit(r);
}
class wo {
  constructor(t = 0, e) {
    this.numChunks = t, this.getChunkIterator = e, this.chunkIndex = 0, this.chunkIterator = this.getChunkIterator(0);
  }
  next() {
    for (; this.chunkIndex < this.numChunks; ) {
      const t = this.chunkIterator.next();
      if (!t.done)
        return t;
      ++this.chunkIndex < this.numChunks && (this.chunkIterator = this.getChunkIterator(this.chunkIndex));
    }
    return { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
function Vl(r) {
  return r.some((t) => t.nullable);
}
function Rc(r) {
  return r.reduce((t, e) => t + e.nullCount, 0);
}
function Pc(r) {
  return r.reduce((t, e, n) => (t[n + 1] = t[n] + e.length, t), new Uint32Array(r.length + 1));
}
function $c(r, t, e, n) {
  const s = [];
  for (let i = -1, a = r.length; ++i < a; ) {
    const c = r[i], d = t[i], { length: p } = c;
    if (d >= n)
      break;
    if (e >= d + p)
      continue;
    if (d >= e && d + p <= n) {
      s.push(c);
      continue;
    }
    const y = Math.max(0, e - d), B = Math.min(n - d, p);
    s.push(c.slice(y, B - y));
  }
  return s.length === 0 && s.push(r[0].slice(0, 0)), s;
}
function xs(r, t, e, n) {
  let s = 0, i = 0, a = t.length - 1;
  do {
    if (s >= a - 1)
      return e < t[a] ? n(r, s, e - t[s]) : null;
    i = s + Math.trunc((a - s) * 0.5), e < t[i] ? a = i : s = i;
  } while (s < a);
}
function As(r, t) {
  return r.getValid(t);
}
function ni(r) {
  function t(e, n, s) {
    return r(e[n], s);
  }
  return function(e) {
    const n = this.data;
    return xs(n, this._offsets, e, t);
  };
}
function zc(r) {
  let t;
  function e(n, s, i) {
    return r(n[s], i, t);
  }
  return function(n, s) {
    const i = this.data;
    t = s;
    const a = xs(i, this._offsets, n, e);
    return t = void 0, a;
  };
}
function jc(r) {
  let t;
  function e(n, s, i) {
    let a = i, c = 0, d = 0;
    for (let p = s - 1, y = n.length; ++p < y; ) {
      const B = n[p];
      if (~(c = r(B, t, a)))
        return d + c;
      a = 0, d += B.length;
    }
    return -1;
  }
  return function(n, s) {
    t = n;
    const i = this.data, a = typeof s != "number" ? e(i, 0, 0) : xs(i, this._offsets, s, e);
    return t = void 0, a;
  };
}
class it extends St {
}
function Wl(r, t) {
  return t === null && r.length > 0 ? 0 : -1;
}
function Zl(r, t) {
  const { nullBitmap: e } = r;
  if (!e || r.nullCount <= 0)
    return -1;
  let n = 0;
  for (const s of new vs(e, r.offset + (t || 0), r.length, e, Cc)) {
    if (!s)
      return n;
    ++n;
  }
  return -1;
}
function ft(r, t, e) {
  if (t === void 0)
    return -1;
  if (t === null)
    switch (r.typeId) {
      // Unions don't have a nullBitmap of its own, so compare the `searchElement` to `get()`.
      case A.Union:
        break;
      // Dictionaries do have a nullBitmap, but their dictionary could also have null elements.
      case A.Dictionary:
        break;
      // All other types can iterate the null bitmap
      default:
        return Zl(r, e);
    }
  const n = ne.getVisitFn(r), s = kr(t);
  for (let i = (e || 0) - 1, a = r.length; ++i < a; )
    if (s(n(r, i)))
      return i;
  return -1;
}
function Vc(r, t, e) {
  const n = ne.getVisitFn(r), s = kr(t);
  for (let i = (e || 0) - 1, a = r.length; ++i < a; )
    if (s(n(r, i)))
      return i;
  return -1;
}
it.prototype.visitNull = Wl;
it.prototype.visitBool = ft;
it.prototype.visitInt = ft;
it.prototype.visitInt8 = ft;
it.prototype.visitInt16 = ft;
it.prototype.visitInt32 = ft;
it.prototype.visitInt64 = ft;
it.prototype.visitUint8 = ft;
it.prototype.visitUint16 = ft;
it.prototype.visitUint32 = ft;
it.prototype.visitUint64 = ft;
it.prototype.visitFloat = ft;
it.prototype.visitFloat16 = ft;
it.prototype.visitFloat32 = ft;
it.prototype.visitFloat64 = ft;
it.prototype.visitUtf8 = ft;
it.prototype.visitLargeUtf8 = ft;
it.prototype.visitBinary = ft;
it.prototype.visitLargeBinary = ft;
it.prototype.visitFixedSizeBinary = ft;
it.prototype.visitDate = ft;
it.prototype.visitDateDay = ft;
it.prototype.visitDateMillisecond = ft;
it.prototype.visitTimestamp = ft;
it.prototype.visitTimestampSecond = ft;
it.prototype.visitTimestampMillisecond = ft;
it.prototype.visitTimestampMicrosecond = ft;
it.prototype.visitTimestampNanosecond = ft;
it.prototype.visitTime = ft;
it.prototype.visitTimeSecond = ft;
it.prototype.visitTimeMillisecond = ft;
it.prototype.visitTimeMicrosecond = ft;
it.prototype.visitTimeNanosecond = ft;
it.prototype.visitDecimal = ft;
it.prototype.visitList = ft;
it.prototype.visitStruct = ft;
it.prototype.visitUnion = ft;
it.prototype.visitDenseUnion = Vc;
it.prototype.visitSparseUnion = Vc;
it.prototype.visitDictionary = ft;
it.prototype.visitInterval = ft;
it.prototype.visitIntervalDayTime = ft;
it.prototype.visitIntervalYearMonth = ft;
it.prototype.visitDuration = ft;
it.prototype.visitDurationSecond = ft;
it.prototype.visitDurationMillisecond = ft;
it.prototype.visitDurationMicrosecond = ft;
it.prototype.visitDurationNanosecond = ft;
it.prototype.visitFixedSizeList = ft;
it.prototype.visitMap = ft;
const ii = new it();
class st extends St {
}
function ht(r) {
  const { type: t } = r;
  if (r.nullCount === 0 && r.stride === 1 && // Don't defer to native iterator for timestamps since Numbers are expected
  // (DataType.isTimestamp(type)) && type.unit === TimeUnit.MILLISECOND ||
  (tt.isInt(t) && t.bitWidth !== 64 || tt.isTime(t) && t.bitWidth !== 64 || tt.isFloat(t) && t.precision !== Jt.HALF))
    return new wo(r.data.length, (n) => {
      const s = r.data[n];
      return s.values.subarray(0, s.length)[Symbol.iterator]();
    });
  let e = 0;
  return new wo(r.data.length, (n) => {
    const i = r.data[n].length, a = r.slice(e, e + i);
    return e += i, new Gl(a);
  });
}
class Gl {
  constructor(t) {
    this.vector = t, this.index = 0;
  }
  next() {
    return this.index < this.vector.length ? {
      value: this.vector.get(this.index++)
    } : { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
st.prototype.visitNull = ht;
st.prototype.visitBool = ht;
st.prototype.visitInt = ht;
st.prototype.visitInt8 = ht;
st.prototype.visitInt16 = ht;
st.prototype.visitInt32 = ht;
st.prototype.visitInt64 = ht;
st.prototype.visitUint8 = ht;
st.prototype.visitUint16 = ht;
st.prototype.visitUint32 = ht;
st.prototype.visitUint64 = ht;
st.prototype.visitFloat = ht;
st.prototype.visitFloat16 = ht;
st.prototype.visitFloat32 = ht;
st.prototype.visitFloat64 = ht;
st.prototype.visitUtf8 = ht;
st.prototype.visitLargeUtf8 = ht;
st.prototype.visitBinary = ht;
st.prototype.visitLargeBinary = ht;
st.prototype.visitFixedSizeBinary = ht;
st.prototype.visitDate = ht;
st.prototype.visitDateDay = ht;
st.prototype.visitDateMillisecond = ht;
st.prototype.visitTimestamp = ht;
st.prototype.visitTimestampSecond = ht;
st.prototype.visitTimestampMillisecond = ht;
st.prototype.visitTimestampMicrosecond = ht;
st.prototype.visitTimestampNanosecond = ht;
st.prototype.visitTime = ht;
st.prototype.visitTimeSecond = ht;
st.prototype.visitTimeMillisecond = ht;
st.prototype.visitTimeMicrosecond = ht;
st.prototype.visitTimeNanosecond = ht;
st.prototype.visitDecimal = ht;
st.prototype.visitList = ht;
st.prototype.visitStruct = ht;
st.prototype.visitUnion = ht;
st.prototype.visitDenseUnion = ht;
st.prototype.visitSparseUnion = ht;
st.prototype.visitDictionary = ht;
st.prototype.visitInterval = ht;
st.prototype.visitIntervalDayTime = ht;
st.prototype.visitIntervalYearMonth = ht;
st.prototype.visitDuration = ht;
st.prototype.visitDurationSecond = ht;
st.prototype.visitDurationMillisecond = ht;
st.prototype.visitDurationMicrosecond = ht;
st.prototype.visitDurationNanosecond = ht;
st.prototype.visitFixedSizeList = ht;
st.prototype.visitMap = ht;
const Es = new st();
var Wc;
const Zc = {}, Gc = {};
class Ft {
  constructor(t) {
    var e, n, s;
    const i = t[0] instanceof Ft ? t.flatMap((c) => c.data) : t;
    if (i.length === 0 || i.some((c) => !(c instanceof Et)))
      throw new TypeError("Vector constructor expects an Array of Data instances.");
    const a = (e = i[0]) === null || e === void 0 ? void 0 : e.type;
    switch (i.length) {
      case 0:
        this._offsets = [0];
        break;
      case 1: {
        const { get: c, set: d, indexOf: p } = Zc[a.typeId], y = i[0];
        this.isValid = (B) => As(y, B), this.get = (B) => c(y, B), this.set = (B, R) => d(y, B, R), this.indexOf = (B) => p(y, B), this._offsets = [0, y.length];
        break;
      }
      default:
        Object.setPrototypeOf(this, Gc[a.typeId]), this._offsets = Pc(i);
        break;
    }
    this.data = i, this.type = a, this.stride = ke(a), this.numChildren = (s = (n = a.children) === null || n === void 0 ? void 0 : n.length) !== null && s !== void 0 ? s : 0, this.length = this._offsets.at(-1);
  }
  /**
   * The aggregate size (in bytes) of this Vector's buffers and/or child Vectors.
   */
  get byteLength() {
    return this.data.reduce((t, e) => t + e.byteLength, 0);
  }
  /**
   * Whether this Vector's elements can contain null values.
   */
  get nullable() {
    return Vl(this.data);
  }
  /**
   * The number of null elements in this Vector.
   */
  get nullCount() {
    return Rc(this.data);
  }
  /**
   * The Array or TypedArray constructor used for the JS representation
   *  of the element's values in {@link Vector.prototype.toArray `toArray()`}.
   */
  get ArrayType() {
    return this.type.ArrayType;
  }
  /**
   * The name that should be printed when the Vector is logged in a message.
   */
  get [Symbol.toStringTag]() {
    return `${this.VectorName}<${this.type[Symbol.toStringTag]}>`;
  }
  /**
   * The name of this Vector.
   */
  get VectorName() {
    return `${A[this.type.typeId]}Vector`;
  }
  /**
   * Check whether an element is null.
   * @param index The index at which to read the validity bitmap.
   */
  // @ts-ignore
  isValid(t) {
    return !1;
  }
  /**
   * Get an element value by position.
   * @param index The index of the element to read.
   */
  // @ts-ignore
  get(t) {
    return null;
  }
  /**
   * Get an element value by position.
   * @param index The index of the element to read. A negative index will count back from the last element.
   */
  at(t) {
    return this.get(Bs(t, this.length));
  }
  /**
   * Set an element value by position.
   * @param index The index of the element to write.
   * @param value The value to set.
   */
  // @ts-ignore
  set(t, e) {
  }
  /**
   * Retrieve the index of the first occurrence of a value in an Vector.
   * @param element The value to locate in the Vector.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  // @ts-ignore
  indexOf(t, e) {
    return -1;
  }
  includes(t, e) {
    return this.indexOf(t, e) > -1;
  }
  /**
   * Iterator for the Vector's elements.
   */
  [Symbol.iterator]() {
    return Es.visit(this);
  }
  /**
   * Combines two or more Vectors of the same type.
   * @param others Additional Vectors to add to the end of this Vector.
   */
  concat(...t) {
    return new Ft(this.data.concat(t.flatMap((e) => e.data).flat(Number.POSITIVE_INFINITY)));
  }
  /**
   * Return a zero-copy sub-section of this Vector.
   * @param start The beginning of the specified portion of the Vector.
   * @param end The end of the specified portion of the Vector. This is exclusive of the element at the index 'end'.
   */
  slice(t, e) {
    return new Ft(Lc(this, t, e, ({ data: n, _offsets: s }, i, a) => $c(n, s, i, a)));
  }
  toJSON() {
    return [...this];
  }
  /**
   * Return a JavaScript Array or TypedArray of the Vector's elements.
   *
   * @note If this Vector contains a single Data chunk and the Vector's type is a
   *  primitive numeric type corresponding to one of the JavaScript TypedArrays, this
   *  method returns a zero-copy slice of the underlying TypedArray values. If there's
   *  more than one chunk, the resulting TypedArray will be a copy of the data from each
   *  chunk's underlying TypedArray values.
   *
   * @returns An Array or TypedArray of the Vector's elements, based on the Vector's DataType.
   */
  toArray() {
    const { type: t, data: e, length: n, stride: s, ArrayType: i } = this;
    switch (t.typeId) {
      case A.Int:
      case A.Float:
      case A.Decimal:
      case A.Time:
      case A.Timestamp:
        switch (e.length) {
          case 0:
            return new i();
          case 1:
            return e[0].values.subarray(0, n * s);
          default:
            return e.reduce((a, { values: c, length: d }) => (a.array.set(c.subarray(0, d * s), a.offset), a.offset += d * s, a), { array: new i(n * s), offset: 0 }).array;
        }
    }
    return [...this];
  }
  /**
   * Returns a string representation of the Vector.
   *
   * @returns A string representation of the Vector.
   */
  toString() {
    return `[${[...this].join(",")}]`;
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   * @param name The name of the child to retrieve.
   */
  getChild(t) {
    var e;
    return this.getChildAt((e = this.type.children) === null || e === void 0 ? void 0 : e.findIndex((n) => n.name === t));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   * @param index The index of the child to retrieve.
   */
  getChildAt(t) {
    return t > -1 && t < this.numChildren ? new Ft(this.data.map(({ children: e }) => e[t])) : null;
  }
  get isMemoized() {
    return tt.isDictionary(this.type) ? this.data[0].dictionary.isMemoized : !1;
  }
  /**
   * Adds memoization to the Vector's {@link get} method. For dictionary
   * vectors, this method return a vector that memoizes only the dictionary
   * values.
   *
   * Memoization is very useful when decoding a value is expensive such as
   * Utf8. The memoization creates a cache of the size of the Vector and
   * therefore increases memory usage.
   *
   * @returns A new vector that memoizes calls to {@link get}.
   */
  memoize() {
    if (tt.isDictionary(this.type)) {
      const t = new si(this.data[0].dictionary), e = this.data.map((n) => {
        const s = n.clone();
        return s.dictionary = t, s;
      });
      return new Ft(e);
    }
    return new si(this);
  }
  /**
   * Returns a vector without memoization of the {@link get} method. If this
   * vector is not memoized, this method returns this vector.
   *
   * @returns A new vector without memoization.
   */
  unmemoize() {
    if (tt.isDictionary(this.type) && this.isMemoized) {
      const t = this.data[0].dictionary.unmemoize(), e = this.data.map((n) => {
        const s = n.clone();
        return s.dictionary = t, s;
      });
      return new Ft(e);
    }
    return this;
  }
}
Wc = Symbol.toStringTag;
Ft[Wc] = ((r) => {
  r.type = tt.prototype, r.data = [], r.length = 0, r.stride = 1, r.numChildren = 0, r._offsets = new Uint32Array([0]), r[Symbol.isConcatSpreadable] = !0;
  const t = Object.keys(A).map((e) => A[e]).filter((e) => typeof e == "number" && e !== A.NONE);
  for (const e of t) {
    const n = ne.getVisitFnByTypeId(e), s = fe.getVisitFnByTypeId(e), i = ii.getVisitFnByTypeId(e);
    Zc[e] = { get: n, set: s, indexOf: i }, Gc[e] = Object.create(r, {
      isValid: { value: ni(As) },
      get: { value: ni(ne.getVisitFnByTypeId(e)) },
      set: { value: zc(fe.getVisitFnByTypeId(e)) },
      indexOf: { value: jc(ii.getVisitFnByTypeId(e)) }
    });
  }
  return "Vector";
})(Ft.prototype);
class si extends Ft {
  constructor(t) {
    super(t.data);
    const e = this.get, n = this.set, s = this.slice, i = new Array(this.length);
    Object.defineProperty(this, "get", {
      value(a) {
        const c = i[a];
        if (c !== void 0)
          return c;
        const d = e.call(this, a);
        return i[a] = d, d;
      }
    }), Object.defineProperty(this, "set", {
      value(a, c) {
        n.call(this, a, c), i[a] = c;
      }
    }), Object.defineProperty(this, "slice", {
      value: (a, c) => new si(s.call(this, a, c))
    }), Object.defineProperty(this, "isMemoized", { value: !0 }), Object.defineProperty(this, "unmemoize", {
      value: () => new Ft(this.data)
    }), Object.defineProperty(this, "memoize", {
      value: () => this
    });
  }
}
class Ki {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  /**
   * Index to the start of the RecordBlock (note this is past the Message header)
   */
  offset() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * Length of the metadata
   */
  metaDataLength() {
    return this.bb.readInt32(this.bb_pos + 8);
  }
  /**
   * Length of the data (this is aligned so there can be a gap between this and
   * the metadata).
   */
  bodyLength() {
    return this.bb.readInt64(this.bb_pos + 16);
  }
  static sizeOf() {
    return 24;
  }
  static createBlock(t, e, n, s) {
    return t.prep(8, 24), t.writeInt64(BigInt(s ?? 0)), t.pad(4), t.writeInt32(n), t.writeInt64(BigInt(e ?? 0)), t.offset();
  }
}
class ie {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsFooter(t, e) {
    return (e || new ie()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsFooter(t, e) {
    return t.setPosition(t.position() + xt), (e || new ie()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  version() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : zt.V1;
  }
  schema(t) {
    const e = this.bb.__offset(this.bb_pos, 6);
    return e ? (t || new Se()).__init(this.bb.__indirect(this.bb_pos + e), this.bb) : null;
  }
  dictionaries(t, e) {
    const n = this.bb.__offset(this.bb_pos, 8);
    return n ? (e || new Ki()).__init(this.bb.__vector(this.bb_pos + n) + t * 24, this.bb) : null;
  }
  dictionariesLength() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  recordBatches(t, e) {
    const n = this.bb.__offset(this.bb_pos, 10);
    return n ? (e || new Ki()).__init(this.bb.__vector(this.bb_pos + n) + t * 24, this.bb) : null;
  }
  recordBatchesLength() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * User-defined metadata
   */
  customMetadata(t, e) {
    const n = this.bb.__offset(this.bb_pos, 12);
    return n ? (e || new jt()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + t * 4), this.bb) : null;
  }
  customMetadataLength() {
    const t = this.bb.__offset(this.bb_pos, 12);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startFooter(t) {
    t.startObject(5);
  }
  static addVersion(t, e) {
    t.addFieldInt16(0, e, zt.V1);
  }
  static addSchema(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static addDictionaries(t, e) {
    t.addFieldOffset(2, e, 0);
  }
  static startDictionariesVector(t, e) {
    t.startVector(24, e, 8);
  }
  static addRecordBatches(t, e) {
    t.addFieldOffset(3, e, 0);
  }
  static startRecordBatchesVector(t, e) {
    t.startVector(24, e, 8);
  }
  static addCustomMetadata(t, e) {
    t.addFieldOffset(4, e, 0);
  }
  static createCustomMetadataVector(t, e) {
    t.startVector(4, e.length, 4);
    for (let n = e.length - 1; n >= 0; n--)
      t.addOffset(e[n]);
    return t.endVector();
  }
  static startCustomMetadataVector(t, e) {
    t.startVector(4, e, 4);
  }
  static endFooter(t) {
    return t.endObject();
  }
  static finishFooterBuffer(t, e) {
    t.finish(e);
  }
  static finishSizePrefixedFooterBuffer(t, e) {
    t.finish(e, void 0, !0);
  }
}
class vt {
  constructor(t = [], e, n, s = zt.V5) {
    this.fields = t || [], this.metadata = e || /* @__PURE__ */ new Map(), n || (n = Xi(this.fields)), this.dictionaries = n, this.metadataVersion = s;
  }
  get [Symbol.toStringTag]() {
    return "Schema";
  }
  get names() {
    return this.fields.map((t) => t.name);
  }
  toString() {
    return `Schema<{ ${this.fields.map((t, e) => `${e}: ${t}`).join(", ")} }>`;
  }
  /**
   * Construct a new Schema containing only specified fields.
   *
   * @param fieldNames Names of fields to keep.
   * @returns A new Schema of fields matching the specified names.
   */
  select(t) {
    const e = new Set(t), n = this.fields.filter((s) => e.has(s.name));
    return new vt(n, this.metadata);
  }
  /**
   * Construct a new Schema containing only fields at the specified indices.
   *
   * @param fieldIndices Indices of fields to keep.
   * @returns A new Schema of fields at the specified indices.
   */
  selectAt(t) {
    const e = t.map((n) => this.fields[n]).filter(Boolean);
    return new vt(e, this.metadata);
  }
  assign(...t) {
    const e = t[0] instanceof vt ? t[0] : Array.isArray(t[0]) ? new vt(t[0]) : new vt(t), n = [...this.fields], s = Sn(Sn(/* @__PURE__ */ new Map(), this.metadata), e.metadata), i = e.fields.filter((c) => {
      const d = n.findIndex((p) => p.name === c.name);
      return ~d ? (n[d] = c.clone({
        metadata: Sn(Sn(/* @__PURE__ */ new Map(), n[d].metadata), c.metadata)
      })) && !1 : !0;
    }), a = Xi(i, /* @__PURE__ */ new Map());
    return new vt([...n, ...i], s, new Map([...this.dictionaries, ...a]));
  }
}
vt.prototype.fields = null;
vt.prototype.metadata = null;
vt.prototype.dictionaries = null;
class Ct {
  /** @nocollapse */
  static new(...t) {
    let [e, n, s, i] = t;
    return t[0] && typeof t[0] == "object" && ({ name: e } = t[0], n === void 0 && (n = t[0].type), s === void 0 && (s = t[0].nullable), i === void 0 && (i = t[0].metadata)), new Ct(`${e}`, n, s, i);
  }
  constructor(t, e, n = !1, s) {
    this.name = t, this.type = e, this.nullable = n, this.metadata = s || /* @__PURE__ */ new Map();
  }
  get typeId() {
    return this.type.typeId;
  }
  get [Symbol.toStringTag]() {
    return "Field";
  }
  toString() {
    return `${this.name}: ${this.type}`;
  }
  clone(...t) {
    let [e, n, s, i] = t;
    return !t[0] || typeof t[0] != "object" ? [e = this.name, n = this.type, s = this.nullable, i = this.metadata] = t : { name: e = this.name, type: n = this.type, nullable: s = this.nullable, metadata: i = this.metadata } = t[0], Ct.new(e, n, s, i);
  }
}
Ct.prototype.type = null;
Ct.prototype.name = null;
Ct.prototype.nullable = null;
Ct.prototype.metadata = null;
function Sn(r, t) {
  return new Map([...r || /* @__PURE__ */ new Map(), ...t || /* @__PURE__ */ new Map()]);
}
function Xi(r, t = /* @__PURE__ */ new Map()) {
  for (let e = -1, n = r.length; ++e < n; ) {
    const i = r[e].type;
    if (tt.isDictionary(i)) {
      if (!t.has(i.id))
        t.set(i.id, i.dictionary);
      else if (t.get(i.id) !== i.dictionary)
        throw new Error("Cannot create Schema containing two different dictionaries with the same Id");
    }
    i.children && i.children.length > 0 && Xi(i.children, t);
  }
  return t;
}
var Yl = ga, Jl = xr;
class Ts {
  /** @nocollapse */
  static decode(t) {
    t = new Jl(It(t));
    const e = ie.getRootAsFooter(t), n = vt.decode(e.schema(), /* @__PURE__ */ new Map(), e.version());
    return new Hl(n, e);
  }
  /** @nocollapse */
  static encode(t) {
    const e = new Yl(), n = vt.encode(e, t.schema);
    ie.startRecordBatchesVector(e, t.numRecordBatches);
    for (const a of [...t.recordBatches()].slice().reverse())
      Tr.encode(e, a);
    const s = e.endVector();
    ie.startDictionariesVector(e, t.numDictionaries);
    for (const a of [...t.dictionaryBatches()].slice().reverse())
      Tr.encode(e, a);
    const i = e.endVector();
    return ie.startFooter(e), ie.addSchema(e, n), ie.addVersion(e, zt.V5), ie.addRecordBatches(e, s), ie.addDictionaries(e, i), ie.finishFooterBuffer(e, ie.endFooter(e)), e.asUint8Array();
  }
  get numRecordBatches() {
    return this._recordBatches.length;
  }
  get numDictionaries() {
    return this._dictionaryBatches.length;
  }
  constructor(t, e = zt.V5, n, s) {
    this.schema = t, this.version = e, n && (this._recordBatches = n), s && (this._dictionaryBatches = s);
  }
  *recordBatches() {
    for (let t, e = -1, n = this.numRecordBatches; ++e < n; )
      (t = this.getRecordBatch(e)) && (yield t);
  }
  *dictionaryBatches() {
    for (let t, e = -1, n = this.numDictionaries; ++e < n; )
      (t = this.getDictionaryBatch(e)) && (yield t);
  }
  getRecordBatch(t) {
    return t >= 0 && t < this.numRecordBatches && this._recordBatches[t] || null;
  }
  getDictionaryBatch(t) {
    return t >= 0 && t < this.numDictionaries && this._dictionaryBatches[t] || null;
  }
}
class Hl extends Ts {
  get numRecordBatches() {
    return this._footer.recordBatchesLength();
  }
  get numDictionaries() {
    return this._footer.dictionariesLength();
  }
  constructor(t, e) {
    super(t, e.version()), this._footer = e;
  }
  getRecordBatch(t) {
    if (t >= 0 && t < this.numRecordBatches) {
      const e = this._footer.recordBatches(t);
      if (e)
        return Tr.decode(e);
    }
    return null;
  }
  getDictionaryBatch(t) {
    if (t >= 0 && t < this.numDictionaries) {
      const e = this._footer.dictionaries(t);
      if (e)
        return Tr.decode(e);
    }
    return null;
  }
}
class Tr {
  /** @nocollapse */
  static decode(t) {
    return new Tr(t.metaDataLength(), t.bodyLength(), t.offset());
  }
  /** @nocollapse */
  static encode(t, e) {
    const { metaDataLength: n } = e, s = BigInt(e.offset), i = BigInt(e.bodyLength);
    return Ki.createBlock(t, s, n, i);
  }
  constructor(t, e, n) {
    this.metaDataLength = t, this.offset = Lt(n), this.bodyLength = Lt(e);
  }
}
const Rt = Object.freeze({ done: !0, value: void 0 });
class bo {
  constructor(t) {
    this._json = t;
  }
  get schema() {
    return this._json.schema;
  }
  get batches() {
    return this._json.batches || [];
  }
  get dictionaries() {
    return this._json.dictionaries || [];
  }
}
class Yc {
  tee() {
    return this._getDOMStream().tee();
  }
  pipe(t, e) {
    return this._getNodeStream().pipe(t, e);
  }
  pipeTo(t, e) {
    return this._getDOMStream().pipeTo(t, e);
  }
  pipeThrough(t, e) {
    return this._getDOMStream().pipeThrough(t, e);
  }
  _getDOMStream() {
    return this._DOMStream || (this._DOMStream = this.toDOMStream());
  }
  _getNodeStream() {
    return this._nodeStream || (this._nodeStream = this.toNodeStream());
  }
}
class ql extends Yc {
  constructor() {
    super(), this._values = [], this.resolvers = [], this._closedPromise = new Promise((t) => this._closedPromiseResolve = t);
  }
  get closed() {
    return this._closedPromise;
  }
  cancel(t) {
    return gt(this, void 0, void 0, function* () {
      yield this.return(t);
    });
  }
  write(t) {
    this._ensureOpen() && (this.resolvers.length <= 0 ? this._values.push(t) : this.resolvers.shift().resolve({ done: !1, value: t }));
  }
  abort(t) {
    this._closedPromiseResolve && (this.resolvers.length <= 0 ? this._error = { error: t } : this.resolvers.shift().reject({ done: !0, value: t }));
  }
  close() {
    if (this._closedPromiseResolve) {
      const { resolvers: t } = this;
      for (; t.length > 0; )
        t.shift().resolve(Rt);
      this._closedPromiseResolve(), this._closedPromiseResolve = void 0;
    }
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  toDOMStream(t) {
    return ce.toDOMStream(this._closedPromiseResolve || this._error ? this : this._values, t);
  }
  toNodeStream(t) {
    return ce.toNodeStream(this._closedPromiseResolve || this._error ? this : this._values, t);
  }
  throw(t) {
    return gt(this, void 0, void 0, function* () {
      return yield this.abort(t), Rt;
    });
  }
  return(t) {
    return gt(this, void 0, void 0, function* () {
      return yield this.close(), Rt;
    });
  }
  read(t) {
    return gt(this, void 0, void 0, function* () {
      return (yield this.next(t, "read")).value;
    });
  }
  peek(t) {
    return gt(this, void 0, void 0, function* () {
      return (yield this.next(t, "peek")).value;
    });
  }
  next(...t) {
    return this._values.length > 0 ? Promise.resolve({ done: !1, value: this._values.shift() }) : this._error ? Promise.reject({ done: !0, value: this._error.error }) : this._closedPromiseResolve ? new Promise((e, n) => {
      this.resolvers.push({ resolve: e, reject: n });
    }) : Promise.resolve(Rt);
  }
  _ensureOpen() {
    if (this._closedPromiseResolve)
      return !0;
    throw new Error("AsyncQueue is closed");
  }
}
class Kl extends ql {
  write(t) {
    if ((t = It(t)).byteLength > 0)
      return super.write(t);
  }
  toString(t = !1) {
    return t ? ji(this.toUint8Array(!0)) : this.toUint8Array(!1).then(ji);
  }
  toUint8Array(t = !1) {
    return t ? Ee(this._values)[0] : gt(this, void 0, void 0, function* () {
      var e, n, s, i;
      const a = [];
      let c = 0;
      try {
        for (var d = !0, p = br(this), y; y = yield p.next(), e = y.done, !e; d = !0) {
          i = y.value, d = !1;
          const B = i;
          a.push(B), c += B.byteLength;
        }
      } catch (B) {
        n = { error: B };
      } finally {
        try {
          !d && !e && (s = p.return) && (yield s.call(p));
        } finally {
          if (n) throw n.error;
        }
      }
      return Ee(a, c)[0];
    });
  }
}
class oi {
  constructor(t) {
    t && (this.source = new Xl(ce.fromIterable(t)));
  }
  [Symbol.iterator]() {
    return this;
  }
  next(t) {
    return this.source.next(t);
  }
  throw(t) {
    return this.source.throw(t);
  }
  return(t) {
    return this.source.return(t);
  }
  peek(t) {
    return this.source.peek(t);
  }
  read(t) {
    return this.source.read(t);
  }
}
class Mr {
  constructor(t) {
    t instanceof Mr ? this.source = t.source : t instanceof Kl ? this.source = new Ke(ce.fromAsyncIterable(t)) : fa(t) ? this.source = new Ke(ce.fromNodeStream(t)) : ms(t) ? this.source = new Ke(ce.fromDOMStream(t)) : la(t) ? this.source = new Ke(ce.fromDOMStream(t.body)) : wi(t) ? this.source = new Ke(ce.fromIterable(t)) : un(t) ? this.source = new Ke(ce.fromAsyncIterable(t)) : gs(t) && (this.source = new Ke(ce.fromAsyncIterable(t)));
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  next(t) {
    return this.source.next(t);
  }
  throw(t) {
    return this.source.throw(t);
  }
  return(t) {
    return this.source.return(t);
  }
  get closed() {
    return this.source.closed;
  }
  cancel(t) {
    return this.source.cancel(t);
  }
  peek(t) {
    return this.source.peek(t);
  }
  read(t) {
    return this.source.read(t);
  }
}
class Xl {
  constructor(t) {
    this.source = t;
  }
  cancel(t) {
    this.return(t);
  }
  peek(t) {
    return this.next(t, "peek").value;
  }
  read(t) {
    return this.next(t, "read").value;
  }
  next(t, e = "read") {
    return this.source.next({ cmd: e, size: t });
  }
  throw(t) {
    return Object.create(this.source.throw && this.source.throw(t) || Rt);
  }
  return(t) {
    return Object.create(this.source.return && this.source.return(t) || Rt);
  }
}
class Ke {
  constructor(t) {
    this.source = t, this._closedPromise = new Promise((e) => this._closedPromiseResolve = e);
  }
  cancel(t) {
    return gt(this, void 0, void 0, function* () {
      yield this.return(t);
    });
  }
  get closed() {
    return this._closedPromise;
  }
  read(t) {
    return gt(this, void 0, void 0, function* () {
      return (yield this.next(t, "read")).value;
    });
  }
  peek(t) {
    return gt(this, void 0, void 0, function* () {
      return (yield this.next(t, "peek")).value;
    });
  }
  next(t) {
    return gt(this, arguments, void 0, function* (e, n = "read") {
      return yield this.source.next({ cmd: n, size: e });
    });
  }
  throw(t) {
    return gt(this, void 0, void 0, function* () {
      const e = this.source.throw && (yield this.source.throw(t)) || Rt;
      return this._closedPromiseResolve && this._closedPromiseResolve(), this._closedPromiseResolve = void 0, Object.create(e);
    });
  }
  return(t) {
    return gt(this, void 0, void 0, function* () {
      const e = this.source.return && (yield this.source.return(t)) || Rt;
      return this._closedPromiseResolve && this._closedPromiseResolve(), this._closedPromiseResolve = void 0, Object.create(e);
    });
  }
}
class _o extends oi {
  constructor(t, e) {
    super(), this.position = 0, this.buffer = It(t), this.size = e === void 0 ? this.buffer.byteLength : e;
  }
  readInt32(t) {
    const { buffer: e, byteOffset: n } = this.readAt(t, 4);
    return new DataView(e, n).getInt32(0, !0);
  }
  seek(t) {
    return this.position = Math.min(t, this.size), t < this.size;
  }
  read(t) {
    const { buffer: e, size: n, position: s } = this;
    return e && s < n ? (typeof t != "number" && (t = Number.POSITIVE_INFINITY), this.position = Math.min(n, s + Math.min(n - s, t)), e.subarray(s, this.position)) : null;
  }
  readAt(t, e) {
    const n = this.buffer, s = Math.min(this.size, t + e);
    return n ? n.subarray(t, s) : new Uint8Array(e);
  }
  close() {
    this.buffer && (this.buffer = null);
  }
  throw(t) {
    return this.close(), { done: !0, value: t };
  }
  return(t) {
    return this.close(), { done: !0, value: t };
  }
}
class ai extends Mr {
  constructor(t, e) {
    super(), this.position = 0, this._handle = t, typeof e == "number" ? this.size = e : this._pending = gt(this, void 0, void 0, function* () {
      this.size = (yield t.stat()).size, delete this._pending;
    });
  }
  readInt32(t) {
    return gt(this, void 0, void 0, function* () {
      const { buffer: e, byteOffset: n } = yield this.readAt(t, 4);
      return new DataView(e, n).getInt32(0, !0);
    });
  }
  seek(t) {
    return gt(this, void 0, void 0, function* () {
      return this._pending && (yield this._pending), this.position = Math.min(t, this.size), t < this.size;
    });
  }
  read(t) {
    return gt(this, void 0, void 0, function* () {
      this._pending && (yield this._pending);
      const { _handle: e, size: n, position: s } = this;
      if (e && s < n) {
        typeof t != "number" && (t = Number.POSITIVE_INFINITY);
        let i = s, a = 0, c = 0;
        const d = Math.min(n, i + Math.min(n - i, t)), p = new Uint8Array(Math.max(0, (this.position = d) - i));
        for (; (i += c) < d && (a += c) < p.byteLength; )
          ({ bytesRead: c } = yield e.read(p, a, p.byteLength - a, i));
        return p;
      }
      return null;
    });
  }
  readAt(t, e) {
    return gt(this, void 0, void 0, function* () {
      this._pending && (yield this._pending);
      const { _handle: n, size: s } = this;
      if (n && t + e < s) {
        const i = Math.min(s, t + e), a = new Uint8Array(i - t);
        return (yield n.read(a, 0, e, t)).buffer;
      }
      return new Uint8Array(e);
    });
  }
  close() {
    return gt(this, void 0, void 0, function* () {
      const t = this._handle;
      this._handle = null, t && (yield t.close());
    });
  }
  throw(t) {
    return gt(this, void 0, void 0, function* () {
      return yield this.close(), { done: !0, value: t };
    });
  }
  return(t) {
    return gt(this, void 0, void 0, function* () {
      return yield this.close(), { done: !0, value: t };
    });
  }
}
const Ql = 65536;
function wr(r) {
  return r < 0 && (r = 4294967295 + r + 1), `0x${r.toString(16)}`;
}
const Or = 8, Ms = [
  1,
  10,
  100,
  1e3,
  1e4,
  1e5,
  1e6,
  1e7,
  1e8
];
class Jc {
  constructor(t) {
    this.buffer = t;
  }
  high() {
    return this.buffer[1];
  }
  low() {
    return this.buffer[0];
  }
  _times(t) {
    const e = new Uint32Array([
      this.buffer[1] >>> 16,
      this.buffer[1] & 65535,
      this.buffer[0] >>> 16,
      this.buffer[0] & 65535
    ]), n = new Uint32Array([
      t.buffer[1] >>> 16,
      t.buffer[1] & 65535,
      t.buffer[0] >>> 16,
      t.buffer[0] & 65535
    ]);
    let s = e[3] * n[3];
    this.buffer[0] = s & 65535;
    let i = s >>> 16;
    return s = e[2] * n[3], i += s, s = e[3] * n[2] >>> 0, i += s, this.buffer[0] += i << 16, this.buffer[1] = i >>> 0 < s ? Ql : 0, this.buffer[1] += i >>> 16, this.buffer[1] += e[1] * n[3] + e[2] * n[2] + e[3] * n[1], this.buffer[1] += e[0] * n[3] + e[1] * n[2] + e[2] * n[1] + e[3] * n[0] << 16, this;
  }
  _plus(t) {
    const e = this.buffer[0] + t.buffer[0] >>> 0;
    this.buffer[1] += t.buffer[1], e < this.buffer[0] >>> 0 && ++this.buffer[1], this.buffer[0] = e;
  }
  lessThan(t) {
    return this.buffer[1] < t.buffer[1] || this.buffer[1] === t.buffer[1] && this.buffer[0] < t.buffer[0];
  }
  equals(t) {
    return this.buffer[1] === t.buffer[1] && this.buffer[0] == t.buffer[0];
  }
  greaterThan(t) {
    return t.lessThan(this);
  }
  hex() {
    return `${wr(this.buffer[1])} ${wr(this.buffer[0])}`;
  }
}
class Tt extends Jc {
  times(t) {
    return this._times(t), this;
  }
  plus(t) {
    return this._plus(t), this;
  }
  /** @nocollapse */
  static from(t, e = new Uint32Array(2)) {
    return Tt.fromString(typeof t == "string" ? t : t.toString(), e);
  }
  /** @nocollapse */
  static fromNumber(t, e = new Uint32Array(2)) {
    return Tt.fromString(t.toString(), e);
  }
  /** @nocollapse */
  static fromString(t, e = new Uint32Array(2)) {
    const n = t.length, s = new Tt(e);
    for (let i = 0; i < n; ) {
      const a = Or < n - i ? Or : n - i, c = new Tt(new Uint32Array([Number.parseInt(t.slice(i, i + a), 10), 0])), d = new Tt(new Uint32Array([Ms[a], 0]));
      s.times(d), s.plus(c), i += a;
    }
    return s;
  }
  /** @nocollapse */
  static convertArray(t) {
    const e = new Uint32Array(t.length * 2);
    for (let n = -1, s = t.length; ++n < s; )
      Tt.from(t[n], new Uint32Array(e.buffer, e.byteOffset + 2 * n * 4, 2));
    return e;
  }
  /** @nocollapse */
  static multiply(t, e) {
    return new Tt(new Uint32Array(t.buffer)).times(e);
  }
  /** @nocollapse */
  static add(t, e) {
    return new Tt(new Uint32Array(t.buffer)).plus(e);
  }
}
class te extends Jc {
  negate() {
    return this.buffer[0] = ~this.buffer[0] + 1, this.buffer[1] = ~this.buffer[1], this.buffer[0] == 0 && ++this.buffer[1], this;
  }
  times(t) {
    return this._times(t), this;
  }
  plus(t) {
    return this._plus(t), this;
  }
  lessThan(t) {
    const e = this.buffer[1] << 0, n = t.buffer[1] << 0;
    return e < n || e === n && this.buffer[0] < t.buffer[0];
  }
  /** @nocollapse */
  static from(t, e = new Uint32Array(2)) {
    return te.fromString(typeof t == "string" ? t : t.toString(), e);
  }
  /** @nocollapse */
  static fromNumber(t, e = new Uint32Array(2)) {
    return te.fromString(t.toString(), e);
  }
  /** @nocollapse */
  static fromString(t, e = new Uint32Array(2)) {
    const n = t.startsWith("-"), s = t.length, i = new te(e);
    for (let a = n ? 1 : 0; a < s; ) {
      const c = Or < s - a ? Or : s - a, d = new te(new Uint32Array([Number.parseInt(t.slice(a, a + c), 10), 0])), p = new te(new Uint32Array([Ms[c], 0]));
      i.times(p), i.plus(d), a += c;
    }
    return n ? i.negate() : i;
  }
  /** @nocollapse */
  static convertArray(t) {
    const e = new Uint32Array(t.length * 2);
    for (let n = -1, s = t.length; ++n < s; )
      te.from(t[n], new Uint32Array(e.buffer, e.byteOffset + 2 * n * 4, 2));
    return e;
  }
  /** @nocollapse */
  static multiply(t, e) {
    return new te(new Uint32Array(t.buffer)).times(e);
  }
  /** @nocollapse */
  static add(t, e) {
    return new te(new Uint32Array(t.buffer)).plus(e);
  }
}
class Ie {
  constructor(t) {
    this.buffer = t;
  }
  high() {
    return new te(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset + 8, 2));
  }
  low() {
    return new te(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset, 2));
  }
  negate() {
    return this.buffer[0] = ~this.buffer[0] + 1, this.buffer[1] = ~this.buffer[1], this.buffer[2] = ~this.buffer[2], this.buffer[3] = ~this.buffer[3], this.buffer[0] == 0 && ++this.buffer[1], this.buffer[1] == 0 && ++this.buffer[2], this.buffer[2] == 0 && ++this.buffer[3], this;
  }
  times(t) {
    const e = new Tt(new Uint32Array([this.buffer[3], 0])), n = new Tt(new Uint32Array([this.buffer[2], 0])), s = new Tt(new Uint32Array([this.buffer[1], 0])), i = new Tt(new Uint32Array([this.buffer[0], 0])), a = new Tt(new Uint32Array([t.buffer[3], 0])), c = new Tt(new Uint32Array([t.buffer[2], 0])), d = new Tt(new Uint32Array([t.buffer[1], 0])), p = new Tt(new Uint32Array([t.buffer[0], 0]));
    let y = Tt.multiply(i, p);
    this.buffer[0] = y.low();
    const B = new Tt(new Uint32Array([y.high(), 0]));
    return y = Tt.multiply(s, p), B.plus(y), y = Tt.multiply(i, d), B.plus(y), this.buffer[1] = B.low(), this.buffer[3] = B.lessThan(y) ? 1 : 0, this.buffer[2] = B.high(), new Tt(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset + 8, 2)).plus(Tt.multiply(n, p)).plus(Tt.multiply(s, d)).plus(Tt.multiply(i, c)), this.buffer[3] += Tt.multiply(e, p).plus(Tt.multiply(n, d)).plus(Tt.multiply(s, c)).plus(Tt.multiply(i, a)).low(), this;
  }
  plus(t) {
    const e = new Uint32Array(4);
    return e[3] = this.buffer[3] + t.buffer[3] >>> 0, e[2] = this.buffer[2] + t.buffer[2] >>> 0, e[1] = this.buffer[1] + t.buffer[1] >>> 0, e[0] = this.buffer[0] + t.buffer[0] >>> 0, e[0] < this.buffer[0] >>> 0 && ++e[1], e[1] < this.buffer[1] >>> 0 && ++e[2], e[2] < this.buffer[2] >>> 0 && ++e[3], this.buffer[3] = e[3], this.buffer[2] = e[2], this.buffer[1] = e[1], this.buffer[0] = e[0], this;
  }
  hex() {
    return `${wr(this.buffer[3])} ${wr(this.buffer[2])} ${wr(this.buffer[1])} ${wr(this.buffer[0])}`;
  }
  /** @nocollapse */
  static multiply(t, e) {
    return new Ie(new Uint32Array(t.buffer)).times(e);
  }
  /** @nocollapse */
  static add(t, e) {
    return new Ie(new Uint32Array(t.buffer)).plus(e);
  }
  /** @nocollapse */
  static from(t, e = new Uint32Array(4)) {
    return Ie.fromString(typeof t == "string" ? t : t.toString(), e);
  }
  /** @nocollapse */
  static fromNumber(t, e = new Uint32Array(4)) {
    return Ie.fromString(t.toString(), e);
  }
  /** @nocollapse */
  static fromString(t, e = new Uint32Array(4)) {
    const n = t.startsWith("-"), s = t.length, i = new Ie(e);
    for (let a = n ? 1 : 0; a < s; ) {
      const c = Or < s - a ? Or : s - a, d = new Ie(new Uint32Array([Number.parseInt(t.slice(a, a + c), 10), 0, 0, 0])), p = new Ie(new Uint32Array([Ms[c], 0, 0, 0]));
      i.times(p), i.plus(d), a += c;
    }
    return n ? i.negate() : i;
  }
  /** @nocollapse */
  static convertArray(t) {
    const e = new Uint32Array(t.length * 4);
    for (let n = -1, s = t.length; ++n < s; )
      Ie.from(t[n], new Uint32Array(e.buffer, e.byteOffset + 4 * 4 * n, 4));
    return e;
  }
}
class Hc extends St {
  constructor(t, e, n, s, i = zt.V5) {
    super(), this.nodesIndex = -1, this.buffersIndex = -1, this.bytes = t, this.nodes = e, this.buffers = n, this.dictionaries = s, this.metadataVersion = i;
  }
  visit(t) {
    return super.visit(t instanceof Ct ? t.type : t);
  }
  visitNull(t, { length: e } = this.nextFieldNode()) {
    return _t({ type: t, length: e });
  }
  visitBool(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitInt(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitFloat(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitUtf8(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), valueOffsets: this.readOffsets(t), data: this.readData(t) });
  }
  visitLargeUtf8(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), valueOffsets: this.readOffsets(t), data: this.readData(t) });
  }
  visitBinary(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), valueOffsets: this.readOffsets(t), data: this.readData(t) });
  }
  visitLargeBinary(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), valueOffsets: this.readOffsets(t), data: this.readData(t) });
  }
  visitFixedSizeBinary(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitDate(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitTimestamp(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitTime(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitDecimal(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitList(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), valueOffsets: this.readOffsets(t), child: this.visit(t.children[0]) });
  }
  visitStruct(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), children: this.visitMany(t.children) });
  }
  visitUnion(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return this.metadataVersion < zt.V5 && this.readNullBitmap(t, n), t.mode === re.Sparse ? this.visitSparseUnion(t, { length: e, nullCount: n }) : this.visitDenseUnion(t, { length: e, nullCount: n });
  }
  visitDenseUnion(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, typeIds: this.readTypeIds(t), valueOffsets: this.readOffsets(t), children: this.visitMany(t.children) });
  }
  visitSparseUnion(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, typeIds: this.readTypeIds(t), children: this.visitMany(t.children) });
  }
  visitDictionary(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t.indices), dictionary: this.readDictionary(t) });
  }
  visitInterval(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitDuration(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitFixedSizeList(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), child: this.visit(t.children[0]) });
  }
  visitMap(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _t({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), valueOffsets: this.readOffsets(t), child: this.visit(t.children[0]) });
  }
  nextFieldNode() {
    return this.nodes[++this.nodesIndex];
  }
  nextBufferRange() {
    return this.buffers[++this.buffersIndex];
  }
  readNullBitmap(t, e, n = this.nextBufferRange()) {
    return e > 0 && this.readData(t, n) || new Uint8Array(0);
  }
  readOffsets(t, e) {
    return this.readData(t, e);
  }
  readTypeIds(t, e) {
    return this.readData(t, e);
  }
  readData(t, { length: e, offset: n } = this.nextBufferRange()) {
    return this.bytes.subarray(n, n + e);
  }
  readDictionary(t) {
    return this.dictionaries.get(t.id);
  }
}
class td extends Hc {
  constructor(t, e, n, s, i) {
    super(new Uint8Array(0), e, n, s, i), this.sources = t;
  }
  readNullBitmap(t, e, { offset: n } = this.nextBufferRange()) {
    return e <= 0 ? new Uint8Array(0) : Hi(this.sources[n]);
  }
  readOffsets(t, { offset: e } = this.nextBufferRange()) {
    return Mt(Uint8Array, Mt(t.OffsetArrayType, this.sources[e]));
  }
  readTypeIds(t, { offset: e } = this.nextBufferRange()) {
    return Mt(Uint8Array, Mt(t.ArrayType, this.sources[e]));
  }
  readData(t, { offset: e } = this.nextBufferRange()) {
    const { sources: n } = this;
    return tt.isTimestamp(t) || (tt.isInt(t) || tt.isTime(t)) && t.bitWidth === 64 || tt.isDuration(t) || tt.isDate(t) && t.unit === de.MILLISECOND ? Mt(Uint8Array, te.convertArray(n[e])) : tt.isDecimal(t) ? Mt(Uint8Array, Ie.convertArray(n[e])) : tt.isBinary(t) || tt.isLargeBinary(t) || tt.isFixedSizeBinary(t) ? ed(n[e]) : tt.isBool(t) ? Hi(n[e]) : tt.isUtf8(t) || tt.isLargeUtf8(t) ? ys(n[e].join("")) : Mt(Uint8Array, Mt(t.ArrayType, n[e].map((s) => +s)));
  }
}
function ed(r) {
  const t = r.join(""), e = new Uint8Array(t.length / 2);
  for (let n = 0; n < t.length; n += 2)
    e[n >> 1] = Number.parseInt(t.slice(n, n + 2), 16);
  return e;
}
class ot extends St {
  compareSchemas(t, e) {
    return t === e || e instanceof t.constructor && this.compareManyFields(t.fields, e.fields);
  }
  compareManyFields(t, e) {
    return t === e || Array.isArray(t) && Array.isArray(e) && t.length === e.length && t.every((n, s) => this.compareFields(n, e[s]));
  }
  compareFields(t, e) {
    return t === e || e instanceof t.constructor && t.name === e.name && t.nullable === e.nullable && this.visit(t.type, e.type);
  }
}
function Xt(r, t) {
  return t instanceof r.constructor;
}
function ir(r, t) {
  return r === t || Xt(r, t);
}
function Pe(r, t) {
  return r === t || Xt(r, t) && r.bitWidth === t.bitWidth && r.isSigned === t.isSigned;
}
function _i(r, t) {
  return r === t || Xt(r, t) && r.precision === t.precision;
}
function rd(r, t) {
  return r === t || Xt(r, t) && r.byteWidth === t.byteWidth;
}
function Os(r, t) {
  return r === t || Xt(r, t) && r.unit === t.unit;
}
function yn(r, t) {
  return r === t || Xt(r, t) && r.unit === t.unit && r.timezone === t.timezone;
}
function gn(r, t) {
  return r === t || Xt(r, t) && r.unit === t.unit && r.bitWidth === t.bitWidth;
}
function nd(r, t) {
  return r === t || Xt(r, t) && r.children.length === t.children.length && Je.compareManyFields(r.children, t.children);
}
function id(r, t) {
  return r === t || Xt(r, t) && r.children.length === t.children.length && Je.compareManyFields(r.children, t.children);
}
function Fs(r, t) {
  return r === t || Xt(r, t) && r.mode === t.mode && r.typeIds.every((e, n) => e === t.typeIds[n]) && Je.compareManyFields(r.children, t.children);
}
function sd(r, t) {
  return r === t || Xt(r, t) && r.id === t.id && r.isOrdered === t.isOrdered && Je.visit(r.indices, t.indices) && Je.visit(r.dictionary, t.dictionary);
}
function ks(r, t) {
  return r === t || Xt(r, t) && r.unit === t.unit;
}
function mn(r, t) {
  return r === t || Xt(r, t) && r.unit === t.unit;
}
function od(r, t) {
  return r === t || Xt(r, t) && r.listSize === t.listSize && r.children.length === t.children.length && Je.compareManyFields(r.children, t.children);
}
function ad(r, t) {
  return r === t || Xt(r, t) && r.keysSorted === t.keysSorted && r.children.length === t.children.length && Je.compareManyFields(r.children, t.children);
}
ot.prototype.visitNull = ir;
ot.prototype.visitBool = ir;
ot.prototype.visitInt = Pe;
ot.prototype.visitInt8 = Pe;
ot.prototype.visitInt16 = Pe;
ot.prototype.visitInt32 = Pe;
ot.prototype.visitInt64 = Pe;
ot.prototype.visitUint8 = Pe;
ot.prototype.visitUint16 = Pe;
ot.prototype.visitUint32 = Pe;
ot.prototype.visitUint64 = Pe;
ot.prototype.visitFloat = _i;
ot.prototype.visitFloat16 = _i;
ot.prototype.visitFloat32 = _i;
ot.prototype.visitFloat64 = _i;
ot.prototype.visitUtf8 = ir;
ot.prototype.visitLargeUtf8 = ir;
ot.prototype.visitBinary = ir;
ot.prototype.visitLargeBinary = ir;
ot.prototype.visitFixedSizeBinary = rd;
ot.prototype.visitDate = Os;
ot.prototype.visitDateDay = Os;
ot.prototype.visitDateMillisecond = Os;
ot.prototype.visitTimestamp = yn;
ot.prototype.visitTimestampSecond = yn;
ot.prototype.visitTimestampMillisecond = yn;
ot.prototype.visitTimestampMicrosecond = yn;
ot.prototype.visitTimestampNanosecond = yn;
ot.prototype.visitTime = gn;
ot.prototype.visitTimeSecond = gn;
ot.prototype.visitTimeMillisecond = gn;
ot.prototype.visitTimeMicrosecond = gn;
ot.prototype.visitTimeNanosecond = gn;
ot.prototype.visitDecimal = ir;
ot.prototype.visitList = nd;
ot.prototype.visitStruct = id;
ot.prototype.visitUnion = Fs;
ot.prototype.visitDenseUnion = Fs;
ot.prototype.visitSparseUnion = Fs;
ot.prototype.visitDictionary = sd;
ot.prototype.visitInterval = ks;
ot.prototype.visitIntervalDayTime = ks;
ot.prototype.visitIntervalYearMonth = ks;
ot.prototype.visitDuration = mn;
ot.prototype.visitDurationSecond = mn;
ot.prototype.visitDurationMillisecond = mn;
ot.prototype.visitDurationMicrosecond = mn;
ot.prototype.visitDurationNanosecond = mn;
ot.prototype.visitFixedSizeList = od;
ot.prototype.visitMap = ad;
const Je = new ot();
function cd(r, t) {
  return Je.compareSchemas(r, t);
}
function Oi(r, t) {
  return ud(r, t.map((e) => e.data.concat()));
}
function ud(r, t) {
  const e = [...r.fields], n = [], s = { numBatches: t.reduce((B, R) => Math.max(B, R.length), 0) };
  let i = 0, a = 0, c = -1;
  const d = t.length;
  let p, y = [];
  for (; s.numBatches-- > 0; ) {
    for (a = Number.POSITIVE_INFINITY, c = -1; ++c < d; )
      y[c] = p = t[c].shift(), a = Math.min(a, p ? p.length : a);
    Number.isFinite(a) && (y = hd(e, a, y, t, s), a > 0 && (n[i++] = _t({
      type: new Kt(e),
      length: a,
      nullCount: 0,
      children: y.slice()
    })));
  }
  return [
    r = r.assign(e),
    n.map((B) => new ye(r, B))
  ];
}
function hd(r, t, e, n, s) {
  var i;
  const a = (t + 63 & -64) >> 3;
  for (let c = -1, d = n.length; ++c < d; ) {
    const p = e[c], y = p?.length;
    if (y >= t)
      y === t ? e[c] = p : (e[c] = p.slice(0, t), s.numBatches = Math.max(s.numBatches, n[c].unshift(p.slice(t, y - t))));
    else {
      const B = r[c];
      r[c] = B.clone({ nullable: !0 }), e[c] = (i = p?._changeLengthAndBackfillNullBitmap(t)) !== null && i !== void 0 ? i : _t({
        type: B.type,
        length: t,
        nullCount: t,
        nullBitmap: new Uint8Array(a)
      });
    }
  }
  return e;
}
var qc;
class le {
  constructor(...t) {
    var e, n;
    if (t.length === 0)
      return this.batches = [], this.schema = new vt([]), this._offsets = [0], this;
    let s, i;
    t[0] instanceof vt && (s = t.shift()), t.at(-1) instanceof Uint32Array && (i = t.pop());
    const a = (d) => {
      if (d) {
        if (d instanceof ye)
          return [d];
        if (d instanceof le)
          return d.batches;
        if (d instanceof Et) {
          if (d.type instanceof Kt)
            return [new ye(new vt(d.type.children), d)];
        } else {
          if (Array.isArray(d))
            return d.flatMap((p) => a(p));
          if (typeof d[Symbol.iterator] == "function")
            return [...d].flatMap((p) => a(p));
          if (typeof d == "object") {
            const p = Object.keys(d), y = p.map((F) => new Ft([d[F]])), B = s ?? new vt(p.map((F, T) => new Ct(String(F), y[T].type, y[T].nullable))), [, R] = Oi(B, y);
            return R.length === 0 ? [new ye(d)] : R;
          }
        }
      }
      return [];
    }, c = t.flatMap((d) => a(d));
    if (s = (n = s ?? ((e = c[0]) === null || e === void 0 ? void 0 : e.schema)) !== null && n !== void 0 ? n : new vt([]), !(s instanceof vt))
      throw new TypeError("Table constructor expects a [Schema, RecordBatch[]] pair.");
    for (const d of c) {
      if (!(d instanceof ye))
        throw new TypeError("Table constructor expects a [Schema, RecordBatch[]] pair.");
      if (!cd(s, d.schema))
        throw new TypeError("Table and inner RecordBatch schemas must be equivalent.");
    }
    this.schema = s, this.batches = c, this._offsets = i ?? Pc(this.data);
  }
  /**
   * The contiguous {@link RecordBatch `RecordBatch`} chunks of the Table rows.
   */
  get data() {
    return this.batches.map(({ data: t }) => t);
  }
  /**
   * The number of columns in this Table.
   */
  get numCols() {
    return this.schema.fields.length;
  }
  /**
   * The number of rows in this Table.
   */
  get numRows() {
    return this.data.reduce((t, e) => t + e.length, 0);
  }
  /**
   * The number of null rows in this Table.
   */
  get nullCount() {
    return this._nullCount === -1 && (this._nullCount = Rc(this.data)), this._nullCount;
  }
  /**
   * Check whether an element is null.
   *
   * @param index The index at which to read the validity bitmap.
   */
  // @ts-ignore
  isValid(t) {
    return !1;
  }
  /**
   * Get an element value by position.
   *
   * @param index The index of the element to read.
   */
  // @ts-ignore
  get(t) {
    return null;
  }
  /**
    * Get an element value by position.
    * @param index The index of the element to read. A negative index will count back from the last element.
    */
  // @ts-ignore
  at(t) {
    return this.get(Bs(t, this.numRows));
  }
  /**
   * Set an element value by position.
   *
   * @param index The index of the element to write.
   * @param value The value to set.
   */
  // @ts-ignore
  set(t, e) {
  }
  /**
   * Retrieve the index of the first occurrence of a value in an Vector.
   *
   * @param element The value to locate in the Vector.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  // @ts-ignore
  indexOf(t, e) {
    return -1;
  }
  /**
   * Iterator for rows in this Table.
   */
  [Symbol.iterator]() {
    return this.batches.length > 0 ? Es.visit(new Ft(this.data)) : new Array(0)[Symbol.iterator]();
  }
  /**
   * Return a JavaScript Array of the Table rows.
   *
   * @returns An Array of Table rows.
   */
  toArray() {
    return [...this];
  }
  /**
   * Returns a string representation of the Table rows.
   *
   * @returns A string representation of the Table rows.
   */
  toString() {
    return `[
  ${this.toArray().join(`,
  `)}
]`;
  }
  /**
   * Combines two or more Tables of the same schema.
   *
   * @param others Additional Tables to add to the end of this Tables.
   */
  concat(...t) {
    const e = this.schema, n = this.data.concat(t.flatMap(({ data: s }) => s));
    return new le(e, n.map((s) => new ye(e, s)));
  }
  /**
   * Return a zero-copy sub-section of this Table.
   *
   * @param begin The beginning of the specified portion of the Table.
   * @param end The end of the specified portion of the Table. This is exclusive of the element at the index 'end'.
   */
  slice(t, e) {
    const n = this.schema;
    [t, e] = Lc({ length: this.numRows }, t, e);
    const s = $c(this.data, this._offsets, t, e);
    return new le(n, s.map((i) => new ye(n, i)));
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   *
   * @param name The name of the child to retrieve.
   */
  getChild(t) {
    return this.getChildAt(this.schema.fields.findIndex((e) => e.name === t));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   *
   * @param index The index of the child to retrieve.
   */
  getChildAt(t) {
    if (t > -1 && t < this.schema.fields.length) {
      const e = this.data.map((n) => n.children[t]);
      if (e.length === 0) {
        const { type: n } = this.schema.fields[t], s = _t({ type: n, length: 0, nullCount: 0 });
        e.push(s._changeLengthAndBackfillNullBitmap(this.numRows));
      }
      return new Ft(e);
    }
    return null;
  }
  /**
   * Sets a child Vector by name.
   *
   * @param name The name of the child to overwrite.
   * @returns A new Table with the supplied child for the specified name.
   */
  setChild(t, e) {
    var n;
    return this.setChildAt((n = this.schema.fields) === null || n === void 0 ? void 0 : n.findIndex((s) => s.name === t), e);
  }
  setChildAt(t, e) {
    let n = this.schema, s = [...this.batches];
    if (t > -1 && t < this.numCols) {
      e || (e = new Ft([_t({ type: new Ye(), length: this.numRows })]));
      const i = n.fields.slice(), a = i[t].clone({ type: e.type }), c = this.schema.fields.map((d, p) => this.getChildAt(p));
      [i[t], c[t]] = [a, e], [n, s] = Oi(n, c);
    }
    return new le(n, s);
  }
  /**
   * Construct a new Table containing only specified columns.
   *
   * @param columnNames Names of columns to keep.
   * @returns A new Table of columns matching the specified names.
   */
  select(t) {
    const e = this.schema.fields.reduce((n, s, i) => n.set(s.name, i), /* @__PURE__ */ new Map());
    return this.selectAt(t.map((n) => e.get(n)).filter((n) => n > -1));
  }
  /**
   * Construct a new Table containing only columns at the specified indices.
   *
   * @param columnIndices Indices of columns to keep.
   * @returns A new Table of columns at the specified indices.
   */
  selectAt(t) {
    const e = this.schema.selectAt(t), n = this.batches.map((s) => s.selectAt(t));
    return new le(e, n);
  }
  assign(t) {
    const e = this.schema.fields, [n, s] = t.schema.fields.reduce((c, d, p) => {
      const [y, B] = c, R = e.findIndex((F) => F.name === d.name);
      return ~R ? B[R] = p : y.push(p), c;
    }, [[], []]), i = this.schema.assign(t.schema), a = [
      ...e.map((c, d) => [d, s[d]]).map(([c, d]) => d === void 0 ? this.getChildAt(c) : t.getChildAt(d)),
      ...n.map((c) => t.getChildAt(c))
    ].filter(Boolean);
    return new le(...Oi(i, a));
  }
}
qc = Symbol.toStringTag;
le[qc] = ((r) => (r.schema = null, r.batches = [], r._offsets = new Uint32Array([0]), r._nullCount = -1, r[Symbol.isConcatSpreadable] = !0, r.isValid = ni(As), r.get = ni(ne.getVisitFn(A.Struct)), r.set = zc(fe.getVisitFn(A.Struct)), r.indexOf = jc(ii.getVisitFn(A.Struct)), "Table"))(le.prototype);
var Kc;
let ye = class on {
  constructor(...t) {
    switch (t.length) {
      case 2: {
        if ([this.schema] = t, !(this.schema instanceof vt))
          throw new TypeError("RecordBatch constructor expects a [Schema, Data] pair.");
        if ([
          ,
          this.data = _t({
            nullCount: 0,
            type: new Kt(this.schema.fields),
            children: this.schema.fields.map((e) => _t({ type: e.type, nullCount: 0 }))
          })
        ] = t, !(this.data instanceof Et))
          throw new TypeError("RecordBatch constructor expects a [Schema, Data] pair.");
        [this.schema, this.data] = So(this.schema, this.data.children);
        break;
      }
      case 1: {
        const [e] = t, { fields: n, children: s, length: i } = Object.keys(e).reduce((d, p, y) => (d.children[y] = e[p], d.length = Math.max(d.length, e[p].length), d.fields[y] = Ct.new({ name: p, type: e[p].type, nullable: !0 }), d), {
          length: 0,
          fields: new Array(),
          children: new Array()
        }), a = new vt(n), c = _t({ type: new Kt(n), length: i, children: s, nullCount: 0 });
        [this.schema, this.data] = So(a, c.children, i);
        break;
      }
      default:
        throw new TypeError("RecordBatch constructor expects an Object mapping names to child Data, or a [Schema, Data] pair.");
    }
  }
  get dictionaries() {
    return this._dictionaries || (this._dictionaries = Xc(this.schema.fields, this.data.children));
  }
  /**
   * The number of columns in this RecordBatch.
   */
  get numCols() {
    return this.schema.fields.length;
  }
  /**
   * The number of rows in this RecordBatch.
   */
  get numRows() {
    return this.data.length;
  }
  /**
   * The number of null rows in this RecordBatch.
   */
  get nullCount() {
    return this.data.nullCount;
  }
  /**
   * Check whether an row is null.
   * @param index The index at which to read the validity bitmap.
   */
  isValid(t) {
    return this.data.getValid(t);
  }
  /**
   * Get a row by position.
   * @param index The index of the row to read.
   */
  get(t) {
    return ne.visit(this.data, t);
  }
  /**
    * Get a row value by position.
    * @param index The index of the row to read. A negative index will count back from the last row.
    */
  at(t) {
    return this.get(Bs(t, this.numRows));
  }
  /**
   * Set a row by position.
   * @param index The index of the row to write.
   * @param value The value to set.
   */
  set(t, e) {
    return fe.visit(this.data, t, e);
  }
  /**
   * Retrieve the index of the first occurrence of a row in an RecordBatch.
   * @param element The row to locate in the RecordBatch.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  indexOf(t, e) {
    return ii.visit(this.data, t, e);
  }
  /**
   * Iterator for rows in this RecordBatch.
   */
  [Symbol.iterator]() {
    return Es.visit(new Ft([this.data]));
  }
  /**
   * Return a JavaScript Array of the RecordBatch rows.
   * @returns An Array of RecordBatch rows.
   */
  toArray() {
    return [...this];
  }
  /**
   * Combines two or more RecordBatch of the same schema.
   * @param others Additional RecordBatch to add to the end of this RecordBatch.
   */
  concat(...t) {
    return new le(this.schema, [this, ...t]);
  }
  /**
   * Return a zero-copy sub-section of this RecordBatch.
   * @param start The beginning of the specified portion of the RecordBatch.
   * @param end The end of the specified portion of the RecordBatch. This is exclusive of the row at the index 'end'.
   */
  slice(t, e) {
    const [n] = new Ft([this.data]).slice(t, e).data;
    return new on(this.schema, n);
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   * @param name The name of the child to retrieve.
   */
  getChild(t) {
    var e;
    return this.getChildAt((e = this.schema.fields) === null || e === void 0 ? void 0 : e.findIndex((n) => n.name === t));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   * @param index The index of the child to retrieve.
   */
  getChildAt(t) {
    return t > -1 && t < this.schema.fields.length ? new Ft([this.data.children[t]]) : null;
  }
  /**
   * Sets a child Vector by name.
   * @param name The name of the child to overwrite.
   * @returns A new RecordBatch with the new child for the specified name.
   */
  setChild(t, e) {
    var n;
    return this.setChildAt((n = this.schema.fields) === null || n === void 0 ? void 0 : n.findIndex((s) => s.name === t), e);
  }
  setChildAt(t, e) {
    let n = this.schema, s = this.data;
    if (t > -1 && t < this.numCols) {
      e || (e = new Ft([_t({ type: new Ye(), length: this.numRows })]));
      const i = n.fields.slice(), a = s.children.slice(), c = i[t].clone({ type: e.type });
      [i[t], a[t]] = [c, e.data[0]], n = new vt(i, new Map(this.schema.metadata)), s = _t({ type: new Kt(i), children: a });
    }
    return new on(n, s);
  }
  /**
   * Construct a new RecordBatch containing only specified columns.
   *
   * @param columnNames Names of columns to keep.
   * @returns A new RecordBatch of columns matching the specified names.
   */
  select(t) {
    const e = this.schema.select(t), n = new Kt(e.fields), s = [];
    for (const i of t) {
      const a = this.schema.fields.findIndex((c) => c.name === i);
      ~a && (s[a] = this.data.children[a]);
    }
    return new on(e, _t({ type: n, length: this.numRows, children: s }));
  }
  /**
   * Construct a new RecordBatch containing only columns at the specified indices.
   *
   * @param columnIndices Indices of columns to keep.
   * @returns A new RecordBatch of columns matching at the specified indices.
   */
  selectAt(t) {
    const e = this.schema.selectAt(t), n = t.map((i) => this.data.children[i]).filter(Boolean), s = _t({ type: new Kt(e.fields), length: this.numRows, children: n });
    return new on(e, s);
  }
};
Kc = Symbol.toStringTag;
ye[Kc] = ((r) => (r._nullCount = -1, r[Symbol.isConcatSpreadable] = !0, "RecordBatch"))(ye.prototype);
function So(r, t, e = t.reduce((n, s) => Math.max(n, s.length), 0)) {
  var n;
  const s = [...r.fields], i = [...t], a = (e + 63 & -64) >> 3;
  for (const [c, d] of r.fields.entries()) {
    const p = t[c];
    (!p || p.length !== e) && (s[c] = d.clone({ nullable: !0 }), i[c] = (n = p?._changeLengthAndBackfillNullBitmap(e)) !== null && n !== void 0 ? n : _t({
      type: d.type,
      length: e,
      nullCount: e,
      nullBitmap: new Uint8Array(a)
    }));
  }
  return [
    r.assign(s),
    _t({ type: new Kt(s), length: e, children: i })
  ];
}
function Xc(r, t, e = /* @__PURE__ */ new Map()) {
  var n, s;
  if (((n = r?.length) !== null && n !== void 0 ? n : 0) > 0 && r?.length === t?.length)
    for (let i = -1, a = r.length; ++i < a; ) {
      const { type: c } = r[i], d = t[i];
      for (const p of [d, ...((s = d?.dictionary) === null || s === void 0 ? void 0 : s.data) || []])
        Xc(c.children, p?.children, e);
      if (tt.isDictionary(c)) {
        const { id: p } = c;
        if (!e.has(p))
          d?.dictionary && e.set(p, d.dictionary);
        else if (e.get(p) !== d.dictionary)
          throw new Error("Cannot create Schema containing two different dictionaries with the same Id");
      }
    }
  return e;
}
class Qc extends ye {
  constructor(t) {
    const e = t.fields.map((s) => _t({ type: s.type })), n = _t({ type: new Kt(t.fields), nullCount: 0, children: e });
    super(t, n);
  }
}
let je = class _e {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsMessage(t, e) {
    return (e || new _e()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsMessage(t, e) {
    return t.setPosition(t.position() + xt), (e || new _e()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  version() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : zt.V1;
  }
  headerType() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.readUint8(this.bb_pos + t) : Bt.NONE;
  }
  header(t) {
    const e = this.bb.__offset(this.bb_pos, 8);
    return e ? this.bb.__union(t, this.bb_pos + e) : null;
  }
  bodyLength() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.readInt64(this.bb_pos + t) : BigInt("0");
  }
  customMetadata(t, e) {
    const n = this.bb.__offset(this.bb_pos, 12);
    return n ? (e || new jt()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + t * 4), this.bb) : null;
  }
  customMetadataLength() {
    const t = this.bb.__offset(this.bb_pos, 12);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startMessage(t) {
    t.startObject(5);
  }
  static addVersion(t, e) {
    t.addFieldInt16(0, e, zt.V1);
  }
  static addHeaderType(t, e) {
    t.addFieldInt8(1, e, Bt.NONE);
  }
  static addHeader(t, e) {
    t.addFieldOffset(2, e, 0);
  }
  static addBodyLength(t, e) {
    t.addFieldInt64(3, e, BigInt("0"));
  }
  static addCustomMetadata(t, e) {
    t.addFieldOffset(4, e, 0);
  }
  static createCustomMetadataVector(t, e) {
    t.startVector(4, e.length, 4);
    for (let n = e.length - 1; n >= 0; n--)
      t.addOffset(e[n]);
    return t.endVector();
  }
  static startCustomMetadataVector(t, e) {
    t.startVector(4, e, 4);
  }
  static endMessage(t) {
    return t.endObject();
  }
  static finishMessageBuffer(t, e) {
    t.finish(e);
  }
  static finishSizePrefixedMessageBuffer(t, e) {
    t.finish(e, void 0, !0);
  }
  static createMessage(t, e, n, s, i, a) {
    return _e.startMessage(t), _e.addVersion(t, e), _e.addHeaderType(t, n), _e.addHeader(t, s), _e.addBodyLength(t, i), _e.addCustomMetadata(t, a), _e.endMessage(t);
  }
};
class ld extends St {
  visit(t, e) {
    return t == null || e == null ? void 0 : super.visit(t, e);
  }
  visitNull(t, e) {
    return ho.startNull(e), ho.endNull(e);
  }
  visitInt(t, e) {
    return oe.startInt(e), oe.addBitWidth(e, t.bitWidth), oe.addIsSigned(e, t.isSigned), oe.endInt(e);
  }
  visitFloat(t, e) {
    return ve.startFloatingPoint(e), ve.addPrecision(e, t.precision), ve.endFloatingPoint(e);
  }
  visitBinary(t, e) {
    return so.startBinary(e), so.endBinary(e);
  }
  visitLargeBinary(t, e) {
    return ao.startLargeBinary(e), ao.endLargeBinary(e);
  }
  visitBool(t, e) {
    return oo.startBool(e), oo.endBool(e);
  }
  visitUtf8(t, e) {
    return lo.startUtf8(e), lo.endUtf8(e);
  }
  visitLargeUtf8(t, e) {
    return co.startLargeUtf8(e), co.endLargeUtf8(e);
  }
  visitDecimal(t, e) {
    return ur.startDecimal(e), ur.addScale(e, t.scale), ur.addPrecision(e, t.precision), ur.addBitWidth(e, t.bitWidth), ur.endDecimal(e);
  }
  visitDate(t, e) {
    return En.startDate(e), En.addUnit(e, t.unit), En.endDate(e);
  }
  visitTime(t, e) {
    return ue.startTime(e), ue.addUnit(e, t.unit), ue.addBitWidth(e, t.bitWidth), ue.endTime(e);
  }
  visitTimestamp(t, e) {
    const n = t.timezone && e.createString(t.timezone) || void 0;
    return he.startTimestamp(e), he.addUnit(e, t.unit), n !== void 0 && he.addTimezone(e, n), he.endTimestamp(e);
  }
  visitInterval(t, e) {
    return xe.startInterval(e), xe.addUnit(e, t.unit), xe.endInterval(e);
  }
  visitDuration(t, e) {
    return Tn.startDuration(e), Tn.addUnit(e, t.unit), Tn.endDuration(e);
  }
  visitList(t, e) {
    return uo.startList(e), uo.endList(e);
  }
  visitStruct(t, e) {
    return Xe.startStruct_(e), Xe.endStruct_(e);
  }
  visitUnion(t, e) {
    ee.startTypeIdsVector(e, t.typeIds.length);
    const n = ee.createTypeIdsVector(e, t.typeIds);
    return ee.startUnion(e), ee.addMode(e, t.mode), ee.addTypeIds(e, n), ee.endUnion(e);
  }
  visitDictionary(t, e) {
    const n = this.visit(t.indices, e);
    return De.startDictionaryEncoding(e), De.addId(e, BigInt(t.id)), De.addIsOrdered(e, t.isOrdered), n !== void 0 && De.addIndexType(e, n), De.endDictionaryEncoding(e);
  }
  visitFixedSizeBinary(t, e) {
    return Mn.startFixedSizeBinary(e), Mn.addByteWidth(e, t.byteWidth), Mn.endFixedSizeBinary(e);
  }
  visitFixedSizeList(t, e) {
    return On.startFixedSizeList(e), On.addListSize(e, t.listSize), On.endFixedSizeList(e);
  }
  visitMap(t, e) {
    return Fn.startMap(e), Fn.addKeysSorted(e, t.keysSorted), Fn.endMap(e);
  }
}
const Fi = new ld();
function dd(r, t = /* @__PURE__ */ new Map()) {
  return new vt(pd(r, t), Nn(r.metadata), t);
}
function tu(r) {
  return new we(r.count, eu(r.columns), ru(r.columns));
}
function fd(r) {
  return new Ce(tu(r.data), r.id, r.isDelta);
}
function pd(r, t) {
  return (r.fields || []).filter(Boolean).map((e) => Ct.fromJSON(e, t));
}
function Io(r, t) {
  return (r.children || []).filter(Boolean).map((e) => Ct.fromJSON(e, t));
}
function eu(r) {
  return (r || []).reduce((t, e) => [
    ...t,
    new Nr(e.count, yd(e.VALIDITY)),
    ...eu(e.children)
  ], []);
}
function ru(r, t = []) {
  for (let e = -1, n = (r || []).length; ++e < n; ) {
    const s = r[e];
    s.VALIDITY && t.push(new Ue(t.length, s.VALIDITY.length)), s.TYPE_ID && t.push(new Ue(t.length, s.TYPE_ID.length)), s.OFFSET && t.push(new Ue(t.length, s.OFFSET.length)), s.DATA && t.push(new Ue(t.length, s.DATA.length)), t = ru(s.children, t);
  }
  return t;
}
function yd(r) {
  return (r || []).reduce((t, e) => t + +(e === 0), 0);
}
function gd(r, t) {
  let e, n, s, i, a, c;
  return !t || !(i = r.dictionary) ? (a = vo(r, Io(r, t)), s = new Ct(r.name, a, r.nullable, Nn(r.metadata))) : t.has(e = i.id) ? (n = (n = i.indexType) ? Bo(n) : new fn(), c = new Er(t.get(e), n, e, i.isOrdered), s = new Ct(r.name, c, r.nullable, Nn(r.metadata))) : (n = (n = i.indexType) ? Bo(n) : new fn(), t.set(e, a = vo(r, Io(r, t))), c = new Er(a, n, e, i.isOrdered), s = new Ct(r.name, c, r.nullable, Nn(r.metadata))), s || null;
}
function Nn(r = []) {
  return new Map(r.map(({ key: t, value: e }) => [t, e]));
}
function Bo(r) {
  return new er(r.isSigned, r.bitWidth);
}
function vo(r, t) {
  const e = r.type.name;
  switch (e) {
    case "NONE":
      return new Ye();
    case "null":
      return new Ye();
    case "binary":
      return new zn();
    case "largebinary":
      return new jn();
    case "utf8":
      return new Vn();
    case "largeutf8":
      return new Wn();
    case "bool":
      return new Zn();
    case "list":
      return new Xn((t || [])[0]);
    case "struct":
      return new Kt(t || []);
    case "struct_":
      return new Kt(t || []);
  }
  switch (e) {
    case "int": {
      const n = r.type;
      return new er(n.isSigned, n.bitWidth);
    }
    case "floatingpoint": {
      const n = r.type;
      return new $n(Jt[n.precision]);
    }
    case "decimal": {
      const n = r.type;
      return new Gn(n.scale, n.precision, n.bitWidth);
    }
    case "date": {
      const n = r.type;
      return new Yn(de[n.unit]);
    }
    case "time": {
      const n = r.type;
      return new Jn(at[n.unit], n.bitWidth);
    }
    case "timestamp": {
      const n = r.type;
      return new Hn(at[n.unit], n.timezone);
    }
    case "interval": {
      const n = r.type;
      return new qn(Te[n.unit]);
    }
    case "duration": {
      const n = r.type;
      return new Kn(at[n.unit]);
    }
    case "union": {
      const n = r.type, [s, ...i] = (n.mode + "").toLowerCase(), a = s.toUpperCase() + i.join("");
      return new Qn(re[a], n.typeIds || [], t || []);
    }
    case "fixedsizebinary": {
      const n = r.type;
      return new ti(n.byteWidth);
    }
    case "fixedsizelist": {
      const n = r.type;
      return new ei(n.listSize, (t || [])[0]);
    }
    case "map": {
      const n = r.type;
      return new ri((t || [])[0], n.keysSorted);
    }
  }
  throw new Error(`Unrecognized type: "${e}"`);
}
var md = ga, wd = xr;
class ge {
  /** @nocollapse */
  static fromJSON(t, e) {
    const n = new ge(0, zt.V5, e);
    return n._createHeader = bd(t, e), n;
  }
  /** @nocollapse */
  static decode(t) {
    t = new wd(It(t));
    const e = je.getRootAsMessage(t), n = e.bodyLength(), s = e.version(), i = e.headerType(), a = new ge(n, s, i);
    return a._createHeader = _d(e, i), a;
  }
  /** @nocollapse */
  static encode(t) {
    const e = new md();
    let n = -1;
    return t.isSchema() ? n = vt.encode(e, t.header()) : t.isRecordBatch() ? n = we.encode(e, t.header()) : t.isDictionaryBatch() && (n = Ce.encode(e, t.header())), je.startMessage(e), je.addVersion(e, zt.V5), je.addHeader(e, n), je.addHeaderType(e, t.headerType), je.addBodyLength(e, BigInt(t.bodyLength)), je.finishMessageBuffer(e, je.endMessage(e)), e.asUint8Array();
  }
  /** @nocollapse */
  static from(t, e = 0) {
    if (t instanceof vt)
      return new ge(0, zt.V5, Bt.Schema, t);
    if (t instanceof we)
      return new ge(e, zt.V5, Bt.RecordBatch, t);
    if (t instanceof Ce)
      return new ge(e, zt.V5, Bt.DictionaryBatch, t);
    throw new Error(`Unrecognized Message header: ${t}`);
  }
  get type() {
    return this.headerType;
  }
  get version() {
    return this._version;
  }
  get headerType() {
    return this._headerType;
  }
  get bodyLength() {
    return this._bodyLength;
  }
  header() {
    return this._createHeader();
  }
  isSchema() {
    return this.headerType === Bt.Schema;
  }
  isRecordBatch() {
    return this.headerType === Bt.RecordBatch;
  }
  isDictionaryBatch() {
    return this.headerType === Bt.DictionaryBatch;
  }
  constructor(t, e, n, s) {
    this._version = e, this._headerType = n, this.body = new Uint8Array(0), s && (this._createHeader = () => s), this._bodyLength = Lt(t);
  }
}
class we {
  get nodes() {
    return this._nodes;
  }
  get length() {
    return this._length;
  }
  get buffers() {
    return this._buffers;
  }
  constructor(t, e, n) {
    this._nodes = e, this._buffers = n, this._length = Lt(t);
  }
}
class Ce {
  get id() {
    return this._id;
  }
  get data() {
    return this._data;
  }
  get isDelta() {
    return this._isDelta;
  }
  get length() {
    return this.data.length;
  }
  get nodes() {
    return this.data.nodes;
  }
  get buffers() {
    return this.data.buffers;
  }
  constructor(t, e, n = !1) {
    this._data = t, this._isDelta = n, this._id = Lt(e);
  }
}
class Ue {
  constructor(t, e) {
    this.offset = Lt(t), this.length = Lt(e);
  }
}
class Nr {
  constructor(t, e) {
    this.length = Lt(t), this.nullCount = Lt(e);
  }
}
function bd(r, t) {
  return () => {
    switch (t) {
      case Bt.Schema:
        return vt.fromJSON(r);
      case Bt.RecordBatch:
        return we.fromJSON(r);
      case Bt.DictionaryBatch:
        return Ce.fromJSON(r);
    }
    throw new Error(`Unrecognized Message type: { name: ${Bt[t]}, type: ${t} }`);
  };
}
function _d(r, t) {
  return () => {
    switch (t) {
      case Bt.Schema:
        return vt.decode(r.header(new Se()), /* @__PURE__ */ new Map(), r.version());
      case Bt.RecordBatch:
        return we.decode(r.header(new Oe()), r.version());
      case Bt.DictionaryBatch:
        return Ce.decode(r.header(new ar()), r.version());
    }
    throw new Error(`Unrecognized Message type: { name: ${Bt[t]}, type: ${t} }`);
  };
}
Ct.encode = Fd;
Ct.decode = Md;
Ct.fromJSON = gd;
vt.encode = Od;
vt.decode = Sd;
vt.fromJSON = dd;
we.encode = kd;
we.decode = Id;
we.fromJSON = tu;
Ce.encode = Nd;
Ce.decode = Bd;
Ce.fromJSON = fd;
Nr.encode = Dd;
Nr.decode = xd;
Ue.encode = Ud;
Ue.decode = vd;
function Sd(r, t = /* @__PURE__ */ new Map(), e = zt.V5) {
  const n = Td(r, t);
  return new vt(n, Dn(r), t, e);
}
function Id(r, t = zt.V5) {
  if (r.compression() !== null)
    throw new Error("Record batch compression not implemented");
  return new we(r.length(), Ad(r), Ed(r, t));
}
function Bd(r, t = zt.V5) {
  return new Ce(we.decode(r.data(), t), r.id(), r.isDelta());
}
function vd(r) {
  return new Ue(r.offset(), r.length());
}
function xd(r) {
  return new Nr(r.length(), r.nullCount());
}
function Ad(r) {
  const t = [];
  for (let e, n = -1, s = -1, i = r.nodesLength(); ++n < i; )
    (e = r.nodes(n)) && (t[++s] = Nr.decode(e));
  return t;
}
function Ed(r, t) {
  const e = [];
  for (let n, s = -1, i = -1, a = r.buffersLength(); ++s < a; )
    (n = r.buffers(s)) && (t < zt.V4 && (n.bb_pos += 8 * (s + 1)), e[++i] = Ue.decode(n));
  return e;
}
function Td(r, t) {
  const e = [];
  for (let n, s = -1, i = -1, a = r.fieldsLength(); ++s < a; )
    (n = r.fields(s)) && (e[++i] = Ct.decode(n, t));
  return e;
}
function xo(r, t) {
  const e = [];
  for (let n, s = -1, i = -1, a = r.childrenLength(); ++s < a; )
    (n = r.children(s)) && (e[++i] = Ct.decode(n, t));
  return e;
}
function Md(r, t) {
  let e, n, s, i, a, c;
  return !t || !(c = r.dictionary()) ? (s = Eo(r, xo(r, t)), n = new Ct(r.name(), s, r.nullable(), Dn(r))) : t.has(e = Lt(c.id())) ? (i = (i = c.indexType()) ? Ao(i) : new fn(), a = new Er(t.get(e), i, e, c.isOrdered()), n = new Ct(r.name(), a, r.nullable(), Dn(r))) : (i = (i = c.indexType()) ? Ao(i) : new fn(), t.set(e, s = Eo(r, xo(r, t))), a = new Er(s, i, e, c.isOrdered()), n = new Ct(r.name(), a, r.nullable(), Dn(r))), n || null;
}
function Dn(r) {
  const t = /* @__PURE__ */ new Map();
  if (r)
    for (let e, n, s = -1, i = Math.trunc(r.customMetadataLength()); ++s < i; )
      (e = r.customMetadata(s)) && (n = e.key()) != null && t.set(n, e.value());
  return t;
}
function Ao(r) {
  return new er(r.isSigned(), r.bitWidth());
}
function Eo(r, t) {
  const e = r.typeType();
  switch (e) {
    case Dt.NONE:
      return new Ye();
    case Dt.Null:
      return new Ye();
    case Dt.Binary:
      return new zn();
    case Dt.LargeBinary:
      return new jn();
    case Dt.Utf8:
      return new Vn();
    case Dt.LargeUtf8:
      return new Wn();
    case Dt.Bool:
      return new Zn();
    case Dt.List:
      return new Xn((t || [])[0]);
    case Dt.Struct_:
      return new Kt(t || []);
  }
  switch (e) {
    case Dt.Int: {
      const n = r.type(new oe());
      return new er(n.isSigned(), n.bitWidth());
    }
    case Dt.FloatingPoint: {
      const n = r.type(new ve());
      return new $n(n.precision());
    }
    case Dt.Decimal: {
      const n = r.type(new ur());
      return new Gn(n.scale(), n.precision(), n.bitWidth());
    }
    case Dt.Date: {
      const n = r.type(new En());
      return new Yn(n.unit());
    }
    case Dt.Time: {
      const n = r.type(new ue());
      return new Jn(n.unit(), n.bitWidth());
    }
    case Dt.Timestamp: {
      const n = r.type(new he());
      return new Hn(n.unit(), n.timezone());
    }
    case Dt.Interval: {
      const n = r.type(new xe());
      return new qn(n.unit());
    }
    case Dt.Duration: {
      const n = r.type(new Tn());
      return new Kn(n.unit());
    }
    case Dt.Union: {
      const n = r.type(new ee());
      return new Qn(n.mode(), n.typeIdsArray() || [], t || []);
    }
    case Dt.FixedSizeBinary: {
      const n = r.type(new Mn());
      return new ti(n.byteWidth());
    }
    case Dt.FixedSizeList: {
      const n = r.type(new On());
      return new ei(n.listSize(), (t || [])[0]);
    }
    case Dt.Map: {
      const n = r.type(new Fn());
      return new ri((t || [])[0], n.keysSorted());
    }
  }
  throw new Error(`Unrecognized type: "${Dt[e]}" (${e})`);
}
function Od(r, t) {
  const e = t.fields.map((i) => Ct.encode(r, i));
  Se.startFieldsVector(r, e.length);
  const n = Se.createFieldsVector(r, e), s = t.metadata && t.metadata.size > 0 ? Se.createCustomMetadataVector(r, [...t.metadata].map(([i, a]) => {
    const c = r.createString(`${i}`), d = r.createString(`${a}`);
    return jt.startKeyValue(r), jt.addKey(r, c), jt.addValue(r, d), jt.endKeyValue(r);
  })) : -1;
  return Se.startSchema(r), Se.addFields(r, n), Se.addEndianness(r, Ld ? Ar.Little : Ar.Big), s !== -1 && Se.addCustomMetadata(r, s), Se.endSchema(r);
}
function Fd(r, t) {
  let e = -1, n = -1, s = -1;
  const i = t.type;
  let a = t.typeId;
  tt.isDictionary(i) ? (a = i.dictionary.typeId, s = Fi.visit(i, r), n = Fi.visit(i.dictionary, r)) : n = Fi.visit(i, r);
  const c = (i.children || []).map((y) => Ct.encode(r, y)), d = ae.createChildrenVector(r, c), p = t.metadata && t.metadata.size > 0 ? ae.createCustomMetadataVector(r, [...t.metadata].map(([y, B]) => {
    const R = r.createString(`${y}`), F = r.createString(`${B}`);
    return jt.startKeyValue(r), jt.addKey(r, R), jt.addValue(r, F), jt.endKeyValue(r);
  })) : -1;
  return t.name && (e = r.createString(t.name)), ae.startField(r), ae.addType(r, n), ae.addTypeType(r, a), ae.addChildren(r, d), ae.addNullable(r, !!t.nullable), e !== -1 && ae.addName(r, e), s !== -1 && ae.addDictionary(r, s), p !== -1 && ae.addCustomMetadata(r, p), ae.endField(r);
}
function kd(r, t) {
  const e = t.nodes || [], n = t.buffers || [];
  Oe.startNodesVector(r, e.length);
  for (const a of e.slice().reverse())
    Nr.encode(r, a);
  const s = r.endVector();
  Oe.startBuffersVector(r, n.length);
  for (const a of n.slice().reverse())
    Ue.encode(r, a);
  const i = r.endVector();
  return Oe.startRecordBatch(r), Oe.addLength(r, BigInt(t.length)), Oe.addNodes(r, s), Oe.addBuffers(r, i), Oe.endRecordBatch(r);
}
function Nd(r, t) {
  const e = we.encode(r, t.data);
  return ar.startDictionaryBatch(r), ar.addId(r, BigInt(t.id)), ar.addIsDelta(r, t.isDelta), ar.addData(r, e), ar.endDictionaryBatch(r);
}
function Dd(r, t) {
  return ba.createFieldNode(r, BigInt(t.length), BigInt(t.nullCount));
}
function Ud(r, t) {
  return wa.createBuffer(r, BigInt(t.offset), BigInt(t.length));
}
const Ld = (() => {
  const r = new ArrayBuffer(2);
  return new DataView(r).setInt16(
    0,
    256,
    !0
    /* littleEndian */
  ), new Int16Array(r)[0] === 256;
})(), Ns = (r) => `Expected ${Bt[r]} Message in stream, but was null or length 0.`, Ds = (r) => `Header pointer of flatbuffer-encoded ${Bt[r]} Message is null or length 0.`, nu = (r, t) => `Expected to read ${r} metadata bytes, but only read ${t}.`, iu = (r, t) => `Expected to read ${r} bytes for message body, but only read ${t}.`;
class su {
  constructor(t) {
    this.source = t instanceof oi ? t : new oi(t);
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    let t;
    return (t = this.readMetadataLength()).done || t.value === -1 && (t = this.readMetadataLength()).done || (t = this.readMetadata(t.value)).done ? Rt : t;
  }
  throw(t) {
    return this.source.throw(t);
  }
  return(t) {
    return this.source.return(t);
  }
  readMessage(t) {
    let e;
    if ((e = this.next()).done)
      return null;
    if (t != null && e.value.headerType !== t)
      throw new Error(Ns(t));
    return e.value;
  }
  readMessageBody(t) {
    if (t <= 0)
      return new Uint8Array(0);
    const e = It(this.source.read(t));
    if (e.byteLength < t)
      throw new Error(iu(t, e.byteLength));
    return (
      /* 1. */
      e.byteOffset % 8 === 0 && /* 2. */
      e.byteOffset + e.byteLength <= e.buffer.byteLength ? e : e.slice()
    );
  }
  readSchema(t = !1) {
    const e = Bt.Schema, n = this.readMessage(e), s = n?.header();
    if (t && !s)
      throw new Error(Ds(e));
    return s;
  }
  readMetadataLength() {
    const t = this.source.read(Si), e = t && new xr(t), n = e?.readInt32(0) || 0;
    return { done: n === 0, value: n };
  }
  readMetadata(t) {
    const e = this.source.read(t);
    if (!e)
      return Rt;
    if (e.byteLength < t)
      throw new Error(nu(t, e.byteLength));
    return { done: !1, value: ge.decode(e) };
  }
}
class Cd {
  constructor(t, e) {
    this.source = t instanceof Mr ? t : ha(t) ? new ai(t, e) : new Mr(t);
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  next() {
    return gt(this, void 0, void 0, function* () {
      let t;
      return (t = yield this.readMetadataLength()).done || t.value === -1 && (t = yield this.readMetadataLength()).done || (t = yield this.readMetadata(t.value)).done ? Rt : t;
    });
  }
  throw(t) {
    return gt(this, void 0, void 0, function* () {
      return yield this.source.throw(t);
    });
  }
  return(t) {
    return gt(this, void 0, void 0, function* () {
      return yield this.source.return(t);
    });
  }
  readMessage(t) {
    return gt(this, void 0, void 0, function* () {
      let e;
      if ((e = yield this.next()).done)
        return null;
      if (t != null && e.value.headerType !== t)
        throw new Error(Ns(t));
      return e.value;
    });
  }
  readMessageBody(t) {
    return gt(this, void 0, void 0, function* () {
      if (t <= 0)
        return new Uint8Array(0);
      const e = It(yield this.source.read(t));
      if (e.byteLength < t)
        throw new Error(iu(t, e.byteLength));
      return (
        /* 1. */
        e.byteOffset % 8 === 0 && /* 2. */
        e.byteOffset + e.byteLength <= e.buffer.byteLength ? e : e.slice()
      );
    });
  }
  readSchema() {
    return gt(this, arguments, void 0, function* (t = !1) {
      const e = Bt.Schema, n = yield this.readMessage(e), s = n?.header();
      if (t && !s)
        throw new Error(Ds(e));
      return s;
    });
  }
  readMetadataLength() {
    return gt(this, void 0, void 0, function* () {
      const t = yield this.source.read(Si), e = t && new xr(t), n = e?.readInt32(0) || 0;
      return { done: n === 0, value: n };
    });
  }
  readMetadata(t) {
    return gt(this, void 0, void 0, function* () {
      const e = yield this.source.read(t);
      if (!e)
        return Rt;
      if (e.byteLength < t)
        throw new Error(nu(t, e.byteLength));
      return { done: !1, value: ge.decode(e) };
    });
  }
}
class Rd extends su {
  constructor(t) {
    super(new Uint8Array(0)), this._schema = !1, this._body = [], this._batchIndex = 0, this._dictionaryIndex = 0, this._json = t instanceof bo ? t : new bo(t);
  }
  next() {
    const { _json: t } = this;
    if (!this._schema)
      return this._schema = !0, { done: !1, value: ge.fromJSON(t.schema, Bt.Schema) };
    if (this._dictionaryIndex < t.dictionaries.length) {
      const e = t.dictionaries[this._dictionaryIndex++];
      return this._body = e.data.columns, { done: !1, value: ge.fromJSON(e, Bt.DictionaryBatch) };
    }
    if (this._batchIndex < t.batches.length) {
      const e = t.batches[this._batchIndex++];
      return this._body = e.columns, { done: !1, value: ge.fromJSON(e, Bt.RecordBatch) };
    }
    return this._body = [], Rt;
  }
  readMessageBody(t) {
    return e(this._body);
    function e(n) {
      return (n || []).reduce((s, i) => [
        ...s,
        ...i.VALIDITY && [i.VALIDITY] || [],
        ...i.TYPE_ID && [i.TYPE_ID] || [],
        ...i.OFFSET && [i.OFFSET] || [],
        ...i.DATA && [i.DATA] || [],
        ...e(i.children)
      ], []);
    }
  }
  readMessage(t) {
    let e;
    if ((e = this.next()).done)
      return null;
    if (t != null && e.value.headerType !== t)
      throw new Error(Ns(t));
    return e.value;
  }
  readSchema() {
    const t = Bt.Schema, e = this.readMessage(t), n = e?.header();
    if (!e || !n)
      throw new Error(Ds(t));
    return n;
  }
}
const Si = 4, Qi = "ARROW1", ci = new Uint8Array(Qi.length);
for (let r = 0; r < Qi.length; r += 1)
  ci[r] = Qi.codePointAt(r);
function Us(r, t = 0) {
  for (let e = -1, n = ci.length; ++e < n; )
    if (ci[e] !== r[t + e])
      return !1;
  return !0;
}
const wn = ci.length, ou = wn + Si, Pd = wn * 2 + Si;
class Le extends Yc {
  constructor(t) {
    super(), this._impl = t;
  }
  get closed() {
    return this._impl.closed;
  }
  get schema() {
    return this._impl.schema;
  }
  get autoDestroy() {
    return this._impl.autoDestroy;
  }
  get dictionaries() {
    return this._impl.dictionaries;
  }
  get numDictionaries() {
    return this._impl.numDictionaries;
  }
  get numRecordBatches() {
    return this._impl.numRecordBatches;
  }
  get footer() {
    return this._impl.isFile() ? this._impl.footer : null;
  }
  isSync() {
    return this._impl.isSync();
  }
  isAsync() {
    return this._impl.isAsync();
  }
  isFile() {
    return this._impl.isFile();
  }
  isStream() {
    return this._impl.isStream();
  }
  next() {
    return this._impl.next();
  }
  throw(t) {
    return this._impl.throw(t);
  }
  return(t) {
    return this._impl.return(t);
  }
  cancel() {
    return this._impl.cancel();
  }
  reset(t) {
    return this._impl.reset(t), this._DOMStream = void 0, this._nodeStream = void 0, this;
  }
  open(t) {
    const e = this._impl.open(t);
    return un(e) ? e.then(() => this) : this;
  }
  readRecordBatch(t) {
    return this._impl.isFile() ? this._impl.readRecordBatch(t) : null;
  }
  [Symbol.iterator]() {
    return this._impl[Symbol.iterator]();
  }
  [Symbol.asyncIterator]() {
    return this._impl[Symbol.asyncIterator]();
  }
  toDOMStream() {
    return ce.toDOMStream(this.isSync() ? { [Symbol.iterator]: () => this } : { [Symbol.asyncIterator]: () => this });
  }
  toNodeStream() {
    return ce.toNodeStream(this.isSync() ? { [Symbol.iterator]: () => this } : { [Symbol.asyncIterator]: () => this }, { objectMode: !0 });
  }
  /** @nocollapse */
  // @ts-ignore
  static throughNode(t) {
    throw new Error('"throughNode" not available in this environment');
  }
  /** @nocollapse */
  static throughDOM(t, e) {
    throw new Error('"throughDOM" not available in this environment');
  }
  /** @nocollapse */
  static from(t) {
    return t instanceof Le ? t : Vi(t) ? Vd(t) : ha(t) ? Gd(t) : un(t) ? gt(this, void 0, void 0, function* () {
      return yield Le.from(yield t);
    }) : la(t) || ms(t) || fa(t) || gs(t) ? Zd(new Mr(t)) : Wd(new oi(t));
  }
  /** @nocollapse */
  static readAll(t) {
    return t instanceof Le ? t.isSync() ? To(t) : Mo(t) : Vi(t) || ArrayBuffer.isView(t) || wi(t) || ua(t) ? To(t) : Mo(t);
  }
}
class ui extends Le {
  constructor(t) {
    super(t), this._impl = t;
  }
  readAll() {
    return [...this];
  }
  [Symbol.iterator]() {
    return this._impl[Symbol.iterator]();
  }
  [Symbol.asyncIterator]() {
    return Ae(this, arguments, function* () {
      yield wt(yield* An(br(this[Symbol.iterator]())));
    });
  }
}
class hi extends Le {
  constructor(t) {
    super(t), this._impl = t;
  }
  readAll() {
    return gt(this, void 0, void 0, function* () {
      var t, e, n, s;
      const i = new Array();
      try {
        for (var a = !0, c = br(this), d; d = yield c.next(), t = d.done, !t; a = !0) {
          s = d.value, a = !1;
          const p = s;
          i.push(p);
        }
      } catch (p) {
        e = { error: p };
      } finally {
        try {
          !a && !t && (n = c.return) && (yield n.call(c));
        } finally {
          if (e) throw e.error;
        }
      }
      return i;
    });
  }
  [Symbol.iterator]() {
    throw new Error("AsyncRecordBatchStreamReader is not Iterable");
  }
  [Symbol.asyncIterator]() {
    return this._impl[Symbol.asyncIterator]();
  }
}
class au extends ui {
  constructor(t) {
    super(t), this._impl = t;
  }
}
class $d extends hi {
  constructor(t) {
    super(t), this._impl = t;
  }
}
class cu {
  get numDictionaries() {
    return this._dictionaryIndex;
  }
  get numRecordBatches() {
    return this._recordBatchIndex;
  }
  constructor(t = /* @__PURE__ */ new Map()) {
    this.closed = !1, this.autoDestroy = !0, this._dictionaryIndex = 0, this._recordBatchIndex = 0, this.dictionaries = t;
  }
  isSync() {
    return !1;
  }
  isAsync() {
    return !1;
  }
  isFile() {
    return !1;
  }
  isStream() {
    return !1;
  }
  reset(t) {
    return this._dictionaryIndex = 0, this._recordBatchIndex = 0, this.schema = t, this.dictionaries = /* @__PURE__ */ new Map(), this;
  }
  _loadRecordBatch(t, e) {
    const n = this._loadVectors(t, e, this.schema.fields), s = _t({ type: new Kt(this.schema.fields), length: t.length, children: n });
    return new ye(this.schema, s);
  }
  _loadDictionaryBatch(t, e) {
    const { id: n, isDelta: s } = t, { dictionaries: i, schema: a } = this, c = i.get(n), d = a.dictionaries.get(n), p = this._loadVectors(t.data, e, [d]);
    return (c && s ? c.concat(new Ft(p)) : new Ft(p)).memoize();
  }
  _loadVectors(t, e, n) {
    return new Hc(e, t.nodes, t.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(n);
  }
}
class li extends cu {
  constructor(t, e) {
    super(e), this._reader = Vi(t) ? new Rd(this._handle = t) : new su(this._handle = t);
  }
  isSync() {
    return !0;
  }
  isStream() {
    return !0;
  }
  [Symbol.iterator]() {
    return this;
  }
  cancel() {
    !this.closed && (this.closed = !0) && (this.reset()._reader.return(), this._reader = null, this.dictionaries = null);
  }
  open(t) {
    return this.closed || (this.autoDestroy = hu(this, t), this.schema || (this.schema = this._reader.readSchema()) || this.cancel()), this;
  }
  throw(t) {
    return !this.closed && this.autoDestroy && (this.closed = !0) ? this.reset()._reader.throw(t) : Rt;
  }
  return(t) {
    return !this.closed && this.autoDestroy && (this.closed = !0) ? this.reset()._reader.return(t) : Rt;
  }
  next() {
    if (this.closed)
      return Rt;
    let t;
    const { _reader: e } = this;
    for (; t = this._readNextMessageAndValidate(); )
      if (t.isSchema())
        this.reset(t.header());
      else if (t.isRecordBatch()) {
        this._recordBatchIndex++;
        const n = t.header(), s = e.readMessageBody(t.bodyLength);
        return { done: !1, value: this._loadRecordBatch(n, s) };
      } else if (t.isDictionaryBatch()) {
        this._dictionaryIndex++;
        const n = t.header(), s = e.readMessageBody(t.bodyLength), i = this._loadDictionaryBatch(n, s);
        this.dictionaries.set(n.id, i);
      }
    return this.schema && this._recordBatchIndex === 0 ? (this._recordBatchIndex++, { done: !1, value: new Qc(this.schema) }) : this.return();
  }
  _readNextMessageAndValidate(t) {
    return this._reader.readMessage(t);
  }
}
class di extends cu {
  constructor(t, e) {
    super(e), this._reader = new Cd(this._handle = t);
  }
  isAsync() {
    return !0;
  }
  isStream() {
    return !0;
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  cancel() {
    return gt(this, void 0, void 0, function* () {
      !this.closed && (this.closed = !0) && (yield this.reset()._reader.return(), this._reader = null, this.dictionaries = null);
    });
  }
  open(t) {
    return gt(this, void 0, void 0, function* () {
      return this.closed || (this.autoDestroy = hu(this, t), this.schema || (this.schema = yield this._reader.readSchema()) || (yield this.cancel())), this;
    });
  }
  throw(t) {
    return gt(this, void 0, void 0, function* () {
      return !this.closed && this.autoDestroy && (this.closed = !0) ? yield this.reset()._reader.throw(t) : Rt;
    });
  }
  return(t) {
    return gt(this, void 0, void 0, function* () {
      return !this.closed && this.autoDestroy && (this.closed = !0) ? yield this.reset()._reader.return(t) : Rt;
    });
  }
  next() {
    return gt(this, void 0, void 0, function* () {
      if (this.closed)
        return Rt;
      let t;
      const { _reader: e } = this;
      for (; t = yield this._readNextMessageAndValidate(); )
        if (t.isSchema())
          yield this.reset(t.header());
        else if (t.isRecordBatch()) {
          this._recordBatchIndex++;
          const n = t.header(), s = yield e.readMessageBody(t.bodyLength);
          return { done: !1, value: this._loadRecordBatch(n, s) };
        } else if (t.isDictionaryBatch()) {
          this._dictionaryIndex++;
          const n = t.header(), s = yield e.readMessageBody(t.bodyLength), i = this._loadDictionaryBatch(n, s);
          this.dictionaries.set(n.id, i);
        }
      return this.schema && this._recordBatchIndex === 0 ? (this._recordBatchIndex++, { done: !1, value: new Qc(this.schema) }) : yield this.return();
    });
  }
  _readNextMessageAndValidate(t) {
    return gt(this, void 0, void 0, function* () {
      return yield this._reader.readMessage(t);
    });
  }
}
class uu extends li {
  get footer() {
    return this._footer;
  }
  get numDictionaries() {
    return this._footer ? this._footer.numDictionaries : 0;
  }
  get numRecordBatches() {
    return this._footer ? this._footer.numRecordBatches : 0;
  }
  constructor(t, e) {
    super(t instanceof _o ? t : new _o(t), e);
  }
  isSync() {
    return !0;
  }
  isFile() {
    return !0;
  }
  open(t) {
    if (!this.closed && !this._footer) {
      this.schema = (this._footer = this._readFooter()).schema;
      for (const e of this._footer.dictionaryBatches())
        e && this._readDictionaryBatch(this._dictionaryIndex++);
    }
    return super.open(t);
  }
  readRecordBatch(t) {
    var e;
    if (this.closed)
      return null;
    this._footer || this.open();
    const n = (e = this._footer) === null || e === void 0 ? void 0 : e.getRecordBatch(t);
    if (n && this._handle.seek(n.offset)) {
      const s = this._reader.readMessage(Bt.RecordBatch);
      if (s?.isRecordBatch()) {
        const i = s.header(), a = this._reader.readMessageBody(s.bodyLength);
        return this._loadRecordBatch(i, a);
      }
    }
    return null;
  }
  _readDictionaryBatch(t) {
    var e;
    const n = (e = this._footer) === null || e === void 0 ? void 0 : e.getDictionaryBatch(t);
    if (n && this._handle.seek(n.offset)) {
      const s = this._reader.readMessage(Bt.DictionaryBatch);
      if (s?.isDictionaryBatch()) {
        const i = s.header(), a = this._reader.readMessageBody(s.bodyLength), c = this._loadDictionaryBatch(i, a);
        this.dictionaries.set(i.id, c);
      }
    }
  }
  _readFooter() {
    const { _handle: t } = this, e = t.size - ou, n = t.readInt32(e), s = t.readAt(e - n, n);
    return Ts.decode(s);
  }
  _readNextMessageAndValidate(t) {
    var e;
    if (this._footer || this.open(), this._footer && this._recordBatchIndex < this.numRecordBatches) {
      const n = (e = this._footer) === null || e === void 0 ? void 0 : e.getRecordBatch(this._recordBatchIndex);
      if (n && this._handle.seek(n.offset))
        return this._reader.readMessage(t);
    }
    return null;
  }
}
class zd extends di {
  get footer() {
    return this._footer;
  }
  get numDictionaries() {
    return this._footer ? this._footer.numDictionaries : 0;
  }
  get numRecordBatches() {
    return this._footer ? this._footer.numRecordBatches : 0;
  }
  constructor(t, ...e) {
    const n = typeof e[0] != "number" ? e.shift() : void 0, s = e[0] instanceof Map ? e.shift() : void 0;
    super(t instanceof ai ? t : new ai(t, n), s);
  }
  isFile() {
    return !0;
  }
  isAsync() {
    return !0;
  }
  open(t) {
    const e = Object.create(null, {
      open: { get: () => super.open }
    });
    return gt(this, void 0, void 0, function* () {
      if (!this.closed && !this._footer) {
        this.schema = (this._footer = yield this._readFooter()).schema;
        for (const n of this._footer.dictionaryBatches())
          n && (yield this._readDictionaryBatch(this._dictionaryIndex++));
      }
      return yield e.open.call(this, t);
    });
  }
  readRecordBatch(t) {
    return gt(this, void 0, void 0, function* () {
      var e;
      if (this.closed)
        return null;
      this._footer || (yield this.open());
      const n = (e = this._footer) === null || e === void 0 ? void 0 : e.getRecordBatch(t);
      if (n && (yield this._handle.seek(n.offset))) {
        const s = yield this._reader.readMessage(Bt.RecordBatch);
        if (s?.isRecordBatch()) {
          const i = s.header(), a = yield this._reader.readMessageBody(s.bodyLength);
          return this._loadRecordBatch(i, a);
        }
      }
      return null;
    });
  }
  _readDictionaryBatch(t) {
    return gt(this, void 0, void 0, function* () {
      var e;
      const n = (e = this._footer) === null || e === void 0 ? void 0 : e.getDictionaryBatch(t);
      if (n && (yield this._handle.seek(n.offset))) {
        const s = yield this._reader.readMessage(Bt.DictionaryBatch);
        if (s?.isDictionaryBatch()) {
          const i = s.header(), a = yield this._reader.readMessageBody(s.bodyLength), c = this._loadDictionaryBatch(i, a);
          this.dictionaries.set(i.id, c);
        }
      }
    });
  }
  _readFooter() {
    return gt(this, void 0, void 0, function* () {
      const { _handle: t } = this;
      t._pending && (yield t._pending);
      const e = t.size - ou, n = yield t.readInt32(e), s = yield t.readAt(e - n, n);
      return Ts.decode(s);
    });
  }
  _readNextMessageAndValidate(t) {
    return gt(this, void 0, void 0, function* () {
      if (this._footer || (yield this.open()), this._footer && this._recordBatchIndex < this.numRecordBatches) {
        const e = this._footer.getRecordBatch(this._recordBatchIndex);
        if (e && (yield this._handle.seek(e.offset)))
          return yield this._reader.readMessage(t);
      }
      return null;
    });
  }
}
class jd extends li {
  constructor(t, e) {
    super(t, e);
  }
  _loadVectors(t, e, n) {
    return new td(e, t.nodes, t.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(n);
  }
}
function hu(r, t) {
  return t && typeof t.autoDestroy == "boolean" ? t.autoDestroy : r.autoDestroy;
}
function* To(r) {
  const t = Le.from(r);
  try {
    if (!t.open({ autoDestroy: !1 }).closed)
      do
        yield t;
      while (!t.reset().open().closed);
  } finally {
    t.cancel();
  }
}
function Mo(r) {
  return Ae(this, arguments, function* () {
    const e = yield wt(Le.from(r));
    try {
      if (!(yield wt(e.open({ autoDestroy: !1 }))).closed)
        do
          yield yield wt(e);
        while (!(yield wt(e.reset().open())).closed);
    } finally {
      yield wt(e.cancel());
    }
  });
}
function Vd(r) {
  return new ui(new jd(r));
}
function Wd(r) {
  const t = r.peek(wn + 7 & -8);
  return t && t.byteLength >= 4 ? Us(t) ? new au(new uu(r.read())) : new ui(new li(r)) : new ui(new li(function* () {
  }()));
}
function Zd(r) {
  return gt(this, void 0, void 0, function* () {
    const t = yield r.peek(wn + 7 & -8);
    return t && t.byteLength >= 4 ? Us(t) ? new au(new uu(yield r.read())) : new hi(new di(r)) : new hi(new di(function() {
      return Ae(this, arguments, function* () {
      });
    }()));
  });
}
function Gd(r) {
  return gt(this, void 0, void 0, function* () {
    const { size: t } = yield r.stat(), e = new ai(r, t);
    return t >= Pd && Us(yield e.readAt(0, wn + 7 & -8)) ? new $d(new zd(e)) : new hi(new di(e));
  });
}
function lu(r) {
  const t = Le.from(r);
  return un(t) ? t.then((e) => lu(e)) : t.isAsync() ? t.readAll().then((e) => new le(e)) : new le(t.readAll());
}
function Ls(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var ki = {}, Ur = {}, Ni = {}, Lr = {}, Oo;
function du() {
  if (Oo) return Lr;
  Oo = 1, Lr.byteLength = c, Lr.toByteArray = p, Lr.fromByteArray = R;
  for (var r = [], t = [], e = typeof Uint8Array < "u" ? Uint8Array : Array, n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, i = n.length; s < i; ++s)
    r[s] = n[s], t[n.charCodeAt(s)] = s;
  t[45] = 62, t[95] = 63;
  function a(F) {
    var T = F.length;
    if (T % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var U = F.indexOf("=");
    U === -1 && (U = T);
    var O = U === T ? 0 : 4 - U % 4;
    return [U, O];
  }
  function c(F) {
    var T = a(F), U = T[0], O = T[1];
    return (U + O) * 3 / 4 - O;
  }
  function d(F, T, U) {
    return (T + U) * 3 / 4 - U;
  }
  function p(F) {
    var T, U = a(F), O = U[0], N = U[1], P = new e(d(F, O, N)), C = 0, V = N > 0 ? O - 4 : O, G;
    for (G = 0; G < V; G += 4)
      T = t[F.charCodeAt(G)] << 18 | t[F.charCodeAt(G + 1)] << 12 | t[F.charCodeAt(G + 2)] << 6 | t[F.charCodeAt(G + 3)], P[C++] = T >> 16 & 255, P[C++] = T >> 8 & 255, P[C++] = T & 255;
    return N === 2 && (T = t[F.charCodeAt(G)] << 2 | t[F.charCodeAt(G + 1)] >> 4, P[C++] = T & 255), N === 1 && (T = t[F.charCodeAt(G)] << 10 | t[F.charCodeAt(G + 1)] << 4 | t[F.charCodeAt(G + 2)] >> 2, P[C++] = T >> 8 & 255, P[C++] = T & 255), P;
  }
  function y(F) {
    return r[F >> 18 & 63] + r[F >> 12 & 63] + r[F >> 6 & 63] + r[F & 63];
  }
  function B(F, T, U) {
    for (var O, N = [], P = T; P < U; P += 3)
      O = (F[P] << 16 & 16711680) + (F[P + 1] << 8 & 65280) + (F[P + 2] & 255), N.push(y(O));
    return N.join("");
  }
  function R(F) {
    for (var T, U = F.length, O = U % 3, N = [], P = 16383, C = 0, V = U - O; C < V; C += P)
      N.push(B(F, C, C + P > V ? V : C + P));
    return O === 1 ? (T = F[U - 1], N.push(
      r[T >> 2] + r[T << 4 & 63] + "=="
    )) : O === 2 && (T = (F[U - 2] << 8) + F[U - 1], N.push(
      r[T >> 10] + r[T >> 4 & 63] + r[T << 2 & 63] + "="
    )), N.join("");
  }
  return Lr;
}
var In = {};
var Fo;
function fu() {
  return Fo || (Fo = 1, In.read = function(r, t, e, n, s) {
    var i, a, c = s * 8 - n - 1, d = (1 << c) - 1, p = d >> 1, y = -7, B = e ? s - 1 : 0, R = e ? -1 : 1, F = r[t + B];
    for (B += R, i = F & (1 << -y) - 1, F >>= -y, y += c; y > 0; i = i * 256 + r[t + B], B += R, y -= 8)
      ;
    for (a = i & (1 << -y) - 1, i >>= -y, y += n; y > 0; a = a * 256 + r[t + B], B += R, y -= 8)
      ;
    if (i === 0)
      i = 1 - p;
    else {
      if (i === d)
        return a ? NaN : (F ? -1 : 1) * (1 / 0);
      a = a + Math.pow(2, n), i = i - p;
    }
    return (F ? -1 : 1) * a * Math.pow(2, i - n);
  }, In.write = function(r, t, e, n, s, i) {
    var a, c, d, p = i * 8 - s - 1, y = (1 << p) - 1, B = y >> 1, R = s === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, F = n ? 0 : i - 1, T = n ? 1 : -1, U = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
    for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (c = isNaN(t) ? 1 : 0, a = y) : (a = Math.floor(Math.log(t) / Math.LN2), t * (d = Math.pow(2, -a)) < 1 && (a--, d *= 2), a + B >= 1 ? t += R / d : t += R * Math.pow(2, 1 - B), t * d >= 2 && (a++, d /= 2), a + B >= y ? (c = 0, a = y) : a + B >= 1 ? (c = (t * d - 1) * Math.pow(2, s), a = a + B) : (c = t * Math.pow(2, B - 1) * Math.pow(2, s), a = 0)); s >= 8; r[e + F] = c & 255, F += T, c /= 256, s -= 8)
      ;
    for (a = a << s | c, p += s; p > 0; r[e + F] = a & 255, F += T, a /= 256, p -= 8)
      ;
    r[e + F - T] |= U * 128;
  }), In;
}
var ko;
function Cs() {
  return ko || (ko = 1, function(r) {
    const t = du(), e = fu(), n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    r.Buffer = c, r.SlowBuffer = P, r.INSPECT_MAX_BYTES = 50;
    const s = 2147483647;
    r.kMaxLength = s, c.TYPED_ARRAY_SUPPORT = i(), !c.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function i() {
      try {
        const h = new Uint8Array(1), o = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(o, Uint8Array.prototype), Object.setPrototypeOf(h, o), h.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(c.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (c.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(c.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (c.isBuffer(this))
          return this.byteOffset;
      }
    });
    function a(h) {
      if (h > s)
        throw new RangeError('The value "' + h + '" is invalid for option "size"');
      const o = new Uint8Array(h);
      return Object.setPrototypeOf(o, c.prototype), o;
    }
    function c(h, o, u) {
      if (typeof h == "number") {
        if (typeof o == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return B(h);
      }
      return d(h, o, u);
    }
    c.poolSize = 8192;
    function d(h, o, u) {
      if (typeof h == "string")
        return R(h, o);
      if (ArrayBuffer.isView(h))
        return T(h);
      if (h == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof h
        );
      if (mt(h, ArrayBuffer) || h && mt(h.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (mt(h, SharedArrayBuffer) || h && mt(h.buffer, SharedArrayBuffer)))
        return U(h, o, u);
      if (typeof h == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      const l = h.valueOf && h.valueOf();
      if (l != null && l !== h)
        return c.from(l, o, u);
      const f = O(h);
      if (f) return f;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof h[Symbol.toPrimitive] == "function")
        return c.from(h[Symbol.toPrimitive]("string"), o, u);
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof h
      );
    }
    c.from = function(h, o, u) {
      return d(h, o, u);
    }, Object.setPrototypeOf(c.prototype, Uint8Array.prototype), Object.setPrototypeOf(c, Uint8Array);
    function p(h) {
      if (typeof h != "number")
        throw new TypeError('"size" argument must be of type number');
      if (h < 0)
        throw new RangeError('The value "' + h + '" is invalid for option "size"');
    }
    function y(h, o, u) {
      return p(h), h <= 0 ? a(h) : o !== void 0 ? typeof u == "string" ? a(h).fill(o, u) : a(h).fill(o) : a(h);
    }
    c.alloc = function(h, o, u) {
      return y(h, o, u);
    };
    function B(h) {
      return p(h), a(h < 0 ? 0 : N(h) | 0);
    }
    c.allocUnsafe = function(h) {
      return B(h);
    }, c.allocUnsafeSlow = function(h) {
      return B(h);
    };
    function R(h, o) {
      if ((typeof o != "string" || o === "") && (o = "utf8"), !c.isEncoding(o))
        throw new TypeError("Unknown encoding: " + o);
      const u = C(h, o) | 0;
      let l = a(u);
      const f = l.write(h, o);
      return f !== u && (l = l.slice(0, f)), l;
    }
    function F(h) {
      const o = h.length < 0 ? 0 : N(h.length) | 0, u = a(o);
      for (let l = 0; l < o; l += 1)
        u[l] = h[l] & 255;
      return u;
    }
    function T(h) {
      if (mt(h, Uint8Array)) {
        const o = new Uint8Array(h);
        return U(o.buffer, o.byteOffset, o.byteLength);
      }
      return F(h);
    }
    function U(h, o, u) {
      if (o < 0 || h.byteLength < o)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (h.byteLength < o + (u || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      let l;
      return o === void 0 && u === void 0 ? l = new Uint8Array(h) : u === void 0 ? l = new Uint8Array(h, o) : l = new Uint8Array(h, o, u), Object.setPrototypeOf(l, c.prototype), l;
    }
    function O(h) {
      if (c.isBuffer(h)) {
        const o = N(h.length) | 0, u = a(o);
        return u.length === 0 || h.copy(u, 0, 0, o), u;
      }
      if (h.length !== void 0)
        return typeof h.length != "number" || Qt(h.length) ? a(0) : F(h);
      if (h.type === "Buffer" && Array.isArray(h.data))
        return F(h.data);
    }
    function N(h) {
      if (h >= s)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s.toString(16) + " bytes");
      return h | 0;
    }
    function P(h) {
      return +h != h && (h = 0), c.alloc(+h);
    }
    c.isBuffer = function(o) {
      return o != null && o._isBuffer === !0 && o !== c.prototype;
    }, c.compare = function(o, u) {
      if (mt(o, Uint8Array) && (o = c.from(o, o.offset, o.byteLength)), mt(u, Uint8Array) && (u = c.from(u, u.offset, u.byteLength)), !c.isBuffer(o) || !c.isBuffer(u))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (o === u) return 0;
      let l = o.length, f = u.length;
      for (let b = 0, I = Math.min(l, f); b < I; ++b)
        if (o[b] !== u[b]) {
          l = o[b], f = u[b];
          break;
        }
      return l < f ? -1 : f < l ? 1 : 0;
    }, c.isEncoding = function(o) {
      switch (String(o).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, c.concat = function(o, u) {
      if (!Array.isArray(o))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (o.length === 0)
        return c.alloc(0);
      let l;
      if (u === void 0)
        for (u = 0, l = 0; l < o.length; ++l)
          u += o[l].length;
      const f = c.allocUnsafe(u);
      let b = 0;
      for (l = 0; l < o.length; ++l) {
        let I = o[l];
        if (mt(I, Uint8Array))
          b + I.length > f.length ? (c.isBuffer(I) || (I = c.from(I)), I.copy(f, b)) : Uint8Array.prototype.set.call(
            f,
            I,
            b
          );
        else if (c.isBuffer(I))
          I.copy(f, b);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        b += I.length;
      }
      return f;
    };
    function C(h, o) {
      if (c.isBuffer(h))
        return h.length;
      if (ArrayBuffer.isView(h) || mt(h, ArrayBuffer))
        return h.byteLength;
      if (typeof h != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof h
        );
      const u = h.length, l = arguments.length > 2 && arguments[2] === !0;
      if (!l && u === 0) return 0;
      let f = !1;
      for (; ; )
        switch (o) {
          case "ascii":
          case "latin1":
          case "binary":
            return u;
          case "utf8":
          case "utf-8":
            return Nt(h).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return u * 2;
          case "hex":
            return u >>> 1;
          case "base64":
            return $t(h).length;
          default:
            if (f)
              return l ? -1 : Nt(h).length;
            o = ("" + o).toLowerCase(), f = !0;
        }
    }
    c.byteLength = C;
    function V(h, o, u) {
      let l = !1;
      if ((o === void 0 || o < 0) && (o = 0), o > this.length || ((u === void 0 || u > this.length) && (u = this.length), u <= 0) || (u >>>= 0, o >>>= 0, u <= o))
        return "";
      for (h || (h = "utf8"); ; )
        switch (h) {
          case "hex":
            return X(this, o, u);
          case "utf8":
          case "utf-8":
            return z(this, o, u);
          case "ascii":
            return Y(this, o, u);
          case "latin1":
          case "binary":
            return Z(this, o, u);
          case "base64":
            return Q(this, o, u);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return K(this, o, u);
          default:
            if (l) throw new TypeError("Unknown encoding: " + h);
            h = (h + "").toLowerCase(), l = !0;
        }
    }
    c.prototype._isBuffer = !0;
    function G(h, o, u) {
      const l = h[o];
      h[o] = h[u], h[u] = l;
    }
    c.prototype.swap16 = function() {
      const o = this.length;
      if (o % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (let u = 0; u < o; u += 2)
        G(this, u, u + 1);
      return this;
    }, c.prototype.swap32 = function() {
      const o = this.length;
      if (o % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (let u = 0; u < o; u += 4)
        G(this, u, u + 3), G(this, u + 1, u + 2);
      return this;
    }, c.prototype.swap64 = function() {
      const o = this.length;
      if (o % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (let u = 0; u < o; u += 8)
        G(this, u, u + 7), G(this, u + 1, u + 6), G(this, u + 2, u + 5), G(this, u + 3, u + 4);
      return this;
    }, c.prototype.toString = function() {
      const o = this.length;
      return o === 0 ? "" : arguments.length === 0 ? z(this, 0, o) : V.apply(this, arguments);
    }, c.prototype.toLocaleString = c.prototype.toString, c.prototype.equals = function(o) {
      if (!c.isBuffer(o)) throw new TypeError("Argument must be a Buffer");
      return this === o ? !0 : c.compare(this, o) === 0;
    }, c.prototype.inspect = function() {
      let o = "";
      const u = r.INSPECT_MAX_BYTES;
      return o = this.toString("hex", 0, u).replace(/(.{2})/g, "$1 ").trim(), this.length > u && (o += " ... "), "<Buffer " + o + ">";
    }, n && (c.prototype[n] = c.prototype.inspect), c.prototype.compare = function(o, u, l, f, b) {
      if (mt(o, Uint8Array) && (o = c.from(o, o.offset, o.byteLength)), !c.isBuffer(o))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof o
        );
      if (u === void 0 && (u = 0), l === void 0 && (l = o ? o.length : 0), f === void 0 && (f = 0), b === void 0 && (b = this.length), u < 0 || l > o.length || f < 0 || b > this.length)
        throw new RangeError("out of range index");
      if (f >= b && u >= l)
        return 0;
      if (f >= b)
        return -1;
      if (u >= l)
        return 1;
      if (u >>>= 0, l >>>= 0, f >>>= 0, b >>>= 0, this === o) return 0;
      let I = b - f, H = l - u;
      const pt = Math.min(I, H), lt = this.slice(f, b), yt = o.slice(u, l);
      for (let et = 0; et < pt; ++et)
        if (lt[et] !== yt[et]) {
          I = lt[et], H = yt[et];
          break;
        }
      return I < H ? -1 : H < I ? 1 : 0;
    };
    function x(h, o, u, l, f) {
      if (h.length === 0) return -1;
      if (typeof u == "string" ? (l = u, u = 0) : u > 2147483647 ? u = 2147483647 : u < -2147483648 && (u = -2147483648), u = +u, Qt(u) && (u = f ? 0 : h.length - 1), u < 0 && (u = h.length + u), u >= h.length) {
        if (f) return -1;
        u = h.length - 1;
      } else if (u < 0)
        if (f) u = 0;
        else return -1;
      if (typeof o == "string" && (o = c.from(o, l)), c.isBuffer(o))
        return o.length === 0 ? -1 : M(h, o, u, l, f);
      if (typeof o == "number")
        return o = o & 255, typeof Uint8Array.prototype.indexOf == "function" ? f ? Uint8Array.prototype.indexOf.call(h, o, u) : Uint8Array.prototype.lastIndexOf.call(h, o, u) : M(h, [o], u, l, f);
      throw new TypeError("val must be string, number or Buffer");
    }
    function M(h, o, u, l, f) {
      let b = 1, I = h.length, H = o.length;
      if (l !== void 0 && (l = String(l).toLowerCase(), l === "ucs2" || l === "ucs-2" || l === "utf16le" || l === "utf-16le")) {
        if (h.length < 2 || o.length < 2)
          return -1;
        b = 2, I /= 2, H /= 2, u /= 2;
      }
      function pt(yt, et) {
        return b === 1 ? yt[et] : yt.readUInt16BE(et * b);
      }
      let lt;
      if (f) {
        let yt = -1;
        for (lt = u; lt < I; lt++)
          if (pt(h, lt) === pt(o, yt === -1 ? 0 : lt - yt)) {
            if (yt === -1 && (yt = lt), lt - yt + 1 === H) return yt * b;
          } else
            yt !== -1 && (lt -= lt - yt), yt = -1;
      } else
        for (u + H > I && (u = I - H), lt = u; lt >= 0; lt--) {
          let yt = !0;
          for (let et = 0; et < H; et++)
            if (pt(h, lt + et) !== pt(o, et)) {
              yt = !1;
              break;
            }
          if (yt) return lt;
        }
      return -1;
    }
    c.prototype.includes = function(o, u, l) {
      return this.indexOf(o, u, l) !== -1;
    }, c.prototype.indexOf = function(o, u, l) {
      return x(this, o, u, l, !0);
    }, c.prototype.lastIndexOf = function(o, u, l) {
      return x(this, o, u, l, !1);
    };
    function m(h, o, u, l) {
      u = Number(u) || 0;
      const f = h.length - u;
      l ? (l = Number(l), l > f && (l = f)) : l = f;
      const b = o.length;
      l > b / 2 && (l = b / 2);
      let I;
      for (I = 0; I < l; ++I) {
        const H = parseInt(o.substr(I * 2, 2), 16);
        if (Qt(H)) return I;
        h[u + I] = H;
      }
      return I;
    }
    function S(h, o, u, l) {
      return Ot(Nt(o, h.length - u), h, u, l);
    }
    function w(h, o, u, l) {
      return Ot(Ht(o), h, u, l);
    }
    function v(h, o, u, l) {
      return Ot($t(o), h, u, l);
    }
    function k(h, o, u, l) {
      return Ot(Vt(o, h.length - u), h, u, l);
    }
    c.prototype.write = function(o, u, l, f) {
      if (u === void 0)
        f = "utf8", l = this.length, u = 0;
      else if (l === void 0 && typeof u == "string")
        f = u, l = this.length, u = 0;
      else if (isFinite(u))
        u = u >>> 0, isFinite(l) ? (l = l >>> 0, f === void 0 && (f = "utf8")) : (f = l, l = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      const b = this.length - u;
      if ((l === void 0 || l > b) && (l = b), o.length > 0 && (l < 0 || u < 0) || u > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      f || (f = "utf8");
      let I = !1;
      for (; ; )
        switch (f) {
          case "hex":
            return m(this, o, u, l);
          case "utf8":
          case "utf-8":
            return S(this, o, u, l);
          case "ascii":
          case "latin1":
          case "binary":
            return w(this, o, u, l);
          case "base64":
            return v(this, o, u, l);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return k(this, o, u, l);
          default:
            if (I) throw new TypeError("Unknown encoding: " + f);
            f = ("" + f).toLowerCase(), I = !0;
        }
    }, c.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function Q(h, o, u) {
      return o === 0 && u === h.length ? t.fromByteArray(h) : t.fromByteArray(h.slice(o, u));
    }
    function z(h, o, u) {
      u = Math.min(h.length, u);
      const l = [];
      let f = o;
      for (; f < u; ) {
        const b = h[f];
        let I = null, H = b > 239 ? 4 : b > 223 ? 3 : b > 191 ? 2 : 1;
        if (f + H <= u) {
          let pt, lt, yt, et;
          switch (H) {
            case 1:
              b < 128 && (I = b);
              break;
            case 2:
              pt = h[f + 1], (pt & 192) === 128 && (et = (b & 31) << 6 | pt & 63, et > 127 && (I = et));
              break;
            case 3:
              pt = h[f + 1], lt = h[f + 2], (pt & 192) === 128 && (lt & 192) === 128 && (et = (b & 15) << 12 | (pt & 63) << 6 | lt & 63, et > 2047 && (et < 55296 || et > 57343) && (I = et));
              break;
            case 4:
              pt = h[f + 1], lt = h[f + 2], yt = h[f + 3], (pt & 192) === 128 && (lt & 192) === 128 && (yt & 192) === 128 && (et = (b & 15) << 18 | (pt & 63) << 12 | (lt & 63) << 6 | yt & 63, et > 65535 && et < 1114112 && (I = et));
          }
        }
        I === null ? (I = 65533, H = 1) : I > 65535 && (I -= 65536, l.push(I >>> 10 & 1023 | 55296), I = 56320 | I & 1023), l.push(I), f += H;
      }
      return D(l);
    }
    const L = 4096;
    function D(h) {
      const o = h.length;
      if (o <= L)
        return String.fromCharCode.apply(String, h);
      let u = "", l = 0;
      for (; l < o; )
        u += String.fromCharCode.apply(
          String,
          h.slice(l, l += L)
        );
      return u;
    }
    function Y(h, o, u) {
      let l = "";
      u = Math.min(h.length, u);
      for (let f = o; f < u; ++f)
        l += String.fromCharCode(h[f] & 127);
      return l;
    }
    function Z(h, o, u) {
      let l = "";
      u = Math.min(h.length, u);
      for (let f = o; f < u; ++f)
        l += String.fromCharCode(h[f]);
      return l;
    }
    function X(h, o, u) {
      const l = h.length;
      (!o || o < 0) && (o = 0), (!u || u < 0 || u > l) && (u = l);
      let f = "";
      for (let b = o; b < u; ++b)
        f += sr[h[b]];
      return f;
    }
    function K(h, o, u) {
      const l = h.slice(o, u);
      let f = "";
      for (let b = 0; b < l.length - 1; b += 2)
        f += String.fromCharCode(l[b] + l[b + 1] * 256);
      return f;
    }
    c.prototype.slice = function(o, u) {
      const l = this.length;
      o = ~~o, u = u === void 0 ? l : ~~u, o < 0 ? (o += l, o < 0 && (o = 0)) : o > l && (o = l), u < 0 ? (u += l, u < 0 && (u = 0)) : u > l && (u = l), u < o && (u = o);
      const f = this.subarray(o, u);
      return Object.setPrototypeOf(f, c.prototype), f;
    };
    function q(h, o, u) {
      if (h % 1 !== 0 || h < 0) throw new RangeError("offset is not uint");
      if (h + o > u) throw new RangeError("Trying to access beyond buffer length");
    }
    c.prototype.readUintLE = c.prototype.readUIntLE = function(o, u, l) {
      o = o >>> 0, u = u >>> 0, l || q(o, u, this.length);
      let f = this[o], b = 1, I = 0;
      for (; ++I < u && (b *= 256); )
        f += this[o + I] * b;
      return f;
    }, c.prototype.readUintBE = c.prototype.readUIntBE = function(o, u, l) {
      o = o >>> 0, u = u >>> 0, l || q(o, u, this.length);
      let f = this[o + --u], b = 1;
      for (; u > 0 && (b *= 256); )
        f += this[o + --u] * b;
      return f;
    }, c.prototype.readUint8 = c.prototype.readUInt8 = function(o, u) {
      return o = o >>> 0, u || q(o, 1, this.length), this[o];
    }, c.prototype.readUint16LE = c.prototype.readUInt16LE = function(o, u) {
      return o = o >>> 0, u || q(o, 2, this.length), this[o] | this[o + 1] << 8;
    }, c.prototype.readUint16BE = c.prototype.readUInt16BE = function(o, u) {
      return o = o >>> 0, u || q(o, 2, this.length), this[o] << 8 | this[o + 1];
    }, c.prototype.readUint32LE = c.prototype.readUInt32LE = function(o, u) {
      return o = o >>> 0, u || q(o, 4, this.length), (this[o] | this[o + 1] << 8 | this[o + 2] << 16) + this[o + 3] * 16777216;
    }, c.prototype.readUint32BE = c.prototype.readUInt32BE = function(o, u) {
      return o = o >>> 0, u || q(o, 4, this.length), this[o] * 16777216 + (this[o + 1] << 16 | this[o + 2] << 8 | this[o + 3]);
    }, c.prototype.readBigUInt64LE = Wt(function(o) {
      o = o >>> 0, $(o, "offset");
      const u = this[o], l = this[o + 7];
      (u === void 0 || l === void 0) && J(o, this.length - 8);
      const f = u + this[++o] * 2 ** 8 + this[++o] * 2 ** 16 + this[++o] * 2 ** 24, b = this[++o] + this[++o] * 2 ** 8 + this[++o] * 2 ** 16 + l * 2 ** 24;
      return BigInt(f) + (BigInt(b) << BigInt(32));
    }), c.prototype.readBigUInt64BE = Wt(function(o) {
      o = o >>> 0, $(o, "offset");
      const u = this[o], l = this[o + 7];
      (u === void 0 || l === void 0) && J(o, this.length - 8);
      const f = u * 2 ** 24 + this[++o] * 2 ** 16 + this[++o] * 2 ** 8 + this[++o], b = this[++o] * 2 ** 24 + this[++o] * 2 ** 16 + this[++o] * 2 ** 8 + l;
      return (BigInt(f) << BigInt(32)) + BigInt(b);
    }), c.prototype.readIntLE = function(o, u, l) {
      o = o >>> 0, u = u >>> 0, l || q(o, u, this.length);
      let f = this[o], b = 1, I = 0;
      for (; ++I < u && (b *= 256); )
        f += this[o + I] * b;
      return b *= 128, f >= b && (f -= Math.pow(2, 8 * u)), f;
    }, c.prototype.readIntBE = function(o, u, l) {
      o = o >>> 0, u = u >>> 0, l || q(o, u, this.length);
      let f = u, b = 1, I = this[o + --f];
      for (; f > 0 && (b *= 256); )
        I += this[o + --f] * b;
      return b *= 128, I >= b && (I -= Math.pow(2, 8 * u)), I;
    }, c.prototype.readInt8 = function(o, u) {
      return o = o >>> 0, u || q(o, 1, this.length), this[o] & 128 ? (255 - this[o] + 1) * -1 : this[o];
    }, c.prototype.readInt16LE = function(o, u) {
      o = o >>> 0, u || q(o, 2, this.length);
      const l = this[o] | this[o + 1] << 8;
      return l & 32768 ? l | 4294901760 : l;
    }, c.prototype.readInt16BE = function(o, u) {
      o = o >>> 0, u || q(o, 2, this.length);
      const l = this[o + 1] | this[o] << 8;
      return l & 32768 ? l | 4294901760 : l;
    }, c.prototype.readInt32LE = function(o, u) {
      return o = o >>> 0, u || q(o, 4, this.length), this[o] | this[o + 1] << 8 | this[o + 2] << 16 | this[o + 3] << 24;
    }, c.prototype.readInt32BE = function(o, u) {
      return o = o >>> 0, u || q(o, 4, this.length), this[o] << 24 | this[o + 1] << 16 | this[o + 2] << 8 | this[o + 3];
    }, c.prototype.readBigInt64LE = Wt(function(o) {
      o = o >>> 0, $(o, "offset");
      const u = this[o], l = this[o + 7];
      (u === void 0 || l === void 0) && J(o, this.length - 8);
      const f = this[o + 4] + this[o + 5] * 2 ** 8 + this[o + 6] * 2 ** 16 + (l << 24);
      return (BigInt(f) << BigInt(32)) + BigInt(u + this[++o] * 2 ** 8 + this[++o] * 2 ** 16 + this[++o] * 2 ** 24);
    }), c.prototype.readBigInt64BE = Wt(function(o) {
      o = o >>> 0, $(o, "offset");
      const u = this[o], l = this[o + 7];
      (u === void 0 || l === void 0) && J(o, this.length - 8);
      const f = (u << 24) + // Overflow
      this[++o] * 2 ** 16 + this[++o] * 2 ** 8 + this[++o];
      return (BigInt(f) << BigInt(32)) + BigInt(this[++o] * 2 ** 24 + this[++o] * 2 ** 16 + this[++o] * 2 ** 8 + l);
    }), c.prototype.readFloatLE = function(o, u) {
      return o = o >>> 0, u || q(o, 4, this.length), e.read(this, o, !0, 23, 4);
    }, c.prototype.readFloatBE = function(o, u) {
      return o = o >>> 0, u || q(o, 4, this.length), e.read(this, o, !1, 23, 4);
    }, c.prototype.readDoubleLE = function(o, u) {
      return o = o >>> 0, u || q(o, 8, this.length), e.read(this, o, !0, 52, 8);
    }, c.prototype.readDoubleBE = function(o, u) {
      return o = o >>> 0, u || q(o, 8, this.length), e.read(this, o, !1, 52, 8);
    };
    function rt(h, o, u, l, f, b) {
      if (!c.isBuffer(h)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (o > f || o < b) throw new RangeError('"value" argument is out of bounds');
      if (u + l > h.length) throw new RangeError("Index out of range");
    }
    c.prototype.writeUintLE = c.prototype.writeUIntLE = function(o, u, l, f) {
      if (o = +o, u = u >>> 0, l = l >>> 0, !f) {
        const H = Math.pow(2, 8 * l) - 1;
        rt(this, o, u, l, H, 0);
      }
      let b = 1, I = 0;
      for (this[u] = o & 255; ++I < l && (b *= 256); )
        this[u + I] = o / b & 255;
      return u + l;
    }, c.prototype.writeUintBE = c.prototype.writeUIntBE = function(o, u, l, f) {
      if (o = +o, u = u >>> 0, l = l >>> 0, !f) {
        const H = Math.pow(2, 8 * l) - 1;
        rt(this, o, u, l, H, 0);
      }
      let b = l - 1, I = 1;
      for (this[u + b] = o & 255; --b >= 0 && (I *= 256); )
        this[u + b] = o / I & 255;
      return u + l;
    }, c.prototype.writeUint8 = c.prototype.writeUInt8 = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 1, 255, 0), this[u] = o & 255, u + 1;
    }, c.prototype.writeUint16LE = c.prototype.writeUInt16LE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 2, 65535, 0), this[u] = o & 255, this[u + 1] = o >>> 8, u + 2;
    }, c.prototype.writeUint16BE = c.prototype.writeUInt16BE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 2, 65535, 0), this[u] = o >>> 8, this[u + 1] = o & 255, u + 2;
    }, c.prototype.writeUint32LE = c.prototype.writeUInt32LE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 4, 4294967295, 0), this[u + 3] = o >>> 24, this[u + 2] = o >>> 16, this[u + 1] = o >>> 8, this[u] = o & 255, u + 4;
    }, c.prototype.writeUint32BE = c.prototype.writeUInt32BE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 4, 4294967295, 0), this[u] = o >>> 24, this[u + 1] = o >>> 16, this[u + 2] = o >>> 8, this[u + 3] = o & 255, u + 4;
    };
    function At(h, o, u, l, f) {
      j(o, l, f, h, u, 7);
      let b = Number(o & BigInt(4294967295));
      h[u++] = b, b = b >> 8, h[u++] = b, b = b >> 8, h[u++] = b, b = b >> 8, h[u++] = b;
      let I = Number(o >> BigInt(32) & BigInt(4294967295));
      return h[u++] = I, I = I >> 8, h[u++] = I, I = I >> 8, h[u++] = I, I = I >> 8, h[u++] = I, u;
    }
    function Ut(h, o, u, l, f) {
      j(o, l, f, h, u, 7);
      let b = Number(o & BigInt(4294967295));
      h[u + 7] = b, b = b >> 8, h[u + 6] = b, b = b >> 8, h[u + 5] = b, b = b >> 8, h[u + 4] = b;
      let I = Number(o >> BigInt(32) & BigInt(4294967295));
      return h[u + 3] = I, I = I >> 8, h[u + 2] = I, I = I >> 8, h[u + 1] = I, I = I >> 8, h[u] = I, u + 8;
    }
    c.prototype.writeBigUInt64LE = Wt(function(o, u = 0) {
      return At(this, o, u, BigInt(0), BigInt("0xffffffffffffffff"));
    }), c.prototype.writeBigUInt64BE = Wt(function(o, u = 0) {
      return Ut(this, o, u, BigInt(0), BigInt("0xffffffffffffffff"));
    }), c.prototype.writeIntLE = function(o, u, l, f) {
      if (o = +o, u = u >>> 0, !f) {
        const pt = Math.pow(2, 8 * l - 1);
        rt(this, o, u, l, pt - 1, -pt);
      }
      let b = 0, I = 1, H = 0;
      for (this[u] = o & 255; ++b < l && (I *= 256); )
        o < 0 && H === 0 && this[u + b - 1] !== 0 && (H = 1), this[u + b] = (o / I >> 0) - H & 255;
      return u + l;
    }, c.prototype.writeIntBE = function(o, u, l, f) {
      if (o = +o, u = u >>> 0, !f) {
        const pt = Math.pow(2, 8 * l - 1);
        rt(this, o, u, l, pt - 1, -pt);
      }
      let b = l - 1, I = 1, H = 0;
      for (this[u + b] = o & 255; --b >= 0 && (I *= 256); )
        o < 0 && H === 0 && this[u + b + 1] !== 0 && (H = 1), this[u + b] = (o / I >> 0) - H & 255;
      return u + l;
    }, c.prototype.writeInt8 = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 1, 127, -128), o < 0 && (o = 255 + o + 1), this[u] = o & 255, u + 1;
    }, c.prototype.writeInt16LE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 2, 32767, -32768), this[u] = o & 255, this[u + 1] = o >>> 8, u + 2;
    }, c.prototype.writeInt16BE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 2, 32767, -32768), this[u] = o >>> 8, this[u + 1] = o & 255, u + 2;
    }, c.prototype.writeInt32LE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 4, 2147483647, -2147483648), this[u] = o & 255, this[u + 1] = o >>> 8, this[u + 2] = o >>> 16, this[u + 3] = o >>> 24, u + 4;
    }, c.prototype.writeInt32BE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 4, 2147483647, -2147483648), o < 0 && (o = 4294967295 + o + 1), this[u] = o >>> 24, this[u + 1] = o >>> 16, this[u + 2] = o >>> 8, this[u + 3] = o & 255, u + 4;
    }, c.prototype.writeBigInt64LE = Wt(function(o, u = 0) {
      return At(this, o, u, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    }), c.prototype.writeBigInt64BE = Wt(function(o, u = 0) {
      return Ut(this, o, u, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function Pt(h, o, u, l, f, b) {
      if (u + l > h.length) throw new RangeError("Index out of range");
      if (u < 0) throw new RangeError("Index out of range");
    }
    function Zt(h, o, u, l, f) {
      return o = +o, u = u >>> 0, f || Pt(h, o, u, 4), e.write(h, o, u, l, 23, 4), u + 4;
    }
    c.prototype.writeFloatLE = function(o, u, l) {
      return Zt(this, o, u, !0, l);
    }, c.prototype.writeFloatBE = function(o, u, l) {
      return Zt(this, o, u, !1, l);
    };
    function Gt(h, o, u, l, f) {
      return o = +o, u = u >>> 0, f || Pt(h, o, u, 8), e.write(h, o, u, l, 52, 8), u + 8;
    }
    c.prototype.writeDoubleLE = function(o, u, l) {
      return Gt(this, o, u, !0, l);
    }, c.prototype.writeDoubleBE = function(o, u, l) {
      return Gt(this, o, u, !1, l);
    }, c.prototype.copy = function(o, u, l, f) {
      if (!c.isBuffer(o)) throw new TypeError("argument should be a Buffer");
      if (l || (l = 0), !f && f !== 0 && (f = this.length), u >= o.length && (u = o.length), u || (u = 0), f > 0 && f < l && (f = l), f === l || o.length === 0 || this.length === 0) return 0;
      if (u < 0)
        throw new RangeError("targetStart out of bounds");
      if (l < 0 || l >= this.length) throw new RangeError("Index out of range");
      if (f < 0) throw new RangeError("sourceEnd out of bounds");
      f > this.length && (f = this.length), o.length - u < f - l && (f = o.length - u + l);
      const b = f - l;
      return this === o && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(u, l, f) : Uint8Array.prototype.set.call(
        o,
        this.subarray(l, f),
        u
      ), b;
    }, c.prototype.fill = function(o, u, l, f) {
      if (typeof o == "string") {
        if (typeof u == "string" ? (f = u, u = 0, l = this.length) : typeof l == "string" && (f = l, l = this.length), f !== void 0 && typeof f != "string")
          throw new TypeError("encoding must be a string");
        if (typeof f == "string" && !c.isEncoding(f))
          throw new TypeError("Unknown encoding: " + f);
        if (o.length === 1) {
          const I = o.charCodeAt(0);
          (f === "utf8" && I < 128 || f === "latin1") && (o = I);
        }
      } else typeof o == "number" ? o = o & 255 : typeof o == "boolean" && (o = Number(o));
      if (u < 0 || this.length < u || this.length < l)
        throw new RangeError("Out of range index");
      if (l <= u)
        return this;
      u = u >>> 0, l = l === void 0 ? this.length : l >>> 0, o || (o = 0);
      let b;
      if (typeof o == "number")
        for (b = u; b < l; ++b)
          this[b] = o;
      else {
        const I = c.isBuffer(o) ? o : c.from(o, f), H = I.length;
        if (H === 0)
          throw new TypeError('The value "' + o + '" is invalid for argument "value"');
        for (b = 0; b < l - u; ++b)
          this[b + u] = I[b % H];
      }
      return this;
    };
    const W = {};
    function g(h, o, u) {
      W[h] = class extends u {
        constructor() {
          super(), Object.defineProperty(this, "message", {
            value: o.apply(this, arguments),
            writable: !0,
            configurable: !0
          }), this.name = `${this.name} [${h}]`, this.stack, delete this.name;
        }
        get code() {
          return h;
        }
        set code(f) {
          Object.defineProperty(this, "code", {
            configurable: !0,
            enumerable: !0,
            value: f,
            writable: !0
          });
        }
        toString() {
          return `${this.name} [${h}]: ${this.message}`;
        }
      };
    }
    g(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(h) {
        return h ? `${h} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
      },
      RangeError
    ), g(
      "ERR_INVALID_ARG_TYPE",
      function(h, o) {
        return `The "${h}" argument must be of type number. Received type ${typeof o}`;
      },
      TypeError
    ), g(
      "ERR_OUT_OF_RANGE",
      function(h, o, u) {
        let l = `The value of "${h}" is out of range.`, f = u;
        return Number.isInteger(u) && Math.abs(u) > 2 ** 32 ? f = _(String(u)) : typeof u == "bigint" && (f = String(u), (u > BigInt(2) ** BigInt(32) || u < -(BigInt(2) ** BigInt(32))) && (f = _(f)), f += "n"), l += ` It must be ${o}. Received ${f}`, l;
      },
      RangeError
    );
    function _(h) {
      let o = "", u = h.length;
      const l = h[0] === "-" ? 1 : 0;
      for (; u >= l + 4; u -= 3)
        o = `_${h.slice(u - 3, u)}${o}`;
      return `${h.slice(0, u)}${o}`;
    }
    function E(h, o, u) {
      $(o, "offset"), (h[o] === void 0 || h[o + u] === void 0) && J(o, h.length - (u + 1));
    }
    function j(h, o, u, l, f, b) {
      if (h > u || h < o) {
        const I = typeof o == "bigint" ? "n" : "";
        let H;
        throw o === 0 || o === BigInt(0) ? H = `>= 0${I} and < 2${I} ** ${(b + 1) * 8}${I}` : H = `>= -(2${I} ** ${(b + 1) * 8 - 1}${I}) and < 2 ** ${(b + 1) * 8 - 1}${I}`, new W.ERR_OUT_OF_RANGE("value", H, h);
      }
      E(l, f, b);
    }
    function $(h, o) {
      if (typeof h != "number")
        throw new W.ERR_INVALID_ARG_TYPE(o, "number", h);
    }
    function J(h, o, u) {
      throw Math.floor(h) !== h ? ($(h, u), new W.ERR_OUT_OF_RANGE("offset", "an integer", h)) : o < 0 ? new W.ERR_BUFFER_OUT_OF_BOUNDS() : new W.ERR_OUT_OF_RANGE(
        "offset",
        `>= 0 and <= ${o}`,
        h
      );
    }
    const bt = /[^+/0-9A-Za-z-_]/g;
    function kt(h) {
      if (h = h.split("=")[0], h = h.trim().replace(bt, ""), h.length < 2) return "";
      for (; h.length % 4 !== 0; )
        h = h + "=";
      return h;
    }
    function Nt(h, o) {
      o = o || 1 / 0;
      let u;
      const l = h.length;
      let f = null;
      const b = [];
      for (let I = 0; I < l; ++I) {
        if (u = h.charCodeAt(I), u > 55295 && u < 57344) {
          if (!f) {
            if (u > 56319) {
              (o -= 3) > -1 && b.push(239, 191, 189);
              continue;
            } else if (I + 1 === l) {
              (o -= 3) > -1 && b.push(239, 191, 189);
              continue;
            }
            f = u;
            continue;
          }
          if (u < 56320) {
            (o -= 3) > -1 && b.push(239, 191, 189), f = u;
            continue;
          }
          u = (f - 55296 << 10 | u - 56320) + 65536;
        } else f && (o -= 3) > -1 && b.push(239, 191, 189);
        if (f = null, u < 128) {
          if ((o -= 1) < 0) break;
          b.push(u);
        } else if (u < 2048) {
          if ((o -= 2) < 0) break;
          b.push(
            u >> 6 | 192,
            u & 63 | 128
          );
        } else if (u < 65536) {
          if ((o -= 3) < 0) break;
          b.push(
            u >> 12 | 224,
            u >> 6 & 63 | 128,
            u & 63 | 128
          );
        } else if (u < 1114112) {
          if ((o -= 4) < 0) break;
          b.push(
            u >> 18 | 240,
            u >> 12 & 63 | 128,
            u >> 6 & 63 | 128,
            u & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return b;
    }
    function Ht(h) {
      const o = [];
      for (let u = 0; u < h.length; ++u)
        o.push(h.charCodeAt(u) & 255);
      return o;
    }
    function Vt(h, o) {
      let u, l, f;
      const b = [];
      for (let I = 0; I < h.length && !((o -= 2) < 0); ++I)
        u = h.charCodeAt(I), l = u >> 8, f = u % 256, b.push(f), b.push(l);
      return b;
    }
    function $t(h) {
      return t.toByteArray(kt(h));
    }
    function Ot(h, o, u, l) {
      let f;
      for (f = 0; f < l && !(f + u >= o.length || f >= h.length); ++f)
        o[f + u] = h[f];
      return f;
    }
    function mt(h, o) {
      return h instanceof o || h != null && h.constructor != null && h.constructor.name != null && h.constructor.name === o.name;
    }
    function Qt(h) {
      return h !== h;
    }
    const sr = function() {
      const h = "0123456789abcdef", o = new Array(256);
      for (let u = 0; u < 16; ++u) {
        const l = u * 16;
        for (let f = 0; f < 16; ++f)
          o[l + f] = h[u] + h[f];
      }
      return o;
    }();
    function Wt(h) {
      return typeof BigInt > "u" ? vi : h;
    }
    function vi() {
      throw new Error("BigInt not supported");
    }
  }(Ni)), Ni;
}
var No;
function Yd() {
  if (No) return Ur;
  No = 1, Object.defineProperty(Ur, "__esModule", { value: !0 }), Ur.BinaryReader = void 0;
  const r = Cs();
  class t {
    constructor(n, s = !1) {
      this.readUInt8 = this._read(r.Buffer.prototype.readUInt8, r.Buffer.prototype.readUInt8, 1), this.readUInt16 = this._read(r.Buffer.prototype.readUInt16LE, r.Buffer.prototype.readUInt16BE, 2), this.readUInt32 = this._read(r.Buffer.prototype.readUInt32LE, r.Buffer.prototype.readUInt32BE, 4), this.readInt8 = this._read(r.Buffer.prototype.readInt8, r.Buffer.prototype.readInt8, 1), this.readInt16 = this._read(r.Buffer.prototype.readInt16LE, r.Buffer.prototype.readInt16BE, 2), this.readInt32 = this._read(r.Buffer.prototype.readInt32LE, r.Buffer.prototype.readInt32BE, 4), this.readFloat = this._read(r.Buffer.prototype.readFloatLE, r.Buffer.prototype.readFloatBE, 4), this.readDouble = this._read(r.Buffer.prototype.readDoubleLE, r.Buffer.prototype.readDoubleBE, 8), this.buffer = n, this.position = 0, this.isBigEndian = s;
    }
    _read(n, s, i) {
      return () => {
        let a;
        return this.isBigEndian ? a = s.call(this.buffer, this.position) : a = n.call(this.buffer, this.position), this.position += i, a;
      };
    }
    readVarInt() {
      let n, s = 0, i = 0;
      do
        n = this.buffer[this.position + i], s += (n & 127) << 7 * i, i++;
      while (n >= 128);
      return this.position += i, s;
    }
  }
  return Ur.BinaryReader = t, Ur;
}
var Cr = {}, Do;
function qe() {
  if (Do) return Cr;
  Do = 1, Object.defineProperty(Cr, "__esModule", { value: !0 }), Cr.BinaryWriter = void 0;
  const r = Cs();
  class t {
    constructor(n, s = !0) {
      this.writeUInt8 = this._write(r.Buffer.prototype.writeUInt8, 1), this.writeUInt16LE = this._write(r.Buffer.prototype.writeUInt16LE, 2), this.writeUInt16BE = this._write(r.Buffer.prototype.writeUInt16BE, 2), this.writeUInt32LE = this._write(r.Buffer.prototype.writeUInt32LE, 4), this.writeUInt32BE = this._write(r.Buffer.prototype.writeUInt32BE, 4), this.writeInt8 = this._write(r.Buffer.prototype.writeInt8, 1), this.writeInt16LE = this._write(r.Buffer.prototype.writeInt16LE, 2), this.writeInt16BE = this._write(r.Buffer.prototype.writeInt16BE, 2), this.writeInt32LE = this._write(r.Buffer.prototype.writeInt32LE, 4), this.writeInt32BE = this._write(r.Buffer.prototype.writeInt32BE, 4), this.writeFloatLE = this._write(r.Buffer.prototype.writeFloatLE, 4), this.writeFloatBE = this._write(r.Buffer.prototype.writeFloatBE, 4), this.writeDoubleLE = this._write(r.Buffer.prototype.writeDoubleLE, 8), this.writeDoubleBE = this._write(r.Buffer.prototype.writeDoubleBE, 8), this.buffer = r.Buffer.alloc(n), this.position = 0, this.allowResize = s;
    }
    _write(n, s) {
      return (i, a = !1) => {
        this.ensureSize(s), n.call(this.buffer, i, this.position, a), this.position += s;
      };
    }
    writeBuffer(n) {
      this.ensureSize(n.length), n.copy(this.buffer, this.position, 0, n.length), this.position += n.length;
    }
    writeVarInt(n) {
      let s = 1;
      for (; (n & 4294967168) !== 0; )
        this.writeUInt8(n & 127 | 128), n >>>= 7, s++;
      return this.writeUInt8(n & 127), s;
    }
    ensureSize(n) {
      if (this.buffer.length < this.position + n)
        if (this.allowResize) {
          const s = r.Buffer.alloc(this.position + n);
          this.buffer.copy(s, 0, 0, this.buffer.length), this.buffer = s;
        } else
          throw new RangeError("index out of range");
    }
  }
  return Cr.BinaryWriter = t, Cr;
}
var Rr = {}, Uo;
function $e() {
  return Uo || (Uo = 1, Object.defineProperty(Rr, "__esModule", { value: !0 }), Rr.CONSTANTS = void 0, Rr.CONSTANTS = {
    wkt: {
      Point: "POINT",
      LineString: "LINESTRING",
      Polygon: "POLYGON",
      MultiPoint: "MULTIPOINT",
      MultiLineString: "MULTILINESTRING",
      MultiPolygon: "MULTIPOLYGON",
      GeometryCollection: "GEOMETRYCOLLECTION"
    },
    wkb: {
      Point: 1,
      LineString: 2,
      Polygon: 3,
      MultiPoint: 4,
      MultiLineString: 5,
      MultiPolygon: 6,
      GeometryCollection: 7
    },
    geoJSON: {
      Point: "Point",
      LineString: "LineString",
      Polygon: "Polygon",
      MultiPoint: "MultiPoint",
      MultiLineString: "MultiLineString",
      MultiPolygon: "MultiPolygon",
      GeometryCollection: "GeometryCollection"
    }
  }), Rr;
}
var Pr = {}, Lo;
function Jd() {
  if (Lo) return Pr;
  Lo = 1, Object.defineProperty(Pr, "__esModule", { value: !0 }), Pr.Geometry = void 0;
  const r = Cs(), t = ze();
  class e {
    constructor() {
      this.srid = void 0, this.hasZ = !1, this.hasM = !1;
    }
    static parse(s, i) {
      if (typeof s === "string" || s instanceof t.WktParser)
        return e._parseWkt(s);
      if (r.Buffer.isBuffer(s) || s instanceof t.BinaryReader)
        try {
          return e._parseWkb(s, i);
        } catch {
          try {
            return e.parseTwkb(s);
          } catch {
            throw new Error("Could not parse WKB or TWKB");
          }
        }
      else
        throw new Error("First argument must be a string or Buffer");
    }
    static _parseWkt(s) {
      let i, a;
      s instanceof t.WktParser ? i = s : i = new t.WktParser(s);
      const c = i.matchRegex([/^SRID=(\d+);/]);
      c && (a = parseInt(c[1], 10));
      const d = i.matchType(), p = i.matchDimension(), y = {
        srid: a,
        hasZ: p.hasZ,
        hasM: p.hasM
      };
      switch (d) {
        case t.CONSTANTS.wkt.Point:
          return t.Point._parseWktWithOptions(i, y);
        case t.CONSTANTS.wkt.LineString:
          return t.LineString._parseWktWithOptions(i, y);
        case t.CONSTANTS.wkt.Polygon:
          return t.Polygon._parseWktWithOptions(i, y);
        case t.CONSTANTS.wkt.MultiPoint:
          return t.MultiPoint._parseWktWithOptions(i, y);
        case t.CONSTANTS.wkt.MultiLineString:
          return t.MultiLineString._parseWktWithOptions(i, y);
        case t.CONSTANTS.wkt.MultiPolygon:
          return t.MultiPolygon._parseWktWithOptions(i, y);
        case t.CONSTANTS.wkt.GeometryCollection:
          return t.GeometryCollection._parseWktWithOptions(i, y);
        default:
          throw new Error("Unsupported geometry type");
      }
    }
    static _parseWkb(s, i) {
      let a, c, d;
      const p = {};
      switch (s instanceof t.BinaryReader ? a = s : a = new t.BinaryReader(s), a.isBigEndian = !a.readInt8(), c = a.readUInt32(), p.hasSrid = (c & 536870912) === 536870912, p.isEwkb = c & 536870912 || c & 1073741824 || c & 2147483648, p.hasSrid && (p.srid = a.readUInt32()), p.hasZ = !1, p.hasM = !1, !p.isEwkb && (!i || !i.isEwkb) ? c >= 1e3 && c < 2e3 ? (p.hasZ = !0, d = c - 1e3) : c >= 2e3 && c < 3e3 ? (p.hasM = !0, d = c - 2e3) : c >= 3e3 && c < 4e3 ? (p.hasZ = !0, p.hasM = !0, d = c - 3e3) : d = c : (c & 2147483648 && (p.hasZ = !0), c & 1073741824 && (p.hasM = !0), d = c & 15), d) {
        case t.CONSTANTS.wkb.Point:
          return t.Point._parseWkb(a, p);
        case t.CONSTANTS.wkb.LineString:
          return t.LineString._parseWkb(a, p);
        case t.CONSTANTS.wkb.Polygon:
          return t.Polygon._parseWkb(a, p);
        case t.CONSTANTS.wkb.MultiPoint:
          return t.MultiPoint._parseWkb(a, p);
        case t.CONSTANTS.wkb.MultiLineString:
          return t.MultiLineString._parseWkb(a, p);
        case t.CONSTANTS.wkb.MultiPolygon:
          return t.MultiPolygon._parseWkb(a, p);
        case t.CONSTANTS.wkb.GeometryCollection:
          return t.GeometryCollection._parseWkb(a, p);
        default:
          throw new Error(`GeometryType ${d} not supported`);
      }
    }
    static parseTwkb(s) {
      let i;
      const a = {};
      s instanceof t.BinaryReader ? i = s : i = new t.BinaryReader(s);
      const c = i.readUInt8(), d = i.readUInt8(), p = c & 15;
      if (a.precision = t.ZigZag.decode(c >> 4), a.precisionFactor = Math.pow(10, a.precision), a.hasBoundingBox = d >> 0 & 1, a.hasSizeAttribute = d >> 1 & 1, a.hasIdList = d >> 2 & 1, a.hasExtendedPrecision = d >> 3 & 1, a.isEmpty = d >> 4 & 1, a.hasExtendedPrecision) {
        const y = i.readUInt8();
        a.hasZ = (y & 1) === 1, a.hasM = (y & 2) === 2, a.zPrecision = t.ZigZag.decode((y & 28) >> 2), a.zPrecisionFactor = Math.pow(10, a.zPrecision), a.mPrecision = t.ZigZag.decode((y & 224) >> 5), a.mPrecisionFactor = Math.pow(10, a.mPrecision);
      } else
        a.hasZ = !1, a.hasM = !1;
      if (a.hasSizeAttribute && i.readVarInt(), a.hasBoundingBox) {
        let y = 2;
        a.hasZ && y++, a.hasM && y++;
        for (let B = 0; B < y; B++)
          i.readVarInt(), i.readVarInt();
      }
      switch (p) {
        case t.CONSTANTS.wkb.Point:
          return t.Point._parseTwkb(i, a);
        case t.CONSTANTS.wkb.LineString:
          return t.LineString._parseTwkb(i, a);
        case t.CONSTANTS.wkb.Polygon:
          return t.Polygon._parseTwkb(i, a);
        case t.CONSTANTS.wkb.MultiPoint:
          return t.MultiPoint._parseTwkb(i, a);
        case t.CONSTANTS.wkb.MultiLineString:
          return t.MultiLineString._parseTwkb(i, a);
        case t.CONSTANTS.wkb.MultiPolygon:
          return t.MultiPolygon._parseTwkb(i, a);
        case t.CONSTANTS.wkb.GeometryCollection:
          return t.GeometryCollection._parseTwkb(i, a);
        default:
          throw new Error("GeometryType " + p + " not supported");
      }
    }
    toGeoJSON(s) {
      const i = {};
      return this.srid && s && (s.shortCrs ? i.crs = {
        type: "name",
        properties: {
          name: "EPSG:" + this.srid
        }
      } : s.longCrs && (i.crs = {
        type: "name",
        properties: {
          name: "urn:ogc:def:crs:EPSG::" + this.srid
        }
      })), i;
    }
    static _parseGeoJSON(s, i) {
      let a;
      switch (s.type) {
        case t.CONSTANTS.geoJSON.Point:
          a = t.Point._parseGeoJSON(s);
          break;
        case t.CONSTANTS.geoJSON.LineString:
          a = t.LineString._parseGeoJSON(s);
          break;
        case t.CONSTANTS.geoJSON.Polygon:
          a = t.Polygon._parseGeoJSON(s);
          break;
        case t.CONSTANTS.geoJSON.MultiPoint:
          a = t.MultiPoint._parseGeoJSON(s);
          break;
        case t.CONSTANTS.geoJSON.MultiLineString:
          a = t.MultiLineString._parseGeoJSON(s);
          break;
        case t.CONSTANTS.geoJSON.MultiPolygon:
          a = t.MultiPolygon._parseGeoJSON(s);
          break;
        case t.CONSTANTS.geoJSON.GeometryCollection:
          a = t.GeometryCollection._parseGeoJSON(s);
          break;
        default:
          throw new Error("GeometryType " + s.type + " not supported");
      }
      if (s.crs && s.crs.type && s.crs.type === "name" && s.crs.properties && s.crs.properties.name) {
        const c = s.crs.properties.name;
        if (c.indexOf("EPSG:") === 0)
          a.srid = parseInt(c.substring(5));
        else if (c.indexOf("urn:ogc:def:crs:EPSG::") === 0)
          a.srid = parseInt(c.substring(22));
        else
          throw new Error("Unsupported crs: " + c);
      } else i || (a.srid = 4326);
      return a;
    }
    toEwkt() {
      return `SRID=${this.srid};${this.toWkt()}`;
    }
    toEwkb() {
      const s = new t.BinaryWriter(this._getWkbSize() + 4), i = this.toWkb();
      return s.writeInt8(1), s.writeUInt32LE((i.slice(1, 5).readUInt32LE(0) | 536870912) >>> 0, !0), s.writeUInt32LE(this.srid), s.writeBuffer(i.slice(5)), s.buffer;
    }
    _getWktType(s, i) {
      let a = s;
      return this.hasZ && this.hasM ? a += " ZM " : this.hasZ ? a += " Z " : this.hasM && (a += " M "), i && !this.hasZ && !this.hasM && (a += " "), i && (a += "EMPTY"), a;
    }
    _getWktCoordinate(s) {
      let i = `${s.x} ${s.y}`;
      return this.hasZ && (i += ` ${s.z}`), this.hasM && (i += ` ${s.m}`), i;
    }
    _writeWkbType(s, i, a) {
      let c = 0;
      typeof this.srid > "u" && (!a || typeof a.srid > "u") ? this.hasZ && this.hasM ? c += 3e3 : this.hasZ ? c += 1e3 : this.hasM && (c += 2e3) : (this.hasZ && (c |= 2147483648), this.hasM && (c |= 1073741824)), s.writeUInt32LE(c + i >>> 0, !0);
    }
    static getTwkbPrecision(s, i, a) {
      return {
        xy: s,
        z: i,
        m: a,
        xyFactor: Math.pow(10, s),
        zFactor: Math.pow(10, i),
        mFactor: Math.pow(10, a)
      };
    }
    _writeTwkbHeader(s, i, a, c) {
      const d = (t.ZigZag.encode(a.xy) << 4) + i;
      let p = this.hasZ || this.hasM ? 1 : 0;
      if (p += c ? 1 : 0, s.writeUInt8(d), s.writeUInt8(p), this.hasZ || this.hasM) {
        let y = 0;
        this.hasZ && (y |= 1), this.hasM && (y |= 2), s.writeUInt8(y);
      }
    }
    toWkt() {
      throw new Error("Method 'toWkt' not implemented.");
    }
    toWkb() {
      throw new Error("Method 'toWkb' not implemented.");
    }
    toTwkb() {
      throw new Error("Method 'toTwkb' not implemented.");
    }
    _getWkbSize() {
      throw new Error("Method '_getWkbSize' not implemented.");
    }
  }
  return Pr.Geometry = e, Pr;
}
var $r = {}, Co;
function Hd() {
  if (Co) return $r;
  Co = 1, Object.defineProperty($r, "__esModule", { value: !0 }), $r.GeometryCollection = void 0;
  const r = qe(), t = $e(), e = ze();
  class n extends e.Geometry {
    constructor(i = [], a) {
      super(), this.geometries = i, this.srid = a, this.geometries.length > 0 && (this.hasZ = this.geometries[0].hasZ, this.hasM = this.geometries[0].hasM);
    }
    static Z(i, a) {
      const c = new n(i, a);
      return c.hasZ = !0, c;
    }
    static M(i, a) {
      const c = new n(i, a);
      return c.hasM = !0, c;
    }
    static ZM(i, a) {
      const c = new n(i, a);
      return c.hasZ = !0, c.hasM = !0, c;
    }
    static _parseWktWithOptions(i, a) {
      const c = new n();
      if (c.srid = a.srid, c.hasZ = a.hasZ, c.hasM = a.hasM, i.isMatch(["EMPTY"]))
        return c;
      i.expectGroupStart();
      do
        c.geometries.push(e.Geometry.parse(i));
      while (i.isMatch([","]));
      return i.expectGroupEnd(), c;
    }
    static _parseWkb(i, a) {
      const c = new n();
      c.srid = a.srid, c.hasZ = a.hasZ, c.hasM = a.hasM;
      const d = i.readUInt32();
      for (let p = 0; p < d; p++)
        c.geometries.push(e.Geometry.parse(i, a));
      return c;
    }
    static _parseTwkb(i, a) {
      const c = new n();
      if (c.hasZ = a.hasZ, c.hasM = a.hasM, a.isEmpty)
        return c;
      const d = i.readVarInt();
      for (let p = 0; p < d; p++)
        c.geometries.push(e.Geometry.parseTwkb(i));
      return c;
    }
    static _parseGeoJSON(i) {
      const a = new n();
      for (let c = 0; c < i.geometries.length; c++)
        a.geometries.push(e.Geometry._parseGeoJSON(i.geometries[c], !0));
      return a.geometries.length > 0 && (a.hasZ = a.geometries[0].hasZ), a;
    }
    toWkt() {
      if (this.geometries.length === 0)
        return this._getWktType(t.CONSTANTS.wkt.GeometryCollection, !0);
      let i = this._getWktType(t.CONSTANTS.wkt.GeometryCollection, !1) + "(";
      for (let a = 0; a < this.geometries.length; a++)
        i += this.geometries[a].toWkt() + ",";
      return i = i.slice(0, -1) + ")", i;
    }
    toWkb() {
      const i = new r.BinaryWriter(this._getWkbSize());
      i.writeInt8(1), this._writeWkbType(i, t.CONSTANTS.wkb.GeometryCollection), i.writeUInt32LE(this.geometries.length);
      for (let a = 0; a < this.geometries.length; a++)
        i.writeBuffer(this.geometries[a].toWkb(
          /* { srid: this.srid }*/
        ));
      return i.buffer;
    }
    toTwkb() {
      const i = new r.BinaryWriter(0, !0), a = e.Geometry.getTwkbPrecision(5, 0, 0), c = this.geometries.length === 0;
      if (this._writeTwkbHeader(i, t.CONSTANTS.wkb.GeometryCollection, a, c), !c) {
        i.writeVarInt(this.geometries.length);
        for (let d = 0; d < this.geometries.length; d++)
          i.writeBuffer(this.geometries[d].toTwkb());
      }
      return i.buffer;
    }
    _getWkbSize() {
      let i = 9;
      for (let a = 0; a < this.geometries.length; a++)
        i += this.geometries[a]._getWkbSize();
      return i;
    }
    toGeoJSON(i) {
      const a = super.toGeoJSON(i);
      return a.type = t.CONSTANTS.geoJSON.GeometryCollection, a.geometries = this.geometries.map((c) => c.toGeoJSON()), a;
    }
  }
  return $r.GeometryCollection = n, $r;
}
var zr = {}, Ro;
function qd() {
  if (Ro) return zr;
  Ro = 1, Object.defineProperty(zr, "__esModule", { value: !0 }), zr.LineString = void 0;
  const r = qe(), t = $e(), e = ze();
  class n extends e.Geometry {
    constructor(i = [], a) {
      super(), this.hasZ = !1, this.hasM = !1, this.points = i, this.srid = a, this.points.length > 0 && (this.hasZ = this.points[0].hasZ, this.hasM = this.points[0].hasM);
    }
    static Z(i, a) {
      const c = new n(i, a);
      return c.hasZ = !0, c;
    }
    static M(i, a) {
      const c = new n(i, a);
      return c.hasM = !0, c;
    }
    static ZM(i, a) {
      const c = new n(i, a);
      return c.hasZ = !0, c.hasM = !0, c;
    }
    static _parseWktWithOptions(i, a) {
      const c = new n();
      return c.srid = a.srid, c.hasZ = a.hasZ, c.hasM = a.hasM, i.isMatch(["EMPTY"]) || (i.expectGroupStart(), c.points.push(...i.matchCoordinates(a)), i.expectGroupEnd()), c;
    }
    static _parseWkb(i, a) {
      const c = new n();
      c.srid = a.srid, c.hasZ = a.hasZ, c.hasM = a.hasM;
      const d = i.readUInt32();
      for (let p = 0; p < d; p++)
        c.points.push(e.Point._readWkbPoint(i, a));
      return c;
    }
    static _parseTwkb(i, a) {
      const c = new n();
      if (c.hasZ = a.hasZ, c.hasM = a.hasM, a.isEmpty)
        return c;
      const d = new e.Point(
        0,
        0,
        0,
        0
        /* options.hasM ? 0 : undefined*/
      ), p = i.readVarInt();
      for (let y = 0; y < p; y++)
        c.points.push(e.Point._readTwkbPoint(i, a, d));
      return c;
    }
    static _parseGeoJSON(i) {
      const a = new n();
      i.coordinates.length > 0 && (a.hasZ = i.coordinates[0].length > 2);
      for (const c of i.coordinates)
        a.points.push(e.Point._readGeoJSONPoint(c));
      return a;
    }
    static fromGeometry(i) {
      const a = new n();
      return a.srid = i.srid, a.hasZ = i.hasZ, a.hasM = i.hasM, i instanceof n ? a.points = i.points : i instanceof e.Point && (a.points = [i]), a;
    }
    toWkt() {
      return this.points.length === 0 ? this._getWktType(t.CONSTANTS.wkt.LineString, !0) : this._getWktType(t.CONSTANTS.wkt.LineString, !1) + this._toInnerWkt();
    }
    _toInnerWkt() {
      let i = "(";
      for (const a of this.points)
        i += `${this._getWktCoordinate(a)},`;
      return i.slice(0, -1) + ")";
    }
    toWkb(i) {
      const a = new r.BinaryWriter(this._getWkbSize());
      a.writeInt8(1), this._writeWkbType(a, t.CONSTANTS.wkb.LineString, i), a.writeUInt32LE(this.points.length);
      for (const c of this.points)
        c._writeWkbPoint(a);
      return a.buffer;
    }
    toTwkb() {
      const i = new r.BinaryWriter(0, !0), a = e.Geometry.getTwkbPrecision(5, 0, 0), c = this.points.length === 0;
      if (this._writeTwkbHeader(i, t.CONSTANTS.wkb.LineString, a, c), !c) {
        i.writeVarInt(this.points.length);
        const d = new e.Point(0, 0, 0, 0);
        for (const p of this.points)
          p._writeTwkbPoint(i, a, d);
      }
      return i.buffer;
    }
    _getWkbSize() {
      let i = 16;
      return this.hasZ && (i += 8), this.hasM && (i += 8), 9 + this.points.length * i;
    }
    toGeoJSON(i) {
      const a = super.toGeoJSON(i);
      return a.type = t.CONSTANTS.geoJSON.LineString, a.coordinates = this.points.map((c) => this.hasZ ? [c.x, c.y, c.z] : [c.x, c.y]), a;
    }
  }
  return zr.LineString = n, zr;
}
var jr = {}, Po;
function Kd() {
  if (Po) return jr;
  Po = 1, Object.defineProperty(jr, "__esModule", { value: !0 }), jr.MultiLineString = void 0;
  const r = qe(), t = $e(), e = ze();
  class n extends e.Geometry {
    constructor(i = [], a) {
      super(), this.lineStrings = i, this.srid = a, this.lineStrings.length > 0 && (this.hasZ = this.lineStrings[0].hasZ, this.hasM = this.lineStrings[0].hasM);
    }
    static Z(i, a) {
      const c = new n(i, a);
      return c.hasZ = !0, c;
    }
    static M(i, a) {
      const c = new n(i, a);
      return c.hasM = !0, c;
    }
    static ZM(i, a) {
      const c = new n(i, a);
      return c.hasZ = !0, c.hasM = !0, c;
    }
    static _parseWktWithOptions(i, a) {
      const c = new n();
      if (c.srid = a.srid, c.hasZ = a.hasZ, c.hasM = a.hasM, i.isMatch(["EMPTY"]))
        return c;
      i.expectGroupStart();
      do
        i.expectGroupStart(), c.lineStrings.push(new e.LineString(i.matchCoordinates(a))), i.expectGroupEnd();
      while (i.isMatch([","]));
      return i.expectGroupEnd(), c;
    }
    static _parseWkb(i, a) {
      const c = new n();
      c.srid = a.srid, c.hasZ = a.hasZ, c.hasM = a.hasM;
      const d = i.readUInt32();
      for (let p = 0; p < d; p++) {
        const y = e.Geometry.parse(i, a);
        c.lineStrings.push(e.LineString.fromGeometry(y));
      }
      return c;
    }
    static _parseTwkb(i, a) {
      const c = new n();
      if (c.hasZ = a.hasZ, c.hasM = a.hasM, a.isEmpty)
        return c;
      const d = new e.Point(
        0,
        0,
        0,
        0
        /* options.hasM ? 0 : undefined*/
      ), p = i.readVarInt();
      for (let y = 0; y < p; y++) {
        const B = new e.LineString();
        B.hasZ = a.hasZ, B.hasM = a.hasM;
        const R = i.readVarInt();
        for (let F = 0; F < R; F++)
          B.points.push(e.Point._readTwkbPoint(i, a, d));
        c.lineStrings.push(B);
      }
      return c;
    }
    static _parseGeoJSON(i) {
      const a = new n();
      i.coordinates.length > 0 && i.coordinates[0].length > 0 && (a.hasZ = i.coordinates[0][0].length > 2);
      for (let c = 0; c < i.coordinates.length; c++)
        a.lineStrings.push(e.LineString._parseGeoJSON({ coordinates: i.coordinates[c] }));
      return a;
    }
    toWkt() {
      if (this.lineStrings.length === 0)
        return this._getWktType(t.CONSTANTS.wkt.MultiLineString, !0);
      let i = this._getWktType(t.CONSTANTS.wkt.MultiLineString, !1) + "(";
      for (let a = 0; a < this.lineStrings.length; a++)
        i += this.lineStrings[a]._toInnerWkt() + ",";
      return i = i.slice(0, -1) + ")", i;
    }
    toWkb() {
      const i = new r.BinaryWriter(this._getWkbSize());
      i.writeInt8(1), this._writeWkbType(i, t.CONSTANTS.wkb.MultiLineString), i.writeUInt32LE(this.lineStrings.length);
      for (let a = 0; a < this.lineStrings.length; a++)
        i.writeBuffer(this.lineStrings[a].toWkb({ srid: this.srid }));
      return i.buffer;
    }
    toTwkb() {
      const i = new r.BinaryWriter(0, !0), a = e.Geometry.getTwkbPrecision(5, 0, 0), c = this.lineStrings.length === 0;
      if (this._writeTwkbHeader(i, t.CONSTANTS.wkb.MultiLineString, a, c), !c) {
        i.writeVarInt(this.lineStrings.length);
        const d = new e.Point(0, 0, 0, 0);
        for (let p = 0; p < this.lineStrings.length; p++) {
          i.writeVarInt(this.lineStrings[p].points.length);
          for (let y = 0; y < this.lineStrings[p].points.length; y++)
            this.lineStrings[p].points[y]._writeTwkbPoint(i, a, d);
        }
      }
      return i.buffer;
    }
    _getWkbSize() {
      let i = 9;
      for (let a = 0; a < this.lineStrings.length; a++)
        i += this.lineStrings[a]._getWkbSize();
      return i;
    }
    toGeoJSON(i) {
      const a = super.toGeoJSON(i);
      a.type = t.CONSTANTS.geoJSON.MultiLineString, a.coordinates = [];
      for (let c = 0; c < this.lineStrings.length; c++)
        a.coordinates.push(this.lineStrings[c].toGeoJSON().coordinates);
      return a;
    }
  }
  return jr.MultiLineString = n, jr;
}
var Vr = {}, $o;
function Xd() {
  if ($o) return Vr;
  $o = 1, Object.defineProperty(Vr, "__esModule", { value: !0 }), Vr.MultiPoint = void 0;
  const r = qe(), t = $e(), e = ze();
  class n extends e.Geometry {
    constructor(i = [], a) {
      super(), this.points = i, this.srid = a, this.points.length > 0 && (this.hasZ = this.points[0].hasZ, this.hasM = this.points[0].hasM);
    }
    static Z(i, a) {
      const c = new n(i, a);
      return c.hasZ = !0, c;
    }
    static M(i, a) {
      const c = new n(i, a);
      return c.hasM = !0, c;
    }
    static ZM(i, a) {
      const c = new n(i, a);
      return c.hasZ = !0, c.hasM = !0, c;
    }
    static _parseWktWithOptions(i, a) {
      const c = new n();
      return c.srid = a.srid, c.hasZ = a.hasZ, c.hasM = a.hasM, i.isMatch(["EMPTY"]) || (i.expectGroupStart(), c.points.push(...i.matchCoordinates(a)), i.expectGroupEnd()), c;
    }
    static _parseWkb(i, a) {
      const c = new n();
      c.srid = a.srid, c.hasZ = a.hasZ, c.hasM = a.hasM;
      const d = i.readUInt32();
      for (let p = 0; p < d; p++) {
        const y = e.Geometry.parse(i, a);
        c.points.push(e.Point.fromGeometry(y));
      }
      return c;
    }
    static _parseTwkb(i, a) {
      const c = new n();
      if (c.hasZ = a.hasZ, c.hasM = a.hasM, a.isEmpty)
        return c;
      const d = new e.Point(
        0,
        0,
        0,
        0
        /* options.hasM ? 0 : undefined*/
      ), p = i.readVarInt();
      for (let y = 0; y < p; y++)
        c.points.push(e.Point._readTwkbPoint(i, a, d));
      return c;
    }
    static _parseGeoJSON(i) {
      const a = new n();
      i.coordinates.length > 0 && (a.hasZ = i.coordinates[0].length > 2);
      for (let c = 0; c < i.coordinates.length; c++)
        a.points.push(e.Point._parseGeoJSON({ coordinates: i.coordinates[c] }));
      return a;
    }
    toWkt() {
      if (this.points.length === 0)
        return this._getWktType(t.CONSTANTS.wkt.MultiPoint, !0);
      let i = this._getWktType(t.CONSTANTS.wkt.MultiPoint, !1) + "(";
      for (let a = 0; a < this.points.length; a++)
        i += this._getWktCoordinate(this.points[a]) + ",";
      return i = i.slice(0, -1) + ")", i;
    }
    toWkb() {
      const i = new r.BinaryWriter(this._getWkbSize());
      i.writeInt8(1), this._writeWkbType(i, t.CONSTANTS.wkb.MultiPoint), i.writeUInt32LE(this.points.length);
      for (let a = 0; a < this.points.length; a++)
        i.writeBuffer(this.points[a].toWkb({ srid: this.srid }));
      return i.buffer;
    }
    toTwkb() {
      const i = new r.BinaryWriter(0, !0), a = e.Geometry.getTwkbPrecision(5, 0, 0), c = this.points.length === 0;
      if (this._writeTwkbHeader(i, t.CONSTANTS.wkb.MultiPoint, a, c), !c) {
        i.writeVarInt(this.points.length);
        const d = new e.Point(0, 0, 0, 0);
        for (let p = 0; p < this.points.length; p++)
          this.points[p]._writeTwkbPoint(i, a, d);
      }
      return i.buffer;
    }
    _getWkbSize() {
      let i = 16;
      return this.hasZ && (i += 8), this.hasM && (i += 8), i += 5, 9 + this.points.length * i;
    }
    toGeoJSON(i) {
      const a = super.toGeoJSON(i);
      a.type = t.CONSTANTS.geoJSON.MultiPoint, a.coordinates = [];
      for (let c = 0; c < this.points.length; c++)
        a.coordinates.push(this.points[c].toGeoJSON().coordinates);
      return a;
    }
  }
  return Vr.MultiPoint = n, Vr;
}
var Wr = {}, zo;
function Qd() {
  if (zo) return Wr;
  zo = 1, Object.defineProperty(Wr, "__esModule", { value: !0 }), Wr.MultiPolygon = void 0;
  const r = qe(), t = $e(), e = ze();
  class n extends e.Geometry {
    constructor(i, a) {
      super(), this.polygons = i || [], this.srid = a, this.polygons.length > 0 ? (this.hasZ = this.polygons[0].hasZ, this.hasM = this.polygons[0].hasM) : (this.hasZ = !1, this.hasM = !1);
    }
    static Z(i, a) {
      const c = new n(i, a);
      return c.hasZ = !0, c;
    }
    static M(i, a) {
      const c = new n(i, a);
      return c.hasM = !0, c;
    }
    static ZM(i, a) {
      const c = new n(i, a);
      return c.hasZ = !0, c.hasM = !0, c;
    }
    static _parseWktWithOptions(i, a) {
      const c = new n();
      if (c.srid = a.srid, c.hasZ = a.hasZ, c.hasM = a.hasM, i.isMatch(["EMPTY"]))
        return c;
      i.expectGroupStart();
      do {
        i.expectGroupStart();
        const d = [], p = [];
        for (i.expectGroupStart(), d.push(...i.matchCoordinates(a)), i.expectGroupEnd(); i.isMatch([","]); )
          i.expectGroupStart(), p.push(i.matchCoordinates(a)), i.expectGroupEnd();
        c.polygons.push(new e.Polygon(d, p)), i.expectGroupEnd();
      } while (i.isMatch([","]));
      return i.expectGroupEnd(), c;
    }
    static _parseWkb(i, a) {
      const c = new n();
      c.srid = a.srid, c.hasZ = a.hasZ, c.hasM = a.hasM;
      const d = i.readUInt32();
      for (let p = 0; p < d; p++)
        c.polygons.push(e.Geometry.parse(i, a));
      return c;
    }
    static _parseTwkb(i, a) {
      const c = new n();
      if (c.hasZ = a.hasZ, c.hasM = a.hasM, a.isEmpty)
        return c;
      const d = new e.Point(
        0,
        0,
        0,
        0
        /* options.hasM ? 0 : undefined*/
      ), p = i.readVarInt();
      for (let y = 0; y < p; y++) {
        const B = new e.Polygon();
        B.hasZ = a.hasZ, B.hasM = a.hasM;
        const R = i.readVarInt(), F = i.readVarInt();
        for (let T = 0; T < F; T++)
          B.exteriorRing.push(e.Point._readTwkbPoint(i, a, d));
        for (let T = 1; T < R; T++) {
          const U = [], O = i.readVarInt();
          for (let N = 0; N < O; N++)
            U.push(e.Point._readTwkbPoint(i, a, d));
          B.interiorRings.push(U);
        }
        c.polygons.push(B);
      }
      return c;
    }
    static _parseGeoJSON(i) {
      const a = new n();
      i.coordinates.length > 0 && i.coordinates[0].length > 0 && i.coordinates[0][0].length > 0 && (a.hasZ = i.coordinates[0][0].length > 2);
      for (let c = 0; c < i.coordinates.length; c++)
        a.polygons.push(e.Polygon._parseGeoJSON({ coordinates: i.coordinates }));
      return a;
    }
    toWkt() {
      if (this.polygons.length === 0)
        return this._getWktType(t.CONSTANTS.wkt.MultiPolygon, !0);
      let i = this._getWktType(t.CONSTANTS.wkt.MultiPolygon, !1) + "(";
      for (let a = 0; a < this.polygons.length; a++)
        i += this.polygons[a]._toInnerWkt() + ",";
      return i = i.slice(0, -1), i += ")", i;
    }
    toWkb() {
      const i = new r.BinaryWriter(this._getWkbSize());
      i.writeInt8(1), this._writeWkbType(i, t.CONSTANTS.wkb.MultiPolygon), i.writeUInt32LE(this.polygons.length);
      for (let a = 0; a < this.polygons.length; a++)
        i.writeBuffer(this.polygons[a].toWkb({ srid: this.srid }));
      return i.buffer;
    }
    toTwkb() {
      const i = new r.BinaryWriter(0, !0), a = e.Geometry.getTwkbPrecision(5, 0, 0), c = this.polygons.length === 0;
      if (this._writeTwkbHeader(i, t.CONSTANTS.wkb.MultiPolygon, a, c), this.polygons.length > 0) {
        i.writeVarInt(this.polygons.length);
        const d = new e.Point(0, 0, 0, 0);
        for (let p = 0; p < this.polygons.length; p++) {
          i.writeVarInt(1 + this.polygons[p].interiorRings.length), i.writeVarInt(this.polygons[p].exteriorRing.length);
          for (let y = 0; y < this.polygons[p].exteriorRing.length; y++)
            this.polygons[p].exteriorRing[y]._writeTwkbPoint(i, a, d);
          for (let y = 0; y < this.polygons[p].interiorRings.length; y++) {
            i.writeVarInt(this.polygons[p].interiorRings[y].length);
            for (let B = 0; B < this.polygons[p].interiorRings[y].length; B++)
              this.polygons[p].interiorRings[y][B]._writeTwkbPoint(i, a, d);
          }
        }
      }
      return i.buffer;
    }
    _getWkbSize() {
      let i = 9;
      for (let a = 0; a < this.polygons.length; a++)
        i += this.polygons[a]._getWkbSize();
      return i;
    }
    toGeoJSON(i) {
      const a = super.toGeoJSON(i);
      a.type = t.CONSTANTS.geoJSON.MultiPolygon, a.coordinates = [];
      for (let c = 0; c < this.polygons.length; c++)
        a.coordinates.push(this.polygons[c].toGeoJSON().coordinates);
      return a;
    }
  }
  return Wr.MultiPolygon = n, Wr;
}
var Zr = {}, Gr = {}, jo;
function pu() {
  if (jo) return Gr;
  jo = 1, Object.defineProperty(Gr, "__esModule", { value: !0 }), Gr.ZigZag = void 0;
  class r {
    static encode(e) {
      return e << 1 ^ e >> 31;
    }
    static decode(e) {
      return e >> 1 ^ -(e & 1);
    }
  }
  return Gr.ZigZag = r, Gr;
}
var Vo;
function yu() {
  if (Vo) return Zr;
  Vo = 1, Object.defineProperty(Zr, "__esModule", { value: !0 }), Zr.Point = void 0;
  const r = qe(), t = pu(), e = $e(), n = ze();
  class s extends n.Geometry {
    constructor(a, c, d, p, y) {
      super(), this.x = a, this.y = c, this.z = d, this.m = p, this.srid = y, this.hasZ = typeof this.z < "u", this.hasM = typeof this.m < "u";
    }
    static Z(a, c, d, p) {
      const y = new s(a, c, d, 0, p);
      return y.hasZ = !0, y;
    }
    static M(a, c, d, p) {
      const y = new s(a, c, 0, d, p);
      return y.hasM = !0, y;
    }
    static ZM(a, c, d, p, y) {
      const B = new s(a, c, d, p, y);
      return B.hasZ = !0, B.hasM = !0, B;
    }
    static _parseWktWithOptions(a, c) {
      const d = new s(0, 0, 0, 0);
      if (d.srid = c.srid, d.hasZ = c.hasZ, d.hasM = c.hasM, a.isMatch(["EMPTY"]))
        return d;
      a.expectGroupStart();
      const p = a.matchCoordinate(c);
      return d.x = p.x, d.y = p.y, d.z = p.z, d.m = p.m, a.expectGroupEnd(), d;
    }
    static _parseWkb(a, c) {
      const d = s._readWkbPoint(a, c);
      return d.srid = c.srid, d;
    }
    static _readWkbPoint(a, c) {
      return new s(a.readDouble(), a.readDouble(), c.hasZ ? a.readDouble() : !1, c.hasM ? a.readDouble() : !1);
    }
    static _parseTwkb(a, c) {
      const d = new s(0, 0, 0, 0);
      return d.hasZ = c.hasZ, d.hasM = c.hasM, c.isEmpty || (d.x = t.ZigZag.decode(a.readVarInt()) / c.precisionFactor, d.y = t.ZigZag.decode(a.readVarInt()) / c.precisionFactor, d.z = c.hasZ ? t.ZigZag.decode(a.readVarInt()) / c.zPrecisionFactor : 0, d.m = c.hasM ? t.ZigZag.decode(a.readVarInt()) / c.mPrecisionFactor : 0), d;
    }
    static _readTwkbPoint(a, c, d) {
      return d.x += t.ZigZag.decode(a.readVarInt()) / c.precisionFactor, d.y += t.ZigZag.decode(a.readVarInt()) / c.precisionFactor, c.hasZ && (d.z += t.ZigZag.decode(a.readVarInt()) / c.zPrecisionFactor), c.hasM && (d.m += t.ZigZag.decode(a.readVarInt()) / c.mPrecisionFactor), new s(d.x, d.y, d.z, d.m);
    }
    static _parseGeoJSON(a) {
      return s._readGeoJSONPoint(a.coordinates);
    }
    static _readGeoJSONPoint(a) {
      return a.length === 0 ? new s(0, 0, 0, 0) : a.length > 2 ? new s(a[0], a[1], a[2], 0) : new s(a[0], a[1], 0, 0);
    }
    static fromGeometry(a) {
      const c = new s(0, 0, 0, 0);
      return c.srid = a.srid, c.hasZ = a.hasZ, c.hasM = a.hasM, a instanceof s ? (c.x = a.x, c.y = a.y, c.z = a.z, c.m = a.m) : console.log("Point.fromGeometry: geom is not an instance of Point"), c;
    }
    toWkt() {
      return this.x === void 0 && this.y === void 0 && this.z === void 0 && this.m === void 0 ? this._getWktType(e.CONSTANTS.wkt.Point, !0) : `${this._getWktType(e.CONSTANTS.wkt.Point, !1)}(${this._getWktCoordinate(this)})`;
    }
    toWkb(a) {
      const c = new r.BinaryWriter(this._getWkbSize());
      return c.writeInt8(1), this._writeWkbType(c, e.CONSTANTS.wkb.Point, a), this.x === void 0 && this.y === void 0 ? (c.writeDoubleLE(NaN), c.writeDoubleLE(NaN), this.hasZ && c.writeDoubleLE(NaN), this.hasM && c.writeDoubleLE(NaN)) : this._writeWkbPoint(c), c.buffer;
    }
    _writeWkbPoint(a) {
      a.writeDoubleLE(this.x), a.writeDoubleLE(this.y), this.hasZ && a.writeDoubleLE(this.z), this.hasM && a.writeDoubleLE(this.m);
    }
    toTwkb() {
      const a = new r.BinaryWriter(0, !0), c = n.Geometry.getTwkbPrecision(5, 0, 0), d = this.x === void 0 && this.y === void 0;
      return this._writeTwkbHeader(a, e.CONSTANTS.wkb.Point, c, d), d || this._writeTwkbPoint(a, c, new s(0, 0, 0, 0)), a.buffer;
    }
    _writeTwkbPoint(a, c, d) {
      const p = this.x * c.xyFactor, y = this.y * c.xyFactor, B = this.z * c.zFactor, R = this.m * c.mFactor;
      a.writeVarInt(t.ZigZag.encode(p - d.x)), a.writeVarInt(t.ZigZag.encode(y - d.y)), this.hasZ && a.writeVarInt(t.ZigZag.encode(B - d.z)), this.hasM && a.writeVarInt(t.ZigZag.encode(R - d.m)), d.x = p, d.y = y, d.z = B, d.m = R;
    }
    _getWkbSize() {
      let a = 21;
      return this.hasZ && (a += 8), this.hasM && (a += 8), a;
    }
    toGeoJSON(a) {
      const c = super.toGeoJSON(a);
      return c.type = e.CONSTANTS.geoJSON.Point, this.x === void 0 && this.y === void 0 ? c.coordinates = [] : this.z !== void 0 ? c.coordinates = [this.x, this.y, this.z] : c.coordinates = [this.x, this.y], c;
    }
  }
  return Zr.Point = s, Zr;
}
var Yr = {}, Wo;
function tf() {
  if (Wo) return Yr;
  Wo = 1, Object.defineProperty(Yr, "__esModule", { value: !0 }), Yr.Polygon = void 0;
  const r = qe(), t = $e(), e = ze();
  class n extends e.Geometry {
    constructor(i, a, c) {
      super(), this.exteriorRing = i || [], this.interiorRings = a || [], this.srid = c, this.exteriorRing.length > 0 ? (this.hasZ = this.exteriorRing[0].hasZ, this.hasM = this.exteriorRing[0].hasM) : (this.hasZ = !1, this.hasM = !1);
    }
    static Z(i, a, c) {
      const d = new n(i, a, c);
      return d.hasZ = !0, d;
    }
    static M(i, a, c) {
      const d = new n(i, a, c);
      return d.hasM = !0, d;
    }
    static ZM(i, a, c) {
      const d = new n(i, a, c);
      return d.hasZ = !0, d.hasM = !0, d;
    }
    static _parseWktWithOptions(i, a) {
      const c = new n();
      if (c.srid = a.srid, c.hasZ = a.hasZ, c.hasM = a.hasM, i.isMatch(["EMPTY"]))
        return c;
      for (i.expectGroupStart(), i.expectGroupStart(), c.exteriorRing.push(...i.matchCoordinates(a)), i.expectGroupEnd(); i.isMatch([","]); )
        i.expectGroupStart(), c.interiorRings.push(i.matchCoordinates(a)), i.expectGroupEnd();
      return i.expectGroupEnd(), c;
    }
    static _parseWkb(i, a) {
      const c = new n();
      c.srid = a.srid, c.hasZ = a.hasZ, c.hasM = a.hasM;
      const d = i.readUInt32();
      if (d > 0) {
        const p = i.readUInt32();
        for (let y = 0; y < p; y++)
          c.exteriorRing.push(e.Point._readWkbPoint(i, a));
        for (let y = 1; y < d; y++) {
          const B = [], R = i.readUInt32();
          for (let F = 0; F < R; F++)
            B.push(e.Point._readWkbPoint(i, a));
          c.interiorRings.push(B);
        }
      }
      return c;
    }
    static _parseTwkb(i, a) {
      const c = new n();
      if (c.hasZ = a.hasZ, c.hasM = a.hasM, a.isEmpty)
        return c;
      const d = new e.Point(
        0,
        0,
        0,
        0
        /* options.hasM ? 0 : undefined*/
      ), p = i.readVarInt(), y = i.readVarInt();
      for (let B = 0; B < y; B++)
        c.exteriorRing.push(e.Point._readTwkbPoint(i, a, d));
      for (let B = 1; B < p; B++) {
        const R = [], F = i.readVarInt();
        for (let T = 0; T < F; T++)
          R.push(e.Point._readTwkbPoint(i, a, d));
        c.interiorRings.push(R);
      }
      return c;
    }
    static _parseGeoJSON(i) {
      const a = new n();
      i.coordinates.length > 0 && i.coordinates[0].length > 0 && (a.hasZ = i.coordinates[0][0].length > 2);
      for (let c = 0; c < i.coordinates.length; c++) {
        c > 0 && a.interiorRings.push([]);
        for (let d = 0; d < i.coordinates[c].length; d++)
          c === 0 ? a.exteriorRing.push(e.Point._readGeoJSONPoint(i.coordinates[c][d])) : a.interiorRings[c - 1].push(e.Point._readGeoJSONPoint(i.coordinates[c][d]));
      }
      return a;
    }
    toWkt() {
      return this.exteriorRing.length === 0 ? this._getWktType(t.CONSTANTS.wkt.Polygon, !0) : this._getWktType(t.CONSTANTS.wkt.Polygon, !1) + this._toInnerWkt();
    }
    _toInnerWkt() {
      let i = "((";
      for (let a = 0; a < this.exteriorRing.length; a++)
        i += this._getWktCoordinate(this.exteriorRing[a]) + ",";
      i = i.slice(0, -1), i += ")";
      for (let a = 0; a < this.interiorRings.length; a++) {
        i += ",(";
        for (let c = 0; c < this.interiorRings[a].length; c++)
          i += this._getWktCoordinate(this.interiorRings[a][c]) + ",";
        i = i.slice(0, -1), i += ")";
      }
      return i += ")", i;
    }
    toWkb(i) {
      const a = new r.BinaryWriter(this._getWkbSize());
      a.writeInt8(1), this._writeWkbType(a, t.CONSTANTS.wkb.Polygon, i), this.exteriorRing.length > 0 ? (a.writeUInt32LE(1 + this.interiorRings.length), a.writeUInt32LE(this.exteriorRing.length)) : a.writeUInt32LE(0);
      for (let c = 0; c < this.exteriorRing.length; c++)
        this.exteriorRing[c]._writeWkbPoint(a);
      for (let c = 0; c < this.interiorRings.length; c++) {
        a.writeUInt32LE(this.interiorRings[c].length);
        for (let d = 0; d < this.interiorRings[c].length; d++)
          this.interiorRings[c][d]._writeWkbPoint(a);
      }
      return a.buffer;
    }
    toTwkb() {
      const i = new r.BinaryWriter(0, !0), a = e.Geometry.getTwkbPrecision(5, 0, 0), c = this.exteriorRing.length === 0;
      if (this._writeTwkbHeader(i, t.CONSTANTS.wkb.Polygon, a, c), this.exteriorRing.length > 0) {
        i.writeVarInt(1 + this.interiorRings.length), i.writeVarInt(this.exteriorRing.length);
        const d = new e.Point(0, 0, 0, 0);
        for (let p = 0; p < this.exteriorRing.length; p++)
          this.exteriorRing[p]._writeTwkbPoint(i, a, d);
        for (let p = 0; p < this.interiorRings.length; p++) {
          i.writeVarInt(this.interiorRings[p].length);
          for (let y = 0; y < this.interiorRings[p].length; y++)
            this.interiorRings[p][y]._writeTwkbPoint(i, a, d);
        }
      }
      return i.buffer;
    }
    _getWkbSize() {
      let i = 16;
      this.hasZ && (i += 8), this.hasM && (i += 8);
      let a = 9;
      this.exteriorRing.length > 0 && (a += 4 + this.exteriorRing.length * i);
      for (let c = 0; c < this.interiorRings.length; c++)
        a += 4 + this.interiorRings[c].length * i;
      return a;
    }
    toGeoJSON(i) {
      const a = super.toGeoJSON(i);
      if (a.type = t.CONSTANTS.geoJSON.Polygon, a.coordinates = [], this.exteriorRing.length > 0) {
        const c = [];
        for (let d = 0; d < this.exteriorRing.length; d++)
          this.hasZ ? c.push([
            this.exteriorRing[d].x,
            this.exteriorRing[d].y,
            this.exteriorRing[d].z
          ]) : c.push([this.exteriorRing[d].x, this.exteriorRing[d].y]);
        a.coordinates.push(c);
      }
      for (let c = 0; c < this.interiorRings.length; c++) {
        const d = [];
        for (let p = 0; p < this.interiorRings[c].length; p++)
          this.hasZ ? d.push([
            this.interiorRings[c][p].x,
            this.interiorRings[c][p].y,
            this.interiorRings[c][p].z
          ]) : d.push([
            this.interiorRings[c][p].x,
            this.interiorRings[c][p].y
          ]);
        a.coordinates.push(d);
      }
      return a;
    }
  }
  return Yr.Polygon = n, Yr;
}
var Jr = {}, Zo;
function ef() {
  if (Zo) return Jr;
  Zo = 1, Object.defineProperty(Jr, "__esModule", { value: !0 }), Jr.WktParser = void 0;
  const r = $e(), t = yu();
  class e {
    constructor(s) {
      this.value = s, this.position = 0;
    }
    match(s) {
      this.skipWhitespaces();
      for (let i = 0; i < s.length; i++)
        if (this.value.substring(this.position).indexOf(s[i]) === 0)
          return this.position += s[i].length, s[i];
      return null;
    }
    matchRegex(s) {
      this.skipWhitespaces();
      for (let i = 0; i < s.length; i++) {
        const a = this.value.substring(this.position).match(s[i]);
        if (a)
          return this.position += a[0].length, a;
      }
      return null;
    }
    isMatch(s) {
      this.skipWhitespaces();
      for (let i = 0; i < s.length; i++)
        if (this.value.substring(this.position).indexOf(s[i]) === 0)
          return this.position += s[i].length, !0;
      return !1;
    }
    matchType() {
      const s = this.match([
        r.CONSTANTS.wkt.Point,
        r.CONSTANTS.wkt.LineString,
        r.CONSTANTS.wkt.Polygon,
        r.CONSTANTS.wkt.MultiPoint,
        r.CONSTANTS.wkt.MultiLineString,
        r.CONSTANTS.wkt.MultiPolygon,
        r.CONSTANTS.wkt.GeometryCollection
      ]);
      if (!s)
        throw new Error("Expected geometry type");
      return s;
    }
    matchDimension() {
      switch (this.match(["ZM", "Z", "M"])) {
        case "ZM":
          return { hasZ: !0, hasM: !0 };
        case "Z":
          return { hasZ: !0, hasM: !1 };
        case "M":
          return { hasZ: !1, hasM: !0 };
        default:
          return { hasZ: !1, hasM: !1 };
      }
    }
    expectGroupStart() {
      if (!this.isMatch(["("]))
        throw new Error("Expected group start");
    }
    expectGroupEnd() {
      if (!this.isMatch([")"]))
        throw new Error("Expected group end");
    }
    matchCoordinate(s) {
      let i;
      if (s.hasZ && s.hasM ? i = this.matchRegex([/^(\S*)\s+(\S*)\s+(\S*)\s+([^\s,)]*)/]) : s.hasZ || s.hasM ? i = this.matchRegex([/^(\S*)\s+(\S*)\s+([^\s,)]*)/]) : i = this.matchRegex([/^(\S*)\s+([^\s,)]*)/]), !i)
        throw new Error("Expected coordinates");
      return s.hasZ && s.hasM ? new t.Point(parseFloat(i[1]), parseFloat(i[2]), parseFloat(i[3]), parseFloat(i[4])) : s.hasZ ? new t.Point(parseFloat(i[1]), parseFloat(i[2]), parseFloat(i[3]), 0) : s.hasM ? new t.Point(parseFloat(i[1]), parseFloat(i[2]), 0, parseFloat(i[3])) : new t.Point(parseFloat(i[1]), parseFloat(i[2]), 0, 0);
    }
    matchCoordinates(s) {
      const i = [];
      do {
        const a = this.isMatch(["("]);
        i.push(this.matchCoordinate(s)), a && this.expectGroupEnd();
      } while (this.isMatch([","]));
      return i;
    }
    skipWhitespaces() {
      for (; this.position < this.value.length && this.value[this.position] === " "; )
        this.position++;
    }
  }
  return Jr.WktParser = e, Jr;
}
var Go;
function ze() {
  return Go || (Go = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.ZigZag = r.WktParser = r.Polygon = r.Point = r.MultiPolygon = r.MultiPoint = r.MultiLineString = r.LineString = r.GeometryCollection = r.Geometry = r.CONSTANTS = r.BinaryWriter = r.BinaryReader = void 0;
    const t = Yd();
    Object.defineProperty(r, "BinaryReader", { enumerable: !0, get: function() {
      return t.BinaryReader;
    } });
    const e = qe();
    Object.defineProperty(r, "BinaryWriter", { enumerable: !0, get: function() {
      return e.BinaryWriter;
    } });
    const n = $e();
    Object.defineProperty(r, "CONSTANTS", { enumerable: !0, get: function() {
      return n.CONSTANTS;
    } });
    const s = Jd();
    Object.defineProperty(r, "Geometry", { enumerable: !0, get: function() {
      return s.Geometry;
    } });
    const i = Hd();
    Object.defineProperty(r, "GeometryCollection", { enumerable: !0, get: function() {
      return i.GeometryCollection;
    } });
    const a = qd();
    Object.defineProperty(r, "LineString", { enumerable: !0, get: function() {
      return a.LineString;
    } });
    const c = Kd();
    Object.defineProperty(r, "MultiLineString", { enumerable: !0, get: function() {
      return c.MultiLineString;
    } });
    const d = Xd();
    Object.defineProperty(r, "MultiPoint", { enumerable: !0, get: function() {
      return d.MultiPoint;
    } });
    const p = Qd();
    Object.defineProperty(r, "MultiPolygon", { enumerable: !0, get: function() {
      return p.MultiPolygon;
    } });
    const y = yu();
    Object.defineProperty(r, "Point", { enumerable: !0, get: function() {
      return y.Point;
    } });
    const B = tf();
    Object.defineProperty(r, "Polygon", { enumerable: !0, get: function() {
      return B.Polygon;
    } });
    const R = ef();
    Object.defineProperty(r, "WktParser", { enumerable: !0, get: function() {
      return R.WktParser;
    } });
    const F = pu();
    Object.defineProperty(r, "ZigZag", { enumerable: !0, get: function() {
      return F.ZigZag;
    } });
  }(ki)), ki;
}
var rf = ze(), Di = {};
var Yo;
function nf() {
  return Yo || (Yo = 1, function(r) {
    const t = du(), e = fu(), n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    r.Buffer = c, r.SlowBuffer = P, r.INSPECT_MAX_BYTES = 50;
    const s = 2147483647;
    r.kMaxLength = s, c.TYPED_ARRAY_SUPPORT = i(), !c.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function i() {
      try {
        const h = new Uint8Array(1), o = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(o, Uint8Array.prototype), Object.setPrototypeOf(h, o), h.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(c.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (c.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(c.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (c.isBuffer(this))
          return this.byteOffset;
      }
    });
    function a(h) {
      if (h > s)
        throw new RangeError('The value "' + h + '" is invalid for option "size"');
      const o = new Uint8Array(h);
      return Object.setPrototypeOf(o, c.prototype), o;
    }
    function c(h, o, u) {
      if (typeof h == "number") {
        if (typeof o == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return B(h);
      }
      return d(h, o, u);
    }
    c.poolSize = 8192;
    function d(h, o, u) {
      if (typeof h == "string")
        return R(h, o);
      if (ArrayBuffer.isView(h))
        return T(h);
      if (h == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof h
        );
      if (mt(h, ArrayBuffer) || h && mt(h.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (mt(h, SharedArrayBuffer) || h && mt(h.buffer, SharedArrayBuffer)))
        return U(h, o, u);
      if (typeof h == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      const l = h.valueOf && h.valueOf();
      if (l != null && l !== h)
        return c.from(l, o, u);
      const f = O(h);
      if (f) return f;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof h[Symbol.toPrimitive] == "function")
        return c.from(h[Symbol.toPrimitive]("string"), o, u);
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof h
      );
    }
    c.from = function(h, o, u) {
      return d(h, o, u);
    }, Object.setPrototypeOf(c.prototype, Uint8Array.prototype), Object.setPrototypeOf(c, Uint8Array);
    function p(h) {
      if (typeof h != "number")
        throw new TypeError('"size" argument must be of type number');
      if (h < 0)
        throw new RangeError('The value "' + h + '" is invalid for option "size"');
    }
    function y(h, o, u) {
      return p(h), h <= 0 ? a(h) : o !== void 0 ? typeof u == "string" ? a(h).fill(o, u) : a(h).fill(o) : a(h);
    }
    c.alloc = function(h, o, u) {
      return y(h, o, u);
    };
    function B(h) {
      return p(h), a(h < 0 ? 0 : N(h) | 0);
    }
    c.allocUnsafe = function(h) {
      return B(h);
    }, c.allocUnsafeSlow = function(h) {
      return B(h);
    };
    function R(h, o) {
      if ((typeof o != "string" || o === "") && (o = "utf8"), !c.isEncoding(o))
        throw new TypeError("Unknown encoding: " + o);
      const u = C(h, o) | 0;
      let l = a(u);
      const f = l.write(h, o);
      return f !== u && (l = l.slice(0, f)), l;
    }
    function F(h) {
      const o = h.length < 0 ? 0 : N(h.length) | 0, u = a(o);
      for (let l = 0; l < o; l += 1)
        u[l] = h[l] & 255;
      return u;
    }
    function T(h) {
      if (mt(h, Uint8Array)) {
        const o = new Uint8Array(h);
        return U(o.buffer, o.byteOffset, o.byteLength);
      }
      return F(h);
    }
    function U(h, o, u) {
      if (o < 0 || h.byteLength < o)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (h.byteLength < o + (u || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      let l;
      return o === void 0 && u === void 0 ? l = new Uint8Array(h) : u === void 0 ? l = new Uint8Array(h, o) : l = new Uint8Array(h, o, u), Object.setPrototypeOf(l, c.prototype), l;
    }
    function O(h) {
      if (c.isBuffer(h)) {
        const o = N(h.length) | 0, u = a(o);
        return u.length === 0 || h.copy(u, 0, 0, o), u;
      }
      if (h.length !== void 0)
        return typeof h.length != "number" || Qt(h.length) ? a(0) : F(h);
      if (h.type === "Buffer" && Array.isArray(h.data))
        return F(h.data);
    }
    function N(h) {
      if (h >= s)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s.toString(16) + " bytes");
      return h | 0;
    }
    function P(h) {
      return +h != h && (h = 0), c.alloc(+h);
    }
    c.isBuffer = function(o) {
      return o != null && o._isBuffer === !0 && o !== c.prototype;
    }, c.compare = function(o, u) {
      if (mt(o, Uint8Array) && (o = c.from(o, o.offset, o.byteLength)), mt(u, Uint8Array) && (u = c.from(u, u.offset, u.byteLength)), !c.isBuffer(o) || !c.isBuffer(u))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (o === u) return 0;
      let l = o.length, f = u.length;
      for (let b = 0, I = Math.min(l, f); b < I; ++b)
        if (o[b] !== u[b]) {
          l = o[b], f = u[b];
          break;
        }
      return l < f ? -1 : f < l ? 1 : 0;
    }, c.isEncoding = function(o) {
      switch (String(o).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, c.concat = function(o, u) {
      if (!Array.isArray(o))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (o.length === 0)
        return c.alloc(0);
      let l;
      if (u === void 0)
        for (u = 0, l = 0; l < o.length; ++l)
          u += o[l].length;
      const f = c.allocUnsafe(u);
      let b = 0;
      for (l = 0; l < o.length; ++l) {
        let I = o[l];
        if (mt(I, Uint8Array))
          b + I.length > f.length ? (c.isBuffer(I) || (I = c.from(I)), I.copy(f, b)) : Uint8Array.prototype.set.call(
            f,
            I,
            b
          );
        else if (c.isBuffer(I))
          I.copy(f, b);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        b += I.length;
      }
      return f;
    };
    function C(h, o) {
      if (c.isBuffer(h))
        return h.length;
      if (ArrayBuffer.isView(h) || mt(h, ArrayBuffer))
        return h.byteLength;
      if (typeof h != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof h
        );
      const u = h.length, l = arguments.length > 2 && arguments[2] === !0;
      if (!l && u === 0) return 0;
      let f = !1;
      for (; ; )
        switch (o) {
          case "ascii":
          case "latin1":
          case "binary":
            return u;
          case "utf8":
          case "utf-8":
            return Nt(h).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return u * 2;
          case "hex":
            return u >>> 1;
          case "base64":
            return $t(h).length;
          default:
            if (f)
              return l ? -1 : Nt(h).length;
            o = ("" + o).toLowerCase(), f = !0;
        }
    }
    c.byteLength = C;
    function V(h, o, u) {
      let l = !1;
      if ((o === void 0 || o < 0) && (o = 0), o > this.length || ((u === void 0 || u > this.length) && (u = this.length), u <= 0) || (u >>>= 0, o >>>= 0, u <= o))
        return "";
      for (h || (h = "utf8"); ; )
        switch (h) {
          case "hex":
            return X(this, o, u);
          case "utf8":
          case "utf-8":
            return z(this, o, u);
          case "ascii":
            return Y(this, o, u);
          case "latin1":
          case "binary":
            return Z(this, o, u);
          case "base64":
            return Q(this, o, u);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return K(this, o, u);
          default:
            if (l) throw new TypeError("Unknown encoding: " + h);
            h = (h + "").toLowerCase(), l = !0;
        }
    }
    c.prototype._isBuffer = !0;
    function G(h, o, u) {
      const l = h[o];
      h[o] = h[u], h[u] = l;
    }
    c.prototype.swap16 = function() {
      const o = this.length;
      if (o % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (let u = 0; u < o; u += 2)
        G(this, u, u + 1);
      return this;
    }, c.prototype.swap32 = function() {
      const o = this.length;
      if (o % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (let u = 0; u < o; u += 4)
        G(this, u, u + 3), G(this, u + 1, u + 2);
      return this;
    }, c.prototype.swap64 = function() {
      const o = this.length;
      if (o % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (let u = 0; u < o; u += 8)
        G(this, u, u + 7), G(this, u + 1, u + 6), G(this, u + 2, u + 5), G(this, u + 3, u + 4);
      return this;
    }, c.prototype.toString = function() {
      const o = this.length;
      return o === 0 ? "" : arguments.length === 0 ? z(this, 0, o) : V.apply(this, arguments);
    }, c.prototype.toLocaleString = c.prototype.toString, c.prototype.equals = function(o) {
      if (!c.isBuffer(o)) throw new TypeError("Argument must be a Buffer");
      return this === o ? !0 : c.compare(this, o) === 0;
    }, c.prototype.inspect = function() {
      let o = "";
      const u = r.INSPECT_MAX_BYTES;
      return o = this.toString("hex", 0, u).replace(/(.{2})/g, "$1 ").trim(), this.length > u && (o += " ... "), "<Buffer " + o + ">";
    }, n && (c.prototype[n] = c.prototype.inspect), c.prototype.compare = function(o, u, l, f, b) {
      if (mt(o, Uint8Array) && (o = c.from(o, o.offset, o.byteLength)), !c.isBuffer(o))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof o
        );
      if (u === void 0 && (u = 0), l === void 0 && (l = o ? o.length : 0), f === void 0 && (f = 0), b === void 0 && (b = this.length), u < 0 || l > o.length || f < 0 || b > this.length)
        throw new RangeError("out of range index");
      if (f >= b && u >= l)
        return 0;
      if (f >= b)
        return -1;
      if (u >= l)
        return 1;
      if (u >>>= 0, l >>>= 0, f >>>= 0, b >>>= 0, this === o) return 0;
      let I = b - f, H = l - u;
      const pt = Math.min(I, H), lt = this.slice(f, b), yt = o.slice(u, l);
      for (let et = 0; et < pt; ++et)
        if (lt[et] !== yt[et]) {
          I = lt[et], H = yt[et];
          break;
        }
      return I < H ? -1 : H < I ? 1 : 0;
    };
    function x(h, o, u, l, f) {
      if (h.length === 0) return -1;
      if (typeof u == "string" ? (l = u, u = 0) : u > 2147483647 ? u = 2147483647 : u < -2147483648 && (u = -2147483648), u = +u, Qt(u) && (u = f ? 0 : h.length - 1), u < 0 && (u = h.length + u), u >= h.length) {
        if (f) return -1;
        u = h.length - 1;
      } else if (u < 0)
        if (f) u = 0;
        else return -1;
      if (typeof o == "string" && (o = c.from(o, l)), c.isBuffer(o))
        return o.length === 0 ? -1 : M(h, o, u, l, f);
      if (typeof o == "number")
        return o = o & 255, typeof Uint8Array.prototype.indexOf == "function" ? f ? Uint8Array.prototype.indexOf.call(h, o, u) : Uint8Array.prototype.lastIndexOf.call(h, o, u) : M(h, [o], u, l, f);
      throw new TypeError("val must be string, number or Buffer");
    }
    function M(h, o, u, l, f) {
      let b = 1, I = h.length, H = o.length;
      if (l !== void 0 && (l = String(l).toLowerCase(), l === "ucs2" || l === "ucs-2" || l === "utf16le" || l === "utf-16le")) {
        if (h.length < 2 || o.length < 2)
          return -1;
        b = 2, I /= 2, H /= 2, u /= 2;
      }
      function pt(yt, et) {
        return b === 1 ? yt[et] : yt.readUInt16BE(et * b);
      }
      let lt;
      if (f) {
        let yt = -1;
        for (lt = u; lt < I; lt++)
          if (pt(h, lt) === pt(o, yt === -1 ? 0 : lt - yt)) {
            if (yt === -1 && (yt = lt), lt - yt + 1 === H) return yt * b;
          } else
            yt !== -1 && (lt -= lt - yt), yt = -1;
      } else
        for (u + H > I && (u = I - H), lt = u; lt >= 0; lt--) {
          let yt = !0;
          for (let et = 0; et < H; et++)
            if (pt(h, lt + et) !== pt(o, et)) {
              yt = !1;
              break;
            }
          if (yt) return lt;
        }
      return -1;
    }
    c.prototype.includes = function(o, u, l) {
      return this.indexOf(o, u, l) !== -1;
    }, c.prototype.indexOf = function(o, u, l) {
      return x(this, o, u, l, !0);
    }, c.prototype.lastIndexOf = function(o, u, l) {
      return x(this, o, u, l, !1);
    };
    function m(h, o, u, l) {
      u = Number(u) || 0;
      const f = h.length - u;
      l ? (l = Number(l), l > f && (l = f)) : l = f;
      const b = o.length;
      l > b / 2 && (l = b / 2);
      let I;
      for (I = 0; I < l; ++I) {
        const H = parseInt(o.substr(I * 2, 2), 16);
        if (Qt(H)) return I;
        h[u + I] = H;
      }
      return I;
    }
    function S(h, o, u, l) {
      return Ot(Nt(o, h.length - u), h, u, l);
    }
    function w(h, o, u, l) {
      return Ot(Ht(o), h, u, l);
    }
    function v(h, o, u, l) {
      return Ot($t(o), h, u, l);
    }
    function k(h, o, u, l) {
      return Ot(Vt(o, h.length - u), h, u, l);
    }
    c.prototype.write = function(o, u, l, f) {
      if (u === void 0)
        f = "utf8", l = this.length, u = 0;
      else if (l === void 0 && typeof u == "string")
        f = u, l = this.length, u = 0;
      else if (isFinite(u))
        u = u >>> 0, isFinite(l) ? (l = l >>> 0, f === void 0 && (f = "utf8")) : (f = l, l = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      const b = this.length - u;
      if ((l === void 0 || l > b) && (l = b), o.length > 0 && (l < 0 || u < 0) || u > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      f || (f = "utf8");
      let I = !1;
      for (; ; )
        switch (f) {
          case "hex":
            return m(this, o, u, l);
          case "utf8":
          case "utf-8":
            return S(this, o, u, l);
          case "ascii":
          case "latin1":
          case "binary":
            return w(this, o, u, l);
          case "base64":
            return v(this, o, u, l);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return k(this, o, u, l);
          default:
            if (I) throw new TypeError("Unknown encoding: " + f);
            f = ("" + f).toLowerCase(), I = !0;
        }
    }, c.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function Q(h, o, u) {
      return o === 0 && u === h.length ? t.fromByteArray(h) : t.fromByteArray(h.slice(o, u));
    }
    function z(h, o, u) {
      u = Math.min(h.length, u);
      const l = [];
      let f = o;
      for (; f < u; ) {
        const b = h[f];
        let I = null, H = b > 239 ? 4 : b > 223 ? 3 : b > 191 ? 2 : 1;
        if (f + H <= u) {
          let pt, lt, yt, et;
          switch (H) {
            case 1:
              b < 128 && (I = b);
              break;
            case 2:
              pt = h[f + 1], (pt & 192) === 128 && (et = (b & 31) << 6 | pt & 63, et > 127 && (I = et));
              break;
            case 3:
              pt = h[f + 1], lt = h[f + 2], (pt & 192) === 128 && (lt & 192) === 128 && (et = (b & 15) << 12 | (pt & 63) << 6 | lt & 63, et > 2047 && (et < 55296 || et > 57343) && (I = et));
              break;
            case 4:
              pt = h[f + 1], lt = h[f + 2], yt = h[f + 3], (pt & 192) === 128 && (lt & 192) === 128 && (yt & 192) === 128 && (et = (b & 15) << 18 | (pt & 63) << 12 | (lt & 63) << 6 | yt & 63, et > 65535 && et < 1114112 && (I = et));
          }
        }
        I === null ? (I = 65533, H = 1) : I > 65535 && (I -= 65536, l.push(I >>> 10 & 1023 | 55296), I = 56320 | I & 1023), l.push(I), f += H;
      }
      return D(l);
    }
    const L = 4096;
    function D(h) {
      const o = h.length;
      if (o <= L)
        return String.fromCharCode.apply(String, h);
      let u = "", l = 0;
      for (; l < o; )
        u += String.fromCharCode.apply(
          String,
          h.slice(l, l += L)
        );
      return u;
    }
    function Y(h, o, u) {
      let l = "";
      u = Math.min(h.length, u);
      for (let f = o; f < u; ++f)
        l += String.fromCharCode(h[f] & 127);
      return l;
    }
    function Z(h, o, u) {
      let l = "";
      u = Math.min(h.length, u);
      for (let f = o; f < u; ++f)
        l += String.fromCharCode(h[f]);
      return l;
    }
    function X(h, o, u) {
      const l = h.length;
      (!o || o < 0) && (o = 0), (!u || u < 0 || u > l) && (u = l);
      let f = "";
      for (let b = o; b < u; ++b)
        f += sr[h[b]];
      return f;
    }
    function K(h, o, u) {
      const l = h.slice(o, u);
      let f = "";
      for (let b = 0; b < l.length - 1; b += 2)
        f += String.fromCharCode(l[b] + l[b + 1] * 256);
      return f;
    }
    c.prototype.slice = function(o, u) {
      const l = this.length;
      o = ~~o, u = u === void 0 ? l : ~~u, o < 0 ? (o += l, o < 0 && (o = 0)) : o > l && (o = l), u < 0 ? (u += l, u < 0 && (u = 0)) : u > l && (u = l), u < o && (u = o);
      const f = this.subarray(o, u);
      return Object.setPrototypeOf(f, c.prototype), f;
    };
    function q(h, o, u) {
      if (h % 1 !== 0 || h < 0) throw new RangeError("offset is not uint");
      if (h + o > u) throw new RangeError("Trying to access beyond buffer length");
    }
    c.prototype.readUintLE = c.prototype.readUIntLE = function(o, u, l) {
      o = o >>> 0, u = u >>> 0, l || q(o, u, this.length);
      let f = this[o], b = 1, I = 0;
      for (; ++I < u && (b *= 256); )
        f += this[o + I] * b;
      return f;
    }, c.prototype.readUintBE = c.prototype.readUIntBE = function(o, u, l) {
      o = o >>> 0, u = u >>> 0, l || q(o, u, this.length);
      let f = this[o + --u], b = 1;
      for (; u > 0 && (b *= 256); )
        f += this[o + --u] * b;
      return f;
    }, c.prototype.readUint8 = c.prototype.readUInt8 = function(o, u) {
      return o = o >>> 0, u || q(o, 1, this.length), this[o];
    }, c.prototype.readUint16LE = c.prototype.readUInt16LE = function(o, u) {
      return o = o >>> 0, u || q(o, 2, this.length), this[o] | this[o + 1] << 8;
    }, c.prototype.readUint16BE = c.prototype.readUInt16BE = function(o, u) {
      return o = o >>> 0, u || q(o, 2, this.length), this[o] << 8 | this[o + 1];
    }, c.prototype.readUint32LE = c.prototype.readUInt32LE = function(o, u) {
      return o = o >>> 0, u || q(o, 4, this.length), (this[o] | this[o + 1] << 8 | this[o + 2] << 16) + this[o + 3] * 16777216;
    }, c.prototype.readUint32BE = c.prototype.readUInt32BE = function(o, u) {
      return o = o >>> 0, u || q(o, 4, this.length), this[o] * 16777216 + (this[o + 1] << 16 | this[o + 2] << 8 | this[o + 3]);
    }, c.prototype.readBigUInt64LE = Wt(function(o) {
      o = o >>> 0, $(o, "offset");
      const u = this[o], l = this[o + 7];
      (u === void 0 || l === void 0) && J(o, this.length - 8);
      const f = u + this[++o] * 2 ** 8 + this[++o] * 2 ** 16 + this[++o] * 2 ** 24, b = this[++o] + this[++o] * 2 ** 8 + this[++o] * 2 ** 16 + l * 2 ** 24;
      return BigInt(f) + (BigInt(b) << BigInt(32));
    }), c.prototype.readBigUInt64BE = Wt(function(o) {
      o = o >>> 0, $(o, "offset");
      const u = this[o], l = this[o + 7];
      (u === void 0 || l === void 0) && J(o, this.length - 8);
      const f = u * 2 ** 24 + this[++o] * 2 ** 16 + this[++o] * 2 ** 8 + this[++o], b = this[++o] * 2 ** 24 + this[++o] * 2 ** 16 + this[++o] * 2 ** 8 + l;
      return (BigInt(f) << BigInt(32)) + BigInt(b);
    }), c.prototype.readIntLE = function(o, u, l) {
      o = o >>> 0, u = u >>> 0, l || q(o, u, this.length);
      let f = this[o], b = 1, I = 0;
      for (; ++I < u && (b *= 256); )
        f += this[o + I] * b;
      return b *= 128, f >= b && (f -= Math.pow(2, 8 * u)), f;
    }, c.prototype.readIntBE = function(o, u, l) {
      o = o >>> 0, u = u >>> 0, l || q(o, u, this.length);
      let f = u, b = 1, I = this[o + --f];
      for (; f > 0 && (b *= 256); )
        I += this[o + --f] * b;
      return b *= 128, I >= b && (I -= Math.pow(2, 8 * u)), I;
    }, c.prototype.readInt8 = function(o, u) {
      return o = o >>> 0, u || q(o, 1, this.length), this[o] & 128 ? (255 - this[o] + 1) * -1 : this[o];
    }, c.prototype.readInt16LE = function(o, u) {
      o = o >>> 0, u || q(o, 2, this.length);
      const l = this[o] | this[o + 1] << 8;
      return l & 32768 ? l | 4294901760 : l;
    }, c.prototype.readInt16BE = function(o, u) {
      o = o >>> 0, u || q(o, 2, this.length);
      const l = this[o + 1] | this[o] << 8;
      return l & 32768 ? l | 4294901760 : l;
    }, c.prototype.readInt32LE = function(o, u) {
      return o = o >>> 0, u || q(o, 4, this.length), this[o] | this[o + 1] << 8 | this[o + 2] << 16 | this[o + 3] << 24;
    }, c.prototype.readInt32BE = function(o, u) {
      return o = o >>> 0, u || q(o, 4, this.length), this[o] << 24 | this[o + 1] << 16 | this[o + 2] << 8 | this[o + 3];
    }, c.prototype.readBigInt64LE = Wt(function(o) {
      o = o >>> 0, $(o, "offset");
      const u = this[o], l = this[o + 7];
      (u === void 0 || l === void 0) && J(o, this.length - 8);
      const f = this[o + 4] + this[o + 5] * 2 ** 8 + this[o + 6] * 2 ** 16 + (l << 24);
      return (BigInt(f) << BigInt(32)) + BigInt(u + this[++o] * 2 ** 8 + this[++o] * 2 ** 16 + this[++o] * 2 ** 24);
    }), c.prototype.readBigInt64BE = Wt(function(o) {
      o = o >>> 0, $(o, "offset");
      const u = this[o], l = this[o + 7];
      (u === void 0 || l === void 0) && J(o, this.length - 8);
      const f = (u << 24) + // Overflow
      this[++o] * 2 ** 16 + this[++o] * 2 ** 8 + this[++o];
      return (BigInt(f) << BigInt(32)) + BigInt(this[++o] * 2 ** 24 + this[++o] * 2 ** 16 + this[++o] * 2 ** 8 + l);
    }), c.prototype.readFloatLE = function(o, u) {
      return o = o >>> 0, u || q(o, 4, this.length), e.read(this, o, !0, 23, 4);
    }, c.prototype.readFloatBE = function(o, u) {
      return o = o >>> 0, u || q(o, 4, this.length), e.read(this, o, !1, 23, 4);
    }, c.prototype.readDoubleLE = function(o, u) {
      return o = o >>> 0, u || q(o, 8, this.length), e.read(this, o, !0, 52, 8);
    }, c.prototype.readDoubleBE = function(o, u) {
      return o = o >>> 0, u || q(o, 8, this.length), e.read(this, o, !1, 52, 8);
    };
    function rt(h, o, u, l, f, b) {
      if (!c.isBuffer(h)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (o > f || o < b) throw new RangeError('"value" argument is out of bounds');
      if (u + l > h.length) throw new RangeError("Index out of range");
    }
    c.prototype.writeUintLE = c.prototype.writeUIntLE = function(o, u, l, f) {
      if (o = +o, u = u >>> 0, l = l >>> 0, !f) {
        const H = Math.pow(2, 8 * l) - 1;
        rt(this, o, u, l, H, 0);
      }
      let b = 1, I = 0;
      for (this[u] = o & 255; ++I < l && (b *= 256); )
        this[u + I] = o / b & 255;
      return u + l;
    }, c.prototype.writeUintBE = c.prototype.writeUIntBE = function(o, u, l, f) {
      if (o = +o, u = u >>> 0, l = l >>> 0, !f) {
        const H = Math.pow(2, 8 * l) - 1;
        rt(this, o, u, l, H, 0);
      }
      let b = l - 1, I = 1;
      for (this[u + b] = o & 255; --b >= 0 && (I *= 256); )
        this[u + b] = o / I & 255;
      return u + l;
    }, c.prototype.writeUint8 = c.prototype.writeUInt8 = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 1, 255, 0), this[u] = o & 255, u + 1;
    }, c.prototype.writeUint16LE = c.prototype.writeUInt16LE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 2, 65535, 0), this[u] = o & 255, this[u + 1] = o >>> 8, u + 2;
    }, c.prototype.writeUint16BE = c.prototype.writeUInt16BE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 2, 65535, 0), this[u] = o >>> 8, this[u + 1] = o & 255, u + 2;
    }, c.prototype.writeUint32LE = c.prototype.writeUInt32LE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 4, 4294967295, 0), this[u + 3] = o >>> 24, this[u + 2] = o >>> 16, this[u + 1] = o >>> 8, this[u] = o & 255, u + 4;
    }, c.prototype.writeUint32BE = c.prototype.writeUInt32BE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 4, 4294967295, 0), this[u] = o >>> 24, this[u + 1] = o >>> 16, this[u + 2] = o >>> 8, this[u + 3] = o & 255, u + 4;
    };
    function At(h, o, u, l, f) {
      j(o, l, f, h, u, 7);
      let b = Number(o & BigInt(4294967295));
      h[u++] = b, b = b >> 8, h[u++] = b, b = b >> 8, h[u++] = b, b = b >> 8, h[u++] = b;
      let I = Number(o >> BigInt(32) & BigInt(4294967295));
      return h[u++] = I, I = I >> 8, h[u++] = I, I = I >> 8, h[u++] = I, I = I >> 8, h[u++] = I, u;
    }
    function Ut(h, o, u, l, f) {
      j(o, l, f, h, u, 7);
      let b = Number(o & BigInt(4294967295));
      h[u + 7] = b, b = b >> 8, h[u + 6] = b, b = b >> 8, h[u + 5] = b, b = b >> 8, h[u + 4] = b;
      let I = Number(o >> BigInt(32) & BigInt(4294967295));
      return h[u + 3] = I, I = I >> 8, h[u + 2] = I, I = I >> 8, h[u + 1] = I, I = I >> 8, h[u] = I, u + 8;
    }
    c.prototype.writeBigUInt64LE = Wt(function(o, u = 0) {
      return At(this, o, u, BigInt(0), BigInt("0xffffffffffffffff"));
    }), c.prototype.writeBigUInt64BE = Wt(function(o, u = 0) {
      return Ut(this, o, u, BigInt(0), BigInt("0xffffffffffffffff"));
    }), c.prototype.writeIntLE = function(o, u, l, f) {
      if (o = +o, u = u >>> 0, !f) {
        const pt = Math.pow(2, 8 * l - 1);
        rt(this, o, u, l, pt - 1, -pt);
      }
      let b = 0, I = 1, H = 0;
      for (this[u] = o & 255; ++b < l && (I *= 256); )
        o < 0 && H === 0 && this[u + b - 1] !== 0 && (H = 1), this[u + b] = (o / I >> 0) - H & 255;
      return u + l;
    }, c.prototype.writeIntBE = function(o, u, l, f) {
      if (o = +o, u = u >>> 0, !f) {
        const pt = Math.pow(2, 8 * l - 1);
        rt(this, o, u, l, pt - 1, -pt);
      }
      let b = l - 1, I = 1, H = 0;
      for (this[u + b] = o & 255; --b >= 0 && (I *= 256); )
        o < 0 && H === 0 && this[u + b + 1] !== 0 && (H = 1), this[u + b] = (o / I >> 0) - H & 255;
      return u + l;
    }, c.prototype.writeInt8 = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 1, 127, -128), o < 0 && (o = 255 + o + 1), this[u] = o & 255, u + 1;
    }, c.prototype.writeInt16LE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 2, 32767, -32768), this[u] = o & 255, this[u + 1] = o >>> 8, u + 2;
    }, c.prototype.writeInt16BE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 2, 32767, -32768), this[u] = o >>> 8, this[u + 1] = o & 255, u + 2;
    }, c.prototype.writeInt32LE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 4, 2147483647, -2147483648), this[u] = o & 255, this[u + 1] = o >>> 8, this[u + 2] = o >>> 16, this[u + 3] = o >>> 24, u + 4;
    }, c.prototype.writeInt32BE = function(o, u, l) {
      return o = +o, u = u >>> 0, l || rt(this, o, u, 4, 2147483647, -2147483648), o < 0 && (o = 4294967295 + o + 1), this[u] = o >>> 24, this[u + 1] = o >>> 16, this[u + 2] = o >>> 8, this[u + 3] = o & 255, u + 4;
    }, c.prototype.writeBigInt64LE = Wt(function(o, u = 0) {
      return At(this, o, u, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    }), c.prototype.writeBigInt64BE = Wt(function(o, u = 0) {
      return Ut(this, o, u, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function Pt(h, o, u, l, f, b) {
      if (u + l > h.length) throw new RangeError("Index out of range");
      if (u < 0) throw new RangeError("Index out of range");
    }
    function Zt(h, o, u, l, f) {
      return o = +o, u = u >>> 0, f || Pt(h, o, u, 4), e.write(h, o, u, l, 23, 4), u + 4;
    }
    c.prototype.writeFloatLE = function(o, u, l) {
      return Zt(this, o, u, !0, l);
    }, c.prototype.writeFloatBE = function(o, u, l) {
      return Zt(this, o, u, !1, l);
    };
    function Gt(h, o, u, l, f) {
      return o = +o, u = u >>> 0, f || Pt(h, o, u, 8), e.write(h, o, u, l, 52, 8), u + 8;
    }
    c.prototype.writeDoubleLE = function(o, u, l) {
      return Gt(this, o, u, !0, l);
    }, c.prototype.writeDoubleBE = function(o, u, l) {
      return Gt(this, o, u, !1, l);
    }, c.prototype.copy = function(o, u, l, f) {
      if (!c.isBuffer(o)) throw new TypeError("argument should be a Buffer");
      if (l || (l = 0), !f && f !== 0 && (f = this.length), u >= o.length && (u = o.length), u || (u = 0), f > 0 && f < l && (f = l), f === l || o.length === 0 || this.length === 0) return 0;
      if (u < 0)
        throw new RangeError("targetStart out of bounds");
      if (l < 0 || l >= this.length) throw new RangeError("Index out of range");
      if (f < 0) throw new RangeError("sourceEnd out of bounds");
      f > this.length && (f = this.length), o.length - u < f - l && (f = o.length - u + l);
      const b = f - l;
      return this === o && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(u, l, f) : Uint8Array.prototype.set.call(
        o,
        this.subarray(l, f),
        u
      ), b;
    }, c.prototype.fill = function(o, u, l, f) {
      if (typeof o == "string") {
        if (typeof u == "string" ? (f = u, u = 0, l = this.length) : typeof l == "string" && (f = l, l = this.length), f !== void 0 && typeof f != "string")
          throw new TypeError("encoding must be a string");
        if (typeof f == "string" && !c.isEncoding(f))
          throw new TypeError("Unknown encoding: " + f);
        if (o.length === 1) {
          const I = o.charCodeAt(0);
          (f === "utf8" && I < 128 || f === "latin1") && (o = I);
        }
      } else typeof o == "number" ? o = o & 255 : typeof o == "boolean" && (o = Number(o));
      if (u < 0 || this.length < u || this.length < l)
        throw new RangeError("Out of range index");
      if (l <= u)
        return this;
      u = u >>> 0, l = l === void 0 ? this.length : l >>> 0, o || (o = 0);
      let b;
      if (typeof o == "number")
        for (b = u; b < l; ++b)
          this[b] = o;
      else {
        const I = c.isBuffer(o) ? o : c.from(o, f), H = I.length;
        if (H === 0)
          throw new TypeError('The value "' + o + '" is invalid for argument "value"');
        for (b = 0; b < l - u; ++b)
          this[b + u] = I[b % H];
      }
      return this;
    };
    const W = {};
    function g(h, o, u) {
      W[h] = class extends u {
        constructor() {
          super(), Object.defineProperty(this, "message", {
            value: o.apply(this, arguments),
            writable: !0,
            configurable: !0
          }), this.name = `${this.name} [${h}]`, this.stack, delete this.name;
        }
        get code() {
          return h;
        }
        set code(f) {
          Object.defineProperty(this, "code", {
            configurable: !0,
            enumerable: !0,
            value: f,
            writable: !0
          });
        }
        toString() {
          return `${this.name} [${h}]: ${this.message}`;
        }
      };
    }
    g(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(h) {
        return h ? `${h} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
      },
      RangeError
    ), g(
      "ERR_INVALID_ARG_TYPE",
      function(h, o) {
        return `The "${h}" argument must be of type number. Received type ${typeof o}`;
      },
      TypeError
    ), g(
      "ERR_OUT_OF_RANGE",
      function(h, o, u) {
        let l = `The value of "${h}" is out of range.`, f = u;
        return Number.isInteger(u) && Math.abs(u) > 2 ** 32 ? f = _(String(u)) : typeof u == "bigint" && (f = String(u), (u > BigInt(2) ** BigInt(32) || u < -(BigInt(2) ** BigInt(32))) && (f = _(f)), f += "n"), l += ` It must be ${o}. Received ${f}`, l;
      },
      RangeError
    );
    function _(h) {
      let o = "", u = h.length;
      const l = h[0] === "-" ? 1 : 0;
      for (; u >= l + 4; u -= 3)
        o = `_${h.slice(u - 3, u)}${o}`;
      return `${h.slice(0, u)}${o}`;
    }
    function E(h, o, u) {
      $(o, "offset"), (h[o] === void 0 || h[o + u] === void 0) && J(o, h.length - (u + 1));
    }
    function j(h, o, u, l, f, b) {
      if (h > u || h < o) {
        const I = typeof o == "bigint" ? "n" : "";
        let H;
        throw o === 0 || o === BigInt(0) ? H = `>= 0${I} and < 2${I} ** ${(b + 1) * 8}${I}` : H = `>= -(2${I} ** ${(b + 1) * 8 - 1}${I}) and < 2 ** ${(b + 1) * 8 - 1}${I}`, new W.ERR_OUT_OF_RANGE("value", H, h);
      }
      E(l, f, b);
    }
    function $(h, o) {
      if (typeof h != "number")
        throw new W.ERR_INVALID_ARG_TYPE(o, "number", h);
    }
    function J(h, o, u) {
      throw Math.floor(h) !== h ? ($(h, u), new W.ERR_OUT_OF_RANGE("offset", "an integer", h)) : o < 0 ? new W.ERR_BUFFER_OUT_OF_BOUNDS() : new W.ERR_OUT_OF_RANGE(
        "offset",
        `>= 0 and <= ${o}`,
        h
      );
    }
    const bt = /[^+/0-9A-Za-z-_]/g;
    function kt(h) {
      if (h = h.split("=")[0], h = h.trim().replace(bt, ""), h.length < 2) return "";
      for (; h.length % 4 !== 0; )
        h = h + "=";
      return h;
    }
    function Nt(h, o) {
      o = o || 1 / 0;
      let u;
      const l = h.length;
      let f = null;
      const b = [];
      for (let I = 0; I < l; ++I) {
        if (u = h.charCodeAt(I), u > 55295 && u < 57344) {
          if (!f) {
            if (u > 56319) {
              (o -= 3) > -1 && b.push(239, 191, 189);
              continue;
            } else if (I + 1 === l) {
              (o -= 3) > -1 && b.push(239, 191, 189);
              continue;
            }
            f = u;
            continue;
          }
          if (u < 56320) {
            (o -= 3) > -1 && b.push(239, 191, 189), f = u;
            continue;
          }
          u = (f - 55296 << 10 | u - 56320) + 65536;
        } else f && (o -= 3) > -1 && b.push(239, 191, 189);
        if (f = null, u < 128) {
          if ((o -= 1) < 0) break;
          b.push(u);
        } else if (u < 2048) {
          if ((o -= 2) < 0) break;
          b.push(
            u >> 6 | 192,
            u & 63 | 128
          );
        } else if (u < 65536) {
          if ((o -= 3) < 0) break;
          b.push(
            u >> 12 | 224,
            u >> 6 & 63 | 128,
            u & 63 | 128
          );
        } else if (u < 1114112) {
          if ((o -= 4) < 0) break;
          b.push(
            u >> 18 | 240,
            u >> 12 & 63 | 128,
            u >> 6 & 63 | 128,
            u & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return b;
    }
    function Ht(h) {
      const o = [];
      for (let u = 0; u < h.length; ++u)
        o.push(h.charCodeAt(u) & 255);
      return o;
    }
    function Vt(h, o) {
      let u, l, f;
      const b = [];
      for (let I = 0; I < h.length && !((o -= 2) < 0); ++I)
        u = h.charCodeAt(I), l = u >> 8, f = u % 256, b.push(f), b.push(l);
      return b;
    }
    function $t(h) {
      return t.toByteArray(kt(h));
    }
    function Ot(h, o, u, l) {
      let f;
      for (f = 0; f < l && !(f + u >= o.length || f >= h.length); ++f)
        o[f + u] = h[f];
      return f;
    }
    function mt(h, o) {
      return h instanceof o || h != null && h.constructor != null && h.constructor.name != null && h.constructor.name === o.name;
    }
    function Qt(h) {
      return h !== h;
    }
    const sr = function() {
      const h = "0123456789abcdef", o = new Array(256);
      for (let u = 0; u < 16; ++u) {
        const l = u * 16;
        for (let f = 0; f < 16; ++f)
          o[l + f] = h[u] + h[f];
      }
      return o;
    }();
    function Wt(h) {
      return typeof BigInt > "u" ? vi : h;
    }
    function vi() {
      throw new Error("BigInt not supported");
    }
  }(Di)), Di;
}
var gu = nf();
function Ii(r) {
  return new Promise((t, e) => {
    r.oncomplete = r.onsuccess = () => t(r.result), r.onabort = r.onerror = () => e(r.error);
  });
}
function mu(r, t) {
  const e = indexedDB.open(r);
  e.onupgradeneeded = () => e.result.createObjectStore(t);
  const n = Ii(e);
  return (s, i) => n.then((a) => i(a.transaction(t, s).objectStore(t)));
}
let Ui;
function Rs() {
  return Ui || (Ui = mu("keyval-store", "keyval")), Ui;
}
function sf(r, t = Rs()) {
  return t("readonly", (e) => Ii(e.get(r)));
}
function of(r, t, e = Rs()) {
  return e("readwrite", (n) => (n.put(t, r), Ii(n.transaction)));
}
function Li(r, t = Rs()) {
  return t("readwrite", (e) => (e.delete(r), Ii(e.transaction)));
}
function Bn(r) {
  throw new Error('Could not dynamically require "' + r + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Ci = { exports: {} }, Jo;
function af() {
  return Jo || (Jo = 1, function(r, t) {
    (function(e) {
      r.exports = e();
    })(function() {
      return function e(n, s, i) {
        function a(p, y) {
          if (!s[p]) {
            if (!n[p]) {
              var B = typeof Bn == "function" && Bn;
              if (!y && B) return B(p, !0);
              if (c) return c(p, !0);
              throw new Error("Cannot find module '" + p + "'");
            }
            y = s[p] = { exports: {} }, n[p][0].call(y.exports, function(R) {
              var F = n[p][1][R];
              return a(F || R);
            }, y, y.exports, e, n, s, i);
          }
          return s[p].exports;
        }
        for (var c = typeof Bn == "function" && Bn, d = 0; d < i.length; d++) a(i[d]);
        return a;
      }({ 1: [function(e, n, s) {
        (function(i, a, c, d, p, y, B, R, F) {
          var T = e("crypto");
          function U(x, M) {
            M = P(x, M);
            var m;
            return (m = M.algorithm !== "passthrough" ? T.createHash(M.algorithm) : new G()).write === void 0 && (m.write = m.update, m.end = m.update), V(M, m).dispatch(x), m.update || m.end(""), m.digest ? m.digest(M.encoding === "buffer" ? void 0 : M.encoding) : (x = m.read(), M.encoding !== "buffer" ? x.toString(M.encoding) : x);
          }
          (s = n.exports = U).sha1 = function(x) {
            return U(x);
          }, s.keys = function(x) {
            return U(x, { excludeValues: !0, algorithm: "sha1", encoding: "hex" });
          }, s.MD5 = function(x) {
            return U(x, { algorithm: "md5", encoding: "hex" });
          }, s.keysMD5 = function(x) {
            return U(x, { algorithm: "md5", encoding: "hex", excludeValues: !0 });
          };
          var O = T.getHashes ? T.getHashes().slice() : ["sha1", "md5"], N = (O.push("passthrough"), ["buffer", "hex", "binary", "base64"]);
          function P(x, M) {
            var m = {};
            if (m.algorithm = (M = M || {}).algorithm || "sha1", m.encoding = M.encoding || "hex", m.excludeValues = !!M.excludeValues, m.algorithm = m.algorithm.toLowerCase(), m.encoding = m.encoding.toLowerCase(), m.ignoreUnknown = M.ignoreUnknown === !0, m.respectType = M.respectType !== !1, m.respectFunctionNames = M.respectFunctionNames !== !1, m.respectFunctionProperties = M.respectFunctionProperties !== !1, m.unorderedArrays = M.unorderedArrays === !0, m.unorderedSets = M.unorderedSets !== !1, m.unorderedObjects = M.unorderedObjects !== !1, m.replacer = M.replacer || void 0, m.excludeKeys = M.excludeKeys || void 0, x === void 0) throw new Error("Object argument required.");
            for (var S = 0; S < O.length; ++S) O[S].toLowerCase() === m.algorithm.toLowerCase() && (m.algorithm = O[S]);
            if (O.indexOf(m.algorithm) === -1) throw new Error('Algorithm "' + m.algorithm + '"  not supported. supported values: ' + O.join(", "));
            if (N.indexOf(m.encoding) === -1 && m.algorithm !== "passthrough") throw new Error('Encoding "' + m.encoding + '"  not supported. supported values: ' + N.join(", "));
            return m;
          }
          function C(x) {
            if (typeof x == "function") return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(x)) != null;
          }
          function V(x, M, m) {
            m = m || [];
            function S(w) {
              return M.update ? M.update(w, "utf8") : M.write(w, "utf8");
            }
            return { dispatch: function(w) {
              return this["_" + ((w = x.replacer ? x.replacer(w) : w) === null ? "null" : typeof w)](w);
            }, _object: function(w) {
              var v, k = Object.prototype.toString.call(w), Q = /\[object (.*)\]/i.exec(k);
              if (Q = (Q = Q ? Q[1] : "unknown:[" + k + "]").toLowerCase(), 0 <= (k = m.indexOf(w))) return this.dispatch("[CIRCULAR:" + k + "]");
              if (m.push(w), c !== void 0 && c.isBuffer && c.isBuffer(w)) return S("buffer:"), S(w);
              if (Q === "object" || Q === "function" || Q === "asyncfunction") return k = Object.keys(w), x.unorderedObjects && (k = k.sort()), x.respectType === !1 || C(w) || k.splice(0, 0, "prototype", "__proto__", "constructor"), x.excludeKeys && (k = k.filter(function(z) {
                return !x.excludeKeys(z);
              })), S("object:" + k.length + ":"), v = this, k.forEach(function(z) {
                v.dispatch(z), S(":"), x.excludeValues || v.dispatch(w[z]), S(",");
              });
              if (!this["_" + Q]) {
                if (x.ignoreUnknown) return S("[" + Q + "]");
                throw new Error('Unknown object type "' + Q + '"');
              }
              this["_" + Q](w);
            }, _array: function(w, z) {
              z = z !== void 0 ? z : x.unorderedArrays !== !1;
              var k = this;
              if (S("array:" + w.length + ":"), !z || w.length <= 1) return w.forEach(function(L) {
                return k.dispatch(L);
              });
              var Q = [], z = w.map(function(L) {
                var D = new G(), Y = m.slice();
                return V(x, D, Y).dispatch(L), Q = Q.concat(Y.slice(m.length)), D.read().toString();
              });
              return m = m.concat(Q), z.sort(), this._array(z, !1);
            }, _date: function(w) {
              return S("date:" + w.toJSON());
            }, _symbol: function(w) {
              return S("symbol:" + w.toString());
            }, _error: function(w) {
              return S("error:" + w.toString());
            }, _boolean: function(w) {
              return S("bool:" + w.toString());
            }, _string: function(w) {
              S("string:" + w.length + ":"), S(w.toString());
            }, _function: function(w) {
              S("fn:"), C(w) ? this.dispatch("[native]") : this.dispatch(w.toString()), x.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(w.name)), x.respectFunctionProperties && this._object(w);
            }, _number: function(w) {
              return S("number:" + w.toString());
            }, _xml: function(w) {
              return S("xml:" + w.toString());
            }, _null: function() {
              return S("Null");
            }, _undefined: function() {
              return S("Undefined");
            }, _regexp: function(w) {
              return S("regex:" + w.toString());
            }, _uint8array: function(w) {
              return S("uint8array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _uint8clampedarray: function(w) {
              return S("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(w));
            }, _int8array: function(w) {
              return S("int8array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _uint16array: function(w) {
              return S("uint16array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _int16array: function(w) {
              return S("int16array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _uint32array: function(w) {
              return S("uint32array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _int32array: function(w) {
              return S("int32array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _float32array: function(w) {
              return S("float32array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _float64array: function(w) {
              return S("float64array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _arraybuffer: function(w) {
              return S("arraybuffer:"), this.dispatch(new Uint8Array(w));
            }, _url: function(w) {
              return S("url:" + w.toString());
            }, _map: function(w) {
              return S("map:"), w = Array.from(w), this._array(w, x.unorderedSets !== !1);
            }, _set: function(w) {
              return S("set:"), w = Array.from(w), this._array(w, x.unorderedSets !== !1);
            }, _file: function(w) {
              return S("file:"), this.dispatch([w.name, w.size, w.type, w.lastModfied]);
            }, _blob: function() {
              if (x.ignoreUnknown) return S("[blob]");
              throw Error(`Hashing Blob objects is currently not supported
(see https://github.com/puleos/object-hash/issues/26)
Use "options.replacer" or "options.ignoreUnknown"
`);
            }, _domwindow: function() {
              return S("domwindow");
            }, _bigint: function(w) {
              return S("bigint:" + w.toString());
            }, _process: function() {
              return S("process");
            }, _timer: function() {
              return S("timer");
            }, _pipe: function() {
              return S("pipe");
            }, _tcp: function() {
              return S("tcp");
            }, _udp: function() {
              return S("udp");
            }, _tty: function() {
              return S("tty");
            }, _statwatcher: function() {
              return S("statwatcher");
            }, _securecontext: function() {
              return S("securecontext");
            }, _connection: function() {
              return S("connection");
            }, _zlib: function() {
              return S("zlib");
            }, _context: function() {
              return S("context");
            }, _nodescript: function() {
              return S("nodescript");
            }, _httpparser: function() {
              return S("httpparser");
            }, _dataview: function() {
              return S("dataview");
            }, _signal: function() {
              return S("signal");
            }, _fsevent: function() {
              return S("fsevent");
            }, _tlswrap: function() {
              return S("tlswrap");
            } };
          }
          function G() {
            return { buf: "", write: function(x) {
              this.buf += x;
            }, end: function(x) {
              this.buf += x;
            }, read: function() {
              return this.buf;
            } };
          }
          s.writeToStream = function(x, M, m) {
            return m === void 0 && (m = M, M = {}), V(M = P(x, M), m).dispatch(x);
          };
        }).call(this, e("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
      }, { buffer: 3, crypto: 5, lYpoI2: 11 }], 2: [function(e, n, s) {
        (function(i, a, c, d, p, y, B, R, F) {
          (function(T) {
            var U = typeof Uint8Array < "u" ? Uint8Array : Array, O = 43, N = 47, P = 48, C = 97, V = 65, G = 45, x = 95;
            function M(m) {
              return m = m.charCodeAt(0), m === O || m === G ? 62 : m === N || m === x ? 63 : m < P ? -1 : m < P + 10 ? m - P + 26 + 26 : m < V + 26 ? m - V : m < C + 26 ? m - C + 26 : void 0;
            }
            T.toByteArray = function(m) {
              var S, w;
              if (0 < m.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
              var v = m.length, v = m.charAt(v - 2) === "=" ? 2 : m.charAt(v - 1) === "=" ? 1 : 0, k = new U(3 * m.length / 4 - v), Q = 0 < v ? m.length - 4 : m.length, z = 0;
              function L(D) {
                k[z++] = D;
              }
              for (S = 0; S < Q; S += 4, 0) L((16711680 & (w = M(m.charAt(S)) << 18 | M(m.charAt(S + 1)) << 12 | M(m.charAt(S + 2)) << 6 | M(m.charAt(S + 3)))) >> 16), L((65280 & w) >> 8), L(255 & w);
              return v == 2 ? L(255 & (w = M(m.charAt(S)) << 2 | M(m.charAt(S + 1)) >> 4)) : v == 1 && (L((w = M(m.charAt(S)) << 10 | M(m.charAt(S + 1)) << 4 | M(m.charAt(S + 2)) >> 2) >> 8 & 255), L(255 & w)), k;
            }, T.fromByteArray = function(m) {
              var S, w, v, k, Q = m.length % 3, z = "";
              function L(D) {
                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(D);
              }
              for (S = 0, v = m.length - Q; S < v; S += 3) w = (m[S] << 16) + (m[S + 1] << 8) + m[S + 2], z += L((k = w) >> 18 & 63) + L(k >> 12 & 63) + L(k >> 6 & 63) + L(63 & k);
              switch (Q) {
                case 1:
                  z = (z += L((w = m[m.length - 1]) >> 2)) + L(w << 4 & 63) + "==";
                  break;
                case 2:
                  z = (z = (z += L((w = (m[m.length - 2] << 8) + m[m.length - 1]) >> 10)) + L(w >> 4 & 63)) + L(w << 2 & 63) + "=";
              }
              return z;
            };
          })(s === void 0 ? this.base64js = {} : s);
        }).call(this, e("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
      }, { buffer: 3, lYpoI2: 11 }], 3: [function(e, n, s) {
        (function(i, a, O, d, p, y, B, R, F) {
          var T = e("base64-js"), U = e("ieee754");
          function O(g, _, E) {
            if (!(this instanceof O)) return new O(g, _, E);
            var j, $, J, bt, kt = typeof g;
            if (_ === "base64" && kt == "string") for (g = (bt = g).trim ? bt.trim() : bt.replace(/^\s+|\s+$/g, ""); g.length % 4 != 0; ) g += "=";
            if (kt == "number") j = Z(g);
            else if (kt == "string") j = O.byteLength(g, _);
            else {
              if (kt != "object") throw new Error("First argument needs to be a number, array or string.");
              j = Z(g.length);
            }
            if (O._useTypedArrays ? $ = O._augment(new Uint8Array(j)) : (($ = this).length = j, $._isBuffer = !0), O._useTypedArrays && typeof g.byteLength == "number") $._set(g);
            else if (X(bt = g) || O.isBuffer(bt) || bt && typeof bt == "object" && typeof bt.length == "number") for (J = 0; J < j; J++) O.isBuffer(g) ? $[J] = g.readUInt8(J) : $[J] = g[J];
            else if (kt == "string") $.write(g, 0, _);
            else if (kt == "number" && !O._useTypedArrays && !E) for (J = 0; J < j; J++) $[J] = 0;
            return $;
          }
          function N(g, _, E, j) {
            return O._charsWritten = At(function($) {
              for (var J = [], bt = 0; bt < $.length; bt++) J.push(255 & $.charCodeAt(bt));
              return J;
            }(_), g, E, j);
          }
          function P(g, _, E, j) {
            return O._charsWritten = At(function($) {
              for (var J, bt, kt = [], Nt = 0; Nt < $.length; Nt++) bt = $.charCodeAt(Nt), J = bt >> 8, bt = bt % 256, kt.push(bt), kt.push(J);
              return kt;
            }(_), g, E, j);
          }
          function C(g, _, E) {
            var j = "";
            E = Math.min(g.length, E);
            for (var $ = _; $ < E; $++) j += String.fromCharCode(g[$]);
            return j;
          }
          function V(g, _, E, J) {
            J || (W(typeof E == "boolean", "missing or invalid endian"), W(_ != null, "missing offset"), W(_ + 1 < g.length, "Trying to read beyond buffer length"));
            var $, J = g.length;
            if (!(J <= _)) return E ? ($ = g[_], _ + 1 < J && ($ |= g[_ + 1] << 8)) : ($ = g[_] << 8, _ + 1 < J && ($ |= g[_ + 1])), $;
          }
          function G(g, _, E, J) {
            J || (W(typeof E == "boolean", "missing or invalid endian"), W(_ != null, "missing offset"), W(_ + 3 < g.length, "Trying to read beyond buffer length"));
            var $, J = g.length;
            if (!(J <= _)) return E ? (_ + 2 < J && ($ = g[_ + 2] << 16), _ + 1 < J && ($ |= g[_ + 1] << 8), $ |= g[_], _ + 3 < J && ($ += g[_ + 3] << 24 >>> 0)) : (_ + 1 < J && ($ = g[_ + 1] << 16), _ + 2 < J && ($ |= g[_ + 2] << 8), _ + 3 < J && ($ |= g[_ + 3]), $ += g[_] << 24 >>> 0), $;
          }
          function x(g, _, E, j) {
            if (j || (W(typeof E == "boolean", "missing or invalid endian"), W(_ != null, "missing offset"), W(_ + 1 < g.length, "Trying to read beyond buffer length")), !(g.length <= _)) return j = V(g, _, E, !0), 32768 & j ? -1 * (65535 - j + 1) : j;
          }
          function M(g, _, E, j) {
            if (j || (W(typeof E == "boolean", "missing or invalid endian"), W(_ != null, "missing offset"), W(_ + 3 < g.length, "Trying to read beyond buffer length")), !(g.length <= _)) return j = G(g, _, E, !0), 2147483648 & j ? -1 * (4294967295 - j + 1) : j;
          }
          function m(g, _, E, j) {
            return j || (W(typeof E == "boolean", "missing or invalid endian"), W(_ + 3 < g.length, "Trying to read beyond buffer length")), U.read(g, _, E, 23, 4);
          }
          function S(g, _, E, j) {
            return j || (W(typeof E == "boolean", "missing or invalid endian"), W(_ + 7 < g.length, "Trying to read beyond buffer length")), U.read(g, _, E, 52, 8);
          }
          function w(g, _, E, j, $) {
            if ($ || (W(_ != null, "missing value"), W(typeof j == "boolean", "missing or invalid endian"), W(E != null, "missing offset"), W(E + 1 < g.length, "trying to write beyond buffer length"), Pt(_, 65535)), $ = g.length, !($ <= E)) for (var J = 0, bt = Math.min($ - E, 2); J < bt; J++) g[E + J] = (_ & 255 << 8 * (j ? J : 1 - J)) >>> 8 * (j ? J : 1 - J);
          }
          function v(g, _, E, j, $) {
            if ($ || (W(_ != null, "missing value"), W(typeof j == "boolean", "missing or invalid endian"), W(E != null, "missing offset"), W(E + 3 < g.length, "trying to write beyond buffer length"), Pt(_, 4294967295)), $ = g.length, !($ <= E)) for (var J = 0, bt = Math.min($ - E, 4); J < bt; J++) g[E + J] = _ >>> 8 * (j ? J : 3 - J) & 255;
          }
          function k(g, _, E, j, $) {
            $ || (W(_ != null, "missing value"), W(typeof j == "boolean", "missing or invalid endian"), W(E != null, "missing offset"), W(E + 1 < g.length, "Trying to write beyond buffer length"), Zt(_, 32767, -32768)), g.length <= E || w(g, 0 <= _ ? _ : 65535 + _ + 1, E, j, $);
          }
          function Q(g, _, E, j, $) {
            $ || (W(_ != null, "missing value"), W(typeof j == "boolean", "missing or invalid endian"), W(E != null, "missing offset"), W(E + 3 < g.length, "Trying to write beyond buffer length"), Zt(_, 2147483647, -2147483648)), g.length <= E || v(g, 0 <= _ ? _ : 4294967295 + _ + 1, E, j, $);
          }
          function z(g, _, E, j, $) {
            $ || (W(_ != null, "missing value"), W(typeof j == "boolean", "missing or invalid endian"), W(E != null, "missing offset"), W(E + 3 < g.length, "Trying to write beyond buffer length"), Gt(_, 34028234663852886e22, -34028234663852886e22)), g.length <= E || U.write(g, _, E, j, 23, 4);
          }
          function L(g, _, E, j, $) {
            $ || (W(_ != null, "missing value"), W(typeof j == "boolean", "missing or invalid endian"), W(E != null, "missing offset"), W(E + 7 < g.length, "Trying to write beyond buffer length"), Gt(_, 17976931348623157e292, -17976931348623157e292)), g.length <= E || U.write(g, _, E, j, 52, 8);
          }
          s.Buffer = O, s.SlowBuffer = O, s.INSPECT_MAX_BYTES = 50, O.poolSize = 8192, O._useTypedArrays = function() {
            try {
              var g = new ArrayBuffer(0), _ = new Uint8Array(g);
              return _.foo = function() {
                return 42;
              }, _.foo() === 42 && typeof _.subarray == "function";
            } catch {
              return !1;
            }
          }(), O.isEncoding = function(g) {
            switch (String(g).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "binary":
              case "base64":
              case "raw":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, O.isBuffer = function(g) {
            return !(g == null || !g._isBuffer);
          }, O.byteLength = function(g, _) {
            var E;
            switch (g += "", _ || "utf8") {
              case "hex":
                E = g.length / 2;
                break;
              case "utf8":
              case "utf-8":
                E = q(g).length;
                break;
              case "ascii":
              case "binary":
              case "raw":
                E = g.length;
                break;
              case "base64":
                E = rt(g).length;
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                E = 2 * g.length;
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return E;
          }, O.concat = function(g, _) {
            if (W(X(g), `Usage: Buffer.concat(list, [totalLength])
list should be an Array.`), g.length === 0) return new O(0);
            if (g.length === 1) return g[0];
            if (typeof _ != "number") for ($ = _ = 0; $ < g.length; $++) _ += g[$].length;
            for (var E = new O(_), j = 0, $ = 0; $ < g.length; $++) {
              var J = g[$];
              J.copy(E, j), j += J.length;
            }
            return E;
          }, O.prototype.write = function(g, _, E, j) {
            isFinite(_) ? isFinite(E) || (j = E, E = void 0) : (Nt = j, j = _, _ = E, E = Nt), _ = Number(_) || 0;
            var $, J, bt, kt, Nt = this.length - _;
            switch ((!E || Nt < (E = Number(E))) && (E = Nt), j = String(j || "utf8").toLowerCase()) {
              case "hex":
                $ = function(Ht, Vt, $t, Ot) {
                  $t = Number($t) || 0;
                  var mt = Ht.length - $t;
                  (!Ot || mt < (Ot = Number(Ot))) && (Ot = mt), W((mt = Vt.length) % 2 == 0, "Invalid hex string"), mt / 2 < Ot && (Ot = mt / 2);
                  for (var Qt = 0; Qt < Ot; Qt++) {
                    var sr = parseInt(Vt.substr(2 * Qt, 2), 16);
                    W(!isNaN(sr), "Invalid hex string"), Ht[$t + Qt] = sr;
                  }
                  return O._charsWritten = 2 * Qt, Qt;
                }(this, g, _, E);
                break;
              case "utf8":
              case "utf-8":
                J = this, bt = _, kt = E, $ = O._charsWritten = At(q(g), J, bt, kt);
                break;
              case "ascii":
              case "binary":
                $ = N(this, g, _, E);
                break;
              case "base64":
                J = this, bt = _, kt = E, $ = O._charsWritten = At(rt(g), J, bt, kt);
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                $ = P(this, g, _, E);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return $;
          }, O.prototype.toString = function(g, _, E) {
            var j, $, J, bt, kt = this;
            if (g = String(g || "utf8").toLowerCase(), _ = Number(_) || 0, (E = E !== void 0 ? Number(E) : kt.length) === _) return "";
            switch (g) {
              case "hex":
                j = function(Nt, Ht, Vt) {
                  var $t = Nt.length;
                  (!Ht || Ht < 0) && (Ht = 0), (!Vt || Vt < 0 || $t < Vt) && (Vt = $t);
                  for (var Ot = "", mt = Ht; mt < Vt; mt++) Ot += K(Nt[mt]);
                  return Ot;
                }(kt, _, E);
                break;
              case "utf8":
              case "utf-8":
                j = function(Nt, Ht, Vt) {
                  var $t = "", Ot = "";
                  Vt = Math.min(Nt.length, Vt);
                  for (var mt = Ht; mt < Vt; mt++) Nt[mt] <= 127 ? ($t += Ut(Ot) + String.fromCharCode(Nt[mt]), Ot = "") : Ot += "%" + Nt[mt].toString(16);
                  return $t + Ut(Ot);
                }(kt, _, E);
                break;
              case "ascii":
              case "binary":
                j = C(kt, _, E);
                break;
              case "base64":
                $ = kt, bt = E, j = (J = _) === 0 && bt === $.length ? T.fromByteArray($) : T.fromByteArray($.slice(J, bt));
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                j = function(Nt, Ht, Vt) {
                  for (var $t = Nt.slice(Ht, Vt), Ot = "", mt = 0; mt < $t.length; mt += 2) Ot += String.fromCharCode($t[mt] + 256 * $t[mt + 1]);
                  return Ot;
                }(kt, _, E);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return j;
          }, O.prototype.toJSON = function() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          }, O.prototype.copy = function(g, _, E, j) {
            if (_ = _ || 0, (j = j || j === 0 ? j : this.length) !== (E = E || 0) && g.length !== 0 && this.length !== 0) {
              W(E <= j, "sourceEnd < sourceStart"), W(0 <= _ && _ < g.length, "targetStart out of bounds"), W(0 <= E && E < this.length, "sourceStart out of bounds"), W(0 <= j && j <= this.length, "sourceEnd out of bounds"), j > this.length && (j = this.length);
              var $ = (j = g.length - _ < j - E ? g.length - _ + E : j) - E;
              if ($ < 100 || !O._useTypedArrays) for (var J = 0; J < $; J++) g[J + _] = this[J + E];
              else g._set(this.subarray(E, E + $), _);
            }
          }, O.prototype.slice = function(g, _) {
            var E = this.length;
            if (g = Y(g, E, 0), _ = Y(_, E, E), O._useTypedArrays) return O._augment(this.subarray(g, _));
            for (var j = _ - g, $ = new O(j, void 0, !0), J = 0; J < j; J++) $[J] = this[J + g];
            return $;
          }, O.prototype.get = function(g) {
            return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(g);
          }, O.prototype.set = function(g, _) {
            return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(g, _);
          }, O.prototype.readUInt8 = function(g, _) {
            if (_ || (W(g != null, "missing offset"), W(g < this.length, "Trying to read beyond buffer length")), !(g >= this.length)) return this[g];
          }, O.prototype.readUInt16LE = function(g, _) {
            return V(this, g, !0, _);
          }, O.prototype.readUInt16BE = function(g, _) {
            return V(this, g, !1, _);
          }, O.prototype.readUInt32LE = function(g, _) {
            return G(this, g, !0, _);
          }, O.prototype.readUInt32BE = function(g, _) {
            return G(this, g, !1, _);
          }, O.prototype.readInt8 = function(g, _) {
            if (_ || (W(g != null, "missing offset"), W(g < this.length, "Trying to read beyond buffer length")), !(g >= this.length)) return 128 & this[g] ? -1 * (255 - this[g] + 1) : this[g];
          }, O.prototype.readInt16LE = function(g, _) {
            return x(this, g, !0, _);
          }, O.prototype.readInt16BE = function(g, _) {
            return x(this, g, !1, _);
          }, O.prototype.readInt32LE = function(g, _) {
            return M(this, g, !0, _);
          }, O.prototype.readInt32BE = function(g, _) {
            return M(this, g, !1, _);
          }, O.prototype.readFloatLE = function(g, _) {
            return m(this, g, !0, _);
          }, O.prototype.readFloatBE = function(g, _) {
            return m(this, g, !1, _);
          }, O.prototype.readDoubleLE = function(g, _) {
            return S(this, g, !0, _);
          }, O.prototype.readDoubleBE = function(g, _) {
            return S(this, g, !1, _);
          }, O.prototype.writeUInt8 = function(g, _, E) {
            E || (W(g != null, "missing value"), W(_ != null, "missing offset"), W(_ < this.length, "trying to write beyond buffer length"), Pt(g, 255)), _ >= this.length || (this[_] = g);
          }, O.prototype.writeUInt16LE = function(g, _, E) {
            w(this, g, _, !0, E);
          }, O.prototype.writeUInt16BE = function(g, _, E) {
            w(this, g, _, !1, E);
          }, O.prototype.writeUInt32LE = function(g, _, E) {
            v(this, g, _, !0, E);
          }, O.prototype.writeUInt32BE = function(g, _, E) {
            v(this, g, _, !1, E);
          }, O.prototype.writeInt8 = function(g, _, E) {
            E || (W(g != null, "missing value"), W(_ != null, "missing offset"), W(_ < this.length, "Trying to write beyond buffer length"), Zt(g, 127, -128)), _ >= this.length || (0 <= g ? this.writeUInt8(g, _, E) : this.writeUInt8(255 + g + 1, _, E));
          }, O.prototype.writeInt16LE = function(g, _, E) {
            k(this, g, _, !0, E);
          }, O.prototype.writeInt16BE = function(g, _, E) {
            k(this, g, _, !1, E);
          }, O.prototype.writeInt32LE = function(g, _, E) {
            Q(this, g, _, !0, E);
          }, O.prototype.writeInt32BE = function(g, _, E) {
            Q(this, g, _, !1, E);
          }, O.prototype.writeFloatLE = function(g, _, E) {
            z(this, g, _, !0, E);
          }, O.prototype.writeFloatBE = function(g, _, E) {
            z(this, g, _, !1, E);
          }, O.prototype.writeDoubleLE = function(g, _, E) {
            L(this, g, _, !0, E);
          }, O.prototype.writeDoubleBE = function(g, _, E) {
            L(this, g, _, !1, E);
          }, O.prototype.fill = function(g, _, E) {
            if (_ = _ || 0, E = E || this.length, W(typeof (g = typeof (g = g || 0) == "string" ? g.charCodeAt(0) : g) == "number" && !isNaN(g), "value is not a number"), W(_ <= E, "end < start"), E !== _ && this.length !== 0) {
              W(0 <= _ && _ < this.length, "start out of bounds"), W(0 <= E && E <= this.length, "end out of bounds");
              for (var j = _; j < E; j++) this[j] = g;
            }
          }, O.prototype.inspect = function() {
            for (var g = [], _ = this.length, E = 0; E < _; E++) if (g[E] = K(this[E]), E === s.INSPECT_MAX_BYTES) {
              g[E + 1] = "...";
              break;
            }
            return "<Buffer " + g.join(" ") + ">";
          }, O.prototype.toArrayBuffer = function() {
            if (typeof Uint8Array > "u") throw new Error("Buffer.toArrayBuffer not supported in this browser");
            if (O._useTypedArrays) return new O(this).buffer;
            for (var g = new Uint8Array(this.length), _ = 0, E = g.length; _ < E; _ += 1) g[_] = this[_];
            return g.buffer;
          };
          var D = O.prototype;
          function Y(g, _, E) {
            return typeof g != "number" ? E : _ <= (g = ~~g) ? _ : 0 <= g || 0 <= (g += _) ? g : 0;
          }
          function Z(g) {
            return (g = ~~Math.ceil(+g)) < 0 ? 0 : g;
          }
          function X(g) {
            return (Array.isArray || function(_) {
              return Object.prototype.toString.call(_) === "[object Array]";
            })(g);
          }
          function K(g) {
            return g < 16 ? "0" + g.toString(16) : g.toString(16);
          }
          function q(g) {
            for (var _ = [], E = 0; E < g.length; E++) {
              var j = g.charCodeAt(E);
              if (j <= 127) _.push(g.charCodeAt(E));
              else for (var $ = E, J = (55296 <= j && j <= 57343 && E++, encodeURIComponent(g.slice($, E + 1)).substr(1).split("%")), bt = 0; bt < J.length; bt++) _.push(parseInt(J[bt], 16));
            }
            return _;
          }
          function rt(g) {
            return T.toByteArray(g);
          }
          function At(g, _, E, j) {
            for (var $ = 0; $ < j && !($ + E >= _.length || $ >= g.length); $++) _[$ + E] = g[$];
            return $;
          }
          function Ut(g) {
            try {
              return decodeURIComponent(g);
            } catch {
              return "�";
            }
          }
          function Pt(g, _) {
            W(typeof g == "number", "cannot write a non-number as a number"), W(0 <= g, "specified a negative value for writing an unsigned value"), W(g <= _, "value is larger than maximum value for type"), W(Math.floor(g) === g, "value has a fractional component");
          }
          function Zt(g, _, E) {
            W(typeof g == "number", "cannot write a non-number as a number"), W(g <= _, "value larger than maximum allowed value"), W(E <= g, "value smaller than minimum allowed value"), W(Math.floor(g) === g, "value has a fractional component");
          }
          function Gt(g, _, E) {
            W(typeof g == "number", "cannot write a non-number as a number"), W(g <= _, "value larger than maximum allowed value"), W(E <= g, "value smaller than minimum allowed value");
          }
          function W(g, _) {
            if (!g) throw new Error(_ || "Failed assertion");
          }
          O._augment = function(g) {
            return g._isBuffer = !0, g._get = g.get, g._set = g.set, g.get = D.get, g.set = D.set, g.write = D.write, g.toString = D.toString, g.toLocaleString = D.toString, g.toJSON = D.toJSON, g.copy = D.copy, g.slice = D.slice, g.readUInt8 = D.readUInt8, g.readUInt16LE = D.readUInt16LE, g.readUInt16BE = D.readUInt16BE, g.readUInt32LE = D.readUInt32LE, g.readUInt32BE = D.readUInt32BE, g.readInt8 = D.readInt8, g.readInt16LE = D.readInt16LE, g.readInt16BE = D.readInt16BE, g.readInt32LE = D.readInt32LE, g.readInt32BE = D.readInt32BE, g.readFloatLE = D.readFloatLE, g.readFloatBE = D.readFloatBE, g.readDoubleLE = D.readDoubleLE, g.readDoubleBE = D.readDoubleBE, g.writeUInt8 = D.writeUInt8, g.writeUInt16LE = D.writeUInt16LE, g.writeUInt16BE = D.writeUInt16BE, g.writeUInt32LE = D.writeUInt32LE, g.writeUInt32BE = D.writeUInt32BE, g.writeInt8 = D.writeInt8, g.writeInt16LE = D.writeInt16LE, g.writeInt16BE = D.writeInt16BE, g.writeInt32LE = D.writeInt32LE, g.writeInt32BE = D.writeInt32BE, g.writeFloatLE = D.writeFloatLE, g.writeFloatBE = D.writeFloatBE, g.writeDoubleLE = D.writeDoubleLE, g.writeDoubleBE = D.writeDoubleBE, g.fill = D.fill, g.inspect = D.inspect, g.toArrayBuffer = D.toArrayBuffer, g;
          };
        }).call(this, e("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
      }, { "base64-js": 2, buffer: 3, ieee754: 10, lYpoI2: 11 }], 4: [function(e, n, s) {
        (function(i, a, T, d, p, y, B, R, F) {
          var T = e("buffer").Buffer, U = 4, O = new T(U);
          O.fill(0), n.exports = { hash: function(N, P, C, V) {
            for (var G = P(function(w, v) {
              w.length % U != 0 && (k = w.length + (U - w.length % U), w = T.concat([w, O], k));
              for (var k, Q = [], z = v ? w.readInt32BE : w.readInt32LE, L = 0; L < w.length; L += U) Q.push(z.call(w, L));
              return Q;
            }(N = T.isBuffer(N) ? N : new T(N), V), 8 * N.length), P = V, x = new T(C), M = P ? x.writeInt32BE : x.writeInt32LE, m = 0; m < G.length; m++) M.call(x, G[m], 4 * m, !0);
            return x;
          } };
        }).call(this, e("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 5: [function(e, n, s) {
        (function(i, a, T, d, p, y, B, R, F) {
          var T = e("buffer").Buffer, U = e("./sha"), O = e("./sha256"), N = e("./rng"), P = { sha1: U, sha256: O, md5: e("./md5") }, C = 64, V = new T(C);
          function G(w, v) {
            var k = P[w = w || "sha1"], Q = [];
            return k || x("algorithm:", w, "is not yet supported"), { update: function(z) {
              return T.isBuffer(z) || (z = new T(z)), Q.push(z), z.length, this;
            }, digest: function(z) {
              var L = T.concat(Q), L = v ? function(D, Y, Z) {
                T.isBuffer(Y) || (Y = new T(Y)), T.isBuffer(Z) || (Z = new T(Z)), Y.length > C ? Y = D(Y) : Y.length < C && (Y = T.concat([Y, V], C));
                for (var X = new T(C), K = new T(C), q = 0; q < C; q++) X[q] = 54 ^ Y[q], K[q] = 92 ^ Y[q];
                return Z = D(T.concat([X, Z])), D(T.concat([K, Z]));
              }(k, v, L) : k(L);
              return Q = null, z ? L.toString(z) : L;
            } };
          }
          function x() {
            var w = [].slice.call(arguments).join(" ");
            throw new Error([w, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join(`
`));
          }
          V.fill(0), s.createHash = function(w) {
            return G(w);
          }, s.createHmac = G, s.randomBytes = function(w, v) {
            if (!v || !v.call) return new T(N(w));
            try {
              v.call(this, void 0, new T(N(w)));
            } catch (k) {
              v(k);
            }
          };
          var M, m = ["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], S = function(w) {
            s[w] = function() {
              x("sorry,", w, "is not implemented yet");
            };
          };
          for (M in m) S(m[M]);
        }).call(this, e("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./md5": 6, "./rng": 7, "./sha": 8, "./sha256": 9, buffer: 3, lYpoI2: 11 }], 6: [function(e, n, s) {
        (function(i, a, c, d, p, y, B, R, F) {
          var T = e("./helpers");
          function U(x, M) {
            x[M >> 5] |= 128 << M % 32, x[14 + (M + 64 >>> 9 << 4)] = M;
            for (var m = 1732584193, S = -271733879, w = -1732584194, v = 271733878, k = 0; k < x.length; k += 16) {
              var Q = m, z = S, L = w, D = v, m = N(m, S, w, v, x[k + 0], 7, -680876936), v = N(v, m, S, w, x[k + 1], 12, -389564586), w = N(w, v, m, S, x[k + 2], 17, 606105819), S = N(S, w, v, m, x[k + 3], 22, -1044525330);
              m = N(m, S, w, v, x[k + 4], 7, -176418897), v = N(v, m, S, w, x[k + 5], 12, 1200080426), w = N(w, v, m, S, x[k + 6], 17, -1473231341), S = N(S, w, v, m, x[k + 7], 22, -45705983), m = N(m, S, w, v, x[k + 8], 7, 1770035416), v = N(v, m, S, w, x[k + 9], 12, -1958414417), w = N(w, v, m, S, x[k + 10], 17, -42063), S = N(S, w, v, m, x[k + 11], 22, -1990404162), m = N(m, S, w, v, x[k + 12], 7, 1804603682), v = N(v, m, S, w, x[k + 13], 12, -40341101), w = N(w, v, m, S, x[k + 14], 17, -1502002290), m = P(m, S = N(S, w, v, m, x[k + 15], 22, 1236535329), w, v, x[k + 1], 5, -165796510), v = P(v, m, S, w, x[k + 6], 9, -1069501632), w = P(w, v, m, S, x[k + 11], 14, 643717713), S = P(S, w, v, m, x[k + 0], 20, -373897302), m = P(m, S, w, v, x[k + 5], 5, -701558691), v = P(v, m, S, w, x[k + 10], 9, 38016083), w = P(w, v, m, S, x[k + 15], 14, -660478335), S = P(S, w, v, m, x[k + 4], 20, -405537848), m = P(m, S, w, v, x[k + 9], 5, 568446438), v = P(v, m, S, w, x[k + 14], 9, -1019803690), w = P(w, v, m, S, x[k + 3], 14, -187363961), S = P(S, w, v, m, x[k + 8], 20, 1163531501), m = P(m, S, w, v, x[k + 13], 5, -1444681467), v = P(v, m, S, w, x[k + 2], 9, -51403784), w = P(w, v, m, S, x[k + 7], 14, 1735328473), m = C(m, S = P(S, w, v, m, x[k + 12], 20, -1926607734), w, v, x[k + 5], 4, -378558), v = C(v, m, S, w, x[k + 8], 11, -2022574463), w = C(w, v, m, S, x[k + 11], 16, 1839030562), S = C(S, w, v, m, x[k + 14], 23, -35309556), m = C(m, S, w, v, x[k + 1], 4, -1530992060), v = C(v, m, S, w, x[k + 4], 11, 1272893353), w = C(w, v, m, S, x[k + 7], 16, -155497632), S = C(S, w, v, m, x[k + 10], 23, -1094730640), m = C(m, S, w, v, x[k + 13], 4, 681279174), v = C(v, m, S, w, x[k + 0], 11, -358537222), w = C(w, v, m, S, x[k + 3], 16, -722521979), S = C(S, w, v, m, x[k + 6], 23, 76029189), m = C(m, S, w, v, x[k + 9], 4, -640364487), v = C(v, m, S, w, x[k + 12], 11, -421815835), w = C(w, v, m, S, x[k + 15], 16, 530742520), m = V(m, S = C(S, w, v, m, x[k + 2], 23, -995338651), w, v, x[k + 0], 6, -198630844), v = V(v, m, S, w, x[k + 7], 10, 1126891415), w = V(w, v, m, S, x[k + 14], 15, -1416354905), S = V(S, w, v, m, x[k + 5], 21, -57434055), m = V(m, S, w, v, x[k + 12], 6, 1700485571), v = V(v, m, S, w, x[k + 3], 10, -1894986606), w = V(w, v, m, S, x[k + 10], 15, -1051523), S = V(S, w, v, m, x[k + 1], 21, -2054922799), m = V(m, S, w, v, x[k + 8], 6, 1873313359), v = V(v, m, S, w, x[k + 15], 10, -30611744), w = V(w, v, m, S, x[k + 6], 15, -1560198380), S = V(S, w, v, m, x[k + 13], 21, 1309151649), m = V(m, S, w, v, x[k + 4], 6, -145523070), v = V(v, m, S, w, x[k + 11], 10, -1120210379), w = V(w, v, m, S, x[k + 2], 15, 718787259), S = V(S, w, v, m, x[k + 9], 21, -343485551), m = G(m, Q), S = G(S, z), w = G(w, L), v = G(v, D);
            }
            return Array(m, S, w, v);
          }
          function O(x, M, m, S, w, v) {
            return G((M = G(G(M, x), G(S, v))) << w | M >>> 32 - w, m);
          }
          function N(x, M, m, S, w, v, k) {
            return O(M & m | ~M & S, x, M, w, v, k);
          }
          function P(x, M, m, S, w, v, k) {
            return O(M & S | m & ~S, x, M, w, v, k);
          }
          function C(x, M, m, S, w, v, k) {
            return O(M ^ m ^ S, x, M, w, v, k);
          }
          function V(x, M, m, S, w, v, k) {
            return O(m ^ (M | ~S), x, M, w, v, k);
          }
          function G(x, M) {
            var m = (65535 & x) + (65535 & M);
            return (x >> 16) + (M >> 16) + (m >> 16) << 16 | 65535 & m;
          }
          n.exports = function(x) {
            return T.hash(x, U, 16);
          };
        }).call(this, e("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 7: [function(e, n, s) {
        (function(i, a, c, d, p, y, B, R, F) {
          n.exports = function(T) {
            for (var U, O = new Array(T), N = 0; N < T; N++) (3 & N) == 0 && (U = 4294967296 * Math.random()), O[N] = U >>> ((3 & N) << 3) & 255;
            return O;
          };
        }).call(this, e("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 8: [function(e, n, s) {
        (function(i, a, c, d, p, y, B, R, F) {
          var T = e("./helpers");
          function U(P, C) {
            P[C >> 5] |= 128 << 24 - C % 32, P[15 + (C + 64 >> 9 << 4)] = C;
            for (var V, G, x, M = Array(80), m = 1732584193, S = -271733879, w = -1732584194, v = 271733878, k = -1009589776, Q = 0; Q < P.length; Q += 16) {
              for (var z = m, L = S, D = w, Y = v, Z = k, X = 0; X < 80; X++) {
                M[X] = X < 16 ? P[Q + X] : N(M[X - 3] ^ M[X - 8] ^ M[X - 14] ^ M[X - 16], 1);
                var K = O(O(N(m, 5), (K = S, G = w, x = v, (V = X) < 20 ? K & G | ~K & x : !(V < 40) && V < 60 ? K & G | K & x | G & x : K ^ G ^ x)), O(O(k, M[X]), (V = X) < 20 ? 1518500249 : V < 40 ? 1859775393 : V < 60 ? -1894007588 : -899497514)), k = v, v = w, w = N(S, 30), S = m, m = K;
              }
              m = O(m, z), S = O(S, L), w = O(w, D), v = O(v, Y), k = O(k, Z);
            }
            return Array(m, S, w, v, k);
          }
          function O(P, C) {
            var V = (65535 & P) + (65535 & C);
            return (P >> 16) + (C >> 16) + (V >> 16) << 16 | 65535 & V;
          }
          function N(P, C) {
            return P << C | P >>> 32 - C;
          }
          n.exports = function(P) {
            return T.hash(P, U, 20, !0);
          };
        }).call(this, e("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 9: [function(e, n, s) {
        (function(i, a, c, d, p, y, B, R, F) {
          function T(C, V) {
            var G = (65535 & C) + (65535 & V);
            return (C >> 16) + (V >> 16) + (G >> 16) << 16 | 65535 & G;
          }
          function U(C, V) {
            var G, x = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), M = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), m = new Array(64);
            C[V >> 5] |= 128 << 24 - V % 32, C[15 + (V + 64 >> 9 << 4)] = V;
            for (var S, w, v = 0; v < C.length; v += 16) {
              for (var k = M[0], Q = M[1], z = M[2], L = M[3], D = M[4], Y = M[5], Z = M[6], X = M[7], K = 0; K < 64; K++) m[K] = K < 16 ? C[K + v] : T(T(T((w = m[K - 2], N(w, 17) ^ N(w, 19) ^ P(w, 10)), m[K - 7]), (w = m[K - 15], N(w, 7) ^ N(w, 18) ^ P(w, 3))), m[K - 16]), G = T(T(T(T(X, N(w = D, 6) ^ N(w, 11) ^ N(w, 25)), D & Y ^ ~D & Z), x[K]), m[K]), S = T(N(S = k, 2) ^ N(S, 13) ^ N(S, 22), k & Q ^ k & z ^ Q & z), X = Z, Z = Y, Y = D, D = T(L, G), L = z, z = Q, Q = k, k = T(G, S);
              M[0] = T(k, M[0]), M[1] = T(Q, M[1]), M[2] = T(z, M[2]), M[3] = T(L, M[3]), M[4] = T(D, M[4]), M[5] = T(Y, M[5]), M[6] = T(Z, M[6]), M[7] = T(X, M[7]);
            }
            return M;
          }
          var O = e("./helpers"), N = function(C, V) {
            return C >>> V | C << 32 - V;
          }, P = function(C, V) {
            return C >>> V;
          };
          n.exports = function(C) {
            return O.hash(C, U, 32, !0);
          };
        }).call(this, e("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 10: [function(e, n, s) {
        (function(i, a, c, d, p, y, B, R, F) {
          s.read = function(T, U, O, N, v) {
            var C, V, G = 8 * v - N - 1, x = (1 << G) - 1, M = x >> 1, m = -7, S = O ? v - 1 : 0, w = O ? -1 : 1, v = T[U + S];
            for (S += w, C = v & (1 << -m) - 1, v >>= -m, m += G; 0 < m; C = 256 * C + T[U + S], S += w, m -= 8) ;
            for (V = C & (1 << -m) - 1, C >>= -m, m += N; 0 < m; V = 256 * V + T[U + S], S += w, m -= 8) ;
            if (C === 0) C = 1 - M;
            else {
              if (C === x) return V ? NaN : 1 / 0 * (v ? -1 : 1);
              V += Math.pow(2, N), C -= M;
            }
            return (v ? -1 : 1) * V * Math.pow(2, C - N);
          }, s.write = function(T, U, O, N, P, k) {
            var V, G, x = 8 * k - P - 1, M = (1 << x) - 1, m = M >> 1, S = P === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, w = N ? 0 : k - 1, v = N ? 1 : -1, k = U < 0 || U === 0 && 1 / U < 0 ? 1 : 0;
            for (U = Math.abs(U), isNaN(U) || U === 1 / 0 ? (G = isNaN(U) ? 1 : 0, V = M) : (V = Math.floor(Math.log(U) / Math.LN2), U * (N = Math.pow(2, -V)) < 1 && (V--, N *= 2), 2 <= (U += 1 <= V + m ? S / N : S * Math.pow(2, 1 - m)) * N && (V++, N /= 2), M <= V + m ? (G = 0, V = M) : 1 <= V + m ? (G = (U * N - 1) * Math.pow(2, P), V += m) : (G = U * Math.pow(2, m - 1) * Math.pow(2, P), V = 0)); 8 <= P; T[O + w] = 255 & G, w += v, G /= 256, P -= 8) ;
            for (V = V << P | G, x += P; 0 < x; T[O + w] = 255 & V, w += v, V /= 256, x -= 8) ;
            T[O + w - v] |= 128 * k;
          };
        }).call(this, e("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
      }, { buffer: 3, lYpoI2: 11 }], 11: [function(e, n, s) {
        (function(i, a, c, d, p, y, B, R, F) {
          var T, U, O;
          function N() {
          }
          (i = n.exports = {}).nextTick = (U = typeof window < "u" && window.setImmediate, O = typeof window < "u" && window.postMessage && window.addEventListener, U ? function(P) {
            return window.setImmediate(P);
          } : O ? (T = [], window.addEventListener("message", function(P) {
            var C = P.source;
            C !== window && C !== null || P.data !== "process-tick" || (P.stopPropagation(), 0 < T.length && T.shift()());
          }, !0), function(P) {
            T.push(P), window.postMessage("process-tick", "*");
          }) : function(P) {
            setTimeout(P, 0);
          }), i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.on = N, i.addListener = N, i.once = N, i.off = N, i.removeListener = N, i.removeAllListeners = N, i.emit = N, i.binding = function(P) {
            throw new Error("process.binding is not supported");
          }, i.cwd = function() {
            return "/";
          }, i.chdir = function(P) {
            throw new Error("process.chdir is not supported");
          };
        }).call(this, e("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
      }, { buffer: 3, lYpoI2: 11 }] }, {}, [1])(1);
    });
  }(Ci)), Ci.exports;
}
var cf = af();
const uf = /* @__PURE__ */ Ls(cf);
new TextEncoder();
const hf = 4096;
function wu(r, t, e) {
  let n = t;
  const s = n + e, i = [];
  let a = "";
  for (; n < s; ) {
    const c = r[n++];
    if ((c & 128) === 0)
      i.push(c);
    else if ((c & 224) === 192) {
      const d = r[n++] & 63;
      i.push((c & 31) << 6 | d);
    } else if ((c & 240) === 224) {
      const d = r[n++] & 63, p = r[n++] & 63;
      i.push((c & 31) << 12 | d << 6 | p);
    } else if ((c & 248) === 240) {
      const d = r[n++] & 63, p = r[n++] & 63, y = r[n++] & 63;
      let B = (c & 7) << 18 | d << 12 | p << 6 | y;
      B > 65535 && (B -= 65536, i.push(B >>> 10 & 1023 | 55296), B = 56320 | B & 1023), i.push(B);
    } else
      i.push(c);
    i.length >= hf && (a += String.fromCharCode(...i), i.length = 0);
  }
  return i.length > 0 && (a += String.fromCharCode(...i)), a;
}
const lf = new TextDecoder(), df = 200;
function ff(r, t, e) {
  const n = r.subarray(t, t + e);
  return lf.decode(n);
}
function pf(r, t, e) {
  return e > df ? ff(r, t, e) : wu(r, t, e);
}
class vn {
  constructor(t, e) {
    this.type = t, this.data = e;
  }
}
class se extends Error {
  constructor(t) {
    super(t);
    const e = Object.create(se.prototype);
    Object.setPrototypeOf(this, e), Object.defineProperty(this, "name", {
      configurable: !0,
      enumerable: !1,
      value: se.name
    });
  }
}
const Hr = 4294967295;
function yf(r, t, e) {
  const n = Math.floor(e / 4294967296), s = e;
  r.setUint32(t, n), r.setUint32(t + 4, s);
}
function bu(r, t) {
  const e = r.getInt32(t), n = r.getUint32(t + 4);
  return e * 4294967296 + n;
}
function gf(r, t) {
  const e = r.getUint32(t), n = r.getUint32(t + 4);
  return e * 4294967296 + n;
}
const mf = -1, wf = 4294967296 - 1, bf = 17179869184 - 1;
function _f({ sec: r, nsec: t }) {
  if (r >= 0 && t >= 0 && r <= bf)
    if (t === 0 && r <= wf) {
      const e = new Uint8Array(4);
      return new DataView(e.buffer).setUint32(0, r), e;
    } else {
      const e = r / 4294967296, n = r & 4294967295, s = new Uint8Array(8), i = new DataView(s.buffer);
      return i.setUint32(0, t << 2 | e & 3), i.setUint32(4, n), s;
    }
  else {
    const e = new Uint8Array(12), n = new DataView(e.buffer);
    return n.setUint32(0, t), yf(n, 4, r), e;
  }
}
function Sf(r) {
  const t = r.getTime(), e = Math.floor(t / 1e3), n = (t - e * 1e3) * 1e6, s = Math.floor(n / 1e9);
  return {
    sec: e + s,
    nsec: n - s * 1e9
  };
}
function If(r) {
  if (r instanceof Date) {
    const t = Sf(r);
    return _f(t);
  } else
    return null;
}
function Bf(r) {
  const t = new DataView(r.buffer, r.byteOffset, r.byteLength);
  switch (r.byteLength) {
    case 4:
      return { sec: t.getUint32(0), nsec: 0 };
    case 8: {
      const e = t.getUint32(0), n = t.getUint32(4), s = (e & 3) * 4294967296 + n, i = e >>> 2;
      return { sec: s, nsec: i };
    }
    case 12: {
      const e = bu(t, 4), n = t.getUint32(0);
      return { sec: e, nsec: n };
    }
    default:
      throw new se(`Unrecognized data size for timestamp (expected 4, 8, or 12): ${r.length}`);
  }
}
function vf(r) {
  const t = Bf(r);
  return new Date(t.sec * 1e3 + t.nsec / 1e6);
}
const xf = {
  type: mf,
  encode: If,
  decode: vf
};
class ts {
  constructor() {
    this.builtInEncoders = [], this.builtInDecoders = [], this.encoders = [], this.decoders = [], this.register(xf);
  }
  register({ type: t, encode: e, decode: n }) {
    if (t >= 0)
      this.encoders[t] = e, this.decoders[t] = n;
    else {
      const s = -1 - t;
      this.builtInEncoders[s] = e, this.builtInDecoders[s] = n;
    }
  }
  tryToEncode(t, e) {
    for (let n = 0; n < this.builtInEncoders.length; n++) {
      const s = this.builtInEncoders[n];
      if (s != null) {
        const i = s(t, e);
        if (i != null) {
          const a = -1 - n;
          return new vn(a, i);
        }
      }
    }
    for (let n = 0; n < this.encoders.length; n++) {
      const s = this.encoders[n];
      if (s != null) {
        const i = s(t, e);
        if (i != null) {
          const a = n;
          return new vn(a, i);
        }
      }
    }
    return t instanceof vn ? t : null;
  }
  decode(t, e, n) {
    const s = e < 0 ? this.builtInDecoders[-1 - e] : this.decoders[e];
    return s ? s(t, e, n) : new vn(e, t);
  }
}
ts.defaultCodec = new ts();
function Af(r) {
  return r instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && r instanceof SharedArrayBuffer;
}
function Ho(r) {
  return r instanceof Uint8Array ? r : ArrayBuffer.isView(r) ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength) : Af(r) ? new Uint8Array(r) : Uint8Array.from(r);
}
function Ri(r) {
  return `${r < 0 ? "-" : ""}0x${Math.abs(r).toString(16).padStart(2, "0")}`;
}
const Ef = 16, Tf = 16;
class Mf {
  constructor(t = Ef, e = Tf) {
    this.hit = 0, this.miss = 0, this.maxKeyLength = t, this.maxLengthPerKey = e, this.caches = [];
    for (let n = 0; n < this.maxKeyLength; n++)
      this.caches.push([]);
  }
  canBeCached(t) {
    return t > 0 && t <= this.maxKeyLength;
  }
  find(t, e, n) {
    const s = this.caches[n - 1];
    t: for (const i of s) {
      const a = i.bytes;
      for (let c = 0; c < n; c++)
        if (a[c] !== t[e + c])
          continue t;
      return i.str;
    }
    return null;
  }
  store(t, e) {
    const n = this.caches[t.length - 1], s = { bytes: t, str: e };
    n.length >= this.maxLengthPerKey ? n[Math.random() * n.length | 0] = s : n.push(s);
  }
  decode(t, e, n) {
    const s = this.find(t, e, n);
    if (s != null)
      return this.hit++, s;
    this.miss++;
    const i = wu(t, e, n), a = Uint8Array.prototype.slice.call(t, e, e + n);
    return this.store(a, i), i;
  }
}
const es = "array", cn = "map_key", _u = "map_value", Of = (r) => {
  if (typeof r == "string" || typeof r == "number")
    return r;
  throw new se("The type of key must be string or number but " + typeof r);
};
class Ff {
  constructor() {
    this.stack = [], this.stackHeadPosition = -1;
  }
  get length() {
    return this.stackHeadPosition + 1;
  }
  top() {
    return this.stack[this.stackHeadPosition];
  }
  pushArrayState(t) {
    const e = this.getUninitializedStateFromPool();
    e.type = es, e.position = 0, e.size = t, e.array = new Array(t);
  }
  pushMapState(t) {
    const e = this.getUninitializedStateFromPool();
    e.type = cn, e.readCount = 0, e.size = t, e.map = {};
  }
  getUninitializedStateFromPool() {
    if (this.stackHeadPosition++, this.stackHeadPosition === this.stack.length) {
      const t = {
        type: void 0,
        size: 0,
        array: void 0,
        position: 0,
        readCount: 0,
        map: void 0,
        key: null
      };
      this.stack.push(t);
    }
    return this.stack[this.stackHeadPosition];
  }
  release(t) {
    if (this.stack[this.stackHeadPosition] !== t)
      throw new Error("Invalid stack state. Released state is not on top of the stack.");
    if (t.type === es) {
      const n = t;
      n.size = 0, n.array = void 0, n.position = 0, n.type = void 0;
    }
    if (t.type === cn || t.type === _u) {
      const n = t;
      n.size = 0, n.map = void 0, n.readCount = 0, n.type = void 0;
    }
    this.stackHeadPosition--;
  }
  reset() {
    this.stack.length = 0, this.stackHeadPosition = -1;
  }
}
const qr = -1, Ps = new DataView(new ArrayBuffer(0)), kf = new Uint8Array(Ps.buffer);
try {
  Ps.getInt8(0);
} catch (r) {
  if (!(r instanceof RangeError))
    throw new Error("This module is not supported in the current JavaScript engine because DataView does not throw RangeError on out-of-bounds access");
}
const qo = new RangeError("Insufficient data"), Nf = new Mf();
class $s {
  constructor(t) {
    this.totalPos = 0, this.pos = 0, this.view = Ps, this.bytes = kf, this.headByte = qr, this.stack = new Ff(), this.entered = !1, this.extensionCodec = t?.extensionCodec ?? ts.defaultCodec, this.context = t?.context, this.useBigInt64 = t?.useBigInt64 ?? !1, this.rawStrings = t?.rawStrings ?? !1, this.maxStrLength = t?.maxStrLength ?? Hr, this.maxBinLength = t?.maxBinLength ?? Hr, this.maxArrayLength = t?.maxArrayLength ?? Hr, this.maxMapLength = t?.maxMapLength ?? Hr, this.maxExtLength = t?.maxExtLength ?? Hr, this.keyDecoder = t?.keyDecoder !== void 0 ? t.keyDecoder : Nf, this.mapKeyConverter = t?.mapKeyConverter ?? Of;
  }
  clone() {
    return new $s({
      extensionCodec: this.extensionCodec,
      context: this.context,
      useBigInt64: this.useBigInt64,
      rawStrings: this.rawStrings,
      maxStrLength: this.maxStrLength,
      maxBinLength: this.maxBinLength,
      maxArrayLength: this.maxArrayLength,
      maxMapLength: this.maxMapLength,
      maxExtLength: this.maxExtLength,
      keyDecoder: this.keyDecoder
    });
  }
  reinitializeState() {
    this.totalPos = 0, this.headByte = qr, this.stack.reset();
  }
  setBuffer(t) {
    const e = Ho(t);
    this.bytes = e, this.view = new DataView(e.buffer, e.byteOffset, e.byteLength), this.pos = 0;
  }
  appendBuffer(t) {
    if (this.headByte === qr && !this.hasRemaining(1))
      this.setBuffer(t);
    else {
      const e = this.bytes.subarray(this.pos), n = Ho(t), s = new Uint8Array(e.length + n.length);
      s.set(e), s.set(n, e.length), this.setBuffer(s);
    }
  }
  hasRemaining(t) {
    return this.view.byteLength - this.pos >= t;
  }
  createExtraByteError(t) {
    const { view: e, pos: n } = this;
    return new RangeError(`Extra ${e.byteLength - n} of ${e.byteLength} byte(s) found at buffer[${t}]`);
  }
  /**
   * @throws {@link DecodeError}
   * @throws {@link RangeError}
   */
  decode(t) {
    if (this.entered)
      return this.clone().decode(t);
    try {
      this.entered = !0, this.reinitializeState(), this.setBuffer(t);
      const e = this.doDecodeSync();
      if (this.hasRemaining(1))
        throw this.createExtraByteError(this.pos);
      return e;
    } finally {
      this.entered = !1;
    }
  }
  *decodeMulti(t) {
    if (this.entered) {
      yield* this.clone().decodeMulti(t);
      return;
    }
    try {
      for (this.entered = !0, this.reinitializeState(), this.setBuffer(t); this.hasRemaining(1); )
        yield this.doDecodeSync();
    } finally {
      this.entered = !1;
    }
  }
  async decodeAsync(t) {
    if (this.entered)
      return this.clone().decodeAsync(t);
    try {
      this.entered = !0;
      let e = !1, n;
      for await (const c of t) {
        if (e)
          throw this.entered = !1, this.createExtraByteError(this.totalPos);
        this.appendBuffer(c);
        try {
          n = this.doDecodeSync(), e = !0;
        } catch (d) {
          if (!(d instanceof RangeError))
            throw d;
        }
        this.totalPos += this.pos;
      }
      if (e) {
        if (this.hasRemaining(1))
          throw this.createExtraByteError(this.totalPos);
        return n;
      }
      const { headByte: s, pos: i, totalPos: a } = this;
      throw new RangeError(`Insufficient data in parsing ${Ri(s)} at ${a} (${i} in the current buffer)`);
    } finally {
      this.entered = !1;
    }
  }
  decodeArrayStream(t) {
    return this.decodeMultiAsync(t, !0);
  }
  decodeStream(t) {
    return this.decodeMultiAsync(t, !1);
  }
  async *decodeMultiAsync(t, e) {
    if (this.entered) {
      yield* this.clone().decodeMultiAsync(t, e);
      return;
    }
    try {
      this.entered = !0;
      let n = e, s = -1;
      for await (const i of t) {
        if (e && s === 0)
          throw this.createExtraByteError(this.totalPos);
        this.appendBuffer(i), n && (s = this.readArraySize(), n = !1, this.complete());
        try {
          for (; yield this.doDecodeSync(), --s !== 0; )
            ;
        } catch (a) {
          if (!(a instanceof RangeError))
            throw a;
        }
        this.totalPos += this.pos;
      }
    } finally {
      this.entered = !1;
    }
  }
  doDecodeSync() {
    t: for (; ; ) {
      const t = this.readHeadByte();
      let e;
      if (t >= 224)
        e = t - 256;
      else if (t < 192)
        if (t < 128)
          e = t;
        else if (t < 144) {
          const s = t - 128;
          if (s !== 0) {
            this.pushMapState(s), this.complete();
            continue t;
          } else
            e = {};
        } else if (t < 160) {
          const s = t - 144;
          if (s !== 0) {
            this.pushArrayState(s), this.complete();
            continue t;
          } else
            e = [];
        } else {
          const s = t - 160;
          e = this.decodeString(s, 0);
        }
      else if (t === 192)
        e = null;
      else if (t === 194)
        e = !1;
      else if (t === 195)
        e = !0;
      else if (t === 202)
        e = this.readF32();
      else if (t === 203)
        e = this.readF64();
      else if (t === 204)
        e = this.readU8();
      else if (t === 205)
        e = this.readU16();
      else if (t === 206)
        e = this.readU32();
      else if (t === 207)
        this.useBigInt64 ? e = this.readU64AsBigInt() : e = this.readU64();
      else if (t === 208)
        e = this.readI8();
      else if (t === 209)
        e = this.readI16();
      else if (t === 210)
        e = this.readI32();
      else if (t === 211)
        this.useBigInt64 ? e = this.readI64AsBigInt() : e = this.readI64();
      else if (t === 217) {
        const s = this.lookU8();
        e = this.decodeString(s, 1);
      } else if (t === 218) {
        const s = this.lookU16();
        e = this.decodeString(s, 2);
      } else if (t === 219) {
        const s = this.lookU32();
        e = this.decodeString(s, 4);
      } else if (t === 220) {
        const s = this.readU16();
        if (s !== 0) {
          this.pushArrayState(s), this.complete();
          continue t;
        } else
          e = [];
      } else if (t === 221) {
        const s = this.readU32();
        if (s !== 0) {
          this.pushArrayState(s), this.complete();
          continue t;
        } else
          e = [];
      } else if (t === 222) {
        const s = this.readU16();
        if (s !== 0) {
          this.pushMapState(s), this.complete();
          continue t;
        } else
          e = {};
      } else if (t === 223) {
        const s = this.readU32();
        if (s !== 0) {
          this.pushMapState(s), this.complete();
          continue t;
        } else
          e = {};
      } else if (t === 196) {
        const s = this.lookU8();
        e = this.decodeBinary(s, 1);
      } else if (t === 197) {
        const s = this.lookU16();
        e = this.decodeBinary(s, 2);
      } else if (t === 198) {
        const s = this.lookU32();
        e = this.decodeBinary(s, 4);
      } else if (t === 212)
        e = this.decodeExtension(1, 0);
      else if (t === 213)
        e = this.decodeExtension(2, 0);
      else if (t === 214)
        e = this.decodeExtension(4, 0);
      else if (t === 215)
        e = this.decodeExtension(8, 0);
      else if (t === 216)
        e = this.decodeExtension(16, 0);
      else if (t === 199) {
        const s = this.lookU8();
        e = this.decodeExtension(s, 1);
      } else if (t === 200) {
        const s = this.lookU16();
        e = this.decodeExtension(s, 2);
      } else if (t === 201) {
        const s = this.lookU32();
        e = this.decodeExtension(s, 4);
      } else
        throw new se(`Unrecognized type byte: ${Ri(t)}`);
      this.complete();
      const n = this.stack;
      for (; n.length > 0; ) {
        const s = n.top();
        if (s.type === es)
          if (s.array[s.position] = e, s.position++, s.position === s.size)
            e = s.array, n.release(s);
          else
            continue t;
        else if (s.type === cn) {
          if (e === "__proto__")
            throw new se("The key __proto__ is not allowed");
          s.key = this.mapKeyConverter(e), s.type = _u;
          continue t;
        } else if (s.map[s.key] = e, s.readCount++, s.readCount === s.size)
          e = s.map, n.release(s);
        else {
          s.key = null, s.type = cn;
          continue t;
        }
      }
      return e;
    }
  }
  readHeadByte() {
    return this.headByte === qr && (this.headByte = this.readU8()), this.headByte;
  }
  complete() {
    this.headByte = qr;
  }
  readArraySize() {
    const t = this.readHeadByte();
    switch (t) {
      case 220:
        return this.readU16();
      case 221:
        return this.readU32();
      default: {
        if (t < 160)
          return t - 144;
        throw new se(`Unrecognized array type byte: ${Ri(t)}`);
      }
    }
  }
  pushMapState(t) {
    if (t > this.maxMapLength)
      throw new se(`Max length exceeded: map length (${t}) > maxMapLengthLength (${this.maxMapLength})`);
    this.stack.pushMapState(t);
  }
  pushArrayState(t) {
    if (t > this.maxArrayLength)
      throw new se(`Max length exceeded: array length (${t}) > maxArrayLength (${this.maxArrayLength})`);
    this.stack.pushArrayState(t);
  }
  decodeString(t, e) {
    return !this.rawStrings || this.stateIsMapKey() ? this.decodeUtf8String(t, e) : this.decodeBinary(t, e);
  }
  /**
   * @throws {@link RangeError}
   */
  decodeUtf8String(t, e) {
    if (t > this.maxStrLength)
      throw new se(`Max length exceeded: UTF-8 byte length (${t}) > maxStrLength (${this.maxStrLength})`);
    if (this.bytes.byteLength < this.pos + e + t)
      throw qo;
    const n = this.pos + e;
    let s;
    return this.stateIsMapKey() && this.keyDecoder?.canBeCached(t) ? s = this.keyDecoder.decode(this.bytes, n, t) : s = pf(this.bytes, n, t), this.pos += e + t, s;
  }
  stateIsMapKey() {
    return this.stack.length > 0 ? this.stack.top().type === cn : !1;
  }
  /**
   * @throws {@link RangeError}
   */
  decodeBinary(t, e) {
    if (t > this.maxBinLength)
      throw new se(`Max length exceeded: bin length (${t}) > maxBinLength (${this.maxBinLength})`);
    if (!this.hasRemaining(t + e))
      throw qo;
    const n = this.pos + e, s = this.bytes.subarray(n, n + t);
    return this.pos += e + t, s;
  }
  decodeExtension(t, e) {
    if (t > this.maxExtLength)
      throw new se(`Max length exceeded: ext length (${t}) > maxExtLength (${this.maxExtLength})`);
    const n = this.view.getInt8(this.pos + e), s = this.decodeBinary(
      t,
      e + 1
      /* extType */
    );
    return this.extensionCodec.decode(s, n, this.context);
  }
  lookU8() {
    return this.view.getUint8(this.pos);
  }
  lookU16() {
    return this.view.getUint16(this.pos);
  }
  lookU32() {
    return this.view.getUint32(this.pos);
  }
  readU8() {
    const t = this.view.getUint8(this.pos);
    return this.pos++, t;
  }
  readI8() {
    const t = this.view.getInt8(this.pos);
    return this.pos++, t;
  }
  readU16() {
    const t = this.view.getUint16(this.pos);
    return this.pos += 2, t;
  }
  readI16() {
    const t = this.view.getInt16(this.pos);
    return this.pos += 2, t;
  }
  readU32() {
    const t = this.view.getUint32(this.pos);
    return this.pos += 4, t;
  }
  readI32() {
    const t = this.view.getInt32(this.pos);
    return this.pos += 4, t;
  }
  readU64() {
    const t = gf(this.view, this.pos);
    return this.pos += 8, t;
  }
  readI64() {
    const t = bu(this.view, this.pos);
    return this.pos += 8, t;
  }
  readU64AsBigInt() {
    const t = this.view.getBigUint64(this.pos);
    return this.pos += 8, t;
  }
  readI64AsBigInt() {
    const t = this.view.getBigInt64(this.pos);
    return this.pos += 8, t;
  }
  readF32() {
    const t = this.view.getFloat32(this.pos);
    return this.pos += 4, t;
  }
  readF64() {
    const t = this.view.getFloat64(this.pos);
    return this.pos += 8, t;
  }
}
function Df(r, t) {
  return new $s(t).decode(r);
}
na.set("msgpack2", async () => ({
  kind: "array_to_bytes",
  fromConfig: (r, t) => ({
    kind: "array_to_bytes",
    async encode(e) {
      throw new Error("msgpack2 encode not implemented");
    },
    async decode(e) {
      const n = Df(e), { shape: s } = t, i = new Array(s.length);
      let a = 1;
      for (let c = s.length - 1; c >= 0; c--)
        i[c] = a, a *= s[c];
      return { data: n, shape: s, stride: i };
    }
  })
}));
function Uf(r) {
  return new Promise((t) => setTimeout(t, r));
}
class Lf {
  cache;
  url;
  params;
  cache_prefix;
  fetchOptions;
  timeout;
  _pending = {};
  constructor(t, e, n = {}) {
    const s = { ...e };
    n.parameters && (s["x-parameters"] = JSON.stringify(n.parameters)), n.chunks && (s["x-chunks"] = n.chunks), n.downsample && (s["x-downsample"] = JSON.stringify(n.downsample)), s["x-filtered"] = "True", this.params = {}, e["x-datamesh-auth"] && (this.params.auth = e["x-datamesh-auth"]), e["x-datamesh-sig"] && (this.params.sig = e["x-datamesh-sig"]), this.fetchOptions = { headers: s }, this.url = t;
    const i = t.split("/").pop();
    n.nocache || typeof window > "u" ? this.cache = void 0 : this.cache = mu("zarr", "cache"), this.cache_prefix = uf({
      datasource: i,
      ...n.parameters,
      chunks: n.chunks,
      downsample: n.downsample
    }), this.timeout = n.timeout || 6e4;
  }
  async get(t, e, n = 0) {
    const s = `${this.cache_prefix}${t}`;
    let i = null;
    if (this.cache && (i = await sf(s, this.cache), i && delete this._pending[s], this._pending[s]))
      if (await Uf(200), n > this.timeout) {
        await Li(s, this.cache), delete this._pending[s], console.error("Zarr timeout");
        return;
      } else
        return await this.get(t, e, n + 200);
    if (!i) {
      this._pending[s] = !0;
      try {
        const a = {
          ...this.fetchOptions,
          ...e,
          headers: {
            ...this.fetchOptions.headers || {},
            ...e?.headers || {}
          },
          signal: AbortSignal.timeout(this.timeout)
        }, c = new URLSearchParams(this.params).toString(), d = await fetch(
          `${this.url}${t}?${c}`,
          a
        );
        if (d.status === 404) {
          this.cache && await Li(s, this.cache);
          return;
        }
        if (d.status >= 400)
          throw new Error(`HTTP error: ${d.status}`);
        i = new Uint8Array(await d.arrayBuffer()), this.cache && await of(s, i, this.cache);
      } catch (a) {
        if (console.debug("Zarr retry:" + s), n < this.timeout / 200)
          return delete this._pending[s], await this.get(t, e, n + 200);
        this.cache && await Li(s, this.cache), console.error(a);
        return;
      } finally {
        delete this._pending[s];
      }
    }
    return i;
  }
}
const Ko = async (r, t = ".zarray") => {
  const { path: e } = r.resolve(t), n = await r.store.get(e);
  return n ? JSON.parse(new TextDecoder().decode(n)) : {};
};
async function Cf(r) {
  const t = await Ko(r, ".zattrs"), e = await Ko(r);
  e.dtype.startsWith("<M8") && (t._dtype = e.dtype);
  const n = [];
  e.order === "F" && n.push({ name: "transpose", configuration: { order: "F" } }), typeof e.dtype == "string" && e.dtype.startsWith(">") && n.push({ name: "bytes", configuration: { endian: "big" } });
  for (const { id: i, ...a } of e.filters ?? [])
    n.push({ name: i, configuration: a });
  if (e.compressor) {
    const { id: i, ...a } = e.compressor;
    n.push({ name: i, configuration: a });
  }
  const s = {
    zarr_format: 3,
    node_type: "array",
    shape: e.shape,
    data_type: "int64",
    chunk_grid: {
      name: "regular",
      configuration: {
        chunk_shape: e.chunks
      }
    },
    chunk_key_encoding: {
      name: "v2",
      configuration: {
        separator: e.dimension_separator ?? "."
      }
    },
    codecs: n,
    fill_value: e.fill_value,
    attributes: t
  };
  return new vr(r.store, r.path, s);
}
function Bi(r, t, e) {
  const n = e.value;
  return e.value = async function(...s) {
    const i = Date.now(), a = await n.apply(this, s), d = Date.now() - i;
    return console.debug(`${t} took ${d}ms`), a;
  }, e;
}
var Rf = Object.defineProperty, Pf = Object.getOwnPropertyDescriptor, $f = (r, t, e, n) => {
  for (var s = Pf(t, e), i = r.length - 1, a; i >= 0; i--)
    (a = r[i]) && (s = a(t, e, s) || s);
  return s && Rf(t, e, s), s;
};
const zf = (r) => {
  const t = new gu.Buffer(r, "base64");
  return rf.Geometry.parse(t).toGeoJSON();
}, fi = (r) => r && (Array.isArray(r) || ArrayBuffer.isView(r)), jf = (r) => {
  const t = [];
  if (!fi(r)) return t;
  for (; t.push(r.length), fi(r[0]); )
    r = r[0];
  return t;
}, Vf = (r) => {
  for (; Array.isArray(r); )
    r = r[0];
  if (r == null)
    return "uint8";
  switch (r.constructor.name) {
    case "Boolean":
      return "bool";
    case "Number":
      return "float32";
    case "Int8Array":
      return "int8";
    case "Int16Array":
      return "int16";
    case "Int32Array":
      return "int32";
    case "BigInt64Array":
      return "int64";
    case "Uint8Array":
      return "uint8";
    case "Uint16Array":
      return "uint16";
    case "Uint32Array":
      return "uint32";
    case "Float32Array":
      return "float32";
    case "Float64Array":
      return "float64";
    case "String":
      return "v2:object";
    case "Object":
      return "v2:object";
  }
  throw new Error("Unsupported data type: " + r.constructor.name);
}, Wf = (r) => {
  let t = r.toString().toLowerCase();
  return r.typeId == 5 ? t = "v2:object" : r.typeId == 1 && (t = "uint8"), t;
}, Zf = (r) => {
  if (!Array.isArray(r)) return r;
  const t = r.flat(1 / 0);
  if (fi(t[0])) {
    const e = t[0].length, n = new t[0].constructor(t.length * e);
    for (let s = 0; s < t.length; s++)
      n.set(t[s], s * e);
    return n;
  } else
    return t;
}, Gf = (r) => {
  const t = r.length, e = Array(t);
  for (let n = t - 1, s = 1; n >= 0; n--)
    e[n] = s, s *= r[n];
  return e;
}, zs = (r, t, e, n = 0) => {
  if (t.length === 0) return r[0];
  if (t.length === 1) {
    const i = new r.constructor(t[0]);
    return i.set(r.slice(n, n + t[0])), i;
  }
  const s = new Array(t[0]);
  for (let i = 0; i < t[0]; i++)
    s[i] = zs(
      r,
      t.slice(1),
      e.slice(1),
      n + i * e[0]
    );
  return s;
}, Yf = (r, t) => {
  const [e, n] = t.split("<M8"), s = new Float64Array(r.data.length);
  let i = 1n;
  switch (n) {
    case "[ms]":
      i = 1000n;
      break;
    case "[us]":
      i = 1000000n;
      break;
    case "[ns]":
      i = 1000000000n;
      break;
    default:
      i = 1n;
      break;
  }
  for (let a = 0; a < r.data.length; a++) {
    const c = r.data[a];
    s[a] = Number(c / i);
  }
  return zs(s, r.shape, r.stride);
}, Su = (r, t, e) => {
  const n = Object.keys(t), s = {};
  for (const i in r)
    fi(r[i].data) && (s[i] = !0);
  if (n.length == 1)
    for (let i = 0; i < t[n[0]]; i++) {
      const a = {};
      for (const c in r)
        s[c] ? r[c].data.length > 1 && (a[c] = r[c].data[i]) : a[c] = r[c].data;
      e.push(a);
    }
  else
    for (let i = 0; i < t[n[0]]; i++) {
      const a = {};
      for (const d in r)
        r[d].dimensions.includes(n[0]) ? a[d] = {
          attributes: r[d].attributes,
          // @ts-expect-error: Is array because include dims
          data: r[d].data[i],
          dimensions: r[d].dimensions.slice(1)
        } : a[d] = r[d];
      const c = { ...t };
      delete c[n[0]], Su(a, c, e);
    }
  return e;
};
class rs {
  /**
   * Creates an instance of DataVar.
   * @param id - The identifier for the data variable.
   * @param dimensions - The dimensions associated with the data variable.
   * @param attributes - The attributes of the data variable, represented as a record of key-value pairs.
   * @param arr - The zarr array associated with the data variable.
   */
  id;
  dimensions;
  attributes;
  arr;
  constructor(t, e, n, s) {
    this.id = t, this.dimensions = e, this.attributes = n, this.arr = s;
  }
  async get(t) {
    if (this.arr.shape.length == 0 || this.arr.shape[0] == 0)
      return [];
    const e = t && t.map((s) => {
      if (typeof s == "string") {
        const [i, a, c] = s.split(":");
        return $i(
          parseInt(i),
          parseInt(a),
          parseInt(c)
        );
      } else
        return s;
    }), n = await wh(
      this.arr,
      e
    );
    if (this.arr.dtype == "v2:object" || !n.shape)
      return n.data;
    if (this.arr.dtype == "bool")
      return [...n.data];
    {
      const s = this.arr.attrs._dtype;
      return s?.startsWith("<M8") ? Yf(n, s) : zs(n.data, n.shape, n.stride);
    }
  }
}
$f([
  Bi
], rs.prototype, "get");
class Qe {
  /**
   * Creates an instance of Dataset.
   * @param dimensions - The dimensions of the dataset.
   * @param variables - The data variables of the dataset.
   * @param attributes - The attributes of the dataset.
   * @param root - The root group of the dataset.
   * @param coordkeys - The coordinates map of the dataset.
   */
  dimensions;
  variables;
  attributes;
  coordkeys;
  root;
  constructor(t, e, n, s, i) {
    this.dimensions = t, this.variables = e, this.attributes = n, this.coordkeys = s, this.root = i;
  }
  /**
   * Creates a Dataset instance from a Zarr store.
   * @param url - The URL of the datamesh gateway.
   * @param authHeaders - The authentication headers.
   * @param options.chunks - Optional chunking for the request.
   * @param options.downsample - Optional downsample parameters for the request.
   * @param options.parameters - Optional parameters for the request.
   * @param options.coordkeys - Optional coordinates for the request.
   * @param options.timeout - Optional timeout for the request.
   * @param options.nocache - Disable caching
   * @returns A promise that resolves to a Dataset instance.
   */
  //@measureTime
  static async zarr(t, e, n = {}) {
    const s = new Lf(t, e, {
      chunks: n.chunks,
      downsample: n.downsample,
      parameters: n.parameters,
      timeout: n.timeout,
      nocache: n.nocache
    }), i = await th(s), a = await Ge(i, { kind: "group" }), c = {}, d = {};
    for (const y of i.contents())
      if (y.kind == "array") {
        let B;
        try {
          B = await Ge(a.resolve(y.path), {
            kind: "array"
          });
        } catch (T) {
          const U = typeof T == "object" && T && "message" in T ? String(T.message) : void 0;
          if (U && U.includes("<M8"))
            B = await Cf(a.resolve(y.path));
          else
            throw T;
        }
        const R = B.attrs._ARRAY_DIMENSIONS, F = y.path.split("/").pop();
        c[F] = new rs(
          F,
          R || [],
          B.attrs,
          B
        ), R && R.map((T, U) => {
          const O = B.shape[U];
          if (d[T] && d[T] != O)
            throw new Error(
              `Inconsistent dimension size for ${T}: ${d[T]} != ${O}`
            );
          d[T] = O;
        });
      }
    const p = JSON.parse(a.attrs._coordinates) || {};
    return new Qe(
      d,
      c,
      a.attrs,
      n.coordkeys || p,
      a
    );
  }
  static async fromArrow(t, e) {
    const n = {}, s = { record: t.numRows }, i = {};
    return t.schema.fields.forEach((a) => {
      const c = t.getChild(a.name);
      let d = {}, p = c?.toArray(), y = Wf(a.type);
      if (tt.isTimestamp(a.type)) {
        const B = new Float64Array(p.length), R = BigInt(1e3 ** (a.type.unit - 0));
        for (let F = 0; F < p.length; F++)
          B[F] = Number(p[F] / R);
        p = B, y = "float64", d = { unit: "Unix timestamp (s)" };
      } else if (tt.isBinary(a.type)) {
        const B = [];
        for (let R = 0; R < p.length; R++)
          B.push(new gu.Buffer(p[R]).toString("base64"));
        p = B, y = "v2:object";
      }
      i[a.name] = {
        dimensions: ["record"],
        attributes: d,
        data: p,
        dtype: y
      };
    }), await Qe.init({ dimensions: s, variables: i, attributes: n }, e);
  }
  static async fromGeojson(t, e) {
    if (!("features" in t && Array.isArray(t.features)) && !("geometry" in t))
      throw new Error("Invalid GeoJSON");
    const n = "features" in t && t.features ? t.features : [t];
    if (n.length === 0)
      throw new Error("FeatureCollection contains no features");
    const s = /* @__PURE__ */ new Set();
    n.forEach((d) => {
      d.properties && Object.keys(d.properties).forEach((p) => s.add(p));
    });
    const i = n.map(
      (d) => {
        const p = {
          geometry: d.geometry
        };
        return d.properties && Object.assign(p, d.properties), p;
      }
    ), a = {
      dimensions: { index: i.length },
      variables: {},
      attributes: {}
    }, c = await Qe.init(a, { ...e, g: "geometry" });
    await c.assign(
      "geometry",
      ["index"],
      i.map((d) => d.geometry),
      { description: "GeoJSON geometry" }
    );
    for (const d of s) {
      const p = i.map((y) => y[d]);
      await c.assign(d, ["index"], p, {
        description: `Property: ${d}`
      });
    }
    return c;
  }
  /**
   * Initializes an in memory Dataset instance from a data object.
   * @param datasource - An object containing id, dimensions, data variables, and attributes.
   */
  static async init(t, e) {
    const n = await Xs(/* @__PURE__ */ new Map(), {
      attributes: { created: /* @__PURE__ */ new Date() }
    }), s = new Qe(
      t.dimensions,
      {},
      t.attributes || {},
      e || {},
      n
    );
    for (const i in t.variables) {
      const { dimensions: a, attributes: c, data: d, dtype: p } = t.variables[i];
      await s.assign(
        i,
        a,
        d,
        c,
        p && p === "string" ? "v2:object" : p
      );
    }
    return s;
  }
  /**
   * Converts the dataset into a dataframe format.
   *
   * @returns {Promise<Record<string, unknown>[]>} A promise that resolves to an array of records,
   * where each record represents a row in the dataframe.
   *
   * @remarks
   * This method iterates over the data variables, retrieves their dimensions and data,
   * and then flattens the data into a dataframe structure.
   * Time coordinates are converted to IDO8601 format.
   * BigInt datatypes are coerced to number.
   *
   * @example
   * ```typescript
   * const dataframe = await instance.asDataframe();
   * console.log(dataframe);
   * ```
   */
  //@measureTime
  async asDataframe() {
    const t = {}, e = [];
    for (const s in this.variables)
      t[s] = {
        attributes: this.variables[s].attributes,
        dimensions: this.variables[s].dimensions
      }, t[s].data = await this.variables[s].get(), this.variables[s].arr.dtype == "int64" && e.push(s);
    const n = Su(t, { ...this.dimensions }, []);
    if (this.coordkeys.t)
      for (let s = 0; s < n.length; s++)
        n[s][this.coordkeys.t] = new Date(
          1e3 * n[s][this.coordkeys.t]
        ).toISOString();
    if (e.length > 0)
      for (const s of e)
        for (let i = 0; i < n.length; i++)
          n[i][s] = Number(n[i][s]);
    return n;
  }
  /**
   * Converts the dataset into a GeoJSON Feature.
   * @param geometry - Optional GeoJSON geometry to apply to all records, otherwise geometry column is required. Will override geometry column if present.
   *
   * @returns {Promise<FeatureCollection>} A promise that resolves to an array of records,
   * where each record represents a row in the dataframe.
   *
   * @throws Will throw an error if no geometry is found in data or as a parameter
   *
   * @remarks
   * This method iterates over the data variables, retrieves their dimensions and data,
   * and then flattens the data into a dataframe structure.
   *
   * @example
   * ```typescript
   * const dataframe = await instance.asDataframe();
   * console.log(dataframe);
   * ```
   */
  async asGeojson(t) {
    if (!this.coordkeys.g && !t)
      throw new Error("No geometry found");
    const e = [], n = await this.asDataframe();
    for (let s = 0; s < n.length; s++) {
      const { ...i } = n[s];
      let a = t;
      if (!a && this.coordkeys.g) {
        delete i[this.coordkeys.g];
        const c = n[s][this.coordkeys.g];
        c.slice(0, 7) == '{"type:' ? a = JSON.parse(c) : a = zf(c);
      }
      e.push({
        type: "Feature",
        geometry: a,
        properties: i
      });
    }
    return {
      type: "FeatureCollection",
      features: e
    };
  }
  /**
   * Asynchronously assigns data to a variable in the dataset.
   *
   * @param varid - The identifier for the variable.
   * @param dims - An array of dimension names corresponding to the data.
   * @param data - The data to be assigned, which can be a multi-dimensional array.
   * @param attrs - Optional. A record of attributes to be associated with the variable.
   * @param dtype - Optional. The data type of the data.
   * @param chunks - Optional. An array specifying the chunk sizes for the data.
   *
   * @returns A promise that resolves when the data has been successfully assigned.
   * @throws Will throw an error if the shape of the data does not match the provided dimensions.
   * @throws Will throw an error if an existing dimension size does not match the new data.
   */
  async assign(t, e, n, s, i, a) {
    const c = jf(n);
    if (c.length != e.length)
      throw new Error("Data shape does not match dimensions");
    e.map((B, R) => {
      if (this.dimensions[B]) {
        if (this.dimensions[B] != c[R])
          throw new Error(
            `Existing size of dimension ${B} does not match new data`
          );
      } else
        this.dimensions[B] = c[R];
    });
    const d = i || Vf(n), p = await Xs(
      this.root.resolve(t),
      {
        shape: c,
        data_type: d,
        chunk_shape: a || c,
        codecs: d == "v2:object" ? [{ name: "json2" }] : []
      }
    );
    let y = Zf(n);
    y.length == 0 ? y = null : d == "bool" ? y = new is(y) : Array.isArray(y) && d == "float32" ? y = Float32Array.from(y, (B) => B ?? NaN) : Array.isArray(y) && d == "float64" ? y = Float64Array.from(y, (B) => B ?? NaN) : Array.isArray(y) && d == "int8" ? y = Int8Array.from(y) : Array.isArray(y) && d == "int16" ? y = Int16Array.from(y) : Array.isArray(y) && d == "int32" ? y = Int32Array.from(y) : Array.isArray(y) && d == "int64" ? y = BigInt64Array.from(y.map((B) => BigInt(B))) : Array.isArray(y) && d == "uint8" ? y = Uint8Array.from(y) : Array.isArray(y) && d == "uint16" ? y = Uint16Array.from(y) : Array.isArray(y) && d == "uint32" ? y = Uint32Array.from(y) : Array.isArray(y) && d == "uint64" && (y = BigUint64Array.from(y.map((B) => BigInt(B)))), y && await bh(
      p,
      c.map(() => null),
      {
        data: y,
        shape: c,
        stride: Gf(c)
      }
    ), this.variables[t] = new rs(t, e, s || {}, p);
  }
}
var Jf = Object.defineProperty, Hf = Object.getOwnPropertyDescriptor, qf = (r, t, e, n) => {
  for (var s = Hf(t, e), i = r.length - 1, a; i >= 0; i--)
    (a = r[i]) && (s = a(t, e, s) || s);
  return s && Jf(t, e, s), s;
};
const Iu = class ns {
  id;
  user;
  creationTime;
  endTime;
  write;
  verified = !1;
  _connection;
  static async acquire(t, e = {}) {
    if (!t._isV1) {
      const n = new ns();
      return n.id = "dummy_session", n.user = "dummy_user", n.creationTime = /* @__PURE__ */ new Date(), n.endTime = new Date(
        Date.now() + (e.duration || 3600) * 1e3
      ), n.write = !1, n.verified = !1, n._connection = t, typeof process < "u" && process.on && process.on("beforeExit", () => {
        n.close();
      }), n;
    }
    try {
      const n = { ...t._authHeaders };
      n["Cache-Control"] = "no-store";
      const s = new URLSearchParams({
        duration: String(e.duration ?? 3600)
      }), i = await fetch(
        `${t._gateway}/session/?${s.toString()}`,
        { headers: n }
      );
      if (i.status !== 200)
        throw new Error(`Failed to create session: ${await i.text()}`);
      const a = await i.json(), c = new ns();
      return c.id = a.id, c.user = a.user, c.creationTime = new Date(a.creation_time), c.endTime = new Date(a.end_time), c.write = a.write, c.verified = a.verified || !1, c._connection = t, typeof process < "u" && process.on && process.on("beforeExit", () => {
        c.close();
      }), c;
    } catch (n) {
      throw new Error(`Error when acquiring datamesh session: ${n}`);
    }
  }
  /**
   * Get the session header for requests.
   *
   * @returns The session header object.
   */
  get header() {
    return { "X-DATAMESH-SESSIONID": this.id };
  }
  /**
   * Add session header to an existing headers object.
   *
   * @param headers - The headers object to add the session header to.
   * @returns The updated headers object.
   */
  addHeader(t) {
    return { ...t, ...this.header };
  }
  /**
   * Close the session.
   *
   * @param finaliseWrite - Whether to finalise any write operations. Defaults to false.
   * @throws {Error} - If the session cannot be closed and finaliseWrite is true.
   */
  async close(t = !1) {
    if (this._connection._isV1)
      try {
        typeof process < "u" && process.off && process.off("beforeExit", this.close);
        const e = await fetch(
          `${this._connection._gateway}/session/${this.id}`,
          {
            method: "DELETE",
            headers: this.header,
            body: JSON.stringify({ finalise_write: t })
          }
        );
        if (e.status !== 204) {
          if (t)
            throw new Error(`Failed to finalise write: ${await e.text()}`);
          console.warn(`Failed to close session: ${await e.text()}`);
        }
      } catch (e) {
        if (t)
          throw new Error(`Error when closing datamesh session: ${e}`);
        console.warn(`Error when closing datamesh session: ${e}`);
      }
  }
  /**
   * Enter a session context.
   *
   * @returns The session instance.
   */
  async enter() {
    return this;
  }
  /**
   * Exit a session context.
   *
   * @param error - Any error that occurred during the session.
   * @returns A promise that resolves when the session is closed.
   */
  async exit(t) {
    await this.close(t === void 0);
  }
};
qf([
  Bi
], Iu, "acquire");
let Kf = Iu;
var Xf = Object.defineProperty, Qf = Object.getOwnPropertyDescriptor, Bu = (r, t, e, n) => {
  for (var s = Qf(t, e), i = r.length - 1, a; i >= 0; i--)
    (a = r[i]) && (s = a(t, e, s) || s);
  return s && Xf(t, e, s), s;
};
const tp = typeof process < "u" && process.env?.DATAMESH_SERVICE ? process.env.DATAMESH_SERVICE : "https://datamesh.oceanum.io", js = class vu {
  static LAZY_LOAD_SIZE = 1e8;
  _token;
  _host;
  _authHeaders;
  _gateway;
  _nocache = !1;
  _isV1 = !1;
  _sessionParams = {};
  _currentSession = null;
  service;
  gateway;
  /**
   * Datamesh connector constructor
   *
   * @param token - Your datamesh access token. Defaults to environment variable DATAMESH_TOKEN is defined else as literal string "DATAMESH_TOKEN". DO NOT put your Datamesh token directly into public facing browser code.
   * @param options - Constructor options.
   * @param options.service - URL of datamesh service. Defaults to environment variable DATAMESH_SERVICE or "https://datamesh.oceanum.io".
   * @param options.gateway - URL of gateway service. Defaults to "https://gateway.<datamesh_service_domain>".
   * @param options.jwtAuth - JWT for Oceanum service.
   * @param options.nocache - Disable caching of datamesh results.
   * @param options.sessionDuration - The desired length of time for acquired datamesh sessions in hours. Will be 1 hour by default.
   *
   * @throws {Error} - If a valid token is not provided.
   */
  constructor(t = typeof process < "u" && process.env?.DATAMESH_TOKEN ? process.env.DATAMESH_TOKEN : "$DATAMESH_TOKEN", e) {
    if (!t && !e?.jwtAuth)
      throw new Error(
        "A valid datamesh token must be supplied as a connector constructor argument or defined in environment variables as DATAMESH_TOKEN"
      );
    this._token = t, this._nocache = e?.nocache ?? !1;
    const n = new URL(e?.service || tp);
    this._host = `${n.protocol}//${n.hostname}`, this._authHeaders = e?.jwtAuth ? {
      Authorization: `Bearer ${e.jwtAuth}`
    } : {
      Authorization: `Token ${this._token}`,
      "X-DATAMESH-TOKEN": this._token
    }, this._gateway = e?.gateway || this._host, this._host.split(".").slice(-1)[0] !== this._gateway.split(".").slice(-1)[0] && console.warn("Datamesh gateway and service domains do not match"), e?.sessionDuration && typeof e.sessionDuration == "number" && (this._sessionParams = { duration: e.sessionDuration }), this._checkApiVersion();
  }
  /**
   * Check if the API version supports sessions.
   *
   * @private
   */
  async _checkApiVersion() {
    try {
      (await fetch(`${this._gateway}/session`, {
        headers: this._authHeaders
      })).status === 200 ? (this._isV1 = !0, console.info("Using datamesh API version 1")) : (this._isV1 = !1, console.info("Using datamesh API version 0"));
    } catch {
      this._isV1 = !1, console.info("Using datamesh API version 0");
    }
  }
  /**
   * Get datamesh host.
   *
   * @returns The datamesh server host.
   */
  get host() {
    return this._host;
  }
  /**
   * Check the status of the metadata server.
   *
   * @returns True if the server is up, false otherwise.
   */
  async status() {
    return (await fetch(this._host, {
      headers: this._authHeaders
    })).status === 200;
  }
  /**
   * Validate response from server.
   *
   * @param response - The response object to validate.
   * @throws {Error} - If the response contains an error status code.
   */
  async validateResponse(t) {
    if (t.status >= 400) {
      let e;
      try {
        e = (await t.json()).detail;
      } catch {
        e = `Datamesh server error: ${await t.text()}`;
      }
      throw new Error(e);
    }
  }
  /**
   * Create a new session.
   *
   * @param options - Session options.
   * @param options.duration - The desired length of time for the session in hours. Defaults to the value set in the constructor or 1 hour.
   * @returns A new session instance.
   */
  async createSession(t = {}) {
    const e = {
      duration: t.duration || this._sessionParams.duration || 3600
    };
    return this._currentSession = await Kf.acquire(this, e), this._currentSession;
  }
  /**
   * Get the current session or create a new one if none exists.
   *
   * @returns The current session.
   */
  async getSession() {
    return this._currentSession ? this._currentSession : this.createSession();
  }
  /**
   * Get headers with session information if available.
   *
   * @param additionalHeaders - Additional headers to include.
   * @returns Headers with session information.
   */
  async getSessionHeaders(t = {}) {
    return this._isV1 && !this._currentSession && await this.createSession(), this._currentSession ? this._currentSession.addHeader({
      ...this._authHeaders,
      ...t
    }) : { ...this._authHeaders, ...t };
  }
  /**
   * Request metadata from datamesh.
   *
   * @param datasourceId - The ID of the datasource to request.
   * @param params - Additional parameters for the request.
   * @returns The response from the server.
   */
  async metadataRequest(t = "", e = {}) {
    const n = new URL(`${this._host}/datasource/${t}`);
    Object.keys(e).forEach(
      (a) => n.searchParams.append(a, e[a])
    );
    const s = await this.getSessionHeaders(), i = await fetch(n.toString(), {
      headers: s
    });
    if (i.status === 403)
      throw new Error(`Datasource ${t} not authorized`);
    return await this.validateResponse(i), i;
  }
  /**
   * Request data from datamesh.
   *
   * @param datasourceId - The ID of the datasource to request.
   * @param dataFormat - The format of the requested data. Defaults to "application/json".
   * @returns The path to the cached file.
   */
  async dataRequest(t, e = "application/vnd.apache.arrow.file") {
    const n = await this.getSessionHeaders({ Accept: e }), s = await fetch(`${this._gateway}/oceanql/${t}?f=arrow`, {
      headers: n
    });
    return await this.validateResponse(s), lu(await s.arrayBuffer());
  }
  async stageRequest(t) {
    const e = JSON.stringify(t), n = await this.getSessionHeaders({
      "Content-Type": "application/json"
    }), s = await fetch(`${this._gateway}/oceanql/stage/`, {
      method: "POST",
      headers: n,
      body: e
    });
    if (s.status >= 400) {
      const i = await s.json();
      throw new Error(i.detail);
    } else return s.status === 204 ? null : s.json();
  }
  async query(t, e = {}) {
    const n = await this.stageRequest(t);
    if (!n)
      return console.warn("No data found for query"), null;
    if (n.size < vu.LAZY_LOAD_SIZE && n.container != "dataset") {
      const d = await this.dataRequest(n.qhash);
      return await Qe.fromArrow(d, n.coordkeys);
    }
    const s = `${this._gateway}/zarr/${this._isV1 ? "query/" : ""}${n.qhash}`, i = t.parameters, a = await this.getSessionHeaders(), c = await Qe.zarr(s, a, {
      parameters: i,
      timeout: e.timeout || 6e4,
      // Default timeout value
      nocache: this._nocache
    });
    if (t.variables)
      for (const d of Object.keys(c.variables))
        !t.variables.includes(d) && !Object.values(c.coordkeys).includes(d) && delete c.variables[d];
    return c;
  }
  /**
   * Get a datasource instance from the datamesh.
   *
   * @param datasourceId - Unique datasource ID.
   * @returns The datasource instance.
   * @throws {Error} - If the datasource cannot be found or is not authorized.
   */
  //@measureTime
  async getDatasource(t) {
    const n = await (await this.metadataRequest(t)).json();
    return {
      id: t,
      geom: n.geometry,
      ...n.properties
    };
  }
  /**
   * Load a datasource into the work environment.
   *
   * @param datasourceId - Unique datasource ID.
   * @param parameters - Additional datasource parameters.
   * @returns The dataset.
   */
  //@measureTime
  async loadDatasource(t, e = {}) {
    const n = { datasource: t, parameters: e };
    return await this.query(n);
  }
  /**
   * Close the current session if one exists.
   *
   * @param finaliseWrite - Whether to finalise any write operations. Defaults to false.
   * @returns A promise that resolves when the session is closed.
   */
  async closeSession(t = !1) {
    this._currentSession && (await this._currentSession.close(t), this._currentSession = null);
  }
};
Bu([
  Bi
], js.prototype, "stageRequest");
Bu([
  Bi
], js.prototype, "query");
let pp = js;
var Un = { exports: {} }, ep = Un.exports, Xo;
function rp() {
  return Xo || (Xo = 1, function(r, t) {
    (function(e, n) {
      r.exports = n();
    })(ep, function() {
      var e = 1e3, n = 6e4, s = 36e5, i = "millisecond", a = "second", c = "minute", d = "hour", p = "day", y = "week", B = "month", R = "quarter", F = "year", T = "date", U = "Invalid Date", O = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, N = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, P = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(z) {
        var L = ["th", "st", "nd", "rd"], D = z % 100;
        return "[" + z + (L[(D - 20) % 10] || L[D] || L[0]) + "]";
      } }, C = function(z, L, D) {
        var Y = String(z);
        return !Y || Y.length >= L ? z : "" + Array(L + 1 - Y.length).join(D) + z;
      }, V = { s: C, z: function(z) {
        var L = -z.utcOffset(), D = Math.abs(L), Y = Math.floor(D / 60), Z = D % 60;
        return (L <= 0 ? "+" : "-") + C(Y, 2, "0") + ":" + C(Z, 2, "0");
      }, m: function z(L, D) {
        if (L.date() < D.date()) return -z(D, L);
        var Y = 12 * (D.year() - L.year()) + (D.month() - L.month()), Z = L.clone().add(Y, B), X = D - Z < 0, K = L.clone().add(Y + (X ? -1 : 1), B);
        return +(-(Y + (D - Z) / (X ? Z - K : K - Z)) || 0);
      }, a: function(z) {
        return z < 0 ? Math.ceil(z) || 0 : Math.floor(z);
      }, p: function(z) {
        return { M: B, y: F, w: y, d: p, D: T, h: d, m: c, s: a, ms: i, Q: R }[z] || String(z || "").toLowerCase().replace(/s$/, "");
      }, u: function(z) {
        return z === void 0;
      } }, G = "en", x = {};
      x[G] = P;
      var M = "$isDayjsObject", m = function(z) {
        return z instanceof k || !(!z || !z[M]);
      }, S = function z(L, D, Y) {
        var Z;
        if (!L) return G;
        if (typeof L == "string") {
          var X = L.toLowerCase();
          x[X] && (Z = X), D && (x[X] = D, Z = X);
          var K = L.split("-");
          if (!Z && K.length > 1) return z(K[0]);
        } else {
          var q = L.name;
          x[q] = L, Z = q;
        }
        return !Y && Z && (G = Z), Z || !Y && G;
      }, w = function(z, L) {
        if (m(z)) return z.clone();
        var D = typeof L == "object" ? L : {};
        return D.date = z, D.args = arguments, new k(D);
      }, v = V;
      v.l = S, v.i = m, v.w = function(z, L) {
        return w(z, { locale: L.$L, utc: L.$u, x: L.$x, $offset: L.$offset });
      };
      var k = function() {
        function z(D) {
          this.$L = S(D.locale, null, !0), this.parse(D), this.$x = this.$x || D.x || {}, this[M] = !0;
        }
        var L = z.prototype;
        return L.parse = function(D) {
          this.$d = function(Y) {
            var Z = Y.date, X = Y.utc;
            if (Z === null) return /* @__PURE__ */ new Date(NaN);
            if (v.u(Z)) return /* @__PURE__ */ new Date();
            if (Z instanceof Date) return new Date(Z);
            if (typeof Z == "string" && !/Z$/i.test(Z)) {
              var K = Z.match(O);
              if (K) {
                var q = K[2] - 1 || 0, rt = (K[7] || "0").substring(0, 3);
                return X ? new Date(Date.UTC(K[1], q, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, rt)) : new Date(K[1], q, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, rt);
              }
            }
            return new Date(Z);
          }(D), this.init();
        }, L.init = function() {
          var D = this.$d;
          this.$y = D.getFullYear(), this.$M = D.getMonth(), this.$D = D.getDate(), this.$W = D.getDay(), this.$H = D.getHours(), this.$m = D.getMinutes(), this.$s = D.getSeconds(), this.$ms = D.getMilliseconds();
        }, L.$utils = function() {
          return v;
        }, L.isValid = function() {
          return this.$d.toString() !== U;
        }, L.isSame = function(D, Y) {
          var Z = w(D);
          return this.startOf(Y) <= Z && Z <= this.endOf(Y);
        }, L.isAfter = function(D, Y) {
          return w(D) < this.startOf(Y);
        }, L.isBefore = function(D, Y) {
          return this.endOf(Y) < w(D);
        }, L.$g = function(D, Y, Z) {
          return v.u(D) ? this[Y] : this.set(Z, D);
        }, L.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, L.valueOf = function() {
          return this.$d.getTime();
        }, L.startOf = function(D, Y) {
          var Z = this, X = !!v.u(Y) || Y, K = v.p(D), q = function(g, _) {
            var E = v.w(Z.$u ? Date.UTC(Z.$y, _, g) : new Date(Z.$y, _, g), Z);
            return X ? E : E.endOf(p);
          }, rt = function(g, _) {
            return v.w(Z.toDate()[g].apply(Z.toDate("s"), (X ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(_)), Z);
          }, At = this.$W, Ut = this.$M, Pt = this.$D, Zt = "set" + (this.$u ? "UTC" : "");
          switch (K) {
            case F:
              return X ? q(1, 0) : q(31, 11);
            case B:
              return X ? q(1, Ut) : q(0, Ut + 1);
            case y:
              var Gt = this.$locale().weekStart || 0, W = (At < Gt ? At + 7 : At) - Gt;
              return q(X ? Pt - W : Pt + (6 - W), Ut);
            case p:
            case T:
              return rt(Zt + "Hours", 0);
            case d:
              return rt(Zt + "Minutes", 1);
            case c:
              return rt(Zt + "Seconds", 2);
            case a:
              return rt(Zt + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, L.endOf = function(D) {
          return this.startOf(D, !1);
        }, L.$set = function(D, Y) {
          var Z, X = v.p(D), K = "set" + (this.$u ? "UTC" : ""), q = (Z = {}, Z[p] = K + "Date", Z[T] = K + "Date", Z[B] = K + "Month", Z[F] = K + "FullYear", Z[d] = K + "Hours", Z[c] = K + "Minutes", Z[a] = K + "Seconds", Z[i] = K + "Milliseconds", Z)[X], rt = X === p ? this.$D + (Y - this.$W) : Y;
          if (X === B || X === F) {
            var At = this.clone().set(T, 1);
            At.$d[q](rt), At.init(), this.$d = At.set(T, Math.min(this.$D, At.daysInMonth())).$d;
          } else q && this.$d[q](rt);
          return this.init(), this;
        }, L.set = function(D, Y) {
          return this.clone().$set(D, Y);
        }, L.get = function(D) {
          return this[v.p(D)]();
        }, L.add = function(D, Y) {
          var Z, X = this;
          D = Number(D);
          var K = v.p(Y), q = function(Ut) {
            var Pt = w(X);
            return v.w(Pt.date(Pt.date() + Math.round(Ut * D)), X);
          };
          if (K === B) return this.set(B, this.$M + D);
          if (K === F) return this.set(F, this.$y + D);
          if (K === p) return q(1);
          if (K === y) return q(7);
          var rt = (Z = {}, Z[c] = n, Z[d] = s, Z[a] = e, Z)[K] || 1, At = this.$d.getTime() + D * rt;
          return v.w(At, this);
        }, L.subtract = function(D, Y) {
          return this.add(-1 * D, Y);
        }, L.format = function(D) {
          var Y = this, Z = this.$locale();
          if (!this.isValid()) return Z.invalidDate || U;
          var X = D || "YYYY-MM-DDTHH:mm:ssZ", K = v.z(this), q = this.$H, rt = this.$m, At = this.$M, Ut = Z.weekdays, Pt = Z.months, Zt = Z.meridiem, Gt = function(_, E, j, $) {
            return _ && (_[E] || _(Y, X)) || j[E].slice(0, $);
          }, W = function(_) {
            return v.s(q % 12 || 12, _, "0");
          }, g = Zt || function(_, E, j) {
            var $ = _ < 12 ? "AM" : "PM";
            return j ? $.toLowerCase() : $;
          };
          return X.replace(N, function(_, E) {
            return E || function(j) {
              switch (j) {
                case "YY":
                  return String(Y.$y).slice(-2);
                case "YYYY":
                  return v.s(Y.$y, 4, "0");
                case "M":
                  return At + 1;
                case "MM":
                  return v.s(At + 1, 2, "0");
                case "MMM":
                  return Gt(Z.monthsShort, At, Pt, 3);
                case "MMMM":
                  return Gt(Pt, At);
                case "D":
                  return Y.$D;
                case "DD":
                  return v.s(Y.$D, 2, "0");
                case "d":
                  return String(Y.$W);
                case "dd":
                  return Gt(Z.weekdaysMin, Y.$W, Ut, 2);
                case "ddd":
                  return Gt(Z.weekdaysShort, Y.$W, Ut, 3);
                case "dddd":
                  return Ut[Y.$W];
                case "H":
                  return String(q);
                case "HH":
                  return v.s(q, 2, "0");
                case "h":
                  return W(1);
                case "hh":
                  return W(2);
                case "a":
                  return g(q, rt, !0);
                case "A":
                  return g(q, rt, !1);
                case "m":
                  return String(rt);
                case "mm":
                  return v.s(rt, 2, "0");
                case "s":
                  return String(Y.$s);
                case "ss":
                  return v.s(Y.$s, 2, "0");
                case "SSS":
                  return v.s(Y.$ms, 3, "0");
                case "Z":
                  return K;
              }
              return null;
            }(_) || K.replace(":", "");
          });
        }, L.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, L.diff = function(D, Y, Z) {
          var X, K = this, q = v.p(Y), rt = w(D), At = (rt.utcOffset() - this.utcOffset()) * n, Ut = this - rt, Pt = function() {
            return v.m(K, rt);
          };
          switch (q) {
            case F:
              X = Pt() / 12;
              break;
            case B:
              X = Pt();
              break;
            case R:
              X = Pt() / 3;
              break;
            case y:
              X = (Ut - At) / 6048e5;
              break;
            case p:
              X = (Ut - At) / 864e5;
              break;
            case d:
              X = Ut / s;
              break;
            case c:
              X = Ut / n;
              break;
            case a:
              X = Ut / e;
              break;
            default:
              X = Ut;
          }
          return Z ? X : v.a(X);
        }, L.daysInMonth = function() {
          return this.endOf(B).$D;
        }, L.$locale = function() {
          return x[this.$L];
        }, L.locale = function(D, Y) {
          if (!D) return this.$L;
          var Z = this.clone(), X = S(D, Y, !0);
          return X && (Z.$L = X), Z;
        }, L.clone = function() {
          return v.w(this.$d, this);
        }, L.toDate = function() {
          return new Date(this.valueOf());
        }, L.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, L.toISOString = function() {
          return this.$d.toISOString();
        }, L.toString = function() {
          return this.$d.toUTCString();
        }, z;
      }(), Q = k.prototype;
      return w.prototype = Q, [["$ms", i], ["$s", a], ["$m", c], ["$H", d], ["$W", p], ["$M", B], ["$y", F], ["$D", T]].forEach(function(z) {
        Q[z[1]] = function(L) {
          return this.$g(L, z[0], z[1]);
        };
      }), w.extend = function(z, L) {
        return z.$i || (z(L, k, w), z.$i = !0), w;
      }, w.locale = S, w.isDayjs = m, w.unix = function(z) {
        return w(1e3 * z);
      }, w.en = x[G], w.Ls = x, w.p = {}, w;
    });
  }(Un)), Un.exports;
}
var np = rp();
const mr = /* @__PURE__ */ Ls(np);
var Ln = { exports: {} }, ip = Ln.exports, Qo;
function sp() {
  return Qo || (Qo = 1, function(r, t) {
    (function(e, n) {
      r.exports = n();
    })(ip, function() {
      var e, n, s = 1e3, i = 6e4, a = 36e5, c = 864e5, d = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, p = 31536e6, y = 2628e6, B = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, R = { years: p, months: y, days: c, hours: a, minutes: i, seconds: s, milliseconds: 1, weeks: 6048e5 }, F = function(x) {
        return x instanceof V;
      }, T = function(x, M, m) {
        return new V(x, m, M.$l);
      }, U = function(x) {
        return n.p(x) + "s";
      }, O = function(x) {
        return x < 0;
      }, N = function(x) {
        return O(x) ? Math.ceil(x) : Math.floor(x);
      }, P = function(x) {
        return Math.abs(x);
      }, C = function(x, M) {
        return x ? O(x) ? { negative: !0, format: "" + P(x) + M } : { negative: !1, format: "" + x + M } : { negative: !1, format: "" };
      }, V = function() {
        function x(m, S, w) {
          var v = this;
          if (this.$d = {}, this.$l = w, m === void 0 && (this.$ms = 0, this.parseFromMilliseconds()), S) return T(m * R[U(S)], this);
          if (typeof m == "number") return this.$ms = m, this.parseFromMilliseconds(), this;
          if (typeof m == "object") return Object.keys(m).forEach(function(z) {
            v.$d[U(z)] = m[z];
          }), this.calMilliseconds(), this;
          if (typeof m == "string") {
            var k = m.match(B);
            if (k) {
              var Q = k.slice(2).map(function(z) {
                return z != null ? Number(z) : 0;
              });
              return this.$d.years = Q[0], this.$d.months = Q[1], this.$d.weeks = Q[2], this.$d.days = Q[3], this.$d.hours = Q[4], this.$d.minutes = Q[5], this.$d.seconds = Q[6], this.calMilliseconds(), this;
            }
          }
          return this;
        }
        var M = x.prototype;
        return M.calMilliseconds = function() {
          var m = this;
          this.$ms = Object.keys(this.$d).reduce(function(S, w) {
            return S + (m.$d[w] || 0) * R[w];
          }, 0);
        }, M.parseFromMilliseconds = function() {
          var m = this.$ms;
          this.$d.years = N(m / p), m %= p, this.$d.months = N(m / y), m %= y, this.$d.days = N(m / c), m %= c, this.$d.hours = N(m / a), m %= a, this.$d.minutes = N(m / i), m %= i, this.$d.seconds = N(m / s), m %= s, this.$d.milliseconds = m;
        }, M.toISOString = function() {
          var m = C(this.$d.years, "Y"), S = C(this.$d.months, "M"), w = +this.$d.days || 0;
          this.$d.weeks && (w += 7 * this.$d.weeks);
          var v = C(w, "D"), k = C(this.$d.hours, "H"), Q = C(this.$d.minutes, "M"), z = this.$d.seconds || 0;
          this.$d.milliseconds && (z += this.$d.milliseconds / 1e3, z = Math.round(1e3 * z) / 1e3);
          var L = C(z, "S"), D = m.negative || S.negative || v.negative || k.negative || Q.negative || L.negative, Y = k.format || Q.format || L.format ? "T" : "", Z = (D ? "-" : "") + "P" + m.format + S.format + v.format + Y + k.format + Q.format + L.format;
          return Z === "P" || Z === "-P" ? "P0D" : Z;
        }, M.toJSON = function() {
          return this.toISOString();
        }, M.format = function(m) {
          var S = m || "YYYY-MM-DDTHH:mm:ss", w = { Y: this.$d.years, YY: n.s(this.$d.years, 2, "0"), YYYY: n.s(this.$d.years, 4, "0"), M: this.$d.months, MM: n.s(this.$d.months, 2, "0"), D: this.$d.days, DD: n.s(this.$d.days, 2, "0"), H: this.$d.hours, HH: n.s(this.$d.hours, 2, "0"), m: this.$d.minutes, mm: n.s(this.$d.minutes, 2, "0"), s: this.$d.seconds, ss: n.s(this.$d.seconds, 2, "0"), SSS: n.s(this.$d.milliseconds, 3, "0") };
          return S.replace(d, function(v, k) {
            return k || String(w[v]);
          });
        }, M.as = function(m) {
          return this.$ms / R[U(m)];
        }, M.get = function(m) {
          var S = this.$ms, w = U(m);
          return w === "milliseconds" ? S %= 1e3 : S = w === "weeks" ? N(S / R[w]) : this.$d[w], S || 0;
        }, M.add = function(m, S, w) {
          var v;
          return v = S ? m * R[U(S)] : F(m) ? m.$ms : T(m, this).$ms, T(this.$ms + v * (w ? -1 : 1), this);
        }, M.subtract = function(m, S) {
          return this.add(m, S, !0);
        }, M.locale = function(m) {
          var S = this.clone();
          return S.$l = m, S;
        }, M.clone = function() {
          return T(this.$ms, this);
        }, M.humanize = function(m) {
          return e().add(this.$ms, "ms").locale(this.$l).fromNow(!m);
        }, M.valueOf = function() {
          return this.asMilliseconds();
        }, M.milliseconds = function() {
          return this.get("milliseconds");
        }, M.asMilliseconds = function() {
          return this.as("milliseconds");
        }, M.seconds = function() {
          return this.get("seconds");
        }, M.asSeconds = function() {
          return this.as("seconds");
        }, M.minutes = function() {
          return this.get("minutes");
        }, M.asMinutes = function() {
          return this.as("minutes");
        }, M.hours = function() {
          return this.get("hours");
        }, M.asHours = function() {
          return this.as("hours");
        }, M.days = function() {
          return this.get("days");
        }, M.asDays = function() {
          return this.as("days");
        }, M.weeks = function() {
          return this.get("weeks");
        }, M.asWeeks = function() {
          return this.as("weeks");
        }, M.months = function() {
          return this.get("months");
        }, M.asMonths = function() {
          return this.as("months");
        }, M.years = function() {
          return this.get("years");
        }, M.asYears = function() {
          return this.as("years");
        }, x;
      }(), G = function(x, M, m) {
        return x.add(M.years() * m, "y").add(M.months() * m, "M").add(M.days() * m, "d").add(M.hours() * m, "h").add(M.minutes() * m, "m").add(M.seconds() * m, "s").add(M.milliseconds() * m, "ms");
      };
      return function(x, M, m) {
        e = m, n = m().$utils(), m.duration = function(v, k) {
          var Q = m.locale();
          return T(v, { $l: Q }, k);
        }, m.isDuration = F;
        var S = M.prototype.add, w = M.prototype.subtract;
        M.prototype.add = function(v, k) {
          return F(v) ? G(this, v, 1) : S.bind(this)(v, k);
        }, M.prototype.subtract = function(v, k) {
          return F(v) ? G(this, v, -1) : w.bind(this)(v, k);
        };
      };
    });
  }(Ln)), Ln.exports;
}
var op = sp();
const ap = /* @__PURE__ */ Ls(op);
mr.extend(ap);
const cp = (r) => {
  if (r instanceof Date)
    return mr(r).toISOString();
  if (r instanceof mr)
    return r.toISOString();
  if (r instanceof mr.duration)
    return r.toISOString();
  try {
    return mr.duration(r).toISOString();
  } catch {
    return mr(r).toISOString();
  }
}, up = (r) => {
  const t = r.times.map((e) => cp(e));
  return {
    type: r.type || "range",
    times: t,
    resolution: r.resolution,
    resample: r.resample
  };
};
class yp {
  datasource;
  parameters;
  description;
  variables;
  timefilter;
  geofilter;
  levelfilter;
  coordfilter;
  crs;
  aggregate;
  limit;
  id;
  constructor(t) {
    this.datasource = t.datasource, this.parameters = t.parameters, this.description = t.description, this.variables = t.variables, this.timefilter = t.timefilter && up(t.timefilter), this.geofilter = t.geofilter, this.levelfilter = t.levelfilter, this.coordfilter = t.coordfilter, this.crs = t.crs, this.aggregate = t.aggregate, this.limit = t.limit, this.id = t.id;
  }
  /**
   * Returns the query as a JSON object.
   */
  toJSON() {
    return {
      datasource: this.datasource,
      parameters: this.parameters,
      description: this.description,
      variables: this.variables,
      timefilter: this.timefilter,
      geofilter: this.geofilter,
      levelfilter: this.levelfilter,
      coordfilter: this.coordfilter,
      crs: this.crs,
      aggregate: this.aggregate,
      limit: this.limit,
      id: this.id
    };
  }
}
export {
  pp as Connector,
  rs as DataVar,
  Qe as Dataset,
  yp as Query,
  zf as wkb_to_geojson
};
